/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./js/components/cart.js":
/*!*******************************!*\
  !*** ./js/components/cart.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Cart)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Cart = /*#__PURE__*/function () {
  function Cart() {
    _classCallCheck(this, Cart);
    this.cartForm = document.querySelector('.js-cart-form');
    this.body = document.body;
    this.cartTimeout = null;
    if (this.cartForm) {
      Cart.init();
    }
    if (window.location.hostname === 'shop.coavacoffee.com') {
      Cart.updateCartCount();
    }
    document.querySelectorAll('.js-qty').forEach(function (input) {
      Cart.updateButtonStates(input);
      input.addEventListener('input', function () {
        return Cart.updateButtonStates(input);
      });
    });
    document.querySelectorAll('.js-qty_adjust').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        var input = Cart.adjustQuantity(event.currentTarget);
        var updateBtn = document.querySelector('.js-cart_update');
        if (updateBtn) updateBtn.classList.add('cart-update--changed');
        Cart.syncPrice(input);
      });
    });
  }
  return _createClass(Cart, null, [{
    key: "updateCartNote",
    value: function updateCartNote(note) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: "note=".concat(note)
      }).then(function (response) {
        return response.json();
      }).then(function () {
        console.log("Cart note updated to ".concat(note));
      })["catch"](function (error) {
        console.log("Cart note error ".concat(error, ". Not updated to ").concat(note));
      })["finally"](function () {
        console.log('Done trying to update cart note.');
      });
    }
  }, {
    key: "init",
    value: function init() {
      document.body.addEventListener('change', function (event) {
        if (event.target.matches('textarea[name="note"]')) {
          Cart.updateCartNote(event.target.value);
        }
      });
    }
  }, {
    key: "adjustQuantity",
    value: function adjustQuantity(element) {
      var qtySelector = element.parentNode.querySelector('.js-qty');
      var qty = parseInt(qtySelector.value.replace(/\D/g, ''), 10);
      qty = Cart.validateQty(qty);
      var min = parseInt(qtySelector.getAttribute('min'), 10) || 1;
      var max = parseInt(qtySelector.getAttribute('max'), 10) || 99;
      if (element.classList.contains('js-qty_adjust--increase')) {
        if (qty < max) qty += 1;
      } else {
        if (qty > min) qty -= 1;
      }
      qtySelector.value = qty;
      Cart.updateButtonStates(qtySelector);
      return qtySelector;
    }
  }, {
    key: "updateButtonStates",
    value: function updateButtonStates(input) {
      var min = parseInt(input.getAttribute('min'), 10) || 1;
      var max = parseInt(input.getAttribute('max'), 10) || 99;
      var qty = parseInt(input.value, 10);
      var container = input.parentNode;
      var decrease = container.querySelector('.js-qty_adjust--decrease');
      var increase = container.querySelector('.js-qty_adjust--increase');
      if (decrease) Cart.setButtonDisabled(decrease, qty <= min, input);
      if (increase) Cart.setButtonDisabled(increase, qty >= max, input);
    }
  }, {
    key: "setButtonDisabled",
    value: function setButtonDisabled(button, isDisabled, input) {
      // Disabling a focused button drops focus to <body>, so hand it to the quantity input instead.
      if (isDisabled && document.activeElement === button) input.focus();
      if ('disabled' in button) button.disabled = isDisabled;
      button.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
      button.style.opacity = isDisabled ? '0.35' : '';
      button.style.pointerEvents = isDisabled ? 'none' : '';
    }
  }, {
    key: "validateQty",
    value: function validateQty(qty) {
      if (parseFloat(qty) === parseInt(qty, 10) && !Number.isNaN(qty)) {
        return qty;
      }
      return 1;
    }
  }, {
    key: "syncPrice",
    value: function syncPrice(input) {
      var row = input.closest('[data-item-key]');
      if (!row) return;
      var key = row.getAttribute('data-item-key');
      var unitPrice = parseInt(row.getAttribute('data-item-price'), 10);
      var qty = parseInt(input.value, 10);
      if (!isNaN(unitPrice) && !isNaN(qty)) {
        var subtotalEl = document.querySelector(".js-line-subtotal[data-key=\"".concat(key, "\"]"));
        if (subtotalEl) subtotalEl.textContent = Cart.formatMoney(unitPrice * qty);
      }
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: _defineProperty({}, key, qty)
        })
      }).then(function (r) {
        return r.json();
      }).then(function (cart) {
        var totalEl = document.querySelector('.js-cart-total');
        if (totalEl) totalEl.textContent = Cart.formatMoney(cart.total_price);
        var grandTotalEl = document.querySelector('.js-cart-grand-total');
        if (grandTotalEl) grandTotalEl.textContent = Cart.formatMoney(cart.total_price);
      })["catch"](function () {});
    }
  }, {
    key: "formatMoney",
    value: function formatMoney(cents) {
      var dollars = (cents / 100).toFixed(2);
      return '$' + (dollars.endsWith('.00') ? dollars.slice(0, -3) : dollars);
    }
  }, {
    key: "updateCartCount",
    value: function updateCartCount() {
      var cartCount = document.querySelector('.js-cart_count');
      fetch('/cart.json').then(function (response) {
        return response.json();
      }).then(function (data) {
        var itemCount = data.item_count;
        if (itemCount > 0) {
          cartCount.textContent = itemCount;
        }
      });
    }
  }]);
}();


/***/ }),

/***/ "./js/components/contactForm.js":
/*!**************************************!*\
  !*** ./js/components/contactForm.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ContactForm)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ContactForm = /*#__PURE__*/function () {
  function ContactForm() {
    var _this = this;
    _classCallCheck(this, ContactForm);
    this.contactForm = document.querySelector('.js-contact_form');
    if (this.contactForm) {
      var errorEl = this.contactForm.querySelector('.js-form_error');
      this.createStatusMessageRegion();
      this.initializeValidation();
      this.setupCustomValidationMessages();
      this.contactForm.addEventListener('submit', function (event) {
        event.preventDefault();
        if (errorEl) {
          errorEl.style.display = 'none';
          errorEl.textContent = '';
        }
        if (_this.validateForm()) {
          ContactForm.submit();
        } else {
          if (errorEl) {
            errorEl.style.display = 'block';
            errorEl.textContent = 'Please fill out all required fields.';
          }
        }
      });
    }
  }
  return _createClass(ContactForm, [{
    key: "createStatusMessageRegion",
    value: function createStatusMessageRegion() {
      // Create status message region compliant with WCAG 2.2 SC 4.1.3
      this.statusRegion = document.createElement('div');
      this.statusRegion.setAttribute('role', 'status');
      this.statusRegion.setAttribute('aria-live', 'polite');
      this.statusRegion.setAttribute('aria-atomic', 'true');
      this.statusRegion.className = 'sr-only';
      this.statusRegion.style.cssText = 'position: absolute; left: -10000px; width: 1px; height: 1px; overflow: hidden;';
      this.contactForm.appendChild(this.statusRegion);
    }
  }, {
    key: "announceStatusMessage",
    value: function announceStatusMessage(message) {
      this.statusRegion.textContent = message;
    }
  }, {
    key: "setupCustomValidationMessages",
    value: function setupCustomValidationMessages() {
      var _this2 = this;
      // Set custom validation messages for each field with more specific, accessible messages
      var customMessages = {
        'fromName': 'Please enter your full name',
        'fromEmail': 'Please enter a valid email address',
        'message[Phone Number]': 'Please enter your phone number',
        'message[Business Name]': 'Please enter your business name',
        'message[Street Address]': 'Please enter your street address',
        'message[City]': 'Please enter your city or town',
        'message[Zip Code]': 'Please enter your 5-digit zip code',
        'message[Estimated Coffee Volume & Frequency]': 'Please describe how much coffee you need and how often (example: 20 pounds per week)',
        'message[Equipment]': 'Please describe your current equipment or what you need to purchase',
        'message[How did you hear about Coava?]': 'Please tell us how you discovered Coava Coffee',
        'message[body]': 'Please describe your business and why you would like to partner with Coava'
      };

      // Apply custom messages to form fields
      Object.entries(customMessages).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          fieldName = _ref2[0],
          message = _ref2[1];
        var field = _this2.contactForm.querySelector("[name=\"".concat(fieldName, "\"]"));
        if (field) {
          field.setAttribute('data-custom-validation-message', message);

          // Override the default validation message
          field.addEventListener('invalid', function (event) {
            event.preventDefault();
            if (field.validity.valueMissing) {
              field.setCustomValidity(message);
            } else {
              field.setCustomValidity('');
            }
          });

          // Clear custom validation message when user starts typing
          field.addEventListener('input', function () {
            field.setCustomValidity('');
          });
        }
      });
    }
  }, {
    key: "initializeValidation",
    value: function initializeValidation() {
      // Define validation rules
      this.validationRules = {
        'fromName': {
          required: true,
          minlength: 2
        },
        'fromEmail': {
          required: true,
          email: true
        },
        'message[Phone Number]': {
          required: true,
          phone: true
        },
        'message[Business Name]': {
          required: true,
          minlength: 2
        },
        'message[Street Address]': {
          required: true,
          minlength: 5
        },
        'message[City]': {
          required: true,
          minlength: 2
        },
        'message[Zip Code]': {
          required: true,
          zipcode: true
        },
        'message[Estimated Coffee Volume & Frequency]': {
          required: true,
          minlength: 5
        },
        'message[Equipment]': {
          required: true,
          minlength: 1
        },
        'message[How did you hear about Coava?]': {
          required: true,
          minlength: 1
        },
        'message[body]': {
          required: true,
          minlength: 1
        },
        'message[Topic]': {
          required: true
        }
      };

      // Define custom error messages with more specific, accessible guidance
      this.errorMessages = {
        'fromName': {
          required: 'Please enter your full name',
          minlength: 'Name must be at least 2 characters long'
        },
        'fromEmail': {
          required: 'Please enter your email address',
          email: 'Please enter a valid email address (example: yourname@company.com)'
        },
        'message[Phone Number]': {
          required: 'Please enter your phone number',
          phone: 'Please enter a valid phone number (example: 555-123-4567)'
        },
        'message[Business Name]': {
          required: 'Please enter your business or organization name',
          minlength: 'Business name must be at least 2 characters long'
        },
        'message[Street Address]': {
          required: 'Please enter your complete street address',
          minlength: 'Address must be at least 5 characters long'
        },
        'message[City]': {
          required: 'Please enter your city or town',
          minlength: 'City must be at least 2 characters long'
        },
        'message[Zip Code]': {
          required: 'Please enter your zip code',
          zipcode: 'Please enter a valid 5-digit zip code'
        },
        'message[Estimated Coffee Volume & Frequency]': {
          required: 'Please describe how much coffee you need and how often',
          minlength: 'Please provide more details about your coffee volume and frequency needs'
        },
        'message[Equipment]': {
          required: 'Please describe your current equipment or what you need to purchase',
          minlength: 'Please provide more details about your equipment needs'
        },
        'message[How did you hear about Coava?]': {
          required: 'Please tell us how you discovered Coava Coffee',
          minlength: 'Please provide more details about how you heard about us'
        },
        'message[body]': {
          required: 'Please describe your business and why you would like to partner with Coava',
          minlength: 'Please provide more details about your business and partnership goals'
        },
        'message[Topic]': {
          required: 'Please select a topic from the dropdown menu'
        }
      };

      // Add real-time validation listeners
      this.addValidationListeners();
    }
  }, {
    key: "addValidationListeners",
    value: function addValidationListeners() {
      var _this3 = this;
      var inputs = this.contactForm.querySelectorAll('input, textarea, select');
      inputs.forEach(function (input) {
        // Validate on blur
        input.addEventListener('blur', function () {
          _this3.validateField(input);
        });

        // Clear errors on input
        input.addEventListener('input', function () {
          _this3.clearFieldError(input);
        });

        // Validate on change (for selects)
        input.addEventListener('change', function () {
          _this3.validateField(input);
        });
      });
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      var _this4 = this;
      var isValid = true;
      var inputs = this.contactForm.querySelectorAll('input, textarea, select');
      var errorCount = 0;
      inputs.forEach(function (input) {
        if (!_this4.validateField(input)) {
          isValid = false;
        }
      });

      // Announce validation status
      if (!isValid) {
        var errorFields = this.contactForm.querySelectorAll('label.error');
        var _errorCount = errorFields.length;
        this.announceStatusMessage("Form validation failed. ".concat(_errorCount, " field").concat(_errorCount > 1 ? 's have' : ' has', " errors."));
      }
      return isValid;
    }
  }, {
    key: "validateField",
    value: function validateField(field) {
      var fieldName = field.name;
      var rules = this.validationRules[fieldName];
      if (!rules) return true;
      var value = field.value.trim();
      var isValid = true;
      var errorMessage = '';

      // Check each rule
      for (var _i = 0, _Object$entries = Object.entries(rules); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          rule = _Object$entries$_i[0],
          ruleValue = _Object$entries$_i[1];
        if (!this.checkRule(value, rule, ruleValue)) {
          isValid = false;
          errorMessage = this.getErrorMessage(fieldName, rule);
          break;
        }
      }
      if (!isValid) {
        this.showFieldError(field, errorMessage);
        // Announce field-specific error
        var fieldLabel = this.getFieldLabel(field);
        this.announceStatusMessage("".concat(fieldLabel, ": ").concat(errorMessage));
      } else {
        this.clearFieldError(field);
      }
      return isValid;
    }
  }, {
    key: "getFieldLabel",
    value: function getFieldLabel(field) {
      // Try to get label from associated label element
      var id = field.getAttribute('id');
      if (id) {
        var label = document.querySelector("label[for=\"".concat(id, "\"]"));
        if (label) {
          return label.textContent.trim();
        }
      }

      // Try to get label from parent label element
      var parentLabel = field.closest('label');
      if (parentLabel) {
        return parentLabel.textContent.trim();
      }

      // Fallback to field name
      return field.name.replace(/[\[\]]/g, '').replace(/([A-Z])/g, ' $1').trim();
    }
  }, {
    key: "checkRule",
    value: function checkRule(value, rule, ruleValue) {
      switch (rule) {
        case 'required':
          return value.length > 0;
        case 'email':
          var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return emailRegex.test(value);
        case 'phone':
          var phoneRegex = /^[\+]?[1-9][\d]{0,15}$/;
          var cleanPhone = value.replace(/[\s\-\(\)]/g, '');
          return phoneRegex.test(cleanPhone);
        case 'zipcode':
          var zipRegex = /^\d{5}(-\d{4})?$/;
          return zipRegex.test(value);
        case 'minlength':
          return value.length >= ruleValue;
        case 'maxlength':
          return value.length <= ruleValue;
        default:
          return true;
      }
    }
  }, {
    key: "getErrorMessage",
    value: function getErrorMessage(fieldName, rule) {
      var fieldMessages = this.errorMessages[fieldName];
      return fieldMessages ? fieldMessages[rule] : 'This field is invalid';
    }
  }, {
    key: "showFieldError",
    value: function showFieldError(field, message) {
      this.clearFieldError(field);
      var errorLabel = document.createElement('label');
      errorLabel.className = 'error';
      errorLabel.textContent = message;
      field.parentNode.insertBefore(errorLabel, field.nextSibling);
      field.classList.add('error');
    }
  }, {
    key: "clearFieldError",
    value: function clearFieldError(field) {
      var existingError = field.parentNode.querySelector('label.error');
      if (existingError) {
        existingError.remove();
      }
      field.classList.remove('error');
    }
  }], [{
    key: "submit",
    value: function () {
      var _submit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var form, button, errorLabels, statusRegion, recaptchaToken, formData, response, responseData, successMsg, errorCount, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              form = document.querySelector('.js-contact_form');
              button = form.querySelector('.js-form_submit');
              errorLabels = form.querySelectorAll('label.error');
              errorLabels.forEach(function (label) {
                return label.remove();
              });

              // Announce form submission
              statusRegion = form.querySelector('[role="status"]');
              if (statusRegion) {
                statusRegion.textContent = 'Submitting form...';
              }
              button.disabled = true;
              button.textContent = 'Submitting...';
              _context.p = 1;
              // Generate reCAPTCHA token before form submission
              recaptchaToken = '';
              if (!(window.grecaptcha && window.grecaptchaReady)) {
                _context.n = 6;
                break;
              }
              _context.p = 2;
              _context.n = 3;
              return grecaptcha.execute('6Le9-YoqAAAAAPML22Mop-wS217z5vM23JjWvoOR', {
                action: 'submit'
              });
            case 3:
              recaptchaToken = _context.v;
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              console.error('reCAPTCHA error:', _t);
              alert('Unable to validate captcha. Please refresh the page and try again.');
              if (statusRegion) {
                statusRegion.textContent = 'Captcha validation failed. Please refresh the page and try again.';
              }
              return _context.a(2);
            case 5:
              _context.n = 7;
              break;
            case 6:
              console.warn('reCAPTCHA not ready, proceeding without token');
            case 7:
              formData = new FormData(form); // Update the reCAPTCHA token in the form data
              if (recaptchaToken) {
                formData.set('g-recaptcha-response', recaptchaToken);
              }
              _context.n = 8;
              return fetch('/actions/contactForm/sendMessage', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                  'X-Requested-With': 'XMLHttpRequest',
                  'Accept': 'application/json'
                },
                body: new URLSearchParams(formData).toString()
              });
            case 8:
              response = _context.v;
              if (response.ok) {
                _context.n = 9;
                break;
              }
              throw new Error("HTTP error! Status: ".concat(response.status));
            case 9:
              _context.n = 10;
              return response.json();
            case 10:
              responseData = _context.v;
              if (!responseData.success) {
                _context.n = 11;
                break;
              }
              successMsg = form.querySelector('.js-form_success');
              if (button) button.style.display = 'none';
              if (successMsg) successMsg.style.display = 'block';
              form.querySelectorAll('input, textarea, select').forEach(function (input) {
                input.disabled = true;
              });

              // Announce success
              if (statusRegion) {
                statusRegion.textContent = 'Form submitted successfully. Thank you for your message.';
              }
              return _context.a(2);
            case 11:
              if (responseData.error) {
                if (responseData.error === 'Unable to validate reCaptcha.') {
                  alert('Unable to validate captcha. Please try again.');
                  if (statusRegion) {
                    statusRegion.textContent = 'Captcha validation failed. Please try again.';
                  }
                } else {
                  Object.entries(responseData.error).forEach(function (_ref3) {
                    var _ref4 = _slicedToArray(_ref3, 2),
                      fieldName = _ref4[0],
                      errors = _ref4[1];
                    var field = form.querySelector("[name=\"".concat(fieldName, "\"]"));
                    if (field) {
                      var errorLabel = document.createElement('label');
                      errorLabel.className = 'error';
                      errorLabel.textContent = errors[0];
                      field.parentNode.insertBefore(errorLabel, field.nextSibling);
                    }
                  });

                  // Announce server-side errors
                  if (statusRegion) {
                    errorCount = Object.keys(responseData.error).length;
                    statusRegion.textContent = "Form submission failed. ".concat(errorCount, " field").concat(errorCount > 1 ? 's have' : ' has', " errors.");
                  }
                }
              }
              _context.n = 13;
              break;
            case 12:
              _context.p = 12;
              _t2 = _context.v;
              console.error('Form submission error:', _t2);
              alert('There was an error submitting the form. Please try again.');
              button.disabled = false;
              button.textContent = 'Submit';

              // Announce error
              if (statusRegion) {
                statusRegion.textContent = 'There was an error submitting the form. Please try again.';
              }
            case 13:
              return _context.a(2);
          }
        }, _callee, null, [[2, 4], [1, 12]]);
      }));
      function submit() {
        return _submit.apply(this, arguments);
      }
      return submit;
    }()
  }]);
}();


/***/ }),

/***/ "./js/components/equalHeight.js":
/*!**************************************!*\
  !*** ./js/components/equalHeight.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EqualHeight)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EqualHeight = /*#__PURE__*/function () {
  function EqualHeight() {
    _classCallCheck(this, EqualHeight);
    EqualHeight.init();
  }
  return _createClass(EqualHeight, null, [{
    key: "init",
    value: function init() {
      EqualHeight.normalizeImageHeights();
      window.addEventListener('resize', function () {
        EqualHeight.normalizeImageHeights();
      });
    }
  }, {
    key: "normalizeImageHeights",
    value: function normalizeImageHeights() {
      var timeoutDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
      window.setTimeout(function () {
        EqualHeight.equalize(document.querySelectorAll('.js-address'));
        document.querySelectorAll('.grid').forEach(function (grid) {
          EqualHeight.equalize(grid.querySelectorAll('.hero'));
          EqualHeight.equalize(grid.querySelectorAll('.js-image_card-image'));
        });
      }, timeoutDuration);
    }
  }, {
    key: "equalize",
    value: function equalize(elements) {
      if (!elements.length) return;
      var tallest = 0;
      elements.forEach(function (el) {
        el.style.height = 'auto';
        var height = el.clientHeight;
        if (height > tallest) {
          tallest = height;
        }
      });
      elements.forEach(function (el) {
        el.style.height = "".concat(tallest, "px");
      });
    }
  }]);
}();


/***/ }),

/***/ "./js/components/giftSubscriptionForm.js":
/*!***********************************************!*\
  !*** ./js/components/giftSubscriptionForm.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ GiftSubscriptionForm)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// NOTE: This uses the "old" subscription builder code.
// I figured that since it was much more simple and less
// integral we didn't need to rewrite it when we rewrote
// the primary subscription builder
var GiftSubscriptionForm = /*#__PURE__*/function () {
  function GiftSubscriptionForm() {
    _classCallCheck(this, GiftSubscriptionForm);
    this.formEl = document.querySelector('.js-gift_subscription-form');
    if (this.formEl) {
      this.submitEl = this.formEl.querySelector('.js-submit');
      this.giftCodeInputEl = this.formEl.querySelector('.js-gift-code');
      this.optionElements = this.formEl.querySelectorAll('.js-subscription_option');
      this.init();
    }
  }
  return _createClass(GiftSubscriptionForm, [{
    key: "init",
    value: function init() {
      var _this = this;
      // 1. On page load, see if there is already a value
      this.optionElements.forEach(function (element) {
        var optionHandle = element.dataset.optionHandle;
        var optionValue = document.querySelector("input[name='fields[".concat(optionHandle, "]']")).value;
        if (optionValue === element.dataset.value) {
          element.classList.add('is-selected');
          element.closest('.js-scrollto-unless-complete').classList.add('is-complete');
          var summaryItem = document.querySelector(".js-summary-item[data-option-handle='".concat(optionHandle, "']"));
          summaryItem.classList.remove('is-empty');
          summaryItem.innerHTML = optionValue;
        }
      });

      // 2. Edit the value on click
      this.optionElements.forEach(function (element) {
        element.addEventListener('click', function (event) {
          event.preventDefault();
          _this.toggleOption(event.currentTarget);
        });
      });

      // 3. Submit if able
      this.submitEl.addEventListener('click', function (event) {
        if (_this.formEl.classList.contains('is-ready')) {
          return true;
        }
        event.preventDefault();
        GiftSubscriptionForm.scrollToIncomplete();
        return true;
      });

      // Consider it complete if they hit a certain min length
      this.giftCodeInputEl.addEventListener('input', function (event) {
        var input = event.target;
        if (input.value.length > 9) {
          input.classList.add('is-selected');
          input.closest('.js-scrollto-unless-complete').classList.add('is-complete');
        } else {
          input.classList.remove('is-selected');
          input.closest('.js-scrollto-unless-complete').classList.remove('is-complete');
        }
      });

      // Move to the next section if they hit enter
      this.giftCodeInputEl.addEventListener('keypress', function (event) {
        if (event.key === 'Enter') {
          GiftSubscriptionForm.scrollToIncomplete();
          event.preventDefault();
          return false;
        }
        return true;
      });
    }
  }, {
    key: "toggleOption",
    value: function toggleOption(optionEl) {
      // Dictionary: (We are using slightly different words/meanings than Shopify
      //   so this will hopefully provide clarify.) For us, a Property is a group
      //   of options, an Option is a specific option.

      // Get the value
      var optionValue = optionEl.dataset.value;
      // Get something that we can identify it's sibling groups by, we'll make sure
      //   they all have the same data-option-handle set
      var optionHandle = optionEl.dataset.optionHandle;
      var optionSiblings = document.querySelectorAll(".js-subscription_option[data-option-handle='".concat(optionHandle, "']"));
      optionSiblings.forEach(function (sibling) {
        return sibling.classList.remove('is-selected');
      });

      // 1. Add the check mark and remove it from siblings
      optionEl.classList.add('is-selected');
      optionEl.closest('.js-scrollto-unless-complete').classList.add('is-complete');

      // 2. Change the value of the associated fields based on what this one is
      document.querySelector("input[name='fields[".concat(optionHandle, "]']")).value = optionValue;
      // 2a. Show the value in the summary.
      var summaryItem = document.querySelector(".js-summary-item[data-option-handle='".concat(optionHandle, "']"));
      summaryItem.classList.remove('is-empty');
      summaryItem.innerHTML = optionValue;

      // 3. Check if it's the last needed option
      var totalProperties = document.querySelectorAll('.js-subscription_property').length - 1;
      var selectedProperties = document.querySelectorAll('.js-subscription_option.is-selected').length;
      if (totalProperties === selectedProperties && this.giftCodeInputEl.classList.contains('is-selected')) {
        this.formEl.classList.add('is-ready');
      }

      // Always scroll to the next not complete section (could be the summary)
      setTimeout(function () {
        GiftSubscriptionForm.scrollToIncomplete();
      }, 300);
    }
  }], [{
    key: "scrollToIncomplete",
    value: function scrollToIncomplete() {
      document.querySelector('.js-scrollto-unless-complete:not(.is-complete)').scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest'
      });
    }
  }]);
}();


/***/ }),

/***/ "./js/components/newsletterSignup.js":
/*!*******************************************!*\
  !*** ./js/components/newsletterSignup.js ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ NewsletterSignup)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
var NewsletterSignup = /*#__PURE__*/function () {
  function NewsletterSignup() {
    _classCallCheck(this, NewsletterSignup);
  }
  return _createClass(NewsletterSignup, null, [{
    key: "init",
    value: function init() {
      document.querySelectorAll('.js-newsletter_signup-form').forEach(function (form) {
        var input = form.querySelector('.js-newsletter_signup-email');
        var error = form.querySelector('.js-newsletter_signup-error');
        if (!input || !error) return;
        var showError = function showError(message) {
          error.textContent = message;
          error.style.display = '';
        };
        var clearError = function clearError() {
          error.textContent = '';
          error.style.display = 'none';
        };

        // Klaviyo's embed script also writes server-side errors into this span and toggles its inline display style.
        var sync = function sync() {
          var hasError = error.style.display !== 'none' && error.textContent.trim().length > 0;
          if (hasError) {
            input.setAttribute('aria-invalid', 'true');
          } else {
            input.removeAttribute('aria-invalid');
          }
        };
        new MutationObserver(sync).observe(error, {
          attributes: true,
          attributeFilter: ['style'],
          childList: true,
          characterData: true,
          subtree: true
        });
        sync();

        // Capture phase so this runs before Klaviyo's submit handler and can block invalid submissions.
        form.addEventListener('submit', function (event) {
          var value = input.value.trim();
          var message = '';
          if (!value) {
            message = 'Enter your email address.';
          } else if (!input.checkValidity() || !EMAIL_PATTERN.test(value)) {
            message = 'Enter a valid email address, for example name@example.com.';
          }
          if (message) {
            event.preventDefault();
            event.stopImmediatePropagation();
            showError(message);
            input.focus();
          }
        }, true);
        input.addEventListener('input', function () {
          if (error.style.display !== 'none') clearError();
        });
      });
    }
  }]);
}();


/***/ }),

/***/ "./js/components/producer.js":
/*!***********************************!*\
  !*** ./js/components/producer.js ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Producers)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Producers = /*#__PURE__*/function () {
  function Producers() {
    _classCallCheck(this, Producers);
    this.producerEl = document.querySelector('.js-producer');
    if (this.producerEl) {
      this.getInfo();
    }
  }
  return _createClass(Producers, [{
    key: "getInfo",
    value: function getInfo() {
      var producerHandle = this.producerEl.dataset.producerHandle;
      var producerElement = this.producerEl;
      if (producerHandle !== '') {
        fetch("https://coavacoffee.com/producer/".concat(producerHandle, ".json")).then(function (response) {
          return response.json();
        }).then(function (data) {
          console.log(data);
          producerElement.innerHTML = "\n            <div class=\"image_w_text_card image_w_text_card--alternate\">\n              <div class=\"image_w_text_card-images\">\n                <img src=\"".concat(data.image, "\" alt=\"\" />\n              </div>\n              <div class=\"image_w_text_card-card\">\n                <div class=\"text_card text_card--shadow has-button\">\n                  <h3 class=\"text_card-title\">Produced By</h3>\n                  <div class=\"text_card-content\">\n                    <h2>").concat(data.title, "</h2>\n                    <p>").concat(data.summary, "</p>\n                  </div>\n                  <a class=\"button text_card-link\" href=\"").concat(data.url, "\" title=\"\">Read More</a>\n                </div>\n              </div>\n            </div>\n          ");
        });
      }
    }
  }]);
}();


/***/ }),

/***/ "./js/components/rebuyCart.js":
/*!************************************!*\
  !*** ./js/components/rebuyCart.js ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   isRebuyCartAvailable: () => (/* binding */ isRebuyCartAvailable),
/* harmony export */   isRebuyLoaded: () => (/* binding */ isRebuyLoaded),
/* harmony export */   openRebuyCart: () => (/* binding */ openRebuyCart),
/* harmony export */   refreshRebuyCart: () => (/* binding */ refreshRebuyCart),
/* harmony export */   watchRebuyCart: () => (/* binding */ watchRebuyCart)
/* harmony export */ });
/* harmony import */ var _subscriptionCartGuard_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./subscriptionCartGuard.js */ "./js/components/subscriptionCartGuard.js");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * Bridge to Rebuy Smart Cart.
 *
 * Smart Cart opens itself only when it intercepts a product-form submit — that's its
 * "Product Form Submission Behavior: Stay on current page" setting, and it's why the
 * product page works. The subscription builder can't use that path: it resolves curated
 * coffees from an API, clears any existing `_rc_bundle` lines, then adds several lines at
 * once with per-line properties and selling plans. That's a fetch to /cart/add.js, so no
 * submit event fires and Smart Cart never hears about it. So we open it ourselves.
 *
 * Method names below come from the live Smart Cart V2 instance, not from guesswork.
 */



// rebuy.js is loaded async and Smart Cart mounts a Vue app after that, so on the first
// add of a session it may not be ready at the moment the customer clicks.
var READY_TIMEOUT_MS = 5000;
var POLL_INTERVAL_MS = 100;
var lastKnownCart = null;
function smartCart() {
  var rebuy = typeof window !== 'undefined' ? window.Rebuy : null;
  if (!rebuy) return null;
  return rebuy.SmartCart || rebuy.smartCart || null;
}
function isReady(cart) {
  return !!(cart && typeof cart.show === 'function');
}
function isRebuyLoaded() {
  return !!(typeof window !== 'undefined' && window.Rebuy);
}
function isRebuyCartAvailable() {
  return isReady(smartCart());
}
function waitForSmartCart(timeoutMs) {
  return new Promise(function (resolve) {
    var cart = smartCart();
    if (isReady(cart)) {
      resolve(cart);
      return;
    }
    var deadline = Date.now() + timeoutMs;
    var timer = setInterval(function () {
      cart = smartCart();
      if (isReady(cart)) {
        clearInterval(timer);
        resolve(cart);
      } else if (Date.now() > deadline) {
        clearInterval(timer);
        resolve(null);
      }
    }, POLL_INTERVAL_MS);
  });
}

/**
 * Re-renders Smart Cart from the given cart, so its lines aren't stale.
 *
 * setCartAsync reads `cart.items`, so the cart MUST be passed in — calling it bare throws
 * "Cannot read properties of undefined (reading 'items')". Pass the cart you already have
 * (e.g. the response from /cart/update.js) and this avoids a redundant fetch.
 */
function refreshRebuyCart(_x) {
  return _refreshRebuyCart.apply(this, arguments);
}

/**
 * Waits for Smart Cart to be ready, re-reads the cart we just changed, then opens it.
 * Resolves true only if the drawer was actually shown.
 */
function _refreshRebuyCart() {
  _refreshRebuyCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(cart) {
    var smart, data, res, _t2, _t3;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          smart = smartCart();
          if (smart) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2);
        case 1:
          data = cart;
          if (data) {
            _context2.n = 7;
            break;
          }
          _context2.p = 2;
          _context2.n = 3;
          return fetch('/cart.js', {
            headers: {
              Accept: 'application/json'
            }
          });
        case 3:
          res = _context2.v;
          if (!res.ok) {
            _context2.n = 5;
            break;
          }
          _context2.n = 4;
          return res.json();
        case 4:
          data = _context2.v;
        case 5:
          _context2.n = 7;
          break;
        case 6:
          _context2.p = 6;
          _t2 = _context2.v;
        case 7:
          _context2.p = 7;
          if (!(data && typeof smart.setCartAsync === 'function')) {
            _context2.n = 9;
            break;
          }
          _context2.n = 8;
          return smart.setCartAsync(data);
        case 8:
          _context2.n = 10;
          break;
        case 9:
          if (typeof smart.handleCartChangeEvent === 'function') {
            smart.handleCartChangeEvent();
          }
        case 10:
          _context2.n = 12;
          break;
        case 11:
          _context2.p = 11;
          _t3 = _context2.v;
          console.warn('[Coava] Rebuy Smart Cart refresh failed:', _t3);
        case 12:
          return _context2.a(2);
      }
    }, _callee2, null, [[7, 11], [2, 6]]);
  }));
  return _refreshRebuyCart.apply(this, arguments);
}
function openRebuyCart() {
  return _openRebuyCart.apply(this, arguments);
}
function _openRebuyCart() {
  _openRebuyCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
    var cart, _t4;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return waitForSmartCart(READY_TIMEOUT_MS);
        case 1:
          cart = _context3.v;
          if (cart) {
            _context3.n = 2;
            break;
          }
          console.warn("[Coava] Rebuy Smart Cart never became ready within ".concat(READY_TIMEOUT_MS, "ms."), {
            rebuyLoaded: isRebuyLoaded(),
            smartCartFound: !!smartCart()
          });
          return _context3.a(2, false);
        case 2:
          _context3.n = 3;
          return refreshRebuyCart();
        case 3:
          _context3.p = 3;
          cart.show();
          return _context3.a(2, true);
        case 4:
          _context3.p = 4;
          _t4 = _context3.v;
          console.error('[Coava] Rebuy Smart Cart show() threw:', _t4);
          return _context3.a(2, false);
      }
    }, _callee3, null, [[3, 4]]);
  }));
  return _openRebuyCart.apply(this, arguments);
}
var WATCH_INTERVAL_MS = 800;
function cartSignature(cart) {
  return (cart && cart.items || []).map(function (l) {
    return "".concat(l.key, ":").concat(l.quantity);
  }).join('|');
}

/**
 * Stops Rebuy's `+` from being clickable once the subscription is at its bag count, rather
 * than letting the quantity jump and then having the guard revert it.
 *
 * Smart Cart's template calls `canIncreaseQuantity(item)` to decide whether `+` is enabled,
 * and resolves it off the instance — verified by overriding it and watching all three
 * buttons go disabled. Note its body calls `getEffectiveQuantityLimits` as a closure
 * variable, so patching *that* would do nothing; `canIncreaseQuantity` is the only usable
 * seam. Add-ons and ordinary products fall straight through to Rebuy's own logic.
 *
 * Re-applied on every tick because Rebuy's `reInit` would otherwise silently drop it.
 */
var NOTICE_ID = 'coava-cart-notice';

/**
 * Tells the customer why checkout is blocked, since Rebuy exposes no hook for our own
 * validation messages. Injected into the drawer footer, above the checkout button.
 * Styles are inline because our component CSS is scoped and can't reach Rebuy's DOM.
 */
function renderSubscriptionNotice(cart) {
  var footer = document.querySelector('.rebuy-cart__flyout-footer');
  if (!footer) return;
  var _short = (0,_subscriptionCartGuard_js__WEBPACK_IMPORTED_MODULE_0__.subscriptionHeadroom)(cart);
  var notice = document.getElementById(NOTICE_ID);
  if (_short <= 0) {
    if (notice) notice.remove();
    return;
  }
  if (!notice) {
    notice = document.createElement('p');
    notice.id = NOTICE_ID;
    notice.setAttribute('role', 'alert');
    notice.style.cssText = 'margin:0 0 14px;padding:10px 12px;background:#fdeaec;' + 'color:#991522;font-size:13px;line-height:18px;text-align:center;';
    footer.insertBefore(notice, footer.firstChild);
  }
  var bags = (0,_subscriptionCartGuard_js__WEBPACK_IMPORTED_MODULE_0__.subscriptionPlanBags)(cart);
  var chosen = bags - _short;
  notice.textContent = "Your subscription needs ".concat(bags, " bags \u2014 ").concat(chosen, " selected. ") + "Add ".concat(_short, " more to check out.");
}

/**
 * Blocks checkout while the subscription is short of its bag count.
 *
 * Same seam as canIncreaseQuantity: Smart Cart's template resolves `checkout` off the
 * instance, so wrapping the property intercepts the button.
 */
function ensureCheckoutPatch(smart) {
  if (!smart || typeof smart.checkout !== 'function') return;
  if (smart.checkout.__coavaPatched) return;
  var original = smart.checkout;
  function patched() {
    var cart = smart.cart && smart.cart.items ? smart.cart : lastKnownCart;
    if ((0,_subscriptionCartGuard_js__WEBPACK_IMPORTED_MODULE_0__.subscriptionHeadroom)(cart) > 0) {
      renderSubscriptionNotice(cart);
      return undefined;
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return original.apply(this, args);
  }
  patched.__coavaPatched = true;
  smart.checkout = patched;
}
function ensureQuantityLimitPatch(smart) {
  if (!smart || typeof smart.canIncreaseQuantity !== 'function') return;
  if (smart.canIncreaseQuantity.__coavaPatched) return;
  var original = smart.canIncreaseQuantity;
  function patched(item) {
    // smart.cart is what's being rendered, so it's the right basis for the decision.
    var cart = smart.cart && smart.cart.items ? smart.cart : lastKnownCart;
    if ((0,_subscriptionCartGuard_js__WEBPACK_IMPORTED_MODULE_0__.isSubscriptionLine)(item) && (0,_subscriptionCartGuard_js__WEBPACK_IMPORTED_MODULE_0__.subscriptionHeadroom)(cart) <= 0) return false;
    return original.call(this, item);
  }
  patched.__coavaPatched = true;
  smart.canIncreaseQuantity = patched;
}

/**
 * Calls onChange(cart) whenever the customer edits the cart from inside Smart Cart.
 *
 * Rebuy mutates the Shopify cart directly and doesn't notify the page, so we poll
 * /cart.js — but only while the drawer is actually on screen, plus one final read once
 * it closes. That keeps it cheap and covers the drawer being opened from the header
 * cart icon as well as from the subscription builder.
 *
 * For instant updates instead of polling, enable Rebuy → Smart Cart → Global Settings →
 * Event Callbacks (LineItemRemoved / LineItemIncrease / LineItemDecrease) and have each
 * call window.coavaSyncBuilderFromCart().
 *
 * Returns a stop function.
 */
function watchRebuyCart(onChange) {
  var signature = null;
  var wasVisible = false;
  var checking = false;
  function check() {
    return _check.apply(this, arguments);
  }
  function _check() {
    _check = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var res, cart, next, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!checking) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            checking = true;
            _context.p = 2;
            _context.n = 3;
            return fetch('/cart.js', {
              headers: {
                Accept: 'application/json'
              }
            });
          case 3:
            res = _context.v;
            if (res.ok) {
              _context.n = 4;
              break;
            }
            return _context.a(2);
          case 4:
            _context.n = 5;
            return res.json();
          case 5:
            cart = _context.v;
            lastKnownCart = cart;
            next = cartSignature(cart);
            if (signature === null) {
              signature = next; // first read after opening is the baseline, not a change
            } else if (next !== signature) {
              signature = next;
              onChange(cart);
            }
            _context.n = 7;
            break;
          case 6:
            _context.p = 6;
            _t = _context.v;
          case 7:
            _context.p = 7;
            checking = false;
            return _context.f(7);
          case 8:
            return _context.a(2);
        }
      }, _callee, null, [[2, 6, 7, 8]]);
    }));
    return _check.apply(this, arguments);
  }
  var timer = setInterval(function () {
    var smart = smartCart();
    // Both install once Smart Cart mounts, and survive Rebuy's reInit dropping them.
    ensureQuantityLimitPatch(smart);
    ensureCheckoutPatch(smart);
    var visible = !!(smart && smart.visible);
    // Keep the notice current so the customer sees the shortfall before clicking checkout.
    if (visible) renderSubscriptionNotice(smart.cart && smart.cart.items ? smart.cart : lastKnownCart);
    if (visible || wasVisible) check();
    wasVisible = visible;
  }, WATCH_INTERVAL_MS);
  return function () {
    return clearInterval(timer);
  };
}

/***/ }),

/***/ "./js/components/sharePopup.js":
/*!*************************************!*\
  !*** ./js/components/sharePopup.js ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SharePopup)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SharePopup = /*#__PURE__*/function () {
  function SharePopup() {
    _classCallCheck(this, SharePopup);
  }
  return _createClass(SharePopup, null, [{
    key: "open",
    value: function open(href) {
      var w = 600;
      var h = 300;
      var left = window.screen.width / 2 - w / 2;
      var top = window.screen.height / 2 - h / 2;
      window.open(href, 'coava', "location=1,status=1,scrollbars=1, width=".concat(w, ",height=").concat(h, ",top=").concat(top, ",left=").concat(left));
    }
  }]);
}();


/***/ }),

/***/ "./js/components/slider.js":
/*!*********************************!*\
  !*** ./js/components/slider.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! swiper */ "./node_modules/swiper/swiper.mjs");
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! swiper/modules */ "./node_modules/swiper/modules/index.mjs");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var Slider = /*#__PURE__*/function () {
  function Slider() {
    _classCallCheck(this, Slider);
    this.sliders = [];
    this.initSliders();
  }
  return _createClass(Slider, [{
    key: "initSliders",
    value: function initSliders() {
      var _this = this;
      // Initialize regular sliders
      var regularSliders = document.querySelectorAll('.js-slider');
      regularSliders.forEach(function (slider) {
        _this.setupSlider(slider);
      });

      // Initialize product sliders
      var productSliders = document.querySelectorAll('.js-slider--product');
      productSliders.forEach(function (slider) {
        _this.setupProductSlider(slider);
      });
    }
  }, {
    key: "createStatusMessageRegion",
    value: function createStatusMessageRegion() {
      // Create status message region compliant with WCAG 2.2 SC 4.1.3
      var statusRegion = document.createElement('div');
      statusRegion.setAttribute('role', 'status');
      statusRegion.setAttribute('aria-live', 'polite');
      statusRegion.setAttribute('aria-atomic', 'true');
      statusRegion.className = 'sr-only';
      statusRegion.style.cssText = 'position: absolute; left: -10000px; width: 1px; height: 1px; overflow: hidden;';
      return statusRegion;
    }
  }, {
    key: "announceStatusMessage",
    value: function announceStatusMessage(swiper, statusRegion) {
      var _currentSlideElement$;
      var currentSlide = swiper.realIndex + 1;
      var totalSlides = swiper.slides.length;

      // Get slide content - prioritize aria-label, then alt text, then text content
      var currentSlideElement = swiper.slides[swiper.realIndex];
      var slideLabel = currentSlideElement.getAttribute('aria-label') || ((_currentSlideElement$ = currentSlideElement.querySelector('img')) === null || _currentSlideElement$ === void 0 ? void 0 : _currentSlideElement$.getAttribute('alt')) || currentSlideElement.textContent.trim();
      var statusMessage = "Slide ".concat(currentSlide, " of ").concat(totalSlides);
      statusRegion.textContent = statusMessage;
    }
  }, {
    key: "setupSlider",
    value: function setupSlider(element) {
      var _this2 = this;
      // Create status message region for WCAG 2.2 compliance
      var statusRegion = this.createStatusMessageRegion();
      element.appendChild(statusRegion);
      var slider = new swiper__WEBPACK_IMPORTED_MODULE_0__["default"](element, {
        modules: [swiper_modules__WEBPACK_IMPORTED_MODULE_1__.Navigation, swiper_modules__WEBPACK_IMPORTED_MODULE_1__.Pagination, swiper_modules__WEBPACK_IMPORTED_MODULE_1__.A11y],
        slidesPerView: 1,
        loop: true,
        autoplay: {
          delay: 1000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.slider-pager',
          clickable: true,
          bulletElement: 'span',
          bulletClass: 'slider-pager-bullet',
          bulletActiveClass: 'is-active',
          enabled: true
        },
        a11y: true,
        on: {
          init: function init(swiper) {
            // Add click handler to slides
            swiper.slides.forEach(function (slide) {
              slide.addEventListener('click', function () {
                swiper.slideNext();
              });
            });

            // Announce initial slide status
            _this2.announceStatusMessage(swiper, statusRegion);
          },
          slideChange: function slideChange(swiper) {
            // Announce slide change status (WCAG 2.2 SC 4.1.3)
            _this2.announceStatusMessage(swiper, statusRegion);
          }
        }
      });
      this.sliders.push(slider);
      return slider;
    }
  }, {
    key: "setupProductSlider",
    value: function setupProductSlider(element) {
      var _this3 = this;
      // Create status message region for WCAG 2.2 compliance
      var statusRegion = this.createStatusMessageRegion();
      element.appendChild(statusRegion);
      var slider = new swiper__WEBPACK_IMPORTED_MODULE_0__["default"](element, {
        modules: [swiper_modules__WEBPACK_IMPORTED_MODULE_1__.Navigation, swiper_modules__WEBPACK_IMPORTED_MODULE_1__.Pagination, swiper_modules__WEBPACK_IMPORTED_MODULE_1__.A11y],
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: '.slider-pager',
          clickable: true,
          bulletElement: 'span',
          bulletClass: 'slider-pager-bullet',
          bulletActiveClass: 'is-active',
          enabled: true
        },
        a11y: true,
        autoHeight: true,
        on: {
          init: function init(swiper) {
            // Add click handler to slides
            swiper.slides.forEach(function (slide) {
              slide.addEventListener('click', function () {
                swiper.slideNext();
              });
            });

            // Announce initial slide status
            _this3.announceStatusMessage(swiper, statusRegion);
          },
          slideChange: function slideChange(swiper) {
            // Announce slide change status (WCAG 2.2 SC 4.1.3)
            _this3.announceStatusMessage(swiper, statusRegion);
          }
        }
      });

      // Handle variant changes
      document.addEventListener('goToSlide', function (event) {
        var variantId = event.detail.variantId;
        var slides = element.querySelectorAll('.slider-item');

        // Find slide with matching variant ID
        var targetSlide = _toConsumableArray(slides).findIndex(function (slide) {
          var variantIds = slide.dataset.variantIds;
          return variantIds && variantIds.split(',').includes(String(variantId));
        });
        if (targetSlide >= 0) {
          slider.slideTo(targetSlide);
        }
      });
      this.sliders.push(slider);
      return slider;
    }
  }], [{
    key: "init",
    value: function init() {
      return new Slider();
    }
  }]);
}();
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Slider);

/***/ }),

/***/ "./js/components/subscriptionBuilder.svelte":
/*!**************************************************!*\
  !*** ./js/components/subscriptionBuilder.svelte ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/internal/index.mjs");
/* harmony import */ var svelte__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte */ "./node_modules/svelte/index.mjs");
/* harmony import */ var _subscriptions_hiddenField_svelte__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./subscriptions/hiddenField.svelte */ "./js/components/subscriptions/hiddenField.svelte");
/* harmony import */ var _rebuyCart_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./rebuyCart.js */ "./js/components/rebuyCart.js");
/* harmony import */ var _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./subscriptions/stores.js */ "./js/components/subscriptions/stores.js");
/* js/components/subscriptionBuilder.svelte generated by Svelte v3.59.2 */


const { Error: Error_1, Object: Object_1, console: console_1 } = svelte_internal__WEBPACK_IMPORTED_MODULE_0__.globals;






const file = "js/components/subscriptionBuilder.svelte";

function add_css(target) {
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_styles)(target, "svelte-12epoft", ".sb.svelte-12epoft.svelte-12epoft{width:100%;max-width:none;margin:0 auto;padding:0 clamp(24px, 5vw, 90px) 48px;font-family:inherit;font-size:18px;box-sizing:border-box;display:grid;grid-template-columns:160px 1fr;align-items:start;gap:0 28px}.sb-main.svelte-12epoft.svelte-12epoft{min-width:0}.sb-steps.svelte-12epoft.svelte-12epoft{display:flex;flex-direction:column;align-items:flex-start;padding-top:28px;padding-right:0;border-right:2px solid #ede5db;margin-right:0;position:sticky;top:20px}.sb-step.svelte-12epoft.svelte-12epoft{display:flex;flex-direction:row;align-items:center;gap:10px;background:none;border:none;cursor:pointer;padding:5px 12px 5px 0;opacity:0.32;transition:opacity 0.2s;text-align:left;width:100%}.sb-step.svelte-12epoft.svelte-12epoft:disabled{cursor:default}.sb-step.is-active.svelte-12epoft.svelte-12epoft,.sb-step.is-done.svelte-12epoft.svelte-12epoft{opacity:1}.sb-step-circle.svelte-12epoft.svelte-12epoft{width:34px;height:34px;flex-shrink:0;border-radius:50%;border:2px solid #767676;display:flex;align-items:center;justify-content:center;font-size:0.82em;font-weight:800;color:#7a6a5a;background:white;transition:background 0.25s, border-color 0.25s, color 0.25s}.sb-step.is-active.svelte-12epoft .sb-step-circle.svelte-12epoft{background:#3b2314;border-color:#3b2314;color:white}.sb-step.is-done.svelte-12epoft .sb-step-circle.svelte-12epoft{background:#8a5a28;border-color:#8a5a28;color:white}.sb-step-label.svelte-12epoft.svelte-12epoft{font-size:0.62em;text-transform:uppercase;letter-spacing:0.07em;color:#595959;white-space:nowrap;font-weight:600;line-height:1.3}.sb-step.is-active.svelte-12epoft .sb-step-label.svelte-12epoft{color:#3b2314;font-weight:800}.sb-step.is-done.svelte-12epoft .sb-step-label.svelte-12epoft{color:#8a5a28}.sb-step-line.svelte-12epoft.svelte-12epoft{width:2px;height:22px;background:#ede5db;margin:1px 0 1px 16px;flex-shrink:0;transition:background 0.4s}.sb-step-line.is-done.svelte-12epoft.svelte-12epoft{background:#c2976a}.sb-panel.svelte-12epoft.svelte-12epoft{background:#fff;border:1px solid #e8ddd2;border-radius:14px;padding:24px 28px 20px;box-shadow:0 4px 24px rgba(59,35,20,0.07), 0 1px 4px rgba(59,35,20,0.04)}.sb-panel-header.svelte-12epoft.svelte-12epoft{margin-bottom:20px}.sb-save-note.svelte-12epoft.svelte-12epoft{display:inline-block;margin:8px 0 0;font-size:0.76em;font-weight:600;color:#be1e2d;background:rgba(190, 30, 45, 0.07);padding:4px 12px;border-radius:20px}.sb-panel-meta.svelte-12epoft.svelte-12epoft{font-size:0.75em;font-weight:700;text-transform:uppercase;letter-spacing:0.12em;color:#8a5a28;margin:0 0 6px}.sb-panel-title.svelte-12epoft.svelte-12epoft{font-size:1.75em;font-weight:800;color:#3b2314;margin:0;line-height:1.15;font-family:\"din-condensed-web\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;text-transform:uppercase;letter-spacing:0.01em;display:flex;align-items:center;flex-wrap:wrap;gap:10px}.sb-field-label.svelte-12epoft.svelte-12epoft{font-size:0.73em;font-weight:700;text-transform:uppercase;letter-spacing:0.09em;color:#7a6a5a;margin-bottom:10px;display:block;white-space:nowrap}.sb-step1-stack.svelte-12epoft.svelte-12epoft{display:flex;flex-direction:column;gap:28px}.sb-size-group.svelte-12epoft.svelte-12epoft{margin-bottom:4px}.sb-size-group.svelte-12epoft+.sb-size-group.svelte-12epoft{margin-top:12px}.sb-size-group-label.svelte-12epoft.svelte-12epoft{font-size:0.7em;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:#595959;margin-bottom:8px}.sb-size-grid.svelte-12epoft.svelte-12epoft{display:grid;grid-template-columns:repeat(auto-fill, minmax(210px, 260px));gap:8px}@media(max-width: 480px){.sb-size-grid.svelte-12epoft.svelte-12epoft{grid-template-columns:1fr}}.sb-size-tile.svelte-12epoft.svelte-12epoft{border:2px solid #767676;border-radius:10px;padding:10px 14px;min-height:54px;cursor:pointer;background:white;transition:border-color 0.18s, background 0.18s, box-shadow 0.18s;display:flex;align-items:center;justify-content:space-between;gap:8px;text-align:left;position:relative;width:100%;box-sizing:border-box}.sb-size-tile.svelte-12epoft.svelte-12epoft:hover{border-color:#c2976a;box-shadow:0 2px 8px rgba(194,151,106,0.22)}.sb-size-tile.is-selected.svelte-12epoft.svelte-12epoft{background:#3b2314;border-color:#3b2314;box-shadow:0 4px 14px rgba(59,35,20,0.22)}.sb-size-main.svelte-12epoft.svelte-12epoft{font-size:0.92em;font-weight:800;color:#3b2314;transition:color 0.18s;white-space:nowrap}.sb-size-tile.is-selected.svelte-12epoft .sb-size-main.svelte-12epoft{color:white}.sb-size-tile-right.svelte-12epoft.svelte-12epoft{display:flex;flex-direction:column;align-items:flex-end;gap:2px;flex-shrink:0}.sb-size-orig.svelte-12epoft.svelte-12epoft{font-size:0.72em;color:#595959;text-decoration:line-through;white-space:nowrap;transition:color 0.18s}.sb-size-disc.svelte-12epoft.svelte-12epoft{font-size:0.85em;font-weight:700;color:#9f6a33;white-space:nowrap;transition:color 0.18s}.sb-size-tile.is-selected.svelte-12epoft .sb-size-orig.svelte-12epoft{color:rgba(255,255,255,0.55)}.sb-size-tile.is-selected.svelte-12epoft .sb-size-disc.svelte-12epoft{color:#ffffff}.sb-freq-col.svelte-12epoft.svelte-12epoft{display:flex;flex-direction:column;gap:8px}.sb-freq-btn.svelte-12epoft.svelte-12epoft{border:1.5px solid #767676;border-radius:7px;padding:11px 14px;text-align:left;cursor:pointer;background:white;transition:border-color 0.15s, background 0.15s;width:100%}.sb-freq-btn.svelte-12epoft.svelte-12epoft:hover{border-color:#c2976a;box-shadow:0 2px 8px rgba(194,151,106,0.22)}.sb-freq-btn.is-selected.svelte-12epoft.svelte-12epoft{background:#3b2314;border-color:#3b2314;box-shadow:0 4px 14px rgba(59,35,20,0.22)}.sb-freq-main.svelte-12epoft.svelte-12epoft{display:block;font-size:0.9em;font-weight:700;color:#3b2314;transition:color 0.15s}.sb-freq-sub.svelte-12epoft.svelte-12epoft{display:block;font-size:0.76em;color:#7a6a5a;margin-top:2px;transition:color 0.15s}.sb-freq-btn.is-selected.svelte-12epoft .sb-freq-main.svelte-12epoft{color:white}.sb-freq-btn.is-selected.svelte-12epoft .sb-freq-sub.svelte-12epoft{color:rgba(255,255,255,0.72)}.sb-price-strip.svelte-12epoft.svelte-12epoft{margin-top:14px;padding:12px 14px;background:#f9f4ef;border-radius:7px}.sb-price-line.svelte-12epoft.svelte-12epoft{display:flex;align-items:center;gap:6px;flex-wrap:wrap}.sb-price-amount.svelte-12epoft.svelte-12epoft{font-size:1.25em;font-weight:700;color:#3b2314}.sb-price-period.svelte-12epoft.svelte-12epoft{font-size:0.72em;font-weight:400;color:#7a6a5a}.sb-badge-discount.svelte-12epoft.svelte-12epoft{display:inline-block;background:#be1e2d;color:white;font-size:0.72em;padding:2px 7px;border-radius:10px;font-weight:600;margin-left:6px}.sb-price-original.svelte-12epoft.svelte-12epoft{font-size:0.82em;color:#9c8878;text-decoration:line-through;margin-right:4px;font-weight:400}.sb-price-perbag.svelte-12epoft.svelte-12epoft{font-size:0.78em;color:#7a6a5a;margin-top:3px}.sb-price-nudge.svelte-12epoft.svelte-12epoft{font-size:0.78em;font-weight:600;color:#b07c2c;margin-top:5px}.sb-price-total.svelte-12epoft.svelte-12epoft{font-size:0.88em;font-weight:700;color:#3b2314;margin-top:8px;padding-top:8px;border-top:1px solid #e8ddd2}.sb-filters-bar.svelte-12epoft.svelte-12epoft{display:flex;flex-direction:column;gap:14px;margin-bottom:20px;border:1.5px solid #e3d8cc;border-radius:12px;padding:16px 18px;background:linear-gradient(135deg, #fdf9f5 0%, #f8f2eb 100%);box-shadow:0 2px 8px rgba(59,35,20,0.05)}.sb-filters-header.svelte-12epoft.svelte-12epoft{display:flex;align-items:center;justify-content:space-between}.sb-filters-title.svelte-12epoft.svelte-12epoft{display:flex;align-items:center;gap:6px;font-size:0.72em;font-weight:700;text-transform:uppercase;letter-spacing:0.11em;color:#6b4a1f}.sb-filters-clear.svelte-12epoft.svelte-12epoft{border:none;background:none;font-size:0.76em;font-weight:600;color:#be1e2d;cursor:pointer;padding:3px 8px;border-radius:20px;transition:background 0.15s}.sb-filters-clear.svelte-12epoft.svelte-12epoft:hover{background:rgba(190,30,45,0.08)}.sb-filters-divider.svelte-12epoft.svelte-12epoft{height:1px;background:linear-gradient(to right, #e3d8cc, transparent);margin:-4px 0 0}.sb-filter-group.svelte-12epoft.svelte-12epoft{display:flex;flex-direction:column;gap:8px}.sb-filter-group-label.svelte-12epoft.svelte-12epoft{font-size:0.68em;font-weight:700;text-transform:uppercase;letter-spacing:0.1em;color:#595959}.sb-filter-required.svelte-12epoft.svelte-12epoft{color:#c2976a;font-weight:900}.sb-segment.svelte-12epoft.svelte-12epoft{display:inline-flex;border:1.5px solid #767676;border-radius:8px;overflow:hidden;background:white;width:fit-content}.sb-segment-btn.svelte-12epoft.svelte-12epoft{padding:7px 22px;font-size:0.88em;font-weight:700;cursor:pointer;background:transparent;color:#595959;border:none;transition:background 0.15s, color 0.15s;letter-spacing:0.02em}.sb-segment-btn.svelte-12epoft+.sb-segment-btn.svelte-12epoft{border-left:1.5px solid #767676}.sb-segment-btn.svelte-12epoft.svelte-12epoft:hover:not(.is-selected){background:#f5ede3;color:#3b2314}.sb-segment-btn.is-selected.svelte-12epoft.svelte-12epoft{background:#3b2314;color:white}.sb-segment.is-attention.svelte-12epoft.svelte-12epoft{border-color:#9f6a33;animation:svelte-12epoft-sb-target-pulse 1.8s ease-in-out infinite}.sb-filter-grid.svelte-12epoft.svelte-12epoft{display:grid;grid-template-columns:1fr 1fr;gap:18px 24px;padding-top:2px}.sb-filter-col.svelte-12epoft.svelte-12epoft{display:flex;flex-direction:column;gap:14px;border-radius:10px;padding:14px 16px;background:#ffffff;border:1.5px solid #e3d8cc}.sb-filter-col-header.svelte-12epoft.svelte-12epoft{display:flex;flex-direction:column;gap:2px}.sb-filter-col-title.svelte-12epoft.svelte-12epoft{font-size:0.72em;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;color:#7a6a5a}.sb-filter-col-subtitle.svelte-12epoft.svelte-12epoft{font-size:0.74em;color:#595959}@media(max-width: 1024px){.sb-filter-grid.svelte-12epoft.svelte-12epoft{grid-template-columns:1fr}}.sb-chip-row.svelte-12epoft.svelte-12epoft{display:flex;gap:5px;flex-wrap:wrap;align-items:center}.sb-chip.svelte-12epoft.svelte-12epoft{border:1.5px solid #767676;border-radius:20px;padding:4px 11px;font-size:0.78em;font-weight:500;cursor:pointer;background:white;color:#5a4a3a;white-space:nowrap;transition:border-color 0.15s, background 0.15s, color 0.15s, box-shadow 0.15s}.sb-chip.svelte-12epoft.svelte-12epoft:hover:not(:disabled):not(.is-selected){border-color:#c2976a;background:#fdf5ea;color:#3b2314}.sb-chip.svelte-12epoft.svelte-12epoft:disabled{opacity:0.42;cursor:not-allowed;background:#f4f1ec;text-decoration:line-through}.sb-chip.is-selected.svelte-12epoft.svelte-12epoft:hover{border-color:#7a5522;background:#7a5522}.sb-chip.is-selected.svelte-12epoft.svelte-12epoft{border-color:#96692a;background:#96692a;color:white;box-shadow:0 2px 6px rgba(176,124,44,0.28)}.sb-coffee-grid.svelte-12epoft.svelte-12epoft{display:grid;grid-template-columns:repeat(4, 1fr);gap:16px;margin-bottom:16px}.sb-coffee-card.svelte-12epoft.svelte-12epoft{border:1.5px solid #dccfbf;border-radius:12px;overflow:hidden;cursor:pointer;background:white;text-align:center;display:flex;flex-direction:column;box-shadow:0 1px 6px rgba(59,35,20,0.07);transition:border-color 0.2s, box-shadow 0.2s, transform 0.18s}.sb-coffee-card.svelte-12epoft.svelte-12epoft:hover{border-color:#c2976a;box-shadow:0 8px 22px rgba(194,151,106,0.2);transform:translateY(-3px)}.sb-coffee-card.is-selected.svelte-12epoft.svelte-12epoft{border:2px solid #9f6a33;box-shadow:0 8px 22px rgba(159,106,51,0.24);transform:translateY(-3px)}.sb-coffee-card.is-roast-disabled.svelte-12epoft.svelte-12epoft{opacity:0.48;cursor:default}.sb-coffee-card.is-roast-disabled.svelte-12epoft.svelte-12epoft:hover{border-color:#dccfbf;box-shadow:0 1px 6px rgba(59,35,20,0.07);transform:none}.sb-roast-unavail.svelte-12epoft.svelte-12epoft{position:absolute;bottom:0;left:0;right:0;background:rgba(30, 20, 10, 0.68);color:#fff;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.06em;text-align:center;padding:5px 8px}.sb-coffee-img.svelte-12epoft.svelte-12epoft{width:100%;height:230px;background:#fff;position:relative;flex-shrink:0;overflow:hidden}.sb-coffee-card.is-selected.svelte-12epoft .sb-coffee-img.svelte-12epoft{background:#fff}.sb-coffee-img.svelte-12epoft img.svelte-12epoft{width:100%;height:100%;object-fit:contain;padding:10px;box-sizing:border-box;display:block;transition:transform 0.3s ease}.sb-coffee-card.svelte-12epoft:hover .sb-coffee-img img.svelte-12epoft{transform:scale(1.06)}.sb-coffee-check.svelte-12epoft.svelte-12epoft{position:absolute;top:6px;right:6px;background:#9f6a33;color:white;width:22px;height:22px;border-radius:50%;font-size:0.72em;font-weight:900;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 6px rgba(0,0,0,0.18)}.sb-coffee-qty-badge.svelte-12epoft.svelte-12epoft{position:absolute;top:6px;right:6px;background:#9f6a33;color:white;min-width:24px;height:24px;padding:0 6px;border-radius:12px;font-size:0.8em;font-weight:900;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 6px rgba(0,0,0,0.2)}.sb-coffee-stepper.svelte-12epoft.svelte-12epoft{display:flex;align-items:center;justify-content:center;gap:10px;margin-top:4px}.sb-coffee-roasts.svelte-12epoft.svelte-12epoft{display:flex;flex-direction:column;gap:4px;margin-top:8px;width:100%;border-top:1px solid #ede6db;padding-top:8px}.sb-stepper-row.svelte-12epoft.svelte-12epoft{display:flex;align-items:center;justify-content:space-between;width:100%;gap:4px}.sb-roast-label.svelte-12epoft.svelte-12epoft{font-size:0.75em;font-weight:700;color:#7a5c35;flex:1;text-align:left}.sb-roast-stepper.svelte-12epoft.svelte-12epoft{display:flex;align-items:center;gap:6px}.sb-curated-roast-row.svelte-12epoft.svelte-12epoft{display:flex;align-items:center;flex-wrap:wrap;gap:6px;margin-top:8px;width:100%;justify-content:center}.sb-curated-roast-label.svelte-12epoft.svelte-12epoft{font-size:0.78em;font-weight:600;color:#6b4f35;width:100%;text-align:center;margin-bottom:2px}.sb-roast-chip.svelte-12epoft.svelte-12epoft{display:inline-flex;align-items:center;padding:3px 10px;border-radius:20px;border:1.5px solid #c4a07a;background:#fff;color:#6b4f35;font-size:0.78em;font-weight:600;cursor:pointer;transition:background 0.15s, color 0.15s}.sb-roast-chip.is-active.svelte-12epoft.svelte-12epoft{background:#9f6a33;border-color:#9f6a33;color:#fff}.sb-curated-roast-hint.svelte-12epoft.svelte-12epoft{font-size:0.75em;color:#c05c1a;margin:4px 0 0;font-weight:500}.sb-curated-remove.svelte-12epoft.svelte-12epoft{display:inline-block;margin-top:8px;background:none;border:none;color:#999;font-size:0.75em;cursor:pointer;text-decoration:underline;padding:0}.sb-curated-remove.svelte-12epoft.svelte-12epoft:hover{color:#c0392b}.sb-progress.svelte-12epoft.svelte-12epoft{margin-bottom:16px;padding:12px 14px;background:#faf6f1;border:1px solid #ece2d6;border-radius:10px}.sb-progress-head.svelte-12epoft.svelte-12epoft{display:flex;align-items:baseline;justify-content:space-between;gap:10px;margin-bottom:8px}.sb-progress-title.svelte-12epoft.svelte-12epoft{font-size:0.78em;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;color:#3b2314}.sb-progress-count.svelte-12epoft.svelte-12epoft{font-size:0.82em;font-weight:700;color:#595959;white-space:nowrap}.sb-progress-count.is-complete.svelte-12epoft.svelte-12epoft{color:#1e6b34}.sb-progress-track.svelte-12epoft.svelte-12epoft{height:8px;border-radius:5px;background:#ece2d6;overflow:hidden}.sb-progress-fill.svelte-12epoft.svelte-12epoft{height:100%;background:linear-gradient(90deg, #c2976a 0%, #9f6a33 100%);border-radius:5px;transition:width 0.35s cubic-bezier(0.2, 0.8, 0.3, 1)}.sb-progress-hint.svelte-12epoft.svelte-12epoft{display:flex;align-items:center;gap:8px;margin:9px 0 0;font-size:0.8em;font-weight:600;color:#595959}.sb-progress-hint.svelte-12epoft .sb-step-guide-arrow.svelte-12epoft{background:#9f6a33;color:#fff}.sb-progress-hint--done.svelte-12epoft.svelte-12epoft{color:#1e6b34}.sb-coffee-info.svelte-12epoft.svelte-12epoft{padding:9px 10px 11px;display:flex;flex-direction:column;align-items:center;gap:5px;flex:1;border-top:1px solid #f0ebe3;width:100%;box-sizing:border-box}.sb-coffee-card.is-selected.svelte-12epoft .sb-coffee-info.svelte-12epoft{border-top-color:#edd9b8}.sb-coffee-name.svelte-12epoft.svelte-12epoft{font-size:0.84em;font-weight:800;color:#3b2314;line-height:1.3}.sb-coffee-tag-row.svelte-12epoft.svelte-12epoft{display:flex;flex-wrap:wrap;gap:3px;justify-content:center}.sb-coffee-tag.svelte-12epoft.svelte-12epoft{font-size:0.64em;font-weight:600;text-transform:capitalize;background:#f0e8dc;color:#7a5c35;padding:2px 6px;border-radius:8px;white-space:nowrap}.sb-coffee-card.is-selected.svelte-12epoft .sb-coffee-tag.svelte-12epoft{background:#f5e5c8;color:#7a3e0a}.sb-coffee-tag--flavor.svelte-12epoft.svelte-12epoft,.sb-coffee-tag--processing.svelte-12epoft.svelte-12epoft,.sb-coffee-tag--note.svelte-12epoft.svelte-12epoft{}.sb-no-results.svelte-12epoft.svelte-12epoft{font-size:0.85em;color:#7a6a5a;grid-column:1 / -1;padding:12px 0}.sb-summary-bar.svelte-12epoft.svelte-12epoft{display:flex;flex-wrap:wrap;align-items:center;gap:6px;padding:9px 12px;background:#f9f4ef;border-radius:7px;margin-bottom:16px;font-size:0.82em}.sb-summary-pill.svelte-12epoft.svelte-12epoft{color:#555;font-weight:500}.sb-summary-pill--coffee.svelte-12epoft.svelte-12epoft{color:#3b2314;font-weight:700}.sb-summary-sep.svelte-12epoft.svelte-12epoft{color:#ccc}.sb-summary-price.svelte-12epoft.svelte-12epoft{margin-left:auto;font-weight:700;color:#3b2314;white-space:nowrap}.sb-addon-intro.svelte-12epoft.svelte-12epoft{font-size:0.85em;color:#7a6a5a;margin:0 0 12px}.sb-carousel.svelte-12epoft.svelte-12epoft{display:grid;grid-template-columns:repeat(4, 1fr);gap:16px;margin-bottom:16px}.sb-carousel-card.svelte-12epoft.svelte-12epoft{border:1.5px solid #dccfbf;border-radius:12px;overflow:hidden;background:white;text-align:center;display:flex;flex-direction:column;box-shadow:0 1px 6px rgba(59,35,20,0.07);transition:border-color 0.2s, box-shadow 0.2s, transform 0.18s}.sb-carousel-card.svelte-12epoft .sb-coffee-info.svelte-12epoft{border-top:1px solid #f0ebe3}.sb-carousel-card.is-selected.svelte-12epoft .sb-coffee-info.svelte-12epoft{border-top-color:#edd9b8}.sb-carousel-card.svelte-12epoft.svelte-12epoft:hover{border-color:#c2976a;box-shadow:0 8px 22px rgba(194,151,106,0.2);transform:translateY(-3px)}.sb-carousel-card.is-selected.svelte-12epoft.svelte-12epoft{border:2px solid #9f6a33;box-shadow:0 8px 22px rgba(159,106,51,0.24);transform:translateY(-3px)}.sb-carousel-img.svelte-12epoft.svelte-12epoft{width:100%;height:230px;background:#fff;position:relative;flex-shrink:0;overflow:hidden}.sb-carousel-card.is-selected.svelte-12epoft .sb-carousel-img.svelte-12epoft{background:#fff}.sb-carousel-img.svelte-12epoft img.svelte-12epoft{width:100%;height:100%;object-fit:contain;padding:10px;box-sizing:border-box;display:block;transition:transform 0.3s ease}.sb-carousel-card.svelte-12epoft:hover .sb-carousel-img img.svelte-12epoft{transform:scale(1.06)}.sb-addon-list.svelte-12epoft.svelte-12epoft{display:flex;flex-direction:column;gap:8px;margin-bottom:16px}.sb-addon-row.svelte-12epoft.svelte-12epoft{display:flex;flex-wrap:wrap;align-items:center;gap:8px 14px;background:#f9f4ef;border:1px solid #ece2d6;border-radius:8px;padding:10px 12px}.sb-addon-row-name.svelte-12epoft.svelte-12epoft{font-weight:700;color:#3b2314;font-size:0.9em;flex:1 1 140px;min-width:0}.sb-addon-row-roast.svelte-12epoft.svelte-12epoft{font-size:0.72em;font-weight:700;text-transform:uppercase;letter-spacing:0.06em;color:#7a5c35;background:#f0e8dc;border-radius:20px;padding:3px 10px;white-space:nowrap;flex-shrink:0}.sb-addon-row-price.svelte-12epoft.svelte-12epoft{font-weight:700;color:#3b2314;font-size:0.88em;margin-left:auto;white-space:nowrap}.sb-addon-remove.svelte-12epoft.svelte-12epoft{border:none;background:none;color:#b07c2c;cursor:pointer;font-size:0.9em;padding:4px 6px;border-radius:6px;line-height:1;transition:background 0.15s, color 0.15s}.sb-addon-remove.svelte-12epoft.svelte-12epoft:hover{background:rgba(190,30,45,0.1);color:#be1e2d}.sb-qty-row.svelte-12epoft.svelte-12epoft{display:flex;align-items:center;gap:7px}.sb-qty-btn.svelte-12epoft.svelte-12epoft{width:28px;height:28px;border:1.5px solid #767676;border-radius:5px;background:white;cursor:pointer;font-size:1em;display:flex;align-items:center;justify-content:center;color:#3b2314;transition:border-color 0.15s}.sb-qty-btn.svelte-12epoft.svelte-12epoft:hover{border-color:#c2976a}.sb-qty-btn.svelte-12epoft.svelte-12epoft:disabled{opacity:0.35;cursor:default;border-color:#c4c4c4}.sb-qty-val.svelte-12epoft.svelte-12epoft{font-weight:700;min-width:22px;text-align:center;font-size:0.95em}.sb-onetime-badge.svelte-12epoft.svelte-12epoft{background:#e0d6cc;color:#777;font-size:0.82em;padding:1px 6px;border-radius:8px}.sb-order-summary.svelte-12epoft.svelte-12epoft{border-top:1px solid #f0ebe5;padding-top:18px;margin-top:16px}.sb-order-summary-title.svelte-12epoft.svelte-12epoft{font-size:0.72em;font-weight:700;text-transform:uppercase;letter-spacing:0.07em;color:#3b2314;margin-bottom:14px}.sb-extras.svelte-12epoft.svelte-12epoft{display:flex;flex-direction:column;gap:12px;margin-bottom:14px}.sb-extra-label.svelte-12epoft.svelte-12epoft{display:flex;flex-direction:column;gap:5px}.sb-total-row.svelte-12epoft.svelte-12epoft{display:flex;justify-content:space-between;align-items:center;padding:6px 0;border-top:1px solid #f5f1ed;font-size:0.85em}.sb-total-label.svelte-12epoft.svelte-12epoft{color:#7a6a5a}.sb-total-val.svelte-12epoft.svelte-12epoft{font-weight:600;color:#3b2314}.sb-total-free.svelte-12epoft.svelte-12epoft{color:#5a9a5a}.sb-total-muted.svelte-12epoft.svelte-12epoft{color:#9c8878;font-weight:500;font-size:0.9em;font-style:italic}.sb-total-row--grand.svelte-12epoft.svelte-12epoft{border-top:2px solid #e3d8cc;margin-top:4px;padding-top:10px}.sb-grand-label.svelte-12epoft.svelte-12epoft{font-weight:700;color:#3b2314;font-size:1em;text-transform:uppercase;letter-spacing:0.04em}.sb-grand-val.svelte-12epoft.svelte-12epoft{font-size:1.15em;font-weight:800;color:#3b2314}.sb-optional-tag.svelte-12epoft.svelte-12epoft{font-size:0.62em;background:#f0ebe5;color:#595959;padding:3px 8px;border-radius:9px;text-transform:uppercase;letter-spacing:0.05em;font-weight:400;vertical-align:middle}.sb-curated-note.svelte-12epoft.svelte-12epoft{font-size:0.82em;color:#be1e2d;background:#fef5f5;border:1px solid #f5c0c0;border-radius:6px;padding:8px 12px;margin-bottom:12px}.sb-error.svelte-12epoft.svelte-12epoft{font-size:0.85em;color:#be1e2d;margin-bottom:10px}.sb-nav.svelte-12epoft.svelte-12epoft{display:flex;justify-content:flex-end;padding-top:16px;border-top:1px solid #f0ebe5;margin-top:8px}.sb-nav--split.svelte-12epoft.svelte-12epoft{justify-content:space-between}.sb-btn-primary.svelte-12epoft.svelte-12epoft{background:#3b2314;color:white;border:none;border-radius:5px;padding:10px 22px;font-size:0.9em;cursor:pointer;font-weight:600;transition:opacity 0.15s}.sb-btn-primary.svelte-12epoft.svelte-12epoft:hover{opacity:0.88}.sb-btn-primary.svelte-12epoft.svelte-12epoft:disabled{background:#ccc;cursor:default;opacity:1}.sb-btn-secondary.svelte-12epoft.svelte-12epoft{background:none;border:1.5px solid #c8b8a8;color:#7a6a5a;border-radius:5px;padding:9px 16px;font-size:0.88em;cursor:pointer;transition:border-color 0.15s, color 0.15s}.sb-btn-secondary.svelte-12epoft.svelte-12epoft:hover{border-color:#3b2314;color:#3b2314}.sb-btn-cta.svelte-12epoft.svelte-12epoft{background:#9f6a33;color:white;border:none;border-radius:3px;padding:0.075em 1.5em 0;height:48px;line-height:46px;font-family:\"din-condensed-web\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;font-size:1em;font-weight:400;text-transform:uppercase;letter-spacing:0.025em;cursor:pointer;transition:background-color 0.15s ease-in-out;white-space:nowrap;min-width:160px}.sb-btn-cta.svelte-12epoft.svelte-12epoft:hover{background:#3b2314}.sb-btn-cta.svelte-12epoft.svelte-12epoft:disabled{background:#ccc;cursor:default}.sb-nav--sticky.svelte-12epoft.svelte-12epoft{position:sticky;bottom:0;background:white;border-top:2px solid #e8ddd2;margin-left:-28px;margin-right:-28px;margin-bottom:-20px;padding:12px 28px;border-radius:0 0 14px 14px;box-shadow:0 -4px 18px rgba(59,35,20,0.1);z-index:20}.sb-selection-badge.svelte-12epoft.svelte-12epoft{display:flex;align-items:center;gap:10px;padding:6px 14px;background:#f9f4ef;border:1.5px solid #c2976a;border-radius:8px;animation:svelte-12epoft-sb-guide-in 0.3s ease}.sb-selection-badge.is-complete.svelte-12epoft.svelte-12epoft{border-color:#5a9a5a;background:#f1f8f1}.sb-selection-badge.is-complete.svelte-12epoft .sb-sel-check.svelte-12epoft{background:#5a9a5a}.sb-selection-badge.is-complete.svelte-12epoft .sb-sel-count.svelte-12epoft{color:#4a8a4a}.sb-sel-check.svelte-12epoft.svelte-12epoft{width:22px;height:22px;background:#9f6a33;color:white;border-radius:50%;font-size:0.72em;font-weight:900;display:flex;align-items:center;justify-content:center;flex-shrink:0}.sb-sel-info.svelte-12epoft.svelte-12epoft{display:flex;flex-direction:column;gap:1px}.sb-sel-count.svelte-12epoft.svelte-12epoft{font-size:0.68em;font-weight:700;text-transform:uppercase;letter-spacing:0.07em;color:#9f6a33}.sb-sel-name.svelte-12epoft.svelte-12epoft{font-size:0.8em;font-weight:600;color:#3b2314;white-space:nowrap;max-width:200px;overflow:hidden;text-overflow:ellipsis}.sb-step-guide.svelte-12epoft.svelte-12epoft{display:flex;align-items:center;gap:8px;width:fit-content;max-width:100%;margin:2px auto 12px;font-size:0.82em;font-weight:700;color:#fff;background:linear-gradient(135deg, #b07c2c 0%, #9f6a33 100%);border:none;border-radius:24px;padding:8px 18px;text-align:center;box-shadow:0 4px 14px rgba(159,106,51,0.28);animation:svelte-12epoft-sb-guide-pop 0.4s cubic-bezier(0.2, 0.8, 0.3, 1.25),\n               svelte-12epoft-sb-guide-glow 1.8s ease-in-out 0.4s infinite}.sb-step-guide-arrow.svelte-12epoft.svelte-12epoft{display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;flex-shrink:0;border-radius:50%;background:rgba(255,255,255,0.22);font-size:1.05em;font-weight:900;line-height:1;animation:svelte-12epoft-sb-arrow-bounce 0.9s ease-in-out infinite}@keyframes svelte-12epoft-sb-arrow-bounce{0%,100%{transform:translateY(-2px);opacity:0.85}50%{transform:translateY(3px);opacity:1}}.sb-freq-col.is-highlight.svelte-12epoft.svelte-12epoft{border-radius:9px;animation:svelte-12epoft-sb-target-pulse 1.8s ease-in-out infinite}@keyframes svelte-12epoft-sb-target-pulse{0%,100%{box-shadow:0 0 0 0 rgba(159,106,51,0)}50%{box-shadow:0 0 0 5px rgba(159,106,51,0.16)}}@keyframes svelte-12epoft-sb-guide-in{from{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:translateY(0)}}@keyframes svelte-12epoft-sb-guide-pop{0%{opacity:0;transform:scale(0.85) translateY(-8px)}60%{opacity:1;transform:scale(1.03) translateY(0)}100%{opacity:1;transform:scale(1)}}@keyframes svelte-12epoft-sb-guide-glow{0%,100%{box-shadow:0 0 0 0 rgba(159,106,51,0)}50%{box-shadow:0 0 0 6px rgba(159,106,51,0.14)}}.sb-coffee-locked.svelte-12epoft.svelte-12epoft{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;text-align:center;padding:48px 20px;border:2px dashed #e0d3c2;border-radius:12px;background:#faf6f1;color:#9c8878;margin-bottom:16px}.sb-coffee-locked-icon.svelte-12epoft.svelte-12epoft{font-size:1.8em;opacity:0.7}@keyframes svelte-12epoft-sb-label-glow{0%,100%{color:#7a6a5a}50%{color:#9f6a33}}.sb-field-label.needs-attention.svelte-12epoft.svelte-12epoft,.sb-filter-group-label.needs-attention.svelte-12epoft.svelte-12epoft{animation:svelte-12epoft-sb-label-glow 1.6s ease-in-out infinite}@keyframes svelte-12epoft-sb-btn-pulse{0%,100%{box-shadow:0 0 0 0 rgba(59,35,20,0.28)}50%{box-shadow:0 0 0 7px rgba(59,35,20,0)}}.sb-btn-primary.is-ready-pulse.svelte-12epoft.svelte-12epoft:not(:disabled){animation:svelte-12epoft-sb-btn-pulse 2s ease-in-out infinite}.sb-btn-cta.is-ready-pulse.svelte-12epoft.svelte-12epoft:not(:disabled){animation:svelte-12epoft-sb-btn-pulse 2s ease-in-out infinite}@media(max-width: 720px){.sb.svelte-12epoft.svelte-12epoft{grid-template-columns:1fr;padding:0 16px 48px;gap:0}.sb-steps.svelte-12epoft.svelte-12epoft{flex-direction:row;align-items:center;justify-content:center;padding-top:4px;padding-right:0;border-right:none;position:static;margin-bottom:16px}.sb-step.svelte-12epoft.svelte-12epoft{flex-direction:column;align-items:center;gap:6px;padding:6px 10px;width:auto}.sb-step-circle.svelte-12epoft.svelte-12epoft{width:38px;height:38px;font-size:0.9em}.sb-step-label.svelte-12epoft.svelte-12epoft{font-size:0.7em}.sb-step-line.svelte-12epoft.svelte-12epoft{flex:1;height:2px;width:auto;margin:0 0 22px 0;min-width:24px;max-width:80px}}@media(max-width: 1024px){.sb-coffee-grid.svelte-12epoft.svelte-12epoft,.sb-carousel.svelte-12epoft.svelte-12epoft{grid-template-columns:repeat(3, 1fr);gap:12px}.sb-coffee-img.svelte-12epoft.svelte-12epoft,.sb-carousel-img.svelte-12epoft.svelte-12epoft{height:200px}}@media(max-width: 760px){.sb-coffee-grid.svelte-12epoft.svelte-12epoft,.sb-carousel.svelte-12epoft.svelte-12epoft{gap:10px}.sb-coffee-img.svelte-12epoft.svelte-12epoft,.sb-carousel-img.svelte-12epoft.svelte-12epoft{height:170px}}@media(max-width: 600px){.sb-panel.svelte-12epoft.svelte-12epoft{padding:16px 14px}.sb-nav--sticky.svelte-12epoft.svelte-12epoft{margin-left:-14px;margin-right:-14px;margin-bottom:-16px;padding:12px 14px}.sb-coffee-grid.svelte-12epoft.svelte-12epoft,.sb-carousel.svelte-12epoft.svelte-12epoft{grid-template-columns:repeat(2, minmax(0, 1fr));gap:8px}.sb-coffee-img.svelte-12epoft.svelte-12epoft,.sb-carousel-img.svelte-12epoft.svelte-12epoft{height:150px}.sb-filter-row.svelte-12epoft.svelte-12epoft{flex-wrap:wrap}.sb-sel-name.svelte-12epoft.svelte-12epoft{max-width:120px}}.sb-size-tile.svelte-12epoft.svelte-12epoft:focus-visible,.sb-freq-btn.svelte-12epoft.svelte-12epoft:focus-visible,.sb-chip.svelte-12epoft.svelte-12epoft:focus-visible,.sb-roast-chip.svelte-12epoft.svelte-12epoft:focus-visible,.sb-qty-btn.svelte-12epoft.svelte-12epoft:focus-visible,.sb-btn-primary.svelte-12epoft.svelte-12epoft:focus-visible,.sb-btn-secondary.svelte-12epoft.svelte-12epoft:focus-visible,.sb-addon-remove.svelte-12epoft.svelte-12epoft:focus-visible,.sb-filters-clear.svelte-12epoft.svelte-12epoft:focus-visible,.sb-curated-remove.svelte-12epoft.svelte-12epoft:focus-visible,.sb-change-mode-btn.svelte-12epoft.svelte-12epoft:focus-visible,.sb-coffee-card.svelte-12epoft.svelte-12epoft:focus-visible{outline:3px solid #005fcc;outline-offset:2px;position:relative;z-index:1}.sb-segment-btn.svelte-12epoft.svelte-12epoft:focus-visible{box-shadow:inset 0 0 0 3px #005fcc;position:relative;z-index:1}.sb-sr-only.svelte-12epoft.svelte-12epoft{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
}

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[132] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[135] = list[i];
	const constants_0 = sizeVariantAvailable(/*item*/ child_ctx[132].product, /*item*/ child_ctx[132].roast, /*opt*/ child_ctx[135].val);
	child_ctx[136] = constants_0;
	return child_ctx;
}

function get_each_context_2(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[139] = list[i];
	const constants_0 = /*addonQtyByKey*/ child_ctx[35][`${/*product*/ child_ctx[139].id}:Drip`] || 0;
	child_ctx[140] = constants_0;
	const constants_1 = /*addonQtyByKey*/ child_ctx[35][`${/*product*/ child_ctx[139].id}:Espresso`] || 0;
	child_ctx[141] = constants_1;
	const constants_2 = /*addonQtyByKey*/ child_ctx[35][`${/*product*/ child_ctx[139].id}:`] || 0;
	child_ctx[142] = constants_2;
	const constants_3 = /*product*/ child_ctx[139].hasDrip || /*product*/ child_ctx[139].hasEspresso;
	child_ctx[143] = constants_3;
	const constants_4 = /*dripQty*/ child_ctx[140] + /*espQty*/ child_ctx[141] + /*plainQty*/ child_ctx[142];
	child_ctx[144] = constants_4;
	return child_ctx;
}

function get_each_context_3(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[147] = list[i];
	return child_ctx;
}

function get_each_context_4(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[139] = list[i];
	const constants_0 = /*coffeeQty*/ child_ctx[1][`${/*product*/ child_ctx[139].id}:Drip`] || 0;
	child_ctx[140] = constants_0;
	const constants_1 = /*coffeeQty*/ child_ctx[1][`${/*product*/ child_ctx[139].id}:Espresso`] || 0;
	child_ctx[141] = constants_1;
	const constants_2 = /*dripQty*/ child_ctx[140] + /*espQty*/ child_ctx[141];
	child_ctx[144] = constants_2;
	const constants_3 = /*roastCompatible*/ child_ctx[53](/*product*/ child_ctx[139]);
	child_ctx[150] = constants_3;
	return child_ctx;
}

function get_each_context_5(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[147] = list[i];
	return child_ctx;
}

function get_each_context_6(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[135] = list[i];
	return child_ctx;
}

function get_each_context_7(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[135] = list[i];
	return child_ctx;
}

function get_each_context_8(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[135] = list[i];
	return child_ctx;
}

function get_each_context_9(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[135] = list[i];
	return child_ctx;
}

function get_each_context_10(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[135] = list[i];
	return child_ctx;
}

function get_each_context_11(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[165] = list[i];
	return child_ctx;
}

// (1105:6) {#if s.n < 3}
function create_if_block_50(ctx) {
	let div;

	const block = {
		c: function create() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div, "class", "sb-step-line svelte-12epoft");

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(div, "is-done", /*s*/ ctx[165].n === 1
			? /*step1Done*/ ctx[13]
			: /*step2Done*/ ctx[12]);

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div, file, 1105, 8, 49286);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div, anchor);
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*step1Done, step2Done*/ 12288) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(div, "is-done", /*s*/ ctx[165].n === 1
				? /*step1Done*/ ctx[13]
				: /*step2Done*/ ctx[12]);
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_50.name,
		type: "if",
		source: "(1105:6) {#if s.n < 3}",
		ctx
	});

	return block;
}

// (1090:4) {#each [       { n: 1, label: 'How Much' },       { n: 2, label: 'Your Coffee' },       { n: 3, label: 'Add-Ons' },     ] as s}
function create_each_block_11(ctx) {
	let button;
	let span0;
	let t0_value = /*s*/ ctx[165].n + "";
	let t0;
	let t1;
	let span1;
	let t2_value = /*s*/ ctx[165].label + "";
	let t2;
	let button_disabled_value;
	let t3;
	let if_block_anchor;
	let mounted;
	let dispose;

	function click_handler() {
		return /*click_handler*/ ctx[76](/*s*/ ctx[165]);
	}

	let if_block = /*s*/ ctx[165].n < 3 && create_if_block_50(ctx);

	const block = {
		c: function create() {
			button = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t0_value);
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t2_value);
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block) if_block.c();
			if_block_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "class", "sb-step-circle svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span0, file, 1101, 8, 49147);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "class", "sb-step-label svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span1, file, 1102, 8, 49197);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "class", "sb-step svelte-12epoft");

			button.disabled = button_disabled_value = /*s*/ ctx[165].n === 2
			? !/*step1Done*/ ctx[13]
			: /*s*/ ctx[165].n === 3 ? !/*step2Done*/ ctx[12] : false;

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button, "is-active", /*currentStep*/ ctx[5] === /*s*/ ctx[165].n);

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button, "is-done", /*s*/ ctx[165].n === 1
			? /*step1Done*/ ctx[13] && /*currentStep*/ ctx[5] !== 1
			: /*s*/ ctx[165].n === 2
				? /*step2Done*/ ctx[12] && /*currentStep*/ ctx[5] !== 2
				: false);

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button, file, 1094, 6, 48722);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, button, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button, span0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span0, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button, span1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, t3, anchor);
			if (if_block) if_block.m(target, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, if_block_anchor, anchor);

			if (!mounted) {
				dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button, "click", click_handler, false, false, false, false);
				mounted = true;
			}
		},
		p: function update(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty[0] & /*step1Done, step2Done*/ 12288 && button_disabled_value !== (button_disabled_value = /*s*/ ctx[165].n === 2
			? !/*step1Done*/ ctx[13]
			: /*s*/ ctx[165].n === 3 ? !/*step2Done*/ ctx[12] : false)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.prop_dev)(button, "disabled", button_disabled_value);
			}

			if (dirty[0] & /*currentStep*/ 32) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button, "is-active", /*currentStep*/ ctx[5] === /*s*/ ctx[165].n);
			}

			if (dirty[0] & /*step1Done, currentStep, step2Done*/ 12320) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button, "is-done", /*s*/ ctx[165].n === 1
				? /*step1Done*/ ctx[13] && /*currentStep*/ ctx[5] !== 1
				: /*s*/ ctx[165].n === 2
					? /*step2Done*/ ctx[12] && /*currentStep*/ ctx[5] !== 2
					: false);
			}

			if (/*s*/ ctx[165].n < 3) if_block.p(ctx, dirty);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(button);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(t3);
			if (if_block) if_block.d(detaching);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(if_block_anchor);
			mounted = false;
			dispose();
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_each_block_11.name,
		type: "each",
		source: "(1090:4) {#each [       { n: 1, label: 'How Much' },       { n: 2, label: 'Your Coffee' },       { n: 3, label: 'Add-Ons' },     ] as s}",
		ctx
	});

	return block;
}

// (1116:2) {#if currentStep === 1}
function create_if_block_40(ctx) {
	let div14;
	let div0;
	let p0;
	let t1;
	let h2;
	let t3;
	let p1;
	let t9;
	let div12;
	let div8;
	let div1;
	let t10;
	let span0;
	let span1;
	let t13;
	let div4;
	let div2;
	let t15;
	let div3;
	let t16;
	let div7;
	let div5;
	let t18;
	let div6;
	let t19;
	let div11;
	let div9;
	let t20;
	let span2;
	let span3;
	let t23;
	let t24;
	let div10;
	let button0;
	let span4;
	let t26;
	let span5;
	let t28;
	let button1;
	let span6;
	let t30;
	let span7;
	let t32;
	let t33;
	let div13;
	let button2;
	let t34;
	let button2_disabled_value;
	let mounted;
	let dispose;
	let each_value_10 = /*opts300g*/ ctx[43];
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_10);
	let each_blocks_1 = [];

	for (let i = 0; i < each_value_10.length; i += 1) {
		each_blocks_1[i] = create_each_block_10(get_each_context_10(ctx, each_value_10, i));
	}

	let each_value_9 = /*opts1kg*/ ctx[42];
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_9);
	let each_blocks = [];

	for (let i = 0; i < each_value_9.length; i += 1) {
		each_blocks[i] = create_each_block_9(get_each_context_9(ctx, each_value_9, i));
	}

	let if_block0 = /*$sizeDisplayValue*/ ctx[14] && !/*$shippingFrequencyDisplayValue*/ ctx[15] && create_if_block_47(ctx);
	let if_block1 = /*price*/ ctx[22] && create_if_block_41(ctx);

	const block = {
		c: function create() {
			div14 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			p0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("p");
			p0.textContent = "Step 1 of 3";
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			h2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("h2");
			h2.textContent = "How much coffee per shipment?";
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			p1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("p");
			p1.textContent = `Subscribe & Save ${/*DISCOUNT_LABEL*/ ctx[44].replace(' off', '')} on ${MIN_DISCOUNT_BAGS} or more bags`;
			t9 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div12 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div8 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t10 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Bag Size & Quantity ");
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span0.textContent = "*";
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span1.textContent = "(required)";
			t13 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div2.textContent = "300g bags";
			t15 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}

			t16 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div7 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div5.textContent = "1 kg bags";
			t18 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t19 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div11 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div9 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t20 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Delivery Frequency ");
			span2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span2.textContent = "*";
			span3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span3.textContent = "(required)";
			t23 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block0) if_block0.c();
			t24 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div10 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			button0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			span4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span4.textContent = "Bi-Weekly";
			t26 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span5.textContent = "Ships every 2 weeks";
			t28 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			button1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			span6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span6.textContent = "Monthly";
			t30 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span7 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span7.textContent = "Ships once a month";
			t32 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block1) if_block1.c();
			t33 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div13 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			button2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t34 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Choose Your Coffee →");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(p0, "class", "sb-panel-meta svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(p0, file, 1118, 6, 49643);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(h2, "class", "sb-panel-title svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(h2, file, 1119, 6, 49690);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(p1, "class", "sb-save-note svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(p1, file, 1120, 6, 49758);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div0, "class", "sb-panel-header svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div0, file, 1117, 4, 49607);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "class", "sb-filter-required svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "aria-hidden", "true");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span0, file, 1126, 60, 50050);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "class", "sb-sr-only svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span1, file, 1126, 120, 50110);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div1, "class", "sb-field-label svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div1, file, 1126, 8, 49998);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div2, "class", "sb-size-group-label svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div2, file, 1129, 10, 50206);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div3, "class", "sb-size-grid svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div3, file, 1130, 10, 50265);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div4, "class", "sb-size-group svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div4, file, 1128, 8, 50168);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div5, "class", "sb-size-group-label svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div5, file, 1150, 10, 51112);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div6, "class", "sb-size-grid svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div6, file, 1151, 10, 51171);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div7, "class", "sb-size-group svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div7, file, 1149, 8, 51074);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div8, "class", "sb-step1-size");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div8, file, 1125, 6, 49962);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span2, "class", "sb-filter-required svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span2, "aria-hidden", "true");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span2, file, 1174, 29, 52228);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span3, "class", "sb-sr-only svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span3, file, 1174, 89, 52288);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div9, "class", "sb-field-label svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(div9, "needs-attention", !!/*$sizeDisplayValue*/ ctx[14] && !/*$shippingFrequencyDisplayValue*/ ctx[15]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div9, file, 1173, 8, 52091);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span4, "class", "sb-freq-main svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span4, file, 1186, 12, 52972);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span5, "class", "sb-freq-sub svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span5, file, 1187, 12, 53028);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "class", "sb-freq-btn svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button0, "is-selected", /*$shippingFrequencyDisplayValue*/ ctx[15] === 'Bi-Weekly');
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button0, file, 1183, 10, 52721);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span6, "class", "sb-freq-main svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span6, file, 1192, 12, 53359);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span7, "class", "sb-freq-sub svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span7, file, 1193, 12, 53413);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "class", "sb-freq-btn svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button1, "is-selected", /*$shippingFrequencyDisplayValue*/ ctx[15] === 'Monthly');
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button1, file, 1189, 10, 53111);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div10, "class", "sb-freq-col svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(div10, "is-highlight", !!/*$sizeDisplayValue*/ ctx[14] && !/*$shippingFrequencyDisplayValue*/ ctx[15]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div10, file, 1182, 8, 52609);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div11, "class", "sb-step1-right");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div11, file, 1172, 6, 52030);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div12, "class", "sb-step1-stack svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div12, file, 1123, 4, 49896);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button2, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button2, "class", "sb-btn-primary svelte-12epoft");
			button2.disabled = button2_disabled_value = !/*step1Done*/ ctx[13];
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button2, "is-ready-pulse", /*step1Done*/ ctx[13]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button2, file, 1217, 6, 54552);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div13, "class", "sb-nav svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div13, file, 1216, 4, 54525);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div14, "class", "sb-panel svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div14, file, 1116, 2, 49580);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div14, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div14, div0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, p0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, h2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, p1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div14, t9);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div14, div12);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div12, div8);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div8, div1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, t10);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, span0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, span1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div8, t13);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div8, div4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, div2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, t15);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, div3);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				if (each_blocks_1[i]) {
					each_blocks_1[i].m(div3, null);
				}
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div8, t16);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div8, div7);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div7, div5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div7, t18);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div7, div6);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(div6, null);
				}
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div12, t19);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div12, div11);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div11, div9);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div9, t20);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div9, span2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div9, span3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div11, t23);
			if (if_block0) if_block0.m(div11, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div11, t24);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div11, div10);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div10, button0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button0, span4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button0, t26);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button0, span5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div10, t28);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div10, button1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button1, span6);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button1, t30);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button1, span7);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div11, t32);
			if (if_block1) if_block1.m(div11, null);
			/*div11_binding*/ ctx[81](div11);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div14, t33);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div14, div13);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div13, button2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button2, t34);

			if (!mounted) {
				dispose = [
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button0, "click", /*click_handler_3*/ ctx[79], false, false, false, false),
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button1, "click", /*click_handler_4*/ ctx[80], false, false, false, false),
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button2, "click", /*click_handler_5*/ ctx[82], false, false, false, false)
				];

				mounted = true;
			}
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*$sizeDisplayValue*/ 16384 | dirty[1] & /*opts300g, selectSize*/ 135168) {
				each_value_10 = /*opts300g*/ ctx[43];
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_10);
				let i;

				for (i = 0; i < each_value_10.length; i += 1) {
					const child_ctx = get_each_context_10(ctx, each_value_10, i);

					if (each_blocks_1[i]) {
						each_blocks_1[i].p(child_ctx, dirty);
					} else {
						each_blocks_1[i] = create_each_block_10(child_ctx);
						each_blocks_1[i].c();
						each_blocks_1[i].m(div3, null);
					}
				}

				for (; i < each_blocks_1.length; i += 1) {
					each_blocks_1[i].d(1);
				}

				each_blocks_1.length = each_value_10.length;
			}

			if (dirty[0] & /*$sizeDisplayValue*/ 16384 | dirty[1] & /*opts1kg, selectSize*/ 133120) {
				each_value_9 = /*opts1kg*/ ctx[42];
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_9);
				let i;

				for (i = 0; i < each_value_9.length; i += 1) {
					const child_ctx = get_each_context_9(ctx, each_value_9, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block_9(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div6, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value_9.length;
			}

			if (dirty[0] & /*$sizeDisplayValue, $shippingFrequencyDisplayValue*/ 49152) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(div9, "needs-attention", !!/*$sizeDisplayValue*/ ctx[14] && !/*$shippingFrequencyDisplayValue*/ ctx[15]);
			}

			if (/*$sizeDisplayValue*/ ctx[14] && !/*$shippingFrequencyDisplayValue*/ ctx[15]) {
				if (if_block0) {
					
				} else {
					if_block0 = create_if_block_47(ctx);
					if_block0.c();
					if_block0.m(div11, t24);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (dirty[0] & /*$shippingFrequencyDisplayValue*/ 32768) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button0, "is-selected", /*$shippingFrequencyDisplayValue*/ ctx[15] === 'Bi-Weekly');
			}

			if (dirty[0] & /*$shippingFrequencyDisplayValue*/ 32768) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button1, "is-selected", /*$shippingFrequencyDisplayValue*/ ctx[15] === 'Monthly');
			}

			if (dirty[0] & /*$sizeDisplayValue, $shippingFrequencyDisplayValue*/ 49152) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(div10, "is-highlight", !!/*$sizeDisplayValue*/ ctx[14] && !/*$shippingFrequencyDisplayValue*/ ctx[15]);
			}

			if (/*price*/ ctx[22]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_41(ctx);
					if_block1.c();
					if_block1.m(div11, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (dirty[0] & /*step1Done*/ 8192 && button2_disabled_value !== (button2_disabled_value = !/*step1Done*/ ctx[13])) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.prop_dev)(button2, "disabled", button2_disabled_value);
			}

			if (dirty[0] & /*step1Done*/ 8192) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button2, "is-ready-pulse", /*step1Done*/ ctx[13]);
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div14);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks_1, detaching);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks, detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			/*div11_binding*/ ctx[81](null);
			mounted = false;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.run_all)(dispose);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_40.name,
		type: "if",
		source: "(1116:2) {#if currentStep === 1}",
		ctx
	});

	return block;
}

// (1141:18) {:else}
function create_else_block_3(ctx) {
	let span;
	let t_value = fmtPrice(/*opt*/ ctx[135].price) + "";
	let t;

	const block = {
		c: function create() {
			span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "class", "sb-size-disc svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span, file, 1141, 20, 50885);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, span, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span, t);
		},
		p: function update(ctx, dirty) {
			if (dirty[1] & /*opts300g*/ 4096 && t_value !== (t_value = fmtPrice(/*opt*/ ctx[135].price) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t, t_value);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(span);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_else_block_3.name,
		type: "else",
		source: "(1141:18) {:else}",
		ctx
	});

	return block;
}

// (1138:18) {#if opt.qty >= MIN_DISCOUNT_BAGS}
function create_if_block_49(ctx) {
	let span0;
	let t0_value = fmtPrice(/*opt*/ ctx[135].price) + "";
	let t0;
	let t1;
	let span1;
	let t2_value = fmtPrice(/*opt*/ ctx[135].price * (1 - DISCOUNT_PCT)) + "";
	let t2;

	const block = {
		c: function create() {
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t0_value);
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t2_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "class", "sb-size-orig svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span0, file, 1138, 20, 50686);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "class", "sb-size-disc svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span1, file, 1139, 20, 50762);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, span0, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span0, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, t1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, span1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, t2);
		},
		p: function update(ctx, dirty) {
			if (dirty[1] & /*opts300g*/ 4096 && t0_value !== (t0_value = fmtPrice(/*opt*/ ctx[135].price) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t0, t0_value);
			if (dirty[1] & /*opts300g*/ 4096 && t2_value !== (t2_value = fmtPrice(/*opt*/ ctx[135].price * (1 - DISCOUNT_PCT)) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t2, t2_value);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(span0);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(t1);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(span1);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_49.name,
		type: "if",
		source: "(1138:18) {#if opt.qty >= MIN_DISCOUNT_BAGS}",
		ctx
	});

	return block;
}

// (1132:12) {#each opts300g as opt}
function create_each_block_10(ctx) {
	let button;
	let span0;
	let t0_value = /*opt*/ ctx[135].label + "";
	let t0;
	let t1;
	let span1;
	let t2;
	let mounted;
	let dispose;

	function select_block_type(ctx, dirty) {
		if (/*opt*/ ctx[135].qty >= MIN_DISCOUNT_BAGS) return create_if_block_49;
		return create_else_block_3;
	}

	let current_block_type = select_block_type(ctx, [-1, -1, -1, -1, -1, -1]);
	let if_block = current_block_type(ctx);

	function click_handler_1() {
		return /*click_handler_1*/ ctx[77](/*opt*/ ctx[135]);
	}

	const block = {
		c: function create() {
			button = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t0_value);
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			if_block.c();
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "class", "sb-size-main svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span0, file, 1135, 16, 50517);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "class", "sb-size-tile-right svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span1, file, 1136, 16, 50579);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "class", "sb-size-tile svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button, "is-selected", /*$sizeDisplayValue*/ ctx[14] === /*opt*/ ctx[135].val);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button, file, 1132, 14, 50342);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, button, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button, span0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span0, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button, span1);
			if_block.m(span1, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button, t2);

			if (!mounted) {
				dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button, "click", click_handler_1, false, false, false, false);
				mounted = true;
			}
		},
		p: function update(new_ctx, dirty) {
			ctx = new_ctx;
			if (dirty[1] & /*opts300g*/ 4096 && t0_value !== (t0_value = /*opt*/ ctx[135].label + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t0, t0_value);

			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(span1, null);
				}
			}

			if (dirty[0] & /*$sizeDisplayValue*/ 16384 | dirty[1] & /*opts300g*/ 4096) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button, "is-selected", /*$sizeDisplayValue*/ ctx[14] === /*opt*/ ctx[135].val);
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(button);
			if_block.d();
			mounted = false;
			dispose();
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_each_block_10.name,
		type: "each",
		source: "(1132:12) {#each opts300g as opt}",
		ctx
	});

	return block;
}

// (1162:18) {:else}
function create_else_block_2(ctx) {
	let span;
	let t_value = fmtPrice(/*opt*/ ctx[135].price) + "";
	let t;

	const block = {
		c: function create() {
			span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "class", "sb-size-disc svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span, file, 1162, 20, 51790);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, span, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span, t);
		},
		p: function update(ctx, dirty) {
			if (dirty[1] & /*opts1kg*/ 2048 && t_value !== (t_value = fmtPrice(/*opt*/ ctx[135].price) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t, t_value);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(span);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_else_block_2.name,
		type: "else",
		source: "(1162:18) {:else}",
		ctx
	});

	return block;
}

// (1159:18) {#if opt.qty >= MIN_DISCOUNT_BAGS}
function create_if_block_48(ctx) {
	let span0;
	let t0_value = fmtPrice(/*opt*/ ctx[135].price) + "";
	let t0;
	let t1;
	let span1;
	let t2_value = fmtPrice(/*opt*/ ctx[135].price * (1 - DISCOUNT_PCT)) + "";
	let t2;

	const block = {
		c: function create() {
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t0_value);
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t2_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "class", "sb-size-orig svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span0, file, 1159, 20, 51591);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "class", "sb-size-disc svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span1, file, 1160, 20, 51667);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, span0, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span0, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, t1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, span1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, t2);
		},
		p: function update(ctx, dirty) {
			if (dirty[1] & /*opts1kg*/ 2048 && t0_value !== (t0_value = fmtPrice(/*opt*/ ctx[135].price) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t0, t0_value);
			if (dirty[1] & /*opts1kg*/ 2048 && t2_value !== (t2_value = fmtPrice(/*opt*/ ctx[135].price * (1 - DISCOUNT_PCT)) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t2, t2_value);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(span0);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(t1);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(span1);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_48.name,
		type: "if",
		source: "(1159:18) {#if opt.qty >= MIN_DISCOUNT_BAGS}",
		ctx
	});

	return block;
}

// (1153:12) {#each opts1kg as opt}
function create_each_block_9(ctx) {
	let button;
	let span0;
	let t0_value = /*opt*/ ctx[135].label + "";
	let t0;
	let t1;
	let span1;
	let t2;
	let mounted;
	let dispose;

	function select_block_type_1(ctx, dirty) {
		if (/*opt*/ ctx[135].qty >= MIN_DISCOUNT_BAGS) return create_if_block_48;
		return create_else_block_2;
	}

	let current_block_type = select_block_type_1(ctx, [-1, -1, -1, -1, -1, -1]);
	let if_block = current_block_type(ctx);

	function click_handler_2() {
		return /*click_handler_2*/ ctx[78](/*opt*/ ctx[135]);
	}

	const block = {
		c: function create() {
			button = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t0_value);
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			if_block.c();
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "class", "sb-size-main svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span0, file, 1156, 16, 51422);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "class", "sb-size-tile-right svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span1, file, 1157, 16, 51484);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "class", "sb-size-tile svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button, "is-selected", /*$sizeDisplayValue*/ ctx[14] === /*opt*/ ctx[135].val);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button, file, 1153, 14, 51247);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, button, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button, span0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span0, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button, span1);
			if_block.m(span1, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button, t2);

			if (!mounted) {
				dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button, "click", click_handler_2, false, false, false, false);
				mounted = true;
			}
		},
		p: function update(new_ctx, dirty) {
			ctx = new_ctx;
			if (dirty[1] & /*opts1kg*/ 2048 && t0_value !== (t0_value = /*opt*/ ctx[135].label + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t0, t0_value);

			if (current_block_type === (current_block_type = select_block_type_1(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(span1, null);
				}
			}

			if (dirty[0] & /*$sizeDisplayValue*/ 16384 | dirty[1] & /*opts1kg*/ 2048) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button, "is-selected", /*$sizeDisplayValue*/ ctx[14] === /*opt*/ ctx[135].val);
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(button);
			if_block.d();
			mounted = false;
			dispose();
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_each_block_9.name,
		type: "each",
		source: "(1153:12) {#each opts1kg as opt}",
		ctx
	});

	return block;
}

// (1177:8) {#if $sizeDisplayValue && !$shippingFrequencyDisplayValue}
function create_if_block_47(ctx) {
	let p;
	let span;
	let t1;

	const block = {
		c: function create() {
			p = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("p");
			span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span.textContent = "↓";
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("\n            Choose how often you'd like delivery");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "class", "sb-step-guide-arrow svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "aria-hidden", "true");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span, file, 1178, 12, 52461);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(p, "class", "sb-step-guide svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(p, file, 1177, 10, 52423);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, p, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(p, span);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(p, t1);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(p);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_47.name,
		type: "if",
		source: "(1177:8) {#if $sizeDisplayValue && !$shippingFrequencyDisplayValue}",
		ctx
	});

	return block;
}

// (1198:8) {#if price}
function create_if_block_41(ctx) {
	let div1;
	let div0;
	let t0;
	let span1;
	let t1;
	let span0;
	let t3;
	let t4;
	let t5;
	let t6;
	let if_block0 = /*originalPrice*/ ctx[27] && create_if_block_46(ctx);
	let if_block1 = /*discountApplied*/ ctx[25] && create_if_block_45(ctx);
	let if_block2 = !/*discountApplied*/ ctx[25] && create_if_block_44(ctx);
	let if_block3 = /*perBagPrice*/ ctx[24] && create_if_block_43(ctx);
	let if_block4 = /*priceNum*/ ctx[23] !== null && create_if_block_42(ctx);

	const block = {
		c: function create() {
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			if (if_block0) if_block0.c();
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*price*/ ctx[22]);
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span0.textContent = "/shipment";
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block1) if_block1.c();
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block2) if_block2.c();
			t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block3) if_block3.c();
			t6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block4) if_block4.c();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "class", "sb-price-period svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span0, file, 1201, 51, 53744);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "class", "sb-price-amount svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span1, file, 1201, 14, 53707);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div0, "class", "sb-price-line svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div0, file, 1199, 12, 53572);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div1, "class", "sb-price-strip svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div1, file, 1198, 10, 53531);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, div0);
			if (if_block0) if_block0.m(div0, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, span1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, span0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t3);
			if (if_block1) if_block1.m(div0, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, t4);
			if (if_block2) if_block2.m(div1, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, t5);
			if (if_block3) if_block3.m(div1, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, t6);
			if (if_block4) if_block4.m(div1, null);
		},
		p: function update(ctx, dirty) {
			if (/*originalPrice*/ ctx[27]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_46(ctx);
					if_block0.c();
					if_block0.m(div0, t0);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (dirty[0] & /*price*/ 4194304) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t1, /*price*/ ctx[22]);

			if (/*discountApplied*/ ctx[25]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_45(ctx);
					if_block1.c();
					if_block1.m(div0, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (!/*discountApplied*/ ctx[25]) {
				if (if_block2) {
					if_block2.p(ctx, dirty);
				} else {
					if_block2 = create_if_block_44(ctx);
					if_block2.c();
					if_block2.m(div1, t5);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}

			if (/*perBagPrice*/ ctx[24]) {
				if (if_block3) {
					if_block3.p(ctx, dirty);
				} else {
					if_block3 = create_if_block_43(ctx);
					if_block3.c();
					if_block3.m(div1, t6);
				}
			} else if (if_block3) {
				if_block3.d(1);
				if_block3 = null;
			}

			if (/*priceNum*/ ctx[23] !== null) {
				if (if_block4) {
					if_block4.p(ctx, dirty);
				} else {
					if_block4 = create_if_block_42(ctx);
					if_block4.c();
					if_block4.m(div1, null);
				}
			} else if (if_block4) {
				if_block4.d(1);
				if_block4 = null;
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div1);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
			if (if_block3) if_block3.d();
			if (if_block4) if_block4.d();
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_41.name,
		type: "if",
		source: "(1198:8) {#if price}",
		ctx
	});

	return block;
}

// (1201:14) {#if originalPrice}
function create_if_block_46(ctx) {
	let span;
	let t;

	const block = {
		c: function create() {
			span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*originalPrice*/ ctx[27]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "class", "sb-price-original svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span, file, 1200, 33, 53633);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, span, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span, t);
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*originalPrice*/ 134217728) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t, /*originalPrice*/ ctx[27]);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(span);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_46.name,
		type: "if",
		source: "(1201:14) {#if originalPrice}",
		ctx
	});

	return block;
}

// (1203:14) {#if discountApplied}
function create_if_block_45(ctx) {
	let span;

	const block = {
		c: function create() {
			span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span.textContent = `${/*DISCOUNT_LABEL*/ ctx[44]}`;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "class", "sb-badge-discount svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span, file, 1202, 35, 53833);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, span, anchor);
		},
		p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(span);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_45.name,
		type: "if",
		source: "(1203:14) {#if discountApplied}",
		ctx
	});

	return block;
}

// (1205:12) {#if !discountApplied}
function create_if_block_44(ctx) {
	let div;
	let t0;

	let t1_value = (MIN_DISCOUNT_BAGS - /*bagCount*/ ctx[7] === 1
	? 'another bag'
	: `${MIN_DISCOUNT_BAGS - /*bagCount*/ ctx[7]} more bags`) + "";

	let t1;
	let t2;
	let t3_value = /*DISCOUNT_LABEL*/ ctx[44].replace(' off', '') + "";
	let t3;

	const block = {
		c: function create() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Add ");
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t1_value);
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(" to save ");
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t3_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div, "class", "sb-price-nudge svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div, file, 1205, 14, 53962);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, t3);
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*bagCount*/ 128 && t1_value !== (t1_value = (MIN_DISCOUNT_BAGS - /*bagCount*/ ctx[7] === 1
			? 'another bag'
			: `${MIN_DISCOUNT_BAGS - /*bagCount*/ ctx[7]} more bags`) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t1, t1_value);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_44.name,
		type: "if",
		source: "(1205:12) {#if !discountApplied}",
		ctx
	});

	return block;
}

// (1208:12) {#if perBagPrice}
function create_if_block_43(ctx) {
	let div;
	let t0;
	let t1;
	let t2_value = /*formatter*/ ctx[45].format(SHIPPING_FLAT_RATE) + "";
	let t2;
	let t3;

	const block = {
		c: function create() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*perBagPrice*/ ctx[24]);
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("/bag · ");
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t2_value);
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(" shipping charges");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div, "class", "sb-price-perbag svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div, file, 1207, 29, 54191);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, t3);
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*perBagPrice*/ 16777216) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t0, /*perBagPrice*/ ctx[24]);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_43.name,
		type: "if",
		source: "(1208:12) {#if perBagPrice}",
		ctx
	});

	return block;
}

// (1209:12) {#if priceNum !== null}
function create_if_block_42(ctx) {
	let div;
	let t0;
	let t1_value = /*formatter*/ ctx[45].format(/*priceNum*/ ctx[23] + SHIPPING_FLAT_RATE) + "";
	let t1;

	const block = {
		c: function create() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Total ");
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t1_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div, "class", "sb-price-total svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div, file, 1209, 14, 54357);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, t1);
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*priceNum*/ 8388608 && t1_value !== (t1_value = /*formatter*/ ctx[45].format(/*priceNum*/ ctx[23] + SHIPPING_FLAT_RATE) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t1, t1_value);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_42.name,
		type: "if",
		source: "(1209:12) {#if priceNum !== null}",
		ctx
	});

	return block;
}

// (1228:2) {#if currentStep === 2}
function create_if_block_24(ctx) {
	let div28;
	let div0;
	let p;
	let t1;
	let h2;
	let t3;
	let div16;
	let div1;
	let span0;
	let t5;
	let t6;
	let div2;
	let t7;
	let div15;
	let div8;
	let div3;
	let span1;
	let t9;
	let span2;
	let t11;
	let div5;
	let span3;
	let t13;
	let div4;
	let button0;
	let t14;
	let button0_aria_pressed_value;
	let t15;
	let button1;
	let t16;
	let button1_aria_pressed_value;
	let t17;
	let button2;
	let t18;
	let button2_aria_pressed_value;
	let t19;
	let div7;
	let span4;
	let t21;
	let div6;
	let t22;
	let div14;
	let div9;
	let span5;
	let t24;
	let div11;
	let span6;
	let t26;
	let div10;
	let t27;
	let div13;
	let span7;
	let t29;
	let div12;
	let t30;
	let div20;
	let div17;
	let span8;
	let t31;
	let t32;
	let t33;
	let t34_value = (/*bagCount*/ ctx[7] === 1 ? 'bag' : 'bags') + "";
	let t34;
	let t35;
	let span9;
	let t36;
	let t37;
	let t38;
	let t39;
	let t40;
	let div19;
	let div18;
	let t41;
	let t42;
	let div26;
	let div25;
	let div21;
	let img;
	let img_src_value;
	let t43;
	let t44;
	let div24;
	let div22;
	let t46;
	let div23;
	let span10;

	let t47_value = (/*bagCount*/ ctx[7] === 1
	? 'We pick it for you'
	: `We pick all ${/*bagCount*/ ctx[7]} for you`) + "";

	let t47;
	let t48;
	let t49;
	let each_blocks = [];
	let each3_lookup = new Map();
	let t50;
	let t51;
	let div27;
	let button3;
	let span11;
	let t53;
	let t54;
	let t55;
	let button4;
	let t56;
	let button4_disabled_value;
	let mounted;
	let dispose;
	let if_block0 = /*anyFilterActive*/ ctx[41] && create_if_block_39(ctx);
	let each_value_8 = /*FLAVOR_OPTIONS*/ ctx[50];
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_8);
	let each_blocks_3 = [];

	for (let i = 0; i < each_value_8.length; i += 1) {
		each_blocks_3[i] = create_each_block_8(get_each_context_8(ctx, each_value_8, i));
	}

	let each_value_7 = /*PROCESSING_OPTIONS*/ ctx[49];
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_7);
	let each_blocks_2 = [];

	for (let i = 0; i < each_value_7.length; i += 1) {
		each_blocks_2[i] = create_each_block_7(get_each_context_7(ctx, each_value_7, i));
	}

	let each_value_6 = /*DESCRIPTOR_OPTIONS*/ ctx[51];
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_6);
	let each_blocks_1 = [];

	for (let i = 0; i < each_value_6.length; i += 1) {
		each_blocks_1[i] = create_each_block_6(get_each_context_6(ctx, each_value_6, i));
	}

	function select_block_type_2(ctx, dirty) {
		if (/*selectedCount*/ ctx[8] < /*bagCount*/ ctx[7]) return create_if_block_37;
		if (/*hasCurated*/ ctx[6] && /*curatedRoasts*/ ctx[2].length === 0) return create_if_block_38;
		return create_else_block_1;
	}

	let current_block_type = select_block_type_2(ctx, [-1, -1, -1, -1, -1, -1]);
	let if_block1 = current_block_type(ctx);
	let if_block2 = /*hasCurated*/ ctx[6] && create_if_block_36(ctx);
	let if_block3 = /*hasCurated*/ ctx[6] && create_if_block_34(ctx);
	let each_value_4 = /*filteredCoffees*/ ctx[40];
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_4);
	const get_key = ctx => /*product*/ ctx[139].id;
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_keys)(ctx, each_value_4, get_each_context_4, get_key);

	for (let i = 0; i < each_value_4.length; i += 1) {
		let child_ctx = get_each_context_4(ctx, each_value_4, i);
		let key = get_key(child_ctx);
		each3_lookup.set(key, each_blocks[i] = create_each_block_4(key, child_ctx));
	}

	let if_block4 = /*filteredCoffees*/ ctx[40].length === 0 && create_if_block_26(ctx);
	let if_block5 = /*selectedCount*/ ctx[8] > 0 && create_if_block_25(ctx);

	const block = {
		c: function create() {
			div28 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			p = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("p");
			p.textContent = "Step 2 of 3";
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			h2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("h2");
			h2.textContent = "Choose your coffee";
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div16 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span0.textContent = "Refine";
			t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block0) if_block0.c();
			t6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t7 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div15 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div8 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span1.textContent = "Coffee Profile";
			t9 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span2.textContent = "Your selection will be carried forward to your upcoming order.";
			t11 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span3.textContent = "Roast";
			t13 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			button0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t14 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("All");
			t15 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			button1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t16 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Drip");
			t17 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			button2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t18 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Espresso");
			t19 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div7 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span4.textContent = "Flavor";
			t21 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");

			for (let i = 0; i < each_blocks_3.length; i += 1) {
				each_blocks_3[i].c();
			}

			t22 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div14 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div9 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span5.textContent = "Browse Filters";
			t24 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div11 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span6.textContent = "Processing";
			t26 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div10 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");

			for (let i = 0; i < each_blocks_2.length; i += 1) {
				each_blocks_2[i].c();
			}

			t27 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div13 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span7 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span7.textContent = "Notes";
			t29 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div12 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}

			t30 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div20 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div17 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span8 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t31 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Pick your ");
			t32 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*bagCount*/ ctx[7]);
			t33 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			t34 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t34_value);
			t35 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span9 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t36 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*selectedCount*/ ctx[8]);
			t37 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(" of ");
			t38 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*bagCount*/ ctx[7]);
			t39 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(" selected");
			t40 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div19 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div18 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t41 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if_block1.c();
			t42 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div26 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div25 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div21 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			img = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("img");
			t43 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block2) if_block2.c();
			t44 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div24 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div22 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div22.textContent = "Curated for me";
			t46 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div23 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span10 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t47 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t47_value);
			t48 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block3) if_block3.c();
			t49 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t50 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block4) if_block4.c();
			t51 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div27 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			button3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			span11 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span11.textContent = "←";
			t53 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(" Back");
			t54 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block5) if_block5.c();
			t55 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			button4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t56 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Add-Ons & Checkout →");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(p, "class", "sb-panel-meta svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(p, file, 1230, 6, 54987);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(h2, "class", "sb-panel-title svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(h2, file, 1231, 6, 55034);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div0, "class", "sb-panel-header svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div0, file, 1229, 4, 54951);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "class", "sb-filters-title svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span0, file, 1237, 8, 55200);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div1, "class", "sb-filters-header svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div1, file, 1236, 6, 55160);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div2, "class", "sb-filters-divider svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div2, file, 1244, 6, 55434);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "class", "sb-filter-col-title svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span1, file, 1251, 12, 55791);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span2, "class", "sb-filter-col-subtitle svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span2, file, 1252, 12, 55859);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div3, "class", "sb-filter-col-header svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div3, file, 1250, 10, 55744);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span3, "class", "sb-filter-group-label svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span3, "id", "sb-lbl-roast");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span3, file, 1255, 12, 56035);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "class", "sb-segment-btn svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "aria-pressed", button0_aria_pressed_value = !/*$roast*/ ctx[19]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button0, "is-selected", !/*$roast*/ ctx[19]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button0, file, 1257, 14, 56197);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "class", "sb-segment-btn svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "aria-pressed", button1_aria_pressed_value = /*$roast*/ ctx[19] === 'Drip');
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button1, "is-selected", /*$roast*/ ctx[19] === 'Drip');
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button1, file, 1263, 14, 56465);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button2, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button2, "class", "sb-segment-btn svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button2, "aria-pressed", button2_aria_pressed_value = /*$roast*/ ctx[19] === 'Espresso');
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button2, "is-selected", /*$roast*/ ctx[19] === 'Espresso');
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button2, file, 1269, 14, 56760);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div4, "class", "sb-segment svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div4, "role", "group");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div4, "aria-labelledby", "sb-lbl-roast");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div4, file, 1256, 12, 56114);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div5, "class", "sb-filter-group svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div5, file, 1254, 10, 55993);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span4, "class", "sb-filter-group-label svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span4, "id", "sb-lbl-flavor");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span4, file, 1279, 12, 57150);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div6, "class", "sb-chip-row svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div6, "role", "group");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div6, "aria-labelledby", "sb-lbl-flavor");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div6, file, 1280, 12, 57231);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div7, "class", "sb-filter-group svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div7, file, 1278, 10, 57108);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div8, "class", "sb-filter-col sb-filter-col--carry svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div8, file, 1249, 8, 55685);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span5, "class", "sb-filter-col-title svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span5, file, 1293, 12, 57826);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div9, "class", "sb-filter-col-header svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div9, file, 1292, 10, 57779);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span6, "class", "sb-filter-group-label svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span6, "id", "sb-lbl-processing");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span6, file, 1296, 12, 57951);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div10, "class", "sb-chip-row svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div10, "role", "group");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div10, "aria-labelledby", "sb-lbl-processing");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div10, file, 1297, 12, 58040);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div11, "class", "sb-filter-group svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div11, file, 1295, 10, 57909);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span7, "class", "sb-filter-group-label svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span7, "id", "sb-lbl-notes");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span7, file, 1308, 12, 58576);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div12, "class", "sb-chip-row svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div12, "role", "group");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div12, "aria-labelledby", "sb-lbl-notes");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div12, file, 1309, 12, 58655);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div13, "class", "sb-filter-group svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div13, file, 1307, 10, 58534);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div14, "class", "sb-filter-col sb-filter-col--session svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div14, file, 1291, 8, 57718);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div15, "class", "sb-filter-grid svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div15, file, 1248, 6, 55648);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div16, "class", "sb-filters-bar svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div16, file, 1235, 4, 55125);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span8, "class", "sb-progress-title svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span8, file, 1325, 8, 59314);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span9, "class", "sb-progress-count svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(span9, "is-complete", /*step2Done*/ ctx[12]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span9, file, 1326, 8, 59416);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div17, "class", "sb-progress-head svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div17, file, 1324, 6, 59275);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div18, "class", "sb-progress-fill svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_style)(div18, "width", /*progressPct*/ ctx[37] + '%');
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div18, file, 1329, 8, 59583);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div19, "class", "sb-progress-track svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div19, file, 1328, 6, 59543);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div20, "class", "sb-progress svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div20, file, 1323, 4, 59243);
			if (!(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.src_url_equal)(img.src, img_src_value = "https://cdn.shopify.com/s/files/1/0057/2942/files/Curated4.jpg?v=1786444881")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(img, "src", img_src_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(img, "alt", "Curated");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(img, "class", "svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(img, file, 1351, 10, 60769);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div21, "class", "sb-coffee-img svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div21, file, 1350, 8, 60731);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div22, "class", "sb-coffee-name svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div22, file, 1355, 10, 61027);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span10, "class", "sb-coffee-tag svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span10, file, 1356, 41, 61117);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div23, "class", "sb-coffee-tag-row svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div23, file, 1356, 10, 61086);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div24, "class", "sb-coffee-info svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div24, file, 1354, 8, 60988);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div25, "class", "sb-coffee-card svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div25, "role", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div25, "tabindex", "0");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(div25, "is-selected", /*hasCurated*/ ctx[6]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div25, file, 1346, 6, 60482);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div26, "class", "sb-coffee-grid svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div26, file, 1344, 4, 60368);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span11, "aria-hidden", "true");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span11, file, 1443, 82, 66110);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button3, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button3, "class", "sb-btn-secondary svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button3, file, 1443, 6, 66034);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button4, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button4, "class", "sb-btn-primary svelte-12epoft");
			button4.disabled = button4_disabled_value = !/*step2Done*/ ctx[12];
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button4, "is-ready-pulse", /*step2Done*/ ctx[12]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button4, file, 1453, 6, 66635);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div27, "class", "sb-nav sb-nav--split sb-nav--sticky svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div27, file, 1442, 4, 65978);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div28, "class", "sb-panel svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div28, file, 1228, 2, 54924);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div28, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div28, div0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, p);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, h2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div28, t3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div28, div16);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div16, div1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, span0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, t5);
			if (if_block0) if_block0.m(div1, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div16, t6);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div16, div2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div16, t7);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div16, div15);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div15, div8);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div8, div3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, span1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, t9);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, span2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div8, t11);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div8, div5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div5, span3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div5, t13);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div5, div4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, button0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button0, t14);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, t15);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, button1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button1, t16);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, t17);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, button2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button2, t18);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div8, t19);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div8, div7);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div7, span4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div7, t21);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div7, div6);

			for (let i = 0; i < each_blocks_3.length; i += 1) {
				if (each_blocks_3[i]) {
					each_blocks_3[i].m(div6, null);
				}
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div15, t22);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div15, div14);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div14, div9);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div9, span5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div14, t24);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div14, div11);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div11, span6);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div11, t26);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div11, div10);

			for (let i = 0; i < each_blocks_2.length; i += 1) {
				if (each_blocks_2[i]) {
					each_blocks_2[i].m(div10, null);
				}
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div14, t27);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div14, div13);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div13, span7);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div13, t29);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div13, div12);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				if (each_blocks_1[i]) {
					each_blocks_1[i].m(div12, null);
				}
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div28, t30);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div28, div20);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div20, div17);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div17, span8);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span8, t31);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span8, t32);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span8, t33);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span8, t34);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div17, t35);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div17, span9);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span9, t36);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span9, t37);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span9, t38);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span9, t39);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div20, t40);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div20, div19);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div19, div18);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div20, t41);
			if_block1.m(div20, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div28, t42);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div28, div26);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div26, div25);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div25, div21);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div21, img);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div21, t43);
			if (if_block2) if_block2.m(div21, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div25, t44);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div25, div24);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div24, div22);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div24, t46);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div24, div23);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div23, span10);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span10, t47);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div24, t48);
			if (if_block3) if_block3.m(div24, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div26, t49);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(div26, null);
				}
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div26, t50);
			if (if_block4) if_block4.m(div26, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div28, t51);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div28, div27);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div27, button3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button3, span11);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button3, t53);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div27, t54);
			if (if_block5) if_block5.m(div27, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div27, t55);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div27, button4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button4, t56);

			if (!mounted) {
				dispose = [
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button0, "click", /*click_handler_6*/ ctx[83], false, false, false, false),
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button1, "click", /*click_handler_7*/ ctx[84], false, false, false, false),
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button2, "click", /*click_handler_8*/ ctx[85], false, false, false, false),
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(div25, "click", /*toggleCurated*/ ctx[57], false, false, false, false),
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(div25, "keydown", /*keydown_handler*/ ctx[91], false, false, false, false),
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button3, "click", /*click_handler_18*/ ctx[96], false, false, false, false),
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button4, "click", /*click_handler_19*/ ctx[97], false, false, false, false)
				];

				mounted = true;
			}
		},
		p: function update(ctx, dirty) {
			if (/*anyFilterActive*/ ctx[41]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_39(ctx);
					if_block0.c();
					if_block0.m(div1, null);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (dirty[0] & /*$roast*/ 524288 && button0_aria_pressed_value !== (button0_aria_pressed_value = !/*$roast*/ ctx[19])) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "aria-pressed", button0_aria_pressed_value);
			}

			if (dirty[0] & /*$roast*/ 524288) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button0, "is-selected", !/*$roast*/ ctx[19]);
			}

			if (dirty[0] & /*$roast*/ 524288 && button1_aria_pressed_value !== (button1_aria_pressed_value = /*$roast*/ ctx[19] === 'Drip')) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "aria-pressed", button1_aria_pressed_value);
			}

			if (dirty[0] & /*$roast*/ 524288) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button1, "is-selected", /*$roast*/ ctx[19] === 'Drip');
			}

			if (dirty[0] & /*$roast*/ 524288 && button2_aria_pressed_value !== (button2_aria_pressed_value = /*$roast*/ ctx[19] === 'Espresso')) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button2, "aria-pressed", button2_aria_pressed_value);
			}

			if (dirty[0] & /*$roast*/ 524288) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button2, "is-selected", /*$roast*/ ctx[19] === 'Espresso');
			}

			if (dirty[0] & /*$flavorFilters*/ 65536 | dirty[1] & /*FLAVOR_OPTIONS*/ 524288) {
				each_value_8 = /*FLAVOR_OPTIONS*/ ctx[50];
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_8);
				let i;

				for (i = 0; i < each_value_8.length; i += 1) {
					const child_ctx = get_each_context_8(ctx, each_value_8, i);

					if (each_blocks_3[i]) {
						each_blocks_3[i].p(child_ctx, dirty);
					} else {
						each_blocks_3[i] = create_each_block_8(child_ctx);
						each_blocks_3[i].c();
						each_blocks_3[i].m(div6, null);
					}
				}

				for (; i < each_blocks_3.length; i += 1) {
					each_blocks_3[i].d(1);
				}

				each_blocks_3.length = each_value_8.length;
			}

			if (dirty[0] & /*$processingFilters*/ 131072 | dirty[1] & /*PROCESSING_OPTIONS*/ 262144) {
				each_value_7 = /*PROCESSING_OPTIONS*/ ctx[49];
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_7);
				let i;

				for (i = 0; i < each_value_7.length; i += 1) {
					const child_ctx = get_each_context_7(ctx, each_value_7, i);

					if (each_blocks_2[i]) {
						each_blocks_2[i].p(child_ctx, dirty);
					} else {
						each_blocks_2[i] = create_each_block_7(child_ctx);
						each_blocks_2[i].c();
						each_blocks_2[i].m(div10, null);
					}
				}

				for (; i < each_blocks_2.length; i += 1) {
					each_blocks_2[i].d(1);
				}

				each_blocks_2.length = each_value_7.length;
			}

			if (dirty[0] & /*$descriptorFilters*/ 262144 | dirty[1] & /*DESCRIPTOR_OPTIONS*/ 1048576) {
				each_value_6 = /*DESCRIPTOR_OPTIONS*/ ctx[51];
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_6);
				let i;

				for (i = 0; i < each_value_6.length; i += 1) {
					const child_ctx = get_each_context_6(ctx, each_value_6, i);

					if (each_blocks_1[i]) {
						each_blocks_1[i].p(child_ctx, dirty);
					} else {
						each_blocks_1[i] = create_each_block_6(child_ctx);
						each_blocks_1[i].c();
						each_blocks_1[i].m(div12, null);
					}
				}

				for (; i < each_blocks_1.length; i += 1) {
					each_blocks_1[i].d(1);
				}

				each_blocks_1.length = each_value_6.length;
			}

			if (dirty[0] & /*bagCount*/ 128) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t32, /*bagCount*/ ctx[7]);
			if (dirty[0] & /*bagCount*/ 128 && t34_value !== (t34_value = (/*bagCount*/ ctx[7] === 1 ? 'bag' : 'bags') + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t34, t34_value);
			if (dirty[0] & /*selectedCount*/ 256) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t36, /*selectedCount*/ ctx[8]);
			if (dirty[0] & /*bagCount*/ 128) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t38, /*bagCount*/ ctx[7]);

			if (dirty[0] & /*step2Done*/ 4096) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(span9, "is-complete", /*step2Done*/ ctx[12]);
			}

			if (dirty[1] & /*progressPct*/ 64) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_style)(div18, "width", /*progressPct*/ ctx[37] + '%');
			}

			if (current_block_type === (current_block_type = select_block_type_2(ctx, dirty)) && if_block1) {
				if_block1.p(ctx, dirty);
			} else {
				if_block1.d(1);
				if_block1 = current_block_type(ctx);

				if (if_block1) {
					if_block1.c();
					if_block1.m(div20, null);
				}
			}

			if (/*hasCurated*/ ctx[6]) {
				if (if_block2) {
					
				} else {
					if_block2 = create_if_block_36(ctx);
					if_block2.c();
					if_block2.m(div21, null);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}

			if (dirty[0] & /*bagCount*/ 128 && t47_value !== (t47_value = (/*bagCount*/ ctx[7] === 1
			? 'We pick it for you'
			: `We pick all ${/*bagCount*/ ctx[7]} for you`) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t47, t47_value);

			if (/*hasCurated*/ ctx[6]) {
				if (if_block3) {
					if_block3.p(ctx, dirty);
				} else {
					if_block3 = create_if_block_34(ctx);
					if_block3.c();
					if_block3.m(div24, null);
				}
			} else if (if_block3) {
				if_block3.d(1);
				if_block3 = null;
			}

			if (dirty[0] & /*hasCurated*/ 64) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(div25, "is-selected", /*hasCurated*/ ctx[6]);
			}

			if (dirty[0] & /*coffeeQty, selectedCount, bagCount, $descriptorFilters*/ 262530 | dirty[1] & /*filteredCoffees, roastCompatible, addCoffee, removeCoffee, getCardTags, bagSizeLabel*/ 56623618) {
				each_value_4 = /*filteredCoffees*/ ctx[40];
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_4);
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_keys)(ctx, each_value_4, get_each_context_4, get_key);
				each_blocks = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.update_keyed_each)(each_blocks, dirty, get_key, 1, ctx, each_value_4, each3_lookup, div26, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_block, create_each_block_4, t50, get_each_context_4);
			}

			if (/*filteredCoffees*/ ctx[40].length === 0) {
				if (if_block4) {
					
				} else {
					if_block4 = create_if_block_26(ctx);
					if_block4.c();
					if_block4.m(div26, null);
				}
			} else if (if_block4) {
				if_block4.d(1);
				if_block4 = null;
			}

			if (/*selectedCount*/ ctx[8] > 0) {
				if (if_block5) {
					if_block5.p(ctx, dirty);
				} else {
					if_block5 = create_if_block_25(ctx);
					if_block5.c();
					if_block5.m(div27, t55);
				}
			} else if (if_block5) {
				if_block5.d(1);
				if_block5 = null;
			}

			if (dirty[0] & /*step2Done*/ 4096 && button4_disabled_value !== (button4_disabled_value = !/*step2Done*/ ctx[12])) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.prop_dev)(button4, "disabled", button4_disabled_value);
			}

			if (dirty[0] & /*step2Done*/ 4096) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button4, "is-ready-pulse", /*step2Done*/ ctx[12]);
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div28);
			if (if_block0) if_block0.d();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks_3, detaching);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks_2, detaching);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks_1, detaching);
			if_block1.d();
			if (if_block2) if_block2.d();
			if (if_block3) if_block3.d();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d();
			}

			if (if_block4) if_block4.d();
			if (if_block5) if_block5.d();
			mounted = false;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.run_all)(dispose);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_24.name,
		type: "if",
		source: "(1228:2) {#if currentStep === 2}",
		ctx
	});

	return block;
}

// (1241:8) {#if anyFilterActive}
function create_if_block_39(ctx) {
	let button;
	let mounted;
	let dispose;

	const block = {
		c: function create() {
			button = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			button.textContent = "✕ Clear filters";
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "class", "sb-filters-clear svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button, file, 1241, 10, 55305);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, button, anchor);

			if (!mounted) {
				dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button, "click", /*clearFilters*/ ctx[54], false, false, false, false);
				mounted = true;
			}
		},
		p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(button);
			mounted = false;
			dispose();
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_39.name,
		type: "if",
		source: "(1241:8) {#if anyFilterActive}",
		ctx
	});

	return block;
}

// (1282:14) {#each FLAVOR_OPTIONS as opt}
function create_each_block_8(ctx) {
	let button;
	let t_value = /*opt*/ ctx[135].label + "";
	let t;
	let button_aria_pressed_value;
	let mounted;
	let dispose;

	function click_handler_9() {
		return /*click_handler_9*/ ctx[86](/*opt*/ ctx[135]);
	}

	const block = {
		c: function create() {
			button = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "class", "sb-chip svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "aria-pressed", button_aria_pressed_value = /*$flavorFilters*/ ctx[16].includes(/*opt*/ ctx[135].label));
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button, "is-selected", /*$flavorFilters*/ ctx[16].includes(/*opt*/ ctx[135].label));
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button, file, 1282, 16, 57362);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, button, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button, t);

			if (!mounted) {
				dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button, "click", click_handler_9, false, false, false, false);
				mounted = true;
			}
		},
		p: function update(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty[0] & /*$flavorFilters*/ 65536 && button_aria_pressed_value !== (button_aria_pressed_value = /*$flavorFilters*/ ctx[16].includes(/*opt*/ ctx[135].label))) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "aria-pressed", button_aria_pressed_value);
			}

			if (dirty[0] & /*$flavorFilters*/ 65536 | dirty[1] & /*FLAVOR_OPTIONS*/ 524288) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button, "is-selected", /*$flavorFilters*/ ctx[16].includes(/*opt*/ ctx[135].label));
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(button);
			mounted = false;
			dispose();
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_each_block_8.name,
		type: "each",
		source: "(1282:14) {#each FLAVOR_OPTIONS as opt}",
		ctx
	});

	return block;
}

// (1299:14) {#each PROCESSING_OPTIONS as opt}
function create_each_block_7(ctx) {
	let button;
	let t_value = /*opt*/ ctx[135].label + "";
	let t;
	let button_aria_pressed_value;
	let mounted;
	let dispose;

	function click_handler_10() {
		return /*click_handler_10*/ ctx[87](/*opt*/ ctx[135]);
	}

	const block = {
		c: function create() {
			button = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "class", "sb-chip svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "aria-pressed", button_aria_pressed_value = /*$processingFilters*/ ctx[17].includes(/*opt*/ ctx[135].label));
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button, "is-selected", /*$processingFilters*/ ctx[17].includes(/*opt*/ ctx[135].label));
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button, file, 1299, 16, 58179);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, button, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button, t);

			if (!mounted) {
				dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button, "click", click_handler_10, false, false, false, false);
				mounted = true;
			}
		},
		p: function update(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty[0] & /*$processingFilters*/ 131072 && button_aria_pressed_value !== (button_aria_pressed_value = /*$processingFilters*/ ctx[17].includes(/*opt*/ ctx[135].label))) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "aria-pressed", button_aria_pressed_value);
			}

			if (dirty[0] & /*$processingFilters*/ 131072 | dirty[1] & /*PROCESSING_OPTIONS*/ 262144) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button, "is-selected", /*$processingFilters*/ ctx[17].includes(/*opt*/ ctx[135].label));
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(button);
			mounted = false;
			dispose();
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_each_block_7.name,
		type: "each",
		source: "(1299:14) {#each PROCESSING_OPTIONS as opt}",
		ctx
	});

	return block;
}

// (1311:14) {#each DESCRIPTOR_OPTIONS as opt}
function create_each_block_6(ctx) {
	let button;
	let t_value = /*opt*/ ctx[135].label + "";
	let t;
	let button_aria_pressed_value;
	let mounted;
	let dispose;

	function click_handler_11() {
		return /*click_handler_11*/ ctx[88](/*opt*/ ctx[135]);
	}

	const block = {
		c: function create() {
			button = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "class", "sb-chip svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "aria-pressed", button_aria_pressed_value = /*$descriptorFilters*/ ctx[18].includes(/*opt*/ ctx[135].label));
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button, "is-selected", /*$descriptorFilters*/ ctx[18].includes(/*opt*/ ctx[135].label));
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button, file, 1311, 16, 58789);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, button, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button, t);

			if (!mounted) {
				dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button, "click", click_handler_11, false, false, false, false);
				mounted = true;
			}
		},
		p: function update(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty[0] & /*$descriptorFilters*/ 262144 && button_aria_pressed_value !== (button_aria_pressed_value = /*$descriptorFilters*/ ctx[18].includes(/*opt*/ ctx[135].label))) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "aria-pressed", button_aria_pressed_value);
			}

			if (dirty[0] & /*$descriptorFilters*/ 262144 | dirty[1] & /*DESCRIPTOR_OPTIONS*/ 1048576) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button, "is-selected", /*$descriptorFilters*/ ctx[18].includes(/*opt*/ ctx[135].label));
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(button);
			mounted = false;
			dispose();
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_each_block_6.name,
		type: "each",
		source: "(1311:14) {#each DESCRIPTOR_OPTIONS as opt}",
		ctx
	});

	return block;
}

// (1339:6) {:else}
function create_else_block_1(ctx) {
	let p;
	let t0;

	let t1_value = (/*bagCount*/ ctx[7] === 1
	? '1 bag'
	: `All ${/*bagCount*/ ctx[7]} bags`) + "";

	let t1;
	let t2;

	const block = {
		c: function create() {
			p = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("p");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("✓ ");
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t1_value);
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(" chosen — you're ready for the next step.");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(p, "class", "sb-progress-hint sb-progress-hint--done svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(p, file, 1339, 8, 60165);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, p, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(p, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(p, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(p, t2);
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*bagCount*/ 128 && t1_value !== (t1_value = (/*bagCount*/ ctx[7] === 1
			? '1 bag'
			: `All ${/*bagCount*/ ctx[7]} bags`) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t1, t1_value);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(p);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_else_block_1.name,
		type: "else",
		source: "(1339:6) {:else}",
		ctx
	});

	return block;
}

// (1337:57) 
function create_if_block_38(ctx) {
	let p;

	const block = {
		c: function create() {
			p = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("p");
			p.textContent = "Choose your roast preference for the curated selection below.";
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(p, "class", "sb-progress-hint svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(p, file, 1337, 8, 60049);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, p, anchor);
		},
		p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(p);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_38.name,
		type: "if",
		source: "(1337:57) ",
		ctx
	});

	return block;
}

// (1332:6) {#if selectedCount < bagCount}
function create_if_block_37(ctx) {
	let p;
	let span;
	let t1;

	let t2_value = (/*bagCount*/ ctx[7] - /*selectedCount*/ ctx[8] === 1
	? 'Add 1'
	: `Add ${/*bagCount*/ ctx[7] - /*selectedCount*/ ctx[8]} more`) + "";

	let t2;
	let t3;

	const block = {
		c: function create() {
			p = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("p");
			span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span.textContent = "↓";
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t2_value);
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(" — mix Drip & Espresso freely, or repeat a coffee with \"+\".");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "class", "sb-step-guide-arrow svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "aria-hidden", "true");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span, file, 1333, 10, 59751);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(p, "class", "sb-progress-hint svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(p, file, 1332, 8, 59712);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, p, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(p, span);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(p, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(p, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(p, t3);
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*bagCount, selectedCount*/ 384 && t2_value !== (t2_value = (/*bagCount*/ ctx[7] - /*selectedCount*/ ctx[8] === 1
			? 'Add 1'
			: `Add ${/*bagCount*/ ctx[7] - /*selectedCount*/ ctx[8]} more`) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t2, t2_value);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(p);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_37.name,
		type: "if",
		source: "(1332:6) {#if selectedCount < bagCount}",
		ctx
	});

	return block;
}

// (1353:10) {#if hasCurated}
function create_if_block_36(ctx) {
	let span;

	const block = {
		c: function create() {
			span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span.textContent = "✓";
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "class", "sb-coffee-check svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "aria-label", "Selected");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span, file, 1352, 26, 60899);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, span, anchor);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(span);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_36.name,
		type: "if",
		source: "(1353:10) {#if hasCurated}",
		ctx
	});

	return block;
}

// (1358:10) {#if hasCurated}
function create_if_block_34(ctx) {
	let div;
	let span;
	let t1;
	let button0;
	let t3;
	let button1;
	let t5;
	let t6;
	let button2;
	let mounted;
	let dispose;
	let if_block = /*curatedRoasts*/ ctx[2].length === 0 && create_if_block_35(ctx);

	const block = {
		c: function create() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span.textContent = "Roast preference:";
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			button0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			button0.textContent = "Drip";
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			button1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			button1.textContent = "Espresso";
			t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block) if_block.c();
			t6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			button2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			button2.textContent = "Remove";
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "class", "sb-curated-roast-label svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span, file, 1359, 14, 61322);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "class", "sb-roast-chip svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button0, "is-active", /*curatedRoasts*/ ctx[2].includes('Drip'));
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button0, file, 1360, 14, 61398);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "class", "sb-roast-chip svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button1, "is-active", /*curatedRoasts*/ ctx[2].includes('Espresso'));
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button1, file, 1362, 14, 61595);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div, "class", "sb-curated-roast-row svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div, file, 1358, 12, 61273);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button2, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button2, "class", "sb-curated-remove svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button2, file, 1368, 12, 61986);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, span);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, button0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, t3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, button1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, t5, anchor);
			if (if_block) if_block.m(target, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, t6, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, button2, anchor);

			if (!mounted) {
				dispose = [
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button0, "click", (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.stop_propagation)(/*click_handler_12*/ ctx[89]), false, false, true, false),
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button1, "click", (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.stop_propagation)(/*click_handler_13*/ ctx[90]), false, false, true, false),
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button2, "click", (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.stop_propagation)(/*toggleCurated*/ ctx[57]), false, false, true, false)
				];

				mounted = true;
			}
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*curatedRoasts*/ 4) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button0, "is-active", /*curatedRoasts*/ ctx[2].includes('Drip'));
			}

			if (dirty[0] & /*curatedRoasts*/ 4) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button1, "is-active", /*curatedRoasts*/ ctx[2].includes('Espresso'));
			}

			if (/*curatedRoasts*/ ctx[2].length === 0) {
				if (if_block) {
					
				} else {
					if_block = create_if_block_35(ctx);
					if_block.c();
					if_block.m(t6.parentNode, t6);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(t5);
			if (if_block) if_block.d(detaching);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(t6);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(button2);
			mounted = false;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.run_all)(dispose);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_34.name,
		type: "if",
		source: "(1358:10) {#if hasCurated}",
		ctx
	});

	return block;
}

// (1366:12) {#if curatedRoasts.length === 0}
function create_if_block_35(ctx) {
	let p;

	const block = {
		c: function create() {
			p = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("p");
			p.textContent = "Please select at least one roast preference above.";
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(p, "class", "sb-curated-roast-hint svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(p, file, 1366, 14, 61868);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, p, anchor);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(p);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_35.name,
		type: "if",
		source: "(1366:12) {#if curatedRoasts.length === 0}",
		ctx
	});

	return block;
}

// (1384:12) {#if totalQty > 0}
function create_if_block_33(ctx) {
	let span;
	let t_value = /*totalQty*/ ctx[144] + "";
	let t;
	let span_aria_label_value;

	const block = {
		c: function create() {
			span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "class", "sb-coffee-qty-badge svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "aria-label", span_aria_label_value = "" + (/*totalQty*/ ctx[144] + " selected"));
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span, file, 1383, 30, 62820);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, span, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span, t);
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*coffeeQty*/ 2 | dirty[1] & /*filteredCoffees*/ 512 && t_value !== (t_value = /*totalQty*/ ctx[144] + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t, t_value);

			if (dirty[0] & /*coffeeQty*/ 2 | dirty[1] & /*filteredCoffees*/ 512 && span_aria_label_value !== (span_aria_label_value = "" + (/*totalQty*/ ctx[144] + " selected"))) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "aria-label", span_aria_label_value);
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(span);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_33.name,
		type: "if",
		source: "(1384:12) {#if totalQty > 0}",
		ctx
	});

	return block;
}

// (1387:64) 
function create_if_block_32(ctx) {
	let div;

	let t_value = (/*product*/ ctx[139].hasDrip
	? 'Drip only'
	: 'Espresso only') + "";

	let t;

	const block = {
		c: function create() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div, "class", "sb-roast-unavail svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div, file, 1391, 14, 63436);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, t);
		},
		p: function update(ctx, dirty) {
			if (dirty[1] & /*filteredCoffees*/ 512 && t_value !== (t_value = (/*product*/ ctx[139].hasDrip
			? 'Drip only'
			: 'Espresso only') + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t, t_value);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_32.name,
		type: "if",
		source: "(1387:64) ",
		ctx
	});

	return block;
}

// (1385:12) {#if !compatible}
function create_if_block_31(ctx) {
	let div;

	const block = {
		c: function create() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div.textContent = "Not available";
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div, "class", "sb-roast-unavail svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div, file, 1385, 14, 62954);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div, anchor);
		},
		p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_31.name,
		type: "if",
		source: "(1385:12) {#if !compatible}",
		ctx
	});

	return block;
}

// (1399:12) {#if product.tags && product.tags.length}
function create_if_block_29(ctx) {
	let show_if = /*getCardTags*/ ctx[52](/*product*/ ctx[139].tags, /*$descriptorFilters*/ ctx[18]).length;
	let if_block_anchor;
	let if_block = show_if && create_if_block_30(ctx);

	const block = {
		c: function create() {
			if (if_block) if_block.c();
			if_block_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
		},
		m: function mount(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, if_block_anchor, anchor);
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*$descriptorFilters*/ 262144 | dirty[1] & /*filteredCoffees*/ 512) show_if = /*getCardTags*/ ctx[52](/*product*/ ctx[139].tags, /*$descriptorFilters*/ ctx[18]).length;

			if (show_if) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_30(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		d: function destroy(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(if_block_anchor);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_29.name,
		type: "if",
		source: "(1399:12) {#if product.tags && product.tags.length}",
		ctx
	});

	return block;
}

// (1400:14) {#if getCardTags(product.tags, $descriptorFilters).length}
function create_if_block_30(ctx) {
	let div;
	let each_value_5 = /*getCardTags*/ ctx[52](/*product*/ ctx[139].tags, /*$descriptorFilters*/ ctx[18]);
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_5);
	let each_blocks = [];

	for (let i = 0; i < each_value_5.length; i += 1) {
		each_blocks[i] = create_each_block_5(get_each_context_5(ctx, each_value_5, i));
	}

	const block = {
		c: function create() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div, "class", "sb-coffee-tag-row svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div, file, 1400, 16, 63833);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(div, null);
				}
			}
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*$descriptorFilters*/ 262144 | dirty[1] & /*getCardTags, filteredCoffees*/ 2097664) {
				each_value_5 = /*getCardTags*/ ctx[52](/*product*/ ctx[139].tags, /*$descriptorFilters*/ ctx[18]);
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_5);
				let i;

				for (i = 0; i < each_value_5.length; i += 1) {
					const child_ctx = get_each_context_5(ctx, each_value_5, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block_5(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value_5.length;
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks, detaching);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_30.name,
		type: "if",
		source: "(1400:14) {#if getCardTags(product.tags, $descriptorFilters).length}",
		ctx
	});

	return block;
}

// (1402:18) {#each getCardTags(product.tags, $descriptorFilters) as tagInfo}
function create_each_block_5(ctx) {
	let span;
	let t_value = /*tagInfo*/ ctx[147].label + "";
	let t;
	let span_class_value;

	const block = {
		c: function create() {
			span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "class", span_class_value = "sb-coffee-tag sb-coffee-tag--" + /*tagInfo*/ ctx[147].type + " svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span, file, 1402, 20, 63968);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, span, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span, t);
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*$descriptorFilters*/ 262144 | dirty[1] & /*filteredCoffees*/ 512 && t_value !== (t_value = /*tagInfo*/ ctx[147].label + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t, t_value);

			if (dirty[0] & /*$descriptorFilters*/ 262144 | dirty[1] & /*filteredCoffees*/ 512 && span_class_value !== (span_class_value = "sb-coffee-tag sb-coffee-tag--" + /*tagInfo*/ ctx[147].type + " svelte-12epoft")) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "class", span_class_value);
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(span);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_each_block_5.name,
		type: "each",
		source: "(1402:18) {#each getCardTags(product.tags, $descriptorFilters) as tagInfo}",
		ctx
	});

	return block;
}

// (1409:14) {#if product.hasDrip}
function create_if_block_28(ctx) {
	let div1;
	let span0;
	let t1;
	let div0;
	let button0;
	let t2;
	let button0_disabled_value;
	let t3;
	let span1;
	let t4_value = /*dripQty*/ ctx[140] + "";
	let t4;
	let t5;
	let button1;
	let t6;
	let button1_disabled_value;
	let mounted;
	let dispose;

	function click_handler_14() {
		return /*click_handler_14*/ ctx[92](/*product*/ ctx[139]);
	}

	function click_handler_15() {
		return /*click_handler_15*/ ctx[93](/*compatible*/ ctx[150], /*product*/ ctx[139]);
	}

	const block = {
		c: function create() {
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span0.textContent = "Drip";
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			button0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("−");
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t4_value);
			t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			button1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("+");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "class", "sb-roast-label svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span0, file, 1410, 18, 64278);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "class", "sb-qty-btn svelte-12epoft");
			button0.disabled = button0_disabled_value = /*dripQty*/ ctx[140] === 0 || !/*compatible*/ ctx[150];
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "aria-label", "Remove Drip");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button0, file, 1412, 20, 64388);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "class", "sb-qty-val svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span1, file, 1414, 20, 64610);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "class", "sb-qty-btn svelte-12epoft");
			button1.disabled = button1_disabled_value = !/*compatible*/ ctx[150] || /*selectedCount*/ ctx[8] >= /*bagCount*/ ctx[7];
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "aria-label", "Add Drip");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button1, file, 1415, 20, 64672);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div0, "class", "sb-roast-stepper svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div0, file, 1411, 18, 64337);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div1, "class", "sb-stepper-row svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div1, file, 1409, 16, 64231);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, span0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, div0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, button0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button0, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, span1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, t4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, button1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button1, t6);

			if (!mounted) {
				dispose = [
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button0, "click", (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.stop_propagation)(click_handler_14), false, false, true, false),
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button1, "click", (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.stop_propagation)(click_handler_15), false, false, true, false)
				];

				mounted = true;
			}
		},
		p: function update(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty[0] & /*coffeeQty*/ 2 | dirty[1] & /*filteredCoffees*/ 512 && button0_disabled_value !== (button0_disabled_value = /*dripQty*/ ctx[140] === 0 || !/*compatible*/ ctx[150])) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.prop_dev)(button0, "disabled", button0_disabled_value);
			}

			if (dirty[0] & /*coffeeQty*/ 2 | dirty[1] & /*filteredCoffees*/ 512 && t4_value !== (t4_value = /*dripQty*/ ctx[140] + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t4, t4_value);

			if (dirty[0] & /*selectedCount, bagCount*/ 384 | dirty[1] & /*filteredCoffees*/ 512 && button1_disabled_value !== (button1_disabled_value = !/*compatible*/ ctx[150] || /*selectedCount*/ ctx[8] >= /*bagCount*/ ctx[7])) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.prop_dev)(button1, "disabled", button1_disabled_value);
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div1);
			mounted = false;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.run_all)(dispose);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_28.name,
		type: "if",
		source: "(1409:14) {#if product.hasDrip}",
		ctx
	});

	return block;
}

// (1421:14) {#if product.hasEspresso}
function create_if_block_27(ctx) {
	let div1;
	let span0;
	let t1;
	let div0;
	let button0;
	let t2;
	let button0_disabled_value;
	let t3;
	let span1;
	let t4_value = /*espQty*/ ctx[141] + "";
	let t4;
	let t5;
	let button1;
	let t6;
	let button1_disabled_value;
	let mounted;
	let dispose;

	function click_handler_16() {
		return /*click_handler_16*/ ctx[94](/*product*/ ctx[139]);
	}

	function click_handler_17() {
		return /*click_handler_17*/ ctx[95](/*compatible*/ ctx[150], /*product*/ ctx[139]);
	}

	const block = {
		c: function create() {
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span0.textContent = "Espresso";
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			button0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("−");
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t4_value);
			t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			button1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("+");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "class", "sb-roast-label svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span0, file, 1422, 18, 65065);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "class", "sb-qty-btn svelte-12epoft");
			button0.disabled = button0_disabled_value = /*espQty*/ ctx[141] === 0 || !/*compatible*/ ctx[150];
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "aria-label", "Remove Espresso");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button0, file, 1424, 20, 65179);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "class", "sb-qty-val svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span1, file, 1426, 20, 65408);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "class", "sb-qty-btn svelte-12epoft");
			button1.disabled = button1_disabled_value = !/*compatible*/ ctx[150] || /*selectedCount*/ ctx[8] >= /*bagCount*/ ctx[7];
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "aria-label", "Add Espresso");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button1, file, 1427, 20, 65469);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div0, "class", "sb-roast-stepper svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div0, file, 1423, 18, 65128);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div1, "class", "sb-stepper-row svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div1, file, 1421, 16, 65018);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, span0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, div0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, button0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button0, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, span1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, t4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, button1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button1, t6);

			if (!mounted) {
				dispose = [
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button0, "click", (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.stop_propagation)(click_handler_16), false, false, true, false),
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button1, "click", (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.stop_propagation)(click_handler_17), false, false, true, false)
				];

				mounted = true;
			}
		},
		p: function update(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty[0] & /*coffeeQty*/ 2 | dirty[1] & /*filteredCoffees*/ 512 && button0_disabled_value !== (button0_disabled_value = /*espQty*/ ctx[141] === 0 || !/*compatible*/ ctx[150])) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.prop_dev)(button0, "disabled", button0_disabled_value);
			}

			if (dirty[0] & /*coffeeQty*/ 2 | dirty[1] & /*filteredCoffees*/ 512 && t4_value !== (t4_value = /*espQty*/ ctx[141] + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t4, t4_value);

			if (dirty[0] & /*selectedCount, bagCount*/ 384 | dirty[1] & /*filteredCoffees*/ 512 && button1_disabled_value !== (button1_disabled_value = !/*compatible*/ ctx[150] || /*selectedCount*/ ctx[8] >= /*bagCount*/ ctx[7])) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.prop_dev)(button1, "disabled", button1_disabled_value);
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div1);
			mounted = false;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.run_all)(dispose);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_27.name,
		type: "if",
		source: "(1421:14) {#if product.hasEspresso}",
		ctx
	});

	return block;
}

// (1375:6) {#each filteredCoffees as product (product.id)}
function create_each_block_4(key_1, ctx) {
	let div4;
	let div0;
	let img;
	let img_src_value;
	let img_alt_value;
	let t0;
	let t1;
	let t2;
	let div3;
	let div1;
	let t3_value = /*product*/ ctx[139].title + "";
	let t3;
	let t4;
	let t5;
	let div2;
	let t6;
	let if_block0 = /*totalQty*/ ctx[144] > 0 && create_if_block_33(ctx);

	function select_block_type_3(ctx, dirty) {
		if (!/*compatible*/ ctx[150]) return create_if_block_31;
		if (!(/*product*/ ctx[139].hasDrip && /*product*/ ctx[139].hasEspresso)) return create_if_block_32;
	}

	let current_block_type = select_block_type_3(ctx, [-1, -1, -1, -1, -1, -1]);
	let if_block1 = current_block_type && current_block_type(ctx);
	let if_block2 = /*product*/ ctx[139].tags && /*product*/ ctx[139].tags.length && create_if_block_29(ctx);
	let if_block3 = /*product*/ ctx[139].hasDrip && create_if_block_28(ctx);
	let if_block4 = /*product*/ ctx[139].hasEspresso && create_if_block_27(ctx);

	const block = {
		key: key_1,
		first: null,
		c: function create() {
			div4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			img = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("img");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block0) if_block0.c();
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block1) if_block1.c();
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t3_value);
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block2) if_block2.c();
			t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			if (if_block3) if_block3.c();
			t6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block4) if_block4.c();
			if (!(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.src_url_equal)(img.src, img_src_value = getProductImage(/*product*/ ctx[139], /*bagSizeLabel*/ ctx[32]) || 'https://uploads.coavacoffee.com/production/uploads/subscriptions/subscription_profile_01.jpg')) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(img, "src", img_src_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(img, "alt", img_alt_value = /*product*/ ctx[139].title);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(img, "class", "svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(img, file, 1381, 12, 62605);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div0, "class", "sb-coffee-img svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div0, file, 1380, 10, 62565);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div1, "class", "sb-coffee-name svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div1, file, 1397, 12, 63640);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div2, "class", "sb-coffee-roasts svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div2, file, 1407, 12, 64148);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div3, "class", "sb-coffee-info svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div3, file, 1396, 10, 63599);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div4, "class", "sb-coffee-card svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(div4, "is-selected", /*totalQty*/ ctx[144] > 0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(div4, "is-roast-disabled", !/*compatible*/ ctx[150]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div4, file, 1379, 8, 62455);
			this.first = div4;
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div4, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, div0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, img);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t0);
			if (if_block0) if_block0.m(div0, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t1);
			if (if_block1) if_block1.m(div0, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, div3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, div1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, t3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, t4);
			if (if_block2) if_block2.m(div3, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, t5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, div2);
			if (if_block3) if_block3.m(div2, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div2, t6);
			if (if_block4) if_block4.m(div2, null);
		},
		p: function update(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty[1] & /*filteredCoffees, bagSizeLabel*/ 514 && !(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.src_url_equal)(img.src, img_src_value = getProductImage(/*product*/ ctx[139], /*bagSizeLabel*/ ctx[32]) || 'https://uploads.coavacoffee.com/production/uploads/subscriptions/subscription_profile_01.jpg')) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(img, "src", img_src_value);
			}

			if (dirty[1] & /*filteredCoffees*/ 512 && img_alt_value !== (img_alt_value = /*product*/ ctx[139].title)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(img, "alt", img_alt_value);
			}

			if (/*totalQty*/ ctx[144] > 0) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_33(ctx);
					if_block0.c();
					if_block0.m(div0, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (current_block_type === (current_block_type = select_block_type_3(ctx, dirty)) && if_block1) {
				if_block1.p(ctx, dirty);
			} else {
				if (if_block1) if_block1.d(1);
				if_block1 = current_block_type && current_block_type(ctx);

				if (if_block1) {
					if_block1.c();
					if_block1.m(div0, null);
				}
			}

			if (dirty[1] & /*filteredCoffees*/ 512 && t3_value !== (t3_value = /*product*/ ctx[139].title + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t3, t3_value);

			if (/*product*/ ctx[139].tags && /*product*/ ctx[139].tags.length) {
				if (if_block2) {
					if_block2.p(ctx, dirty);
				} else {
					if_block2 = create_if_block_29(ctx);
					if_block2.c();
					if_block2.m(div3, t5);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}

			if (/*product*/ ctx[139].hasDrip) {
				if (if_block3) {
					if_block3.p(ctx, dirty);
				} else {
					if_block3 = create_if_block_28(ctx);
					if_block3.c();
					if_block3.m(div2, t6);
				}
			} else if (if_block3) {
				if_block3.d(1);
				if_block3 = null;
			}

			if (/*product*/ ctx[139].hasEspresso) {
				if (if_block4) {
					if_block4.p(ctx, dirty);
				} else {
					if_block4 = create_if_block_27(ctx);
					if_block4.c();
					if_block4.m(div2, null);
				}
			} else if (if_block4) {
				if_block4.d(1);
				if_block4 = null;
			}

			if (dirty[0] & /*coffeeQty*/ 2 | dirty[1] & /*filteredCoffees*/ 512) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(div4, "is-selected", /*totalQty*/ ctx[144] > 0);
			}

			if (dirty[1] & /*roastCompatible, filteredCoffees*/ 4194816) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(div4, "is-roast-disabled", !/*compatible*/ ctx[150]);
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div4);
			if (if_block0) if_block0.d();

			if (if_block1) {
				if_block1.d();
			}

			if (if_block2) if_block2.d();
			if (if_block3) if_block3.d();
			if (if_block4) if_block4.d();
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_each_block_4.name,
		type: "each",
		source: "(1375:6) {#each filteredCoffees as product (product.id)}",
		ctx
	});

	return block;
}

// (1438:6) {#if filteredCoffees.length === 0}
function create_if_block_26(ctx) {
	let p;

	const block = {
		c: function create() {
			p = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("p");
			p.textContent = "No coffees match the selected filters.";
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(p, "class", "sb-no-results svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(p, file, 1438, 8, 65882);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, p, anchor);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(p);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_26.name,
		type: "if",
		source: "(1438:6) {#if filteredCoffees.length === 0}",
		ctx
	});

	return block;
}

// (1445:6) {#if selectedCount > 0}
function create_if_block_25(ctx) {
	let div1;
	let span0;
	let t0_value = (/*step2Done*/ ctx[12] ? '✓' : /*selectedCount*/ ctx[8]) + "";
	let t0;
	let t1;
	let div0;
	let span1;
	let t2;
	let t3;
	let t4;
	let t5;
	let t6_value = (/*bagCount*/ ctx[7] === 1 ? 'bag' : 'bags') + "";
	let t6;
	let t7;
	let span2;

	let t8_value = (/*hasCurated*/ ctx[6]
	? 'Curated by our team'
	: /*coffeeSummaryText*/ ctx[39]) + "";

	let t8;

	const block = {
		c: function create() {
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t0_value);
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*selectedCount*/ ctx[8]);
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(" of ");
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*bagCount*/ ctx[7]);
			t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			t6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t6_value);
			t7 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t8 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t8_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "class", "sb-sel-check svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span0, file, 1446, 10, 66269);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "class", "sb-sel-count svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span1, file, 1448, 12, 66385);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span2, "class", "sb-sel-name svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span2, file, 1449, 12, 66495);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div0, "class", "sb-sel-info svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div0, file, 1447, 10, 66347);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div1, "class", "sb-selection-badge svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(div1, "is-complete", /*step2Done*/ ctx[12]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div1, file, 1445, 8, 66196);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, span0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span0, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, div0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, span1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, t3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, t4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, t5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, t6);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t7);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, span2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span2, t8);
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*step2Done, selectedCount*/ 4352 && t0_value !== (t0_value = (/*step2Done*/ ctx[12] ? '✓' : /*selectedCount*/ ctx[8]) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t0, t0_value);
			if (dirty[0] & /*selectedCount*/ 256) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t2, /*selectedCount*/ ctx[8]);
			if (dirty[0] & /*bagCount*/ 128) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t4, /*bagCount*/ ctx[7]);
			if (dirty[0] & /*bagCount*/ 128 && t6_value !== (t6_value = (/*bagCount*/ ctx[7] === 1 ? 'bag' : 'bags') + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t6, t6_value);

			if (dirty[0] & /*hasCurated*/ 64 | dirty[1] & /*coffeeSummaryText*/ 256 && t8_value !== (t8_value = (/*hasCurated*/ ctx[6]
			? 'Curated by our team'
			: /*coffeeSummaryText*/ ctx[39]) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t8, t8_value);

			if (dirty[0] & /*step2Done*/ 4096) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(div1, "is-complete", /*step2Done*/ ctx[12]);
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div1);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_25.name,
		type: "if",
		source: "(1445:6) {#if selectedCount > 0}",
		ctx
	});

	return block;
}

// (1464:2) {#if currentStep === 3}
function create_if_block(ctx) {
	let div6;
	let div0;
	let p0;
	let t1;
	let h2;
	let t2;
	let span0;
	let t4;
	let div1;
	let span1;
	let t5;
	let t6;
	let span2;
	let t8;
	let span3;
	let t9;
	let t10;
	let span4;
	let t12;
	let span5;
	let t13;
	let t14;
	let t15;
	let t16;
	let p1;
	let t18;
	let t19;
	let t20;
	let t21;
	let div4;
	let div2;
	let t23;
	let t24;
	let t25;
	let div3;
	let span6;
	let t27;
	let span7;

	let t28_value = (/*addonEnabled*/ ctx[9]
	? 'Calculated at checkout'
	: /*formatter*/ ctx[45].format(SHIPPING_FLAT_RATE)) + "";

	let t28;
	let t29;
	let t30;
	let t31;
	let t32;
	let div5;
	let button0;
	let span8;
	let t34;
	let t35;
	let button1;

	let t36_value = (/*submitting*/ ctx[20]
	? 'Adding…'
	: /*subscriptionInCart*/ ctx[30]
		? 'Update My Subscription'
		: 'Add to Cart') + "";

	let t36;
	let button1_disabled_value;
	let t37;
	let current;
	let mounted;
	let dispose;
	let if_block0 = (/*coffeeSummaryText*/ ctx[39] || /*hasCurated*/ ctx[6]) && create_if_block_23(ctx);
	let if_block1 = /*price*/ ctx[22] && create_if_block_22(ctx);
	let if_block2 = /*addonCoffees*/ ctx[10].length > 0 && create_if_block_20(ctx);

	function select_block_type_4(ctx, dirty) {
		if (/*addonCoffees*/ ctx[10].length > 0) return create_if_block_11;
		return create_else_block;
	}

	let current_block_type = select_block_type_4(ctx, [-1, -1, -1, -1, -1, -1]);
	let if_block3 = current_block_type(ctx);
	let if_block4 = /*addonItems*/ ctx[3].length && create_if_block_9(ctx);
	let if_block5 = /*price*/ ctx[22] && create_if_block_6(ctx);
	let if_block6 = /*addonTotalDisplay*/ ctx[34] && create_if_block_5(ctx);
	let if_block7 = /*grandTotal*/ ctx[26] && create_if_block_4(ctx);
	let if_block8 = /*hasCurated*/ ctx[6] && !/*curatedApiAvailable*/ ctx[11] && create_if_block_3(ctx);
	let if_block9 = /*submitError*/ ctx[21] && create_if_block_2(ctx);
	let if_block10 = /*debug*/ ctx[0] && create_if_block_1(ctx);

	const block = {
		c: function create() {
			div6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			p0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("p");
			p0.textContent = "Step 3 of 3";
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			h2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("h2");
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Add-Ons ");
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span0.textContent = "Optional";
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*$sizeDisplayValue*/ ctx[14]);
			t6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span2.textContent = "·";
			t8 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t9 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*$shippingFrequencyDisplayValue*/ ctx[15]);
			t10 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span4.textContent = "·";
			t12 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t13 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*roastSummaryText*/ ctx[38]);
			t14 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block0) if_block0.c();
			t15 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block1) if_block1.c();
			t16 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			p1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("p");
			p1.textContent = "Want extra one-time bags with your first order? Pick any coffees below — they won't recur. Add as many as you like.";
			t18 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block2) if_block2.c();
			t19 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if_block3.c();
			t20 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block4) if_block4.c();
			t21 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div2.textContent = "Your Order";
			t23 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block5) if_block5.c();
			t24 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block6) if_block6.c();
			t25 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span6.textContent = "Shipping";
			t27 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span7 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t28 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t28_value);
			t29 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block7) if_block7.c();
			t30 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block8) if_block8.c();
			t31 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block9) if_block9.c();
			t32 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			button0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			span8 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span8.textContent = "←";
			t34 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(" Back");
			t35 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			button1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t36 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t36_value);
			t37 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block10) if_block10.c();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(p0, "class", "sb-panel-meta svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(p0, file, 1466, 6, 67073);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "class", "sb-optional-tag svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span0, file, 1467, 55, 67169);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(h2, "class", "sb-panel-title svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(h2, "tabindex", "-1");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(h2, file, 1467, 6, 67120);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div0, "class", "sb-panel-header svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div0, file, 1465, 4, 67037);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "class", "sb-summary-pill svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span1, file, 1472, 6, 67301);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span2, "class", "sb-summary-sep svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span2, file, 1473, 6, 67364);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span3, "class", "sb-summary-pill svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span3, file, 1474, 6, 67408);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span4, "class", "sb-summary-sep svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span4, file, 1475, 6, 67484);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span5, "class", "sb-summary-pill svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span5, file, 1476, 6, 67528);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div1, "class", "sb-summary-bar svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div1, file, 1471, 4, 67266);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(p1, "class", "sb-addon-intro svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(p1, file, 1489, 4, 67966);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div2, "class", "sb-order-summary-title svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div2, file, 1660, 6, 76773);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span6, "class", "sb-total-label svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span6, file, 1701, 8, 78639);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span7, "class", "sb-total-val svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span7, file, 1702, 8, 78692);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div3, "class", "sb-total-row svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div3, file, 1700, 6, 78604);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div4, "class", "sb-order-summary svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div4, file, 1659, 4, 76736);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span8, "aria-hidden", "true");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span8, file, 1721, 82, 79462);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "class", "sb-btn-secondary svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button0, file, 1721, 6, 79386);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "class", "sb-btn-cta js-add-subscription svelte-12epoft");
			button1.disabled = button1_disabled_value = !/*isReady*/ ctx[33] || /*submitting*/ ctx[20];
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button1, "is-ready-pulse", /*isReady*/ ctx[33] && !/*submitting*/ ctx[20]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button1, file, 1722, 6, 79516);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div5, "class", "sb-nav sb-nav--split sb-nav--sticky svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div5, file, 1720, 4, 79330);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div6, "class", "sb-panel svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div6, file, 1464, 2, 67010);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div6, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div6, div0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, p0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, h2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(h2, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(h2, span0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div6, t4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div6, div1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, span1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, t5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, t6);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, span2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, t8);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, span3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span3, t9);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, t10);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, span4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, t12);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, span5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span5, t13);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, t14);
			if (if_block0) if_block0.m(div1, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, t15);
			if (if_block1) if_block1.m(div1, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div6, t16);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div6, p1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div6, t18);
			if (if_block2) if_block2.m(div6, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div6, t19);
			if_block3.m(div6, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div6, t20);
			if (if_block4) if_block4.m(div6, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div6, t21);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div6, div4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, div2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, t23);
			if (if_block5) if_block5.m(div4, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, t24);
			if (if_block6) if_block6.m(div4, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, t25);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, div3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, span6);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, t27);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, span7);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span7, t28);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, t29);
			if (if_block7) if_block7.m(div4, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div6, t30);
			if (if_block8) if_block8.m(div6, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div6, t31);
			if (if_block9) if_block9.m(div6, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div6, t32);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div6, div5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div5, button0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button0, span8);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button0, t34);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div5, t35);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div5, button1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button1, t36);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div6, t37);
			if (if_block10) if_block10.m(div6, null);
			current = true;

			if (!mounted) {
				dispose = [
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button0, "click", /*click_handler_34*/ ctx[112], false, false, false, false),
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button1, "click", /*handleAddToCart*/ ctx[64], false, false, false, false)
				];

				mounted = true;
			}
		},
		p: function update(ctx, dirty) {
			if (!current || dirty[0] & /*$sizeDisplayValue*/ 16384) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t5, /*$sizeDisplayValue*/ ctx[14]);
			if (!current || dirty[0] & /*$shippingFrequencyDisplayValue*/ 32768) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t9, /*$shippingFrequencyDisplayValue*/ ctx[15]);
			if (!current || dirty[1] & /*roastSummaryText*/ 128) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t13, /*roastSummaryText*/ ctx[38]);

			if (/*coffeeSummaryText*/ ctx[39] || /*hasCurated*/ ctx[6]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_23(ctx);
					if_block0.c();
					if_block0.m(div1, t15);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*price*/ ctx[22]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_22(ctx);
					if_block1.c();
					if_block1.m(div1, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (/*addonCoffees*/ ctx[10].length > 0) {
				if (if_block2) {
					if_block2.p(ctx, dirty);
				} else {
					if_block2 = create_if_block_20(ctx);
					if_block2.c();
					if_block2.m(div6, t19);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}

			if (current_block_type === (current_block_type = select_block_type_4(ctx, dirty)) && if_block3) {
				if_block3.p(ctx, dirty);
			} else {
				if_block3.d(1);
				if_block3 = current_block_type(ctx);

				if (if_block3) {
					if_block3.c();
					if_block3.m(div6, t20);
				}
			}

			if (/*addonItems*/ ctx[3].length) {
				if (if_block4) {
					if_block4.p(ctx, dirty);
				} else {
					if_block4 = create_if_block_9(ctx);
					if_block4.c();
					if_block4.m(div6, t21);
				}
			} else if (if_block4) {
				if_block4.d(1);
				if_block4 = null;
			}

			if (/*price*/ ctx[22]) {
				if (if_block5) {
					if_block5.p(ctx, dirty);
				} else {
					if_block5 = create_if_block_6(ctx);
					if_block5.c();
					if_block5.m(div4, t24);
				}
			} else if (if_block5) {
				if_block5.d(1);
				if_block5 = null;
			}

			if (/*addonTotalDisplay*/ ctx[34]) {
				if (if_block6) {
					if_block6.p(ctx, dirty);
				} else {
					if_block6 = create_if_block_5(ctx);
					if_block6.c();
					if_block6.m(div4, t25);
				}
			} else if (if_block6) {
				if_block6.d(1);
				if_block6 = null;
			}

			if ((!current || dirty[0] & /*addonEnabled*/ 512) && t28_value !== (t28_value = (/*addonEnabled*/ ctx[9]
			? 'Calculated at checkout'
			: /*formatter*/ ctx[45].format(SHIPPING_FLAT_RATE)) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t28, t28_value);

			if (/*grandTotal*/ ctx[26]) {
				if (if_block7) {
					if_block7.p(ctx, dirty);
				} else {
					if_block7 = create_if_block_4(ctx);
					if_block7.c();
					if_block7.m(div4, null);
				}
			} else if (if_block7) {
				if_block7.d(1);
				if_block7 = null;
			}

			if (/*hasCurated*/ ctx[6] && !/*curatedApiAvailable*/ ctx[11]) {
				if (if_block8) {
					
				} else {
					if_block8 = create_if_block_3(ctx);
					if_block8.c();
					if_block8.m(div6, t31);
				}
			} else if (if_block8) {
				if_block8.d(1);
				if_block8 = null;
			}

			if (/*submitError*/ ctx[21]) {
				if (if_block9) {
					if_block9.p(ctx, dirty);
				} else {
					if_block9 = create_if_block_2(ctx);
					if_block9.c();
					if_block9.m(div6, t32);
				}
			} else if (if_block9) {
				if_block9.d(1);
				if_block9 = null;
			}

			if ((!current || dirty[0] & /*submitting, subscriptionInCart*/ 1074790400) && t36_value !== (t36_value = (/*submitting*/ ctx[20]
			? 'Adding…'
			: /*subscriptionInCart*/ ctx[30]
				? 'Update My Subscription'
				: 'Add to Cart') + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t36, t36_value);

			if (!current || dirty[0] & /*submitting*/ 1048576 | dirty[1] & /*isReady*/ 4 && button1_disabled_value !== (button1_disabled_value = !/*isReady*/ ctx[33] || /*submitting*/ ctx[20])) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.prop_dev)(button1, "disabled", button1_disabled_value);
			}

			if (!current || dirty[0] & /*submitting*/ 1048576 | dirty[1] & /*isReady*/ 4) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button1, "is-ready-pulse", /*isReady*/ ctx[33] && !/*submitting*/ ctx[20]);
			}

			if (/*debug*/ ctx[0]) {
				if (if_block10) {
					if_block10.p(ctx, dirty);

					if (dirty[0] & /*debug*/ 1) {
						(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(if_block10, 1);
					}
				} else {
					if_block10 = create_if_block_1(ctx);
					if_block10.c();
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(if_block10, 1);
					if_block10.m(div6, null);
				}
			} else if (if_block10) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.group_outros)();

				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(if_block10, 1, 1, () => {
					if_block10 = null;
				});

				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.check_outros)();
			}
		},
		i: function intro(local) {
			if (current) return;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(if_block10);
			current = true;
		},
		o: function outro(local) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(if_block10);
			current = false;
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div6);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
			if_block3.d();
			if (if_block4) if_block4.d();
			if (if_block5) if_block5.d();
			if (if_block6) if_block6.d();
			if (if_block7) if_block7.d();
			if (if_block8) if_block8.d();
			if (if_block9) if_block9.d();
			if (if_block10) if_block10.d();
			mounted = false;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.run_all)(dispose);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block.name,
		type: "if",
		source: "(1464:2) {#if currentStep === 3}",
		ctx
	});

	return block;
}

// (1478:6) {#if coffeeSummaryText || hasCurated}
function create_if_block_23(ctx) {
	let span0;
	let t1;
	let span1;

	let t2_value = (/*hasCurated*/ ctx[6]
	? 'Curated by our team'
	: /*coffeeSummaryText*/ ctx[39]) + "";

	let t2;

	const block = {
		c: function create() {
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span0.textContent = "·";
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t2_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "class", "sb-summary-sep svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span0, file, 1478, 8, 67636);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "class", "sb-summary-pill sb-summary-pill--coffee svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span1, file, 1479, 8, 67682);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, span0, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, t1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, span1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, t2);
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*hasCurated*/ 64 | dirty[1] & /*coffeeSummaryText*/ 256 && t2_value !== (t2_value = (/*hasCurated*/ ctx[6]
			? 'Curated by our team'
			: /*coffeeSummaryText*/ ctx[39]) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t2, t2_value);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(span0);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(t1);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(span1);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_23.name,
		type: "if",
		source: "(1478:6) {#if coffeeSummaryText || hasCurated}",
		ctx
	});

	return block;
}

// (1482:6) {#if price}
function create_if_block_22(ctx) {
	let span;
	let t0;
	let t1;

	const block = {
		c: function create() {
			span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*price*/ ctx[22]);
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("/shipment");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "class", "sb-summary-price svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span, file, 1482, 8, 67838);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, span, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span, t1);
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*price*/ 4194304) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t0, /*price*/ ctx[22]);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(span);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_22.name,
		type: "if",
		source: "(1482:6) {#if price}",
		ctx
	});

	return block;
}

// (1493:4) {#if addonCoffees.length > 0}
function create_if_block_20(ctx) {
	let div4;
	let div0;
	let span0;
	let t1;
	let t2;
	let div1;
	let t3;
	let div3;
	let span1;
	let t5;
	let div2;
	let button0;
	let t6;
	let button0_aria_pressed_value;
	let t7;
	let button1;
	let t8;
	let button1_aria_pressed_value;
	let t9;
	let button2;
	let t10;
	let button2_aria_pressed_value;
	let mounted;
	let dispose;
	let if_block = /*addonRoastFilter*/ ctx[4] && create_if_block_21(ctx);

	const block = {
		c: function create() {
			div4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span0.textContent = "Refine add-ons";
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block) if_block.c();
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span1.textContent = "Roast";
			t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			button0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("All");
			t7 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			button1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t8 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Drip");
			t9 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			button2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t10 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("Espresso");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "class", "sb-filters-title svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span0, file, 1495, 10, 68320);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div0, "class", "sb-filters-header svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div0, file, 1494, 8, 68278);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div1, "class", "sb-filters-divider svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div1, file, 1501, 8, 68572);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "class", "sb-filter-group-label svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "id", "sb-lbl-addon-roast");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span1, file, 1504, 10, 68660);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "class", "sb-segment-btn svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "aria-pressed", button0_aria_pressed_value = !/*addonRoastFilter*/ ctx[4]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button0, "is-selected", !/*addonRoastFilter*/ ctx[4]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button0, file, 1506, 12, 68830);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "class", "sb-segment-btn svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "aria-pressed", button1_aria_pressed_value = /*addonRoastFilter*/ ctx[4] === 'Drip');
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button1, "is-selected", /*addonRoastFilter*/ ctx[4] === 'Drip');
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button1, file, 1512, 12, 69084);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button2, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button2, "class", "sb-segment-btn svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button2, "aria-pressed", button2_aria_pressed_value = /*addonRoastFilter*/ ctx[4] === 'Espresso');
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button2, "is-selected", /*addonRoastFilter*/ ctx[4] === 'Espresso');
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button2, file, 1518, 12, 69361);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div2, "class", "sb-segment svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div2, "role", "group");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div2, "aria-labelledby", "sb-lbl-addon-roast");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div2, file, 1505, 10, 68743);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div3, "class", "sb-filter-group svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div3, file, 1503, 8, 68620);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div4, "class", "sb-filters-bar svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div4, file, 1493, 6, 68241);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div4, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, div0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, span0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t1);
			if (if_block) if_block.m(div0, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, div1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, t3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, div3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, span1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, t5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, div2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div2, button0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button0, t6);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div2, t7);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div2, button1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button1, t8);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div2, t9);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div2, button2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button2, t10);

			if (!mounted) {
				dispose = [
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button0, "click", /*click_handler_21*/ ctx[99], false, false, false, false),
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button1, "click", /*click_handler_22*/ ctx[100], false, false, false, false),
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button2, "click", /*click_handler_23*/ ctx[101], false, false, false, false)
				];

				mounted = true;
			}
		},
		p: function update(ctx, dirty) {
			if (/*addonRoastFilter*/ ctx[4]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_21(ctx);
					if_block.c();
					if_block.m(div0, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty[0] & /*addonRoastFilter*/ 16 && button0_aria_pressed_value !== (button0_aria_pressed_value = !/*addonRoastFilter*/ ctx[4])) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "aria-pressed", button0_aria_pressed_value);
			}

			if (dirty[0] & /*addonRoastFilter*/ 16) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button0, "is-selected", !/*addonRoastFilter*/ ctx[4]);
			}

			if (dirty[0] & /*addonRoastFilter*/ 16 && button1_aria_pressed_value !== (button1_aria_pressed_value = /*addonRoastFilter*/ ctx[4] === 'Drip')) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "aria-pressed", button1_aria_pressed_value);
			}

			if (dirty[0] & /*addonRoastFilter*/ 16) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button1, "is-selected", /*addonRoastFilter*/ ctx[4] === 'Drip');
			}

			if (dirty[0] & /*addonRoastFilter*/ 16 && button2_aria_pressed_value !== (button2_aria_pressed_value = /*addonRoastFilter*/ ctx[4] === 'Espresso')) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button2, "aria-pressed", button2_aria_pressed_value);
			}

			if (dirty[0] & /*addonRoastFilter*/ 16) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button2, "is-selected", /*addonRoastFilter*/ ctx[4] === 'Espresso');
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div4);
			if (if_block) if_block.d();
			mounted = false;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.run_all)(dispose);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_20.name,
		type: "if",
		source: "(1493:4) {#if addonCoffees.length > 0}",
		ctx
	});

	return block;
}

// (1497:10) {#if addonRoastFilter}
function create_if_block_21(ctx) {
	let button;
	let mounted;
	let dispose;

	const block = {
		c: function create() {
			button = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			button.textContent = "✕ Clear filter";
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "class", "sb-filters-clear svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button, file, 1497, 12, 68418);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, button, anchor);

			if (!mounted) {
				dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button, "click", /*click_handler_20*/ ctx[98], false, false, false, false);
				mounted = true;
			}
		},
		p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(button);
			mounted = false;
			dispose();
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_21.name,
		type: "if",
		source: "(1497:10) {#if addonRoastFilter}",
		ctx
	});

	return block;
}

// (1615:4) {:else}
function create_else_block(ctx) {
	let p;

	const block = {
		c: function create() {
			p = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("p");
			p.textContent = "No additional coffees available as add-ons.";
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(p, "class", "sb-no-results svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(p, file, 1615, 6, 74462);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, p, anchor);
		},
		p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(p);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_else_block.name,
		type: "else",
		source: "(1615:4) {:else}",
		ctx
	});

	return block;
}

// (1531:4) {#if addonCoffees.length > 0}
function create_if_block_11(ctx) {
	let div;
	let each_blocks = [];
	let each_1_lookup = new Map();
	let t;
	let if_block_anchor;
	let each_value_2 = /*filteredAddons*/ ctx[36];
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_2);
	const get_key = ctx => /*product*/ ctx[139].id;
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_keys)(ctx, each_value_2, get_each_context_2, get_key);

	for (let i = 0; i < each_value_2.length; i += 1) {
		let child_ctx = get_each_context_2(ctx, each_value_2, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block_2(key, child_ctx));
	}

	let if_block = /*filteredAddons*/ ctx[36].length === 0 && create_if_block_12(ctx);

	const block = {
		c: function create() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block) if_block.c();
			if_block_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div, "class", "sb-carousel svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div, file, 1531, 6, 69807);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(div, null);
				}
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, t, anchor);
			if (if_block) if_block.m(target, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, if_block_anchor, anchor);
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*$descriptorFilters*/ 262144 | dirty[1] & /*addonQtyByKey, filteredAddons, bagSizeLabel, addAddon, removeAddon, getCardTags*/ 807403570) {
				each_value_2 = /*filteredAddons*/ ctx[36];
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_2);
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_keys)(ctx, each_value_2, get_each_context_2, get_key);
				each_blocks = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.update_keyed_each)(each_blocks, dirty, get_key, 1, ctx, each_value_2, each_1_lookup, div, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_block, create_each_block_2, null, get_each_context_2);
			}

			if (/*filteredAddons*/ ctx[36].length === 0) {
				if (if_block) {
					
				} else {
					if_block = create_if_block_12(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d();
			}

			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(t);
			if (if_block) if_block.d(detaching);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(if_block_anchor);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_11.name,
		type: "if",
		source: "(1531:4) {#if addonCoffees.length > 0}",
		ctx
	});

	return block;
}

// (1543:14) {#if totalQty > 0}
function create_if_block_19(ctx) {
	let span;
	let t_value = /*totalQty*/ ctx[144] + "";
	let t;
	let span_aria_label_value;

	const block = {
		c: function create() {
			span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "class", "sb-coffee-qty-badge svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "aria-label", span_aria_label_value = "" + (/*totalQty*/ ctx[144] + " selected"));
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span, file, 1543, 16, 70607);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, span, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span, t);
		},
		p: function update(ctx, dirty) {
			if (dirty[1] & /*addonQtyByKey, filteredAddons*/ 48 && t_value !== (t_value = /*totalQty*/ ctx[144] + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t, t_value);

			if (dirty[1] & /*addonQtyByKey, filteredAddons*/ 48 && span_aria_label_value !== (span_aria_label_value = "" + (/*totalQty*/ ctx[144] + " selected"))) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "aria-label", span_aria_label_value);
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(span);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_19.name,
		type: "if",
		source: "(1543:14) {#if totalQty > 0}",
		ctx
	});

	return block;
}

// (1546:14) {#if hasRoasts && !(product.hasDrip && product.hasEspresso)}
function create_if_block_18(ctx) {
	let div;

	let t_value = (/*product*/ ctx[139].hasDrip
	? 'Drip only'
	: 'Espresso only') + "";

	let t;

	const block = {
		c: function create() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div, "class", "sb-roast-unavail svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div, file, 1548, 16, 70985);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, t);
		},
		p: function update(ctx, dirty) {
			if (dirty[1] & /*filteredAddons*/ 32 && t_value !== (t_value = (/*product*/ ctx[139].hasDrip
			? 'Drip only'
			: 'Espresso only') + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t, t_value);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_18.name,
		type: "if",
		source: "(1546:14) {#if hasRoasts && !(product.hasDrip && product.hasEspresso)}",
		ctx
	});

	return block;
}

// (1556:14) {#if product.tags && product.tags.length}
function create_if_block_16(ctx) {
	let show_if = /*getCardTags*/ ctx[52](/*product*/ ctx[139].tags, /*$descriptorFilters*/ ctx[18]).length;
	let if_block_anchor;
	let if_block = show_if && create_if_block_17(ctx);

	const block = {
		c: function create() {
			if (if_block) if_block.c();
			if_block_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
		},
		m: function mount(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, if_block_anchor, anchor);
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*$descriptorFilters*/ 262144 | dirty[1] & /*filteredAddons*/ 32) show_if = /*getCardTags*/ ctx[52](/*product*/ ctx[139].tags, /*$descriptorFilters*/ ctx[18]).length;

			if (show_if) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_17(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		d: function destroy(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(if_block_anchor);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_16.name,
		type: "if",
		source: "(1556:14) {#if product.tags && product.tags.length}",
		ctx
	});

	return block;
}

// (1557:16) {#if getCardTags(product.tags, $descriptorFilters).length}
function create_if_block_17(ctx) {
	let div;
	let each_value_3 = /*getCardTags*/ ctx[52](/*product*/ ctx[139].tags, /*$descriptorFilters*/ ctx[18]);
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_3);
	let each_blocks = [];

	for (let i = 0; i < each_value_3.length; i += 1) {
		each_blocks[i] = create_each_block_3(get_each_context_3(ctx, each_value_3, i));
	}

	const block = {
		c: function create() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div, "class", "sb-coffee-tag-row svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div, file, 1557, 18, 71400);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(div, null);
				}
			}
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*$descriptorFilters*/ 262144 | dirty[1] & /*getCardTags, filteredAddons*/ 2097184) {
				each_value_3 = /*getCardTags*/ ctx[52](/*product*/ ctx[139].tags, /*$descriptorFilters*/ ctx[18]);
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_3);
				let i;

				for (i = 0; i < each_value_3.length; i += 1) {
					const child_ctx = get_each_context_3(ctx, each_value_3, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block_3(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value_3.length;
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks, detaching);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_17.name,
		type: "if",
		source: "(1557:16) {#if getCardTags(product.tags, $descriptorFilters).length}",
		ctx
	});

	return block;
}

// (1559:20) {#each getCardTags(product.tags, $descriptorFilters) as tagInfo}
function create_each_block_3(ctx) {
	let span;
	let t_value = /*tagInfo*/ ctx[147].label + "";
	let t;
	let span_class_value;

	const block = {
		c: function create() {
			span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "class", span_class_value = "sb-coffee-tag sb-coffee-tag--" + /*tagInfo*/ ctx[147].type + " svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span, file, 1559, 22, 71539);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, span, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span, t);
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*$descriptorFilters*/ 262144 | dirty[1] & /*filteredAddons*/ 32 && t_value !== (t_value = /*tagInfo*/ ctx[147].label + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t, t_value);

			if (dirty[0] & /*$descriptorFilters*/ 262144 | dirty[1] & /*filteredAddons*/ 32 && span_class_value !== (span_class_value = "sb-coffee-tag sb-coffee-tag--" + /*tagInfo*/ ctx[147].type + " svelte-12epoft")) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "class", span_class_value);
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(span);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_each_block_3.name,
		type: "each",
		source: "(1559:20) {#each getCardTags(product.tags, $descriptorFilters) as tagInfo}",
		ctx
	});

	return block;
}

// (1566:16) {#if product.hasDrip}
function create_if_block_15(ctx) {
	let div1;
	let span0;
	let t1;
	let div0;
	let button0;
	let t2;
	let button0_disabled_value;
	let t3;
	let span1;
	let t4_value = /*dripQty*/ ctx[140] + "";
	let t4;
	let t5;
	let button1;
	let t6;
	let button1_disabled_value;
	let mounted;
	let dispose;

	function click_handler_24() {
		return /*click_handler_24*/ ctx[102](/*product*/ ctx[139]);
	}

	function click_handler_25() {
		return /*click_handler_25*/ ctx[103](/*product*/ ctx[139]);
	}

	const block = {
		c: function create() {
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span0.textContent = "Drip";
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			button0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("−");
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t4_value);
			t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			button1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("+");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "class", "sb-roast-label svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span0, file, 1567, 20, 71865);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "class", "sb-qty-btn svelte-12epoft");
			button0.disabled = button0_disabled_value = /*dripQty*/ ctx[140] === 0;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "aria-label", "Remove Drip add-on");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button0, file, 1569, 22, 71979);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "class", "sb-qty-val svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span1, file, 1571, 22, 72180);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "class", "sb-qty-btn svelte-12epoft");
			button1.disabled = button1_disabled_value = !addonOrderable(/*product*/ ctx[139], 'Drip', /*bagSizeLabel*/ ctx[32]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "aria-label", "Add Drip add-on");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button1, file, 1572, 22, 72244);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div0, "class", "sb-roast-stepper svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div0, file, 1568, 20, 71926);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div1, "class", "sb-stepper-row svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div1, file, 1566, 18, 71816);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, span0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, div0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, button0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button0, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, span1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, t4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, button1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button1, t6);

			if (!mounted) {
				dispose = [
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button0, "click", click_handler_24, false, false, false, false),
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button1, "click", click_handler_25, false, false, false, false)
				];

				mounted = true;
			}
		},
		p: function update(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty[1] & /*addonQtyByKey, filteredAddons*/ 48 && button0_disabled_value !== (button0_disabled_value = /*dripQty*/ ctx[140] === 0)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.prop_dev)(button0, "disabled", button0_disabled_value);
			}

			if (dirty[1] & /*addonQtyByKey, filteredAddons*/ 48 && t4_value !== (t4_value = /*dripQty*/ ctx[140] + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t4, t4_value);

			if (dirty[1] & /*filteredAddons, bagSizeLabel*/ 34 && button1_disabled_value !== (button1_disabled_value = !addonOrderable(/*product*/ ctx[139], 'Drip', /*bagSizeLabel*/ ctx[32]))) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.prop_dev)(button1, "disabled", button1_disabled_value);
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div1);
			mounted = false;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.run_all)(dispose);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_15.name,
		type: "if",
		source: "(1566:16) {#if product.hasDrip}",
		ctx
	});

	return block;
}

// (1579:16) {#if product.hasEspresso}
function create_if_block_14(ctx) {
	let div1;
	let span0;
	let t1;
	let div0;
	let button0;
	let t2;
	let button0_disabled_value;
	let t3;
	let span1;
	let t4_value = /*espQty*/ ctx[141] + "";
	let t4;
	let t5;
	let button1;
	let t6;
	let button1_disabled_value;
	let mounted;
	let dispose;

	function click_handler_26() {
		return /*click_handler_26*/ ctx[104](/*product*/ ctx[139]);
	}

	function click_handler_27() {
		return /*click_handler_27*/ ctx[105](/*product*/ ctx[139]);
	}

	const block = {
		c: function create() {
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span0.textContent = "Espresso";
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			button0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("−");
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t4_value);
			t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			button1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("+");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "class", "sb-roast-label svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span0, file, 1580, 20, 72657);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "class", "sb-qty-btn svelte-12epoft");
			button0.disabled = button0_disabled_value = /*espQty*/ ctx[141] === 0;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "aria-label", "Remove Espresso add-on");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button0, file, 1582, 22, 72775);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "class", "sb-qty-val svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span1, file, 1584, 22, 72983);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "class", "sb-qty-btn svelte-12epoft");
			button1.disabled = button1_disabled_value = !addonOrderable(/*product*/ ctx[139], 'Espresso', /*bagSizeLabel*/ ctx[32]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "aria-label", "Add Espresso add-on");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button1, file, 1585, 22, 73046);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div0, "class", "sb-roast-stepper svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div0, file, 1581, 20, 72722);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div1, "class", "sb-stepper-row svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div1, file, 1579, 18, 72608);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, span0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, div0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, button0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button0, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, span1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, t4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, button1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button1, t6);

			if (!mounted) {
				dispose = [
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button0, "click", click_handler_26, false, false, false, false),
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button1, "click", click_handler_27, false, false, false, false)
				];

				mounted = true;
			}
		},
		p: function update(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty[1] & /*addonQtyByKey, filteredAddons*/ 48 && button0_disabled_value !== (button0_disabled_value = /*espQty*/ ctx[141] === 0)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.prop_dev)(button0, "disabled", button0_disabled_value);
			}

			if (dirty[1] & /*addonQtyByKey, filteredAddons*/ 48 && t4_value !== (t4_value = /*espQty*/ ctx[141] + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t4, t4_value);

			if (dirty[1] & /*filteredAddons, bagSizeLabel*/ 34 && button1_disabled_value !== (button1_disabled_value = !addonOrderable(/*product*/ ctx[139], 'Espresso', /*bagSizeLabel*/ ctx[32]))) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.prop_dev)(button1, "disabled", button1_disabled_value);
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div1);
			mounted = false;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.run_all)(dispose);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_14.name,
		type: "if",
		source: "(1579:16) {#if product.hasEspresso}",
		ctx
	});

	return block;
}

// (1592:16) {#if !hasRoasts}
function create_if_block_13(ctx) {
	let div1;
	let span0;
	let t1;
	let div0;
	let button0;
	let t2;
	let button0_disabled_value;
	let t3;
	let span1;
	let t4_value = /*plainQty*/ ctx[142] + "";
	let t4;
	let t5;
	let button1;
	let t6;
	let button1_disabled_value;
	let mounted;
	let dispose;

	function click_handler_28() {
		return /*click_handler_28*/ ctx[106](/*product*/ ctx[139]);
	}

	function click_handler_29() {
		return /*click_handler_29*/ ctx[107](/*product*/ ctx[139]);
	}

	const block = {
		c: function create() {
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span0.textContent = "Add";
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			button0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("−");
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t4_value);
			t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			button1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("+");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "class", "sb-roast-label svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span0, file, 1594, 20, 73556);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "class", "sb-qty-btn svelte-12epoft");
			button0.disabled = button0_disabled_value = /*plainQty*/ ctx[142] === 0;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "aria-label", "Remove add-on");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button0, file, 1596, 22, 73669);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "class", "sb-qty-val svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span1, file, 1598, 22, 73864);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "class", "sb-qty-btn svelte-12epoft");
			button1.disabled = button1_disabled_value = !addonOrderable(/*product*/ ctx[139], null, /*bagSizeLabel*/ ctx[32]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "aria-label", "Add add-on");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button1, file, 1599, 22, 73929);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div0, "class", "sb-roast-stepper svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div0, file, 1595, 20, 73616);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div1, "class", "sb-stepper-row svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div1, file, 1593, 18, 73507);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, span0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, div0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, button0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button0, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, span1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, t4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, button1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button1, t6);

			if (!mounted) {
				dispose = [
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button0, "click", click_handler_28, false, false, false, false),
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button1, "click", click_handler_29, false, false, false, false)
				];

				mounted = true;
			}
		},
		p: function update(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty[1] & /*addonQtyByKey, filteredAddons*/ 48 && button0_disabled_value !== (button0_disabled_value = /*plainQty*/ ctx[142] === 0)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.prop_dev)(button0, "disabled", button0_disabled_value);
			}

			if (dirty[1] & /*addonQtyByKey, filteredAddons*/ 48 && t4_value !== (t4_value = /*plainQty*/ ctx[142] + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t4, t4_value);

			if (dirty[1] & /*filteredAddons, bagSizeLabel*/ 34 && button1_disabled_value !== (button1_disabled_value = !addonOrderable(/*product*/ ctx[139], null, /*bagSizeLabel*/ ctx[32]))) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.prop_dev)(button1, "disabled", button1_disabled_value);
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div1);
			mounted = false;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.run_all)(dispose);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_13.name,
		type: "if",
		source: "(1592:16) {#if !hasRoasts}",
		ctx
	});

	return block;
}

// (1533:8) {#each filteredAddons as product (product.id)}
function create_each_block_2(key_1, ctx) {
	let div4;
	let div0;
	let img;
	let img_src_value;
	let img_alt_value;
	let t0;
	let t1;
	let t2;
	let div3;
	let div1;
	let t3_value = /*product*/ ctx[139].title + "";
	let t3;
	let t4;
	let t5;
	let div2;
	let t6;
	let t7;
	let t8;
	let if_block0 = /*totalQty*/ ctx[144] > 0 && create_if_block_19(ctx);
	let if_block1 = /*hasRoasts*/ ctx[143] && !(/*product*/ ctx[139].hasDrip && /*product*/ ctx[139].hasEspresso) && create_if_block_18(ctx);
	let if_block2 = /*product*/ ctx[139].tags && /*product*/ ctx[139].tags.length && create_if_block_16(ctx);
	let if_block3 = /*product*/ ctx[139].hasDrip && create_if_block_15(ctx);
	let if_block4 = /*product*/ ctx[139].hasEspresso && create_if_block_14(ctx);
	let if_block5 = !/*hasRoasts*/ ctx[143] && create_if_block_13(ctx);

	const block = {
		key: key_1,
		first: null,
		c: function create() {
			div4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			img = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("img");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block0) if_block0.c();
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block1) if_block1.c();
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t3_value);
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block2) if_block2.c();
			t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			if (if_block3) if_block3.c();
			t6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block4) if_block4.c();
			t7 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block5) if_block5.c();
			t8 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (!(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.src_url_equal)(img.src, img_src_value = getProductImage(/*product*/ ctx[139], /*bagSizeLabel*/ ctx[32]) || 'https://uploads.coavacoffee.com/production/uploads/subscriptions/subscription_profile_01.jpg')) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(img, "src", img_src_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(img, "alt", img_alt_value = /*product*/ ctx[139].title);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(img, "class", "svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(img, file, 1540, 14, 70371);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div0, "class", "sb-carousel-img svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div0, file, 1539, 12, 70327);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div1, "class", "sb-coffee-name svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div1, file, 1554, 14, 71201);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div2, "class", "sb-coffee-roasts svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div2, file, 1564, 14, 71729);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div3, "class", "sb-coffee-info svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div3, file, 1553, 12, 71158);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div4, "class", "sb-carousel-card svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(div4, "is-selected", /*totalQty*/ ctx[144] > 0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div4, file, 1538, 10, 70251);
			this.first = div4;
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div4, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, div0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, img);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t0);
			if (if_block0) if_block0.m(div0, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t1);
			if (if_block1) if_block1.m(div0, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, div3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, div1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, t3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, t4);
			if (if_block2) if_block2.m(div3, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, t5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, div2);
			if (if_block3) if_block3.m(div2, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div2, t6);
			if (if_block4) if_block4.m(div2, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div2, t7);
			if (if_block5) if_block5.m(div2, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div4, t8);
		},
		p: function update(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty[1] & /*filteredAddons, bagSizeLabel*/ 34 && !(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.src_url_equal)(img.src, img_src_value = getProductImage(/*product*/ ctx[139], /*bagSizeLabel*/ ctx[32]) || 'https://uploads.coavacoffee.com/production/uploads/subscriptions/subscription_profile_01.jpg')) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(img, "src", img_src_value);
			}

			if (dirty[1] & /*filteredAddons*/ 32 && img_alt_value !== (img_alt_value = /*product*/ ctx[139].title)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(img, "alt", img_alt_value);
			}

			if (/*totalQty*/ ctx[144] > 0) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_19(ctx);
					if_block0.c();
					if_block0.m(div0, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*hasRoasts*/ ctx[143] && !(/*product*/ ctx[139].hasDrip && /*product*/ ctx[139].hasEspresso)) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_18(ctx);
					if_block1.c();
					if_block1.m(div0, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (dirty[1] & /*filteredAddons*/ 32 && t3_value !== (t3_value = /*product*/ ctx[139].title + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t3, t3_value);

			if (/*product*/ ctx[139].tags && /*product*/ ctx[139].tags.length) {
				if (if_block2) {
					if_block2.p(ctx, dirty);
				} else {
					if_block2 = create_if_block_16(ctx);
					if_block2.c();
					if_block2.m(div3, t5);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}

			if (/*product*/ ctx[139].hasDrip) {
				if (if_block3) {
					if_block3.p(ctx, dirty);
				} else {
					if_block3 = create_if_block_15(ctx);
					if_block3.c();
					if_block3.m(div2, t6);
				}
			} else if (if_block3) {
				if_block3.d(1);
				if_block3 = null;
			}

			if (/*product*/ ctx[139].hasEspresso) {
				if (if_block4) {
					if_block4.p(ctx, dirty);
				} else {
					if_block4 = create_if_block_14(ctx);
					if_block4.c();
					if_block4.m(div2, t7);
				}
			} else if (if_block4) {
				if_block4.d(1);
				if_block4 = null;
			}

			if (!/*hasRoasts*/ ctx[143]) {
				if (if_block5) {
					if_block5.p(ctx, dirty);
				} else {
					if_block5 = create_if_block_13(ctx);
					if_block5.c();
					if_block5.m(div2, null);
				}
			} else if (if_block5) {
				if_block5.d(1);
				if_block5 = null;
			}

			if (dirty[1] & /*addonQtyByKey, filteredAddons*/ 48) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(div4, "is-selected", /*totalQty*/ ctx[144] > 0);
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div4);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
			if (if_block3) if_block3.d();
			if (if_block4) if_block4.d();
			if (if_block5) if_block5.d();
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_each_block_2.name,
		type: "each",
		source: "(1533:8) {#each filteredAddons as product (product.id)}",
		ctx
	});

	return block;
}

// (1612:6) {#if filteredAddons.length === 0}
function create_if_block_12(ctx) {
	let p;

	const block = {
		c: function create() {
			p = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("p");
			p.textContent = "No add-on coffees match the selected roast.";
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(p, "class", "sb-no-results svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(p, file, 1612, 8, 74359);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, p, anchor);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(p);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_12.name,
		type: "if",
		source: "(1612:6) {#if filteredAddons.length === 0}",
		ctx
	});

	return block;
}

// (1620:4) {#if addonItems.length}
function create_if_block_9(ctx) {
	let div;
	let each_blocks = [];
	let each_1_lookup = new Map();
	let each_value = /*addonItems*/ ctx[3];
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value);
	const get_key = ctx => /*item*/ ctx[132].id;
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_keys)(ctx, each_value, get_each_context, get_key);

	for (let i = 0; i < each_value.length; i += 1) {
		let child_ctx = get_each_context(ctx, each_value, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block(key, child_ctx));
	}

	const block = {
		c: function create() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div, "class", "sb-addon-list svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div, file, 1620, 6, 74638);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(div, null);
				}
			}
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*addonItems*/ 8 | dirty[1] & /*removeAddonItem, formatter, getVariantPrice*/ 1073790976 | dirty[2] & /*changeAddonQty, setAddonSize*/ 3) {
				each_value = /*addonItems*/ ctx[3];
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value);
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_keys)(ctx, each_value, get_each_context, get_key);
				each_blocks = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.update_keyed_each)(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, div, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_block, create_each_block, null, get_each_context);
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d();
			}
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_9.name,
		type: "if",
		source: "(1620:4) {#if addonItems.length}",
		ctx
	});

	return block;
}

// (1627:12) {#if item.roast}
function create_if_block_10(ctx) {
	let span;
	let t_value = /*item*/ ctx[132].roast + "";
	let t;

	const block = {
		c: function create() {
			span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t_value);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "class", "sb-addon-row-roast svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span, file, 1627, 14, 75024);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, span, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span, t);
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*addonItems*/ 8 && t_value !== (t_value = /*item*/ ctx[132].roast + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t, t_value);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(span);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_10.name,
		type: "if",
		source: "(1627:12) {#if item.roast}",
		ctx
	});

	return block;
}

// (1633:14) {#each [{ val: '300g', label: '300g' }, { val: '1 Kilo', label: '1 kg' }] as opt}
function create_each_block_1(ctx) {
	let button;
	let t0_value = /*opt*/ ctx[135].label + "";
	let t0;
	let t1;

	let t2_value = (/*sizeOk*/ ctx[136]
	? /*formatter*/ ctx[45].format(/*getVariantPrice*/ ctx[46](/*item*/ ctx[132].product, /*opt*/ ctx[135].val))
	: 'unavailable') + "";

	let t2;
	let t3;
	let button_disabled_value;
	let button_title_value;
	let mounted;
	let dispose;

	function click_handler_30() {
		return /*click_handler_30*/ ctx[108](/*item*/ ctx[132], /*opt*/ ctx[135]);
	}

	const block = {
		c: function create() {
			button = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t0_value);
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(" — ");
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t2_value);
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "class", "sb-chip svelte-12epoft");
			button.disabled = button_disabled_value = !/*sizeOk*/ ctx[136];

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "title", button_title_value = /*sizeOk*/ ctx[136]
			? ''
			: `${/*item*/ ctx[132].product.title} isn't sold in ${/*opt*/ ctx[135].label}`);

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button, "is-selected", /*item*/ ctx[132].size === /*opt*/ ctx[135].val);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button, file, 1634, 16, 75511);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, button, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button, t3);

			if (!mounted) {
				dispose = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button, "click", click_handler_30, false, false, false, false);
				mounted = true;
			}
		},
		p: function update(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty[0] & /*addonItems*/ 8 && t2_value !== (t2_value = (/*sizeOk*/ ctx[136]
			? /*formatter*/ ctx[45].format(/*getVariantPrice*/ ctx[46](/*item*/ ctx[132].product, /*opt*/ ctx[135].val))
			: 'unavailable') + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t2, t2_value);

			if (dirty[0] & /*addonItems*/ 8 && button_disabled_value !== (button_disabled_value = !/*sizeOk*/ ctx[136])) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.prop_dev)(button, "disabled", button_disabled_value);
			}

			if (dirty[0] & /*addonItems*/ 8 && button_title_value !== (button_title_value = /*sizeOk*/ ctx[136]
			? ''
			: `${/*item*/ ctx[132].product.title} isn't sold in ${/*opt*/ ctx[135].label}`)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button, "title", button_title_value);
			}

			if (dirty[0] & /*addonItems*/ 8) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.toggle_class)(button, "is-selected", /*item*/ ctx[132].size === /*opt*/ ctx[135].val);
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(button);
			mounted = false;
			dispose();
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_each_block_1.name,
		type: "each",
		source: "(1633:14) {#each [{ val: '300g', label: '300g' }, { val: '1 Kilo', label: '1 kg' }] as opt}",
		ctx
	});

	return block;
}

// (1622:8) {#each addonItems as item (item.id)}
function create_each_block(key_1, ctx) {
	let div2;
	let span0;
	let t0_value = /*item*/ ctx[132].product.title + "";
	let t0;
	let t1;
	let t2;
	let div0;
	let t3;
	let div1;
	let button0;
	let t4;
	let button0_disabled_value;
	let t5;
	let span1;
	let t6_value = /*item*/ ctx[132].qty + "";
	let t6;
	let t7;
	let button1;
	let t9;
	let span2;
	let t10_value = /*formatter*/ ctx[45].format(/*getVariantPrice*/ ctx[46](/*item*/ ctx[132].product, /*item*/ ctx[132].size) * /*item*/ ctx[132].qty) + "";
	let t10;
	let t11;
	let button2;
	let t13;
	let mounted;
	let dispose;
	let if_block = /*item*/ ctx[132].roast && create_if_block_10(ctx);
	let each_value_1 = [{ val: '300g', label: '300g' }, { val: '1 Kilo', label: '1 kg' }];
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_1);
	let each_blocks = [];

	for (let i = 0; i < 2; i += 1) {
		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	function click_handler_31() {
		return /*click_handler_31*/ ctx[109](/*item*/ ctx[132]);
	}

	function click_handler_32() {
		return /*click_handler_32*/ ctx[110](/*item*/ ctx[132]);
	}

	function click_handler_33() {
		return /*click_handler_33*/ ctx[111](/*item*/ ctx[132]);
	}

	const block = {
		key: key_1,
		first: null,
		c: function create() {
			div2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t0_value);
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block) if_block.c();
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");

			for (let i = 0; i < 2; i += 1) {
				each_blocks[i].c();
			}

			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			button0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("−");
			t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t6 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t6_value);
			t7 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			button1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			button1.textContent = "+";
			t9 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t10 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t10_value);
			t11 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			button2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("button");
			button2.textContent = "✕";
			t13 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "class", "sb-addon-row-name svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span0, file, 1623, 12, 74760);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div0, "class", "sb-chip-row svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div0, file, 1631, 12, 75283);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button0, "class", "sb-qty-btn svelte-12epoft");
			button0.disabled = button0_disabled_value = /*item*/ ctx[132].qty <= 1;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button0, file, 1644, 14, 76035);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "class", "sb-qty-val svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span1, file, 1646, 14, 76184);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button1, "class", "sb-qty-btn svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button1, file, 1647, 14, 76241);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div1, "class", "sb-qty-row svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div1, file, 1643, 12, 75996);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span2, "class", "sb-addon-row-price svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span2, file, 1650, 12, 76381);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button2, "type", "button");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button2, "class", "sb-addon-remove svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(button2, "aria-label", "Remove add-on");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(button2, file, 1651, 12, 76505);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div2, "class", "sb-addon-row svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div2, file, 1622, 10, 74721);
			this.first = div2;
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div2, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div2, span0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span0, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div2, t1);
			if (if_block) if_block.m(div2, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div2, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div2, div0);

			for (let i = 0; i < 2; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(div0, null);
				}
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div2, t3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div2, div1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, button0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(button0, t4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, t5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, span1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, t6);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, t7);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div1, button1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div2, t9);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div2, span2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span2, t10);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div2, t11);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div2, button2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div2, t13);

			if (!mounted) {
				dispose = [
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button0, "click", click_handler_31, false, false, false, false),
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button1, "click", click_handler_32, false, false, false, false),
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.listen_dev)(button2, "click", click_handler_33, false, false, false, false)
				];

				mounted = true;
			}
		},
		p: function update(new_ctx, dirty) {
			ctx = new_ctx;
			if (dirty[0] & /*addonItems*/ 8 && t0_value !== (t0_value = /*item*/ ctx[132].product.title + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t0, t0_value);

			if (/*item*/ ctx[132].roast) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_10(ctx);
					if_block.c();
					if_block.m(div2, t2);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty[0] & /*addonItems*/ 8 | dirty[1] & /*formatter, getVariantPrice*/ 49152 | dirty[2] & /*setAddonSize*/ 1) {
				each_value_1 = [{ val: '300g', label: '300g' }, { val: '1 Kilo', label: '1 kg' }];
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_1);
				let i;

				for (i = 0; i < 2; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block_1(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div0, null);
					}
				}

				for (; i < 2; i += 1) {
					each_blocks[i].d(1);
				}
			}

			if (dirty[0] & /*addonItems*/ 8 && button0_disabled_value !== (button0_disabled_value = /*item*/ ctx[132].qty <= 1)) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.prop_dev)(button0, "disabled", button0_disabled_value);
			}

			if (dirty[0] & /*addonItems*/ 8 && t6_value !== (t6_value = /*item*/ ctx[132].qty + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t6, t6_value);
			if (dirty[0] & /*addonItems*/ 8 && t10_value !== (t10_value = /*formatter*/ ctx[45].format(/*getVariantPrice*/ ctx[46](/*item*/ ctx[132].product, /*item*/ ctx[132].size) * /*item*/ ctx[132].qty) + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t10, t10_value);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div2);
			if (if_block) if_block.d();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks, detaching);
			mounted = false;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.run_all)(dispose);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_each_block.name,
		type: "each",
		source: "(1622:8) {#each addonItems as item (item.id)}",
		ctx
	});

	return block;
}

// (1686:6) {#if price}
function create_if_block_6(ctx) {
	let div;
	let span0;
	let t1;
	let span1;
	let t2;
	let t3;
	let t4;
	let if_block0 = /*originalPrice*/ ctx[27] && create_if_block_8(ctx);
	let if_block1 = /*discountApplied*/ ctx[25] && create_if_block_7(ctx);

	const block = {
		c: function create() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span0.textContent = "Subscription";
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			if (if_block0) if_block0.c();
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*price*/ ctx[22]);
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("/shipment ");
			if (if_block1) if_block1.c();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "class", "sb-total-label svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span0, file, 1687, 10, 77976);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "class", "sb-total-val svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span1, file, 1688, 10, 78035);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div, "class", "sb-total-row svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div, file, 1686, 8, 77939);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, span0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, span1);
			if (if_block0) if_block0.m(span1, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, t3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, t4);
			if (if_block1) if_block1.m(span1, null);
		},
		p: function update(ctx, dirty) {
			if (/*originalPrice*/ ctx[27]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_8(ctx);
					if_block0.c();
					if_block0.m(span1, t2);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (dirty[0] & /*price*/ 4194304) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t3, /*price*/ ctx[22]);

			if (/*discountApplied*/ ctx[25]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_7(ctx);
					if_block1.c();
					if_block1.m(span1, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_6.name,
		type: "if",
		source: "(1686:6) {#if price}",
		ctx
	});

	return block;
}

// (1690:12) {#if originalPrice}
function create_if_block_8(ctx) {
	let span;
	let t;

	const block = {
		c: function create() {
			span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*originalPrice*/ ctx[27]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "class", "sb-price-original svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span, file, 1689, 31, 78094);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, span, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span, t);
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*originalPrice*/ 134217728) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t, /*originalPrice*/ ctx[27]);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(span);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_8.name,
		type: "if",
		source: "(1690:12) {#if originalPrice}",
		ctx
	});

	return block;
}

// (1691:29) {#if discountApplied}
function create_if_block_7(ctx) {
	let span;

	const block = {
		c: function create() {
			span = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span.textContent = `${/*DISCOUNT_LABEL*/ ctx[44]}`;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span, "class", "sb-badge-discount svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span, file, 1690, 50, 78204);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, span, anchor);
		},
		p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(span);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_7.name,
		type: "if",
		source: "(1691:29) {#if discountApplied}",
		ctx
	});

	return block;
}

// (1695:6) {#if addonTotalDisplay}
function create_if_block_5(ctx) {
	let div;
	let span0;
	let t0;
	let t1_value = /*addonItems*/ ctx[3].length + "";
	let t1;
	let t2;
	let t3;
	let span2;
	let t4;
	let t5;
	let span1;

	const block = {
		c: function create() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)("One-time add-ons (");
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(t1_value);
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(")");
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*addonTotalDisplay*/ ctx[34]);
			t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span1.textContent = "one-time";
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "class", "sb-total-label svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span0, file, 1696, 10, 78385);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "class", "sb-onetime-badge svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span1, file, 1697, 57, 78517);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span2, "class", "sb-total-val svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span2, file, 1697, 10, 78470);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div, "class", "sb-total-row svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div, file, 1695, 8, 78348);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, span0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span0, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span0, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span0, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, t3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, span2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span2, t4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span2, t5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span2, span1);
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*addonItems*/ 8 && t1_value !== (t1_value = /*addonItems*/ ctx[3].length + "")) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t1, t1_value);
			if (dirty[1] & /*addonTotalDisplay*/ 8) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t4, /*addonTotalDisplay*/ ctx[34]);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_5.name,
		type: "if",
		source: "(1695:6) {#if addonTotalDisplay}",
		ctx
	});

	return block;
}

// (1705:6) {#if grandTotal}
function create_if_block_4(ctx) {
	let div;
	let span0;
	let t1;
	let span1;
	let t2;

	const block = {
		c: function create() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			span0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			span0.textContent = "Grand Total";
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			span1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("span");
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*grandTotal*/ ctx[26]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span0, "class", "sb-total-label sb-grand-label svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span0, file, 1706, 10, 78908);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(span1, "class", "sb-total-val sb-grand-val svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(span1, file, 1707, 10, 78981);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div, "class", "sb-total-row sb-total-row--grand svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div, file, 1705, 8, 78851);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, span0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div, span1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(span1, t2);
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*grandTotal*/ 67108864) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t2, /*grandTotal*/ ctx[26]);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_4.name,
		type: "if",
		source: "(1705:6) {#if grandTotal}",
		ctx
	});

	return block;
}

// (1713:4) {#if hasCurated && !curatedApiAvailable}
function create_if_block_3(ctx) {
	let p;

	const block = {
		c: function create() {
			p = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("p");
			p.textContent = "Curated subscriptions require manual setup — please contact us to finalize.";
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(p, "class", "sb-curated-note svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(p, file, 1713, 6, 79131);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, p, anchor);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(p);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_3.name,
		type: "if",
		source: "(1713:4) {#if hasCurated && !curatedApiAvailable}",
		ctx
	});

	return block;
}

// (1717:4) {#if submitError}
function create_if_block_2(ctx) {
	let p;
	let t;

	const block = {
		c: function create() {
			p = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("p");
			t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*submitError*/ ctx[21]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(p, "class", "sb-error svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(p, file, 1717, 6, 79277);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, p, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(p, t);
		},
		p: function update(ctx, dirty) {
			if (dirty[0] & /*submitError*/ 2097152) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t, /*submitError*/ ctx[21]);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(p);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_2.name,
		type: "if",
		source: "(1717:4) {#if submitError}",
		ctx
	});

	return block;
}

// (1731:4) {#if debug}
function create_if_block_1(ctx) {
	let hiddenfield0;
	let t0;
	let hiddenfield1;
	let t1;
	let hiddenfield2;
	let t2;
	let hiddenfield3;
	let t3;
	let hiddenfield4;
	let t4;
	let hiddenfield5;
	let t5;
	let hiddenfield6;
	let current;

	hiddenfield0 = new _subscriptions_hiddenField_svelte__WEBPACK_IMPORTED_MODULE_2__["default"]({
			props: {
				debug: /*debug*/ ctx[0],
				name: "debug_bagCount",
				value: String(/*bagCount*/ ctx[7])
			},
			$$inline: true
		});

	hiddenfield1 = new _subscriptions_hiddenField_svelte__WEBPACK_IMPORTED_MODULE_2__["default"]({
			props: {
				debug: /*debug*/ ctx[0],
				name: "debug_selected",
				value: String(/*selectedCount*/ ctx[8])
			},
			$$inline: true
		});

	hiddenfield2 = new _subscriptions_hiddenField_svelte__WEBPACK_IMPORTED_MODULE_2__["default"]({
			props: {
				debug: /*debug*/ ctx[0],
				name: "debug_coffees",
				value: /*coffeeSummaryText*/ ctx[39]
			},
			$$inline: true
		});

	hiddenfield3 = new _subscriptions_hiddenField_svelte__WEBPACK_IMPORTED_MODULE_2__["default"]({
			props: {
				debug: /*debug*/ ctx[0],
				name: "debug_roast",
				value: /*$roast*/ ctx[19]
			},
			$$inline: true
		});

	hiddenfield4 = new _subscriptions_hiddenField_svelte__WEBPACK_IMPORTED_MODULE_2__["default"]({
			props: {
				debug: /*debug*/ ctx[0],
				name: "debug_size",
				value: /*$sizeDisplayValue*/ ctx[14]
			},
			$$inline: true
		});

	hiddenfield5 = new _subscriptions_hiddenField_svelte__WEBPACK_IMPORTED_MODULE_2__["default"]({
			props: {
				debug: /*debug*/ ctx[0],
				name: "debug_frequency",
				value: /*$shippingFrequencyDisplayValue*/ ctx[15]
			},
			$$inline: true
		});

	hiddenfield6 = new _subscriptions_hiddenField_svelte__WEBPACK_IMPORTED_MODULE_2__["default"]({
			props: {
				debug: /*debug*/ ctx[0],
				name: "debug_addons",
				value: /*addonItems*/ ctx[3].map(func).join('; ')
			},
			$$inline: true
		});

	const block = {
		c: function create() {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(hiddenfield0.$$.fragment);
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(hiddenfield1.$$.fragment);
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(hiddenfield2.$$.fragment);
			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(hiddenfield3.$$.fragment);
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(hiddenfield4.$$.fragment);
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(hiddenfield5.$$.fragment);
			t5 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_component)(hiddenfield6.$$.fragment);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(hiddenfield0, target, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, t0, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(hiddenfield1, target, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, t1, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(hiddenfield2, target, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, t2, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(hiddenfield3, target, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, t3, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(hiddenfield4, target, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, t4, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(hiddenfield5, target, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, t5, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.mount_component)(hiddenfield6, target, anchor);
			current = true;
		},
		p: function update(ctx, dirty) {
			const hiddenfield0_changes = {};
			if (dirty[0] & /*debug*/ 1) hiddenfield0_changes.debug = /*debug*/ ctx[0];
			if (dirty[0] & /*bagCount*/ 128) hiddenfield0_changes.value = String(/*bagCount*/ ctx[7]);
			hiddenfield0.$set(hiddenfield0_changes);
			const hiddenfield1_changes = {};
			if (dirty[0] & /*debug*/ 1) hiddenfield1_changes.debug = /*debug*/ ctx[0];
			if (dirty[0] & /*selectedCount*/ 256) hiddenfield1_changes.value = String(/*selectedCount*/ ctx[8]);
			hiddenfield1.$set(hiddenfield1_changes);
			const hiddenfield2_changes = {};
			if (dirty[0] & /*debug*/ 1) hiddenfield2_changes.debug = /*debug*/ ctx[0];
			if (dirty[1] & /*coffeeSummaryText*/ 256) hiddenfield2_changes.value = /*coffeeSummaryText*/ ctx[39];
			hiddenfield2.$set(hiddenfield2_changes);
			const hiddenfield3_changes = {};
			if (dirty[0] & /*debug*/ 1) hiddenfield3_changes.debug = /*debug*/ ctx[0];
			if (dirty[0] & /*$roast*/ 524288) hiddenfield3_changes.value = /*$roast*/ ctx[19];
			hiddenfield3.$set(hiddenfield3_changes);
			const hiddenfield4_changes = {};
			if (dirty[0] & /*debug*/ 1) hiddenfield4_changes.debug = /*debug*/ ctx[0];
			if (dirty[0] & /*$sizeDisplayValue*/ 16384) hiddenfield4_changes.value = /*$sizeDisplayValue*/ ctx[14];
			hiddenfield4.$set(hiddenfield4_changes);
			const hiddenfield5_changes = {};
			if (dirty[0] & /*debug*/ 1) hiddenfield5_changes.debug = /*debug*/ ctx[0];
			if (dirty[0] & /*$shippingFrequencyDisplayValue*/ 32768) hiddenfield5_changes.value = /*$shippingFrequencyDisplayValue*/ ctx[15];
			hiddenfield5.$set(hiddenfield5_changes);
			const hiddenfield6_changes = {};
			if (dirty[0] & /*debug*/ 1) hiddenfield6_changes.debug = /*debug*/ ctx[0];
			if (dirty[0] & /*addonItems*/ 8) hiddenfield6_changes.value = /*addonItems*/ ctx[3].map(func).join('; ');
			hiddenfield6.$set(hiddenfield6_changes);
		},
		i: function intro(local) {
			if (current) return;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(hiddenfield0.$$.fragment, local);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(hiddenfield1.$$.fragment, local);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(hiddenfield2.$$.fragment, local);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(hiddenfield3.$$.fragment, local);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(hiddenfield4.$$.fragment, local);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(hiddenfield5.$$.fragment, local);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(hiddenfield6.$$.fragment, local);
			current = true;
		},
		o: function outro(local) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(hiddenfield0.$$.fragment, local);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(hiddenfield1.$$.fragment, local);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(hiddenfield2.$$.fragment, local);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(hiddenfield3.$$.fragment, local);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(hiddenfield4.$$.fragment, local);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(hiddenfield5.$$.fragment, local);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(hiddenfield6.$$.fragment, local);
			current = false;
		},
		d: function destroy(detaching) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(hiddenfield0, detaching);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(hiddenfield1, detaching);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(hiddenfield2, detaching);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(hiddenfield3, detaching);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(t3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(hiddenfield4, detaching);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(t4);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(hiddenfield5, detaching);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(t5);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_component)(hiddenfield6, detaching);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_1.name,
		type: "if",
		source: "(1731:4) {#if debug}",
		ctx
	});

	return block;
}

function create_fragment(ctx) {
	let div3;
	let div0;
	let t0;
	let t1;
	let div1;
	let t2;
	let div2;
	let t3;
	let t4;
	let current;

	let each_value_11 = [
		{ n: 1, label: 'How Much' },
		{ n: 2, label: 'Your Coffee' },
		{ n: 3, label: 'Add-Ons' }
	];

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_11);
	let each_blocks = [];

	for (let i = 0; i < 3; i += 1) {
		each_blocks[i] = create_each_block_11(get_each_context_11(ctx, each_value_11, i));
	}

	let if_block0 = /*currentStep*/ ctx[5] === 1 && create_if_block_40(ctx);
	let if_block1 = /*currentStep*/ ctx[5] === 2 && create_if_block_24(ctx);
	let if_block2 = /*currentStep*/ ctx[5] === 3 && create_if_block(ctx);

	const block = {
		c: function create() {
			div3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*liveMessage*/ ctx[28]);
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");

			for (let i = 0; i < 3; i += 1) {
				each_blocks[i].c();
			}

			t2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			div2 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			if (if_block0) if_block0.c();
			t3 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block1) if_block1.c();
			t4 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block2) if_block2.c();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div0, "class", "sb-sr-only svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div0, "role", "status");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div0, "aria-live", "polite");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div0, "aria-atomic", "true");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div0, file, 1085, 2, 48430);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div1, "class", "sb-steps svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div1, file, 1088, 2, 48561);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div2, "class", "sb-main svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div2, file, 1110, 2, 49405);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(div3, "class", "sb svelte-12epoft");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(div3, file, 1083, 0, 48386);
		},
		l: function claim(nodes) {
			throw new Error_1("options.hydrate only works if the component was compiled with the `hydratable: true` option");
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, div3, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, div0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div0, t0);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, t1);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, div1);

			for (let i = 0; i < 3; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(div1, null);
				}
			}

			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, t2);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div3, div2);
			if (if_block0) if_block0.m(div2, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div2, t3);
			if (if_block1) if_block1.m(div2, null);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(div2, t4);
			if (if_block2) if_block2.m(div2, null);
			/*div3_binding*/ ctx[113](div3);
			current = true;
		},
		p: function update(ctx, dirty) {
			if (!current || dirty[0] & /*liveMessage*/ 268435456) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t0, /*liveMessage*/ ctx[28]);

			if (dirty[0] & /*step1Done, step2Done, currentStep*/ 12320 | dirty[1] & /*goToStep*/ 65536) {
				each_value_11 = [
					{ n: 1, label: 'How Much' },
					{ n: 2, label: 'Your Coffee' },
					{ n: 3, label: 'Add-Ons' }
				];

				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_each_argument)(each_value_11);
				let i;

				for (i = 0; i < 3; i += 1) {
					const child_ctx = get_each_context_11(ctx, each_value_11, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block_11(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div1, null);
					}
				}

				for (; i < 3; i += 1) {
					each_blocks[i].d(1);
				}
			}

			if (/*currentStep*/ ctx[5] === 1) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_40(ctx);
					if_block0.c();
					if_block0.m(div2, t3);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*currentStep*/ ctx[5] === 2) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_24(ctx);
					if_block1.c();
					if_block1.m(div2, t4);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (/*currentStep*/ ctx[5] === 3) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty[0] & /*currentStep*/ 32) {
						(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block(ctx);
					if_block2.c();
					(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(if_block2, 1);
					if_block2.m(div2, null);
				}
			} else if (if_block2) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.group_outros)();

				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.check_outros)();
			}
		},
		i: function intro(local) {
			if (current) return;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_in)(if_block2);
			current = true;
		},
		o: function outro(local) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.transition_out)(if_block2);
			current = false;
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(div3);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.destroy_each)(each_blocks, detaching);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
			/*div3_binding*/ ctx[113](null);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

const DISCOUNT_PCT = 0.05;

// Subscribe & Save kicks in at this many bags per shipment; below it, full price.
const MIN_DISCOUNT_BAGS = 2;

const SHIPPING_FLAT_RATE = 6.95;

// ── Persistence: keep the full selection in localStorage until checkout / cache clear ──
const STORAGE_KEY = 'coavaSubBuilder';

function fmtPrice(n) {
	const s = n.toFixed(2);
	return '$' + (s.endsWith('.00') ? s.slice(0, -3) : s);
}

function getProductImage(product, sizeLabel) {
	if (!product || !product.variants || !product.variants.length) return product && product.image;

	const sizeKey = (sizeLabel || '').toLowerCase().includes('kilo')
	? 'kilo'
	: '300';

	const match = product.variants.find(v => {
		const opts = ((v.option1 || '') + ' ' + (v.option2 || '')).toLowerCase();
		return opts.includes(sizeKey) && v.image;
	});

	return match && match.image || product.image;
}

// ── Shared availability rules (steps 2 and 3) ──
/**
 * Is `roastVal` actually orderable for this product? Distinct from roastCompatible(),
 * which is a filter test: this is a hard rule — a Drip-only coffee must never be
 * ordered as Espresso. Products carrying no roast options at all (non-coffee add-ons)
 * are orderable only with a null roast.
 */
function roastAvailable(product, roastVal) {
	if (!product) return false;
	if (!roastVal) return !product.hasDrip && !product.hasEspresso;
	if (roastVal === 'Drip') return !!product.hasDrip;
	if (roastVal === 'Espresso') return !!product.hasEspresso;
	return false;
}

/**
 * Does a real, in-stock variant exist for this size? getVariantPrice() and
 * getCoffeeVariantId() both fall back when they can't match (a flat price, and
 * variants[0] respectively), which is fine for display but useless for validation —
 * an unmatched 1 Kilo would show $62.50 and then quietly order the 300g variant.
 */
function variantSizeMatches(optsLower, sizeLabel) {
	if (!(sizeLabel || '').toLowerCase().includes('kilo')) return optsLower.includes('300');

	// A 2 Kilo / 3 Kilo variant must not satisfy a 1 Kilo request.
	if ((/(^|[^\d])[2-9]\s*kilo/).test(optsLower)) return false;

	return optsLower.includes('kilo');
}

function sizeVariantAvailable(product, roastVal, sizeLabel) {
	return (product && product.variants || []).some(v => {
		if (v.available === false) return false;
		const opts = ((v.option1 || '') + ' ' + (v.option2 || '')).toLowerCase();
		if (!variantSizeMatches(opts, sizeLabel)) return false;
		return roastVal ? opts.includes(roastVal.toLowerCase()) : true;
	});
}

// Prefer the bag size chosen in step 1; fall back to the other size when this coffee
// doesn't sell it. null means nothing is orderable for this roast at all.
function resolveAddonSize(product, roastVal, preferred) {
	if (sizeVariantAvailable(product, roastVal, preferred)) return preferred;

	const other = (preferred || '').toLowerCase().includes('kilo')
	? '300g'
	: '1 Kilo';

	return sizeVariantAvailable(product, roastVal, other)
	? other
	: null;
}

// `preferred` is passed in from the markup rather than read off bagSizeLabel here, so
// Svelte re-evaluates the card steppers when the step-1 bag size changes.
function addonOrderable(product, roastVal, preferred) {
	return roastAvailable(product, roastVal) && !!resolveAddonSize(product, roastVal, preferred);
}

// ── Add-on identity: one line per product + roast ──
// Products with no roast options at all (non-coffee add-ons) collapse to a single
// roast-less key.
function addonKey(productId, roastVal) {
	return `${productId}:${roastVal || ''}`;
}

/**
 * Collapse duplicates by key, summing quantities. The {#each} over addonItems is keyed
 * by item.id, so two entries sharing a key would be a runtime error — restore and cart
 * sync both build their lists from untrusted data, so they merge through here first.
 */
function mergeAddonItems(list) {
	const merged = [];

	for (const it of list) {
		const existing = merged.find(m => m.id === it.id);
		if (existing) existing.qty += it.qty; else merged.push({ ...it });
	}

	return merged;
}

function cartHasBundle(cart) {
	return (cart && cart.items || []).some(l => (l.properties || {})._rc_bundle);
}

function groupMatches(productTags, activeLabels, options) {
	if (!activeLabels.length) return true;

	return activeLabels.some(label => {
		const opt = options.find(o => o.label === label);

		return opt
		? opt.tags.some(t => productTags.includes(t))
		: false;
	});
}

async function fetchSellingPlanId(productHandle, freqDisplayValue) {
	try {
		const res = await fetch(`/products/${productHandle}.js`);
		if (!res.ok) return { id: null };
		const data = await res.json();
		const allPlans = (data.selling_plan_groups || []).flatMap(g => g.selling_plans || []);
		if (!allPlans.length) return { id: null };
		const freqKey = freqDisplayValue.toLowerCase().replace(/[\s-]/g, '');

		const plan = allPlans.find(p => {
			const pname = (p.name || '').toLowerCase().replace(/[\s-]/g, '');
			if (pname === freqKey || pname.includes(freqKey) || freqKey.includes(pname)) return true;
			if (freqKey === 'monthly') return pname.includes('month');
			if (freqKey === 'biweekly') return pname.includes('week') && (pname.includes('2') || pname.includes('bi') || pname.includes('other'));
			return false;
		});

		return plan ? { id: plan.id } : { id: null };
	} catch(e) {
		return { id: null };
	}
}

function getCoffeeVariantId(coffeeProduct, selectedRoast, selectedSize) {
	if (!coffeeProduct || coffeeProduct.id === 'curated') return null;
	const variants = coffeeProduct.variants || [];
	if (!variants.length) return null;

	const sizeKey = selectedSize && selectedSize.toLowerCase().includes('kilo')
	? 'kilo'
	: '300g';

	if (selectedRoast && selectedSize) {
		const match = variants.find(v => {
			const opts = ((v.option1 || '') + ' ' + (v.option2 || '')).toLowerCase();
			return opts.includes(selectedRoast.toLowerCase()) && opts.includes(sizeKey);
		});

		if (match) return match.id;
	}

	if (selectedRoast) {
		const match = variants.find(v => ((v.option1 || '') + ' ' + (v.option2 || '')).toLowerCase().includes(selectedRoast.toLowerCase()));
		if (match) return match.id;
	}

	return variants[0].id;
}

function matchPlan(plans, freqKey) {
	if (!plans || !plans.length) return null;

	const plan = plans.find(p => {
		const pname = (p.name || '').toLowerCase().replace(/[\s-]/g, '');
		if (pname === freqKey || pname.includes(freqKey) || freqKey.includes(pname)) return true;
		if (freqKey === 'monthly') return pname.includes('month');
		if (freqKey === 'biweekly') return pname.includes('week') && (pname.includes('2') || pname.includes('bi') || pname.includes('other'));
		return false;
	});

	return plan ? plan.id : null;
}

function parseBagCount(sizeVal) {
	return parseInt(sizeVal, 10) || 1;
}

function toggleFilter(store, value) {
	store.update(arr => arr.includes(value)
	? arr.filter(f => f !== value)
	: [...arr, value]);
}

const func = a => `${a.product.title} ${a.qty}x${a.size}`;

function instance($$self, $$props, $$invalidate) {
	let SIZE_OPTIONS;
	let opts300g;
	let opts1kg;
	let anyFilterActive;
	let filteredCoffees;
	let bagCount;
	let bagSizeLabel;
	let selectedCount;
	let hasCurated;
	let selectedCoffeeList;
	let coffeeSummaryText;
	let roastSummaryText;
	let step1Done;
	let step2Done;
	let curatedApiAvailable;
	let isReady;
	let progressPct;
	let addonCoffees;
	let filteredAddons;
	let addonQtyByKey;
	let addonEnabled;
	let addonTotalNum;
	let addonTotalDisplay;
	let processingPrefText;
	let flavorPrefText;
	let $sizeDisplayValue;
	let $shippingFrequencyDisplayValue;
	let $flavorFilters;
	let $processingFilters;
	let $descriptorFilters;
	let $shippingFrequency;
	let $size;
	let $roastDisplayValue;
	let $roast;
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_store)(_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.sizeDisplayValue, 'sizeDisplayValue');
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.sizeDisplayValue, $$value => $$invalidate(14, $sizeDisplayValue = $$value));
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_store)(_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.shippingFrequencyDisplayValue, 'shippingFrequencyDisplayValue');
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.shippingFrequencyDisplayValue, $$value => $$invalidate(15, $shippingFrequencyDisplayValue = $$value));
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_store)(_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.flavorFilters, 'flavorFilters');
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.flavorFilters, $$value => $$invalidate(16, $flavorFilters = $$value));
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_store)(_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.processingFilters, 'processingFilters');
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.processingFilters, $$value => $$invalidate(17, $processingFilters = $$value));
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_store)(_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.descriptorFilters, 'descriptorFilters');
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.descriptorFilters, $$value => $$invalidate(18, $descriptorFilters = $$value));
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_store)(_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.shippingFrequency, 'shippingFrequency');
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.shippingFrequency, $$value => $$invalidate(73, $shippingFrequency = $$value));
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_store)(_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.size, 'size');
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.size, $$value => $$invalidate(74, $size = $$value));
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_store)(_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.roastDisplayValue, 'roastDisplayValue');
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.roastDisplayValue, $$value => $$invalidate(75, $roastDisplayValue = $$value));
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_store)(_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.roast, 'roast');
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.component_subscribe)($$self, _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.roast, $$value => $$invalidate(19, $roast = $$value));
	let { $$slots: slots$1 = {}, $$scope } = $$props;
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_slots)('SubscriptionBuilder', slots$1, []);
	let { debug } = $$props;
	let { recurring } = $$props;
	let PRICE_300G = 24.00;
	let PRICE_1KILO = 62.50;
	const DISCOUNT_LABEL = `${Math.round(DISCOUNT_PCT * 100)}% off`;

	const formatter = new Intl.NumberFormat('en-US',
	{
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 2
		});

	let bundleData = typeof window !== 'undefined' && window.coavaBundle
	? { ...window.coavaBundle }
	: {
			variantId: null,
			productHandle: 'coffee-subscription-plan-1',
			sellingPlans: []
		};

	const coffeeProducts = typeof window !== 'undefined' && window.coavaCoffees
	? window.coavaCoffees
	: [];

	const addonProducts = typeof window !== 'undefined' && window.coavaAddons
	? window.coavaAddons
	: [];

	// Derive base 300g and 1kg prices from subscription coffee variants
	for (const p of coffeeProducts) {
		for (const v of p.variants || []) {
			const opts = ((v.option1 || '') + ' ' + (v.option2 || '')).toLowerCase();

			if (opts.includes('300') && v.price > 0) {
				PRICE_300G = v.price / 100;
				break;
			}
		}

		for (const v of p.variants || []) {
			const opts = ((v.option1 || '') + ' ' + (v.option2 || '')).toLowerCase();

			if (opts.includes('kilo') && v.price > 0) {
				PRICE_1KILO = v.price / 100;
				break;
			}
		}

		if (PRICE_300G !== 24.00 && PRICE_1KILO !== 62.50) break;
	}

	function getVariantPrice(product, sizeLabel) {
		if (!product || !product.variants || !product.variants.length) {
			return (sizeLabel || '').toLowerCase().includes('kilo')
			? PRICE_1KILO
			: PRICE_300G;
		}

		const sizeKey = (sizeLabel || '').toLowerCase().includes('kilo')
		? 'kilo'
		: '300';

		const match = product.variants.find(v => {
			const opts = ((v.option1 || '') + ' ' + (v.option2 || '')).toLowerCase();
			return opts.includes(sizeKey) && v.price > 0;
		});

		if (match) return match.price / 100;

		return (sizeLabel || '').toLowerCase().includes('kilo')
		? PRICE_1KILO
		: PRICE_300G;
	}

	let submitting = false;
	let submitError = '';
	let price = null;
	let priceNum = null;
	let perBagPrice = null;
	let discountApplied = false;
	let grandTotal = null;
	let originalPrice = null;

	// Accessibility: a single polite live region announces state changes (quantity/price
	// updates, filters cleared, add-ons removed) that are otherwise only shown visually.
	let liveMessage = '';

	function announce(msg) {
		$$invalidate(28, liveMessage = '');

		// Re-set on the next tick so repeated identical messages still fire a fresh announcement.
		setTimeout(
			() => {
				$$invalidate(28, liveMessage = msg);
			},
			50
		);
	}

	/**
 * Like announce(), but for messages that quote a reactive ($:) value — grandTotal,
 * addonTotalDisplay, etc. Those only recompute after Svelte's own update cycle, so
 * building the string before awaiting tick() would quote the value from BEFORE this
 * change (the exact "out-of-date grand total" bug this fixes).
 */
	async function announceAfterUpdate(buildMsg) {
		$$invalidate(28, liveMessage = '');
		await (0,svelte__WEBPACK_IMPORTED_MODULE_1__.tick)();
		$$invalidate(28, liveMessage = buildMsg());
	}

	// Step 2: multi-coffee selection by quantity.
	// coffeeQty maps a product id (string) -> number of bags chosen for it.
	// The total must equal the bag count picked in step 1.
	const CURATED = {
		id: 'curated',
		title: 'Curated by our team',
		handle: null,
		variants: [],
		tags: []
	};

	let coffeeQty = {}; // keys: 'productId:Roast' (e.g. '12345:Drip') or 'curated'
	let curatedRoasts = []; // ['Drip'] | ['Espresso'] | ['Drip','Espresso']

	// Step 3: add-ons — an array so the customer can add as many as they like.
	// Each: { id: 'productId:Roast', productId, product, size: '300g' | '1 Kilo', qty, roast }
	// Keyed by product AND roast (like step 2's coffeeQty) so Drip and Espresso of the same
	// coffee are two independent add-on lines, each picked from the card itself.
	let addonItems = [];

	// Step 3 roast filter — mirrors step 2's Roast segment but scoped to the add-on grid,
	// so it never disturbs the subscription roast in $roast.
	let addonRoastFilter = null;

	let currentStep = 1;
	let sbContainer;

	// Persisted: distinguishes "never added yet" from "added, then emptied elsewhere".
	let hasAddedToCart = false;

	function lookupProduct(id) {
		if (id === 'curated') return CURATED;
		return coffeeProducts.find(p => String(p.id) === String(id)) || null;
	}

	// Add-ons come from the separate 'addon-coffees' collection (window.coavaAddons), so
	// they aren't in coffeeProducts. Anything resolving a cart line or a saved add-on has
	// to search both lists.
	function lookupAnyProduct(id) {
		return lookupProduct(id) || addonProducts.find(p => String(p.id) === String(id)) || null;
	}

	let restored = false; // becomes true after we load any saved selection
	let subscriptionInCart = false; // true if the cart already holds a subscription bundle

	function restoreSelection() {
		if (typeof localStorage === 'undefined') return;

		try {
			const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');

			if (saved) {
				if (saved.roast) {
					_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.roast.set(saved.roast);
					_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.roastDisplayValue.set(saved.roastDisplay || saved.roast);
				}

				if (saved.size) _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.size.set(saved.size);
				if (saved.sizeDisplay) _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.sizeDisplayValue.set(saved.sizeDisplay);
				if (Array.isArray(saved.freq)) _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.shippingFrequency.set(saved.freq);
				if (saved.freqDisplay) _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.shippingFrequencyDisplayValue.set(saved.freqDisplay);
				if (Array.isArray(saved.processing)) _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.processingFilters.set(saved.processing);
				if (Array.isArray(saved.flavor)) _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.flavorFilters.set(saved.flavor);
				if (Array.isArray(saved.descriptor)) _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.descriptorFilters.set(saved.descriptor);

				if (saved.coffeeQty && typeof saved.coffeeQty === 'object') {
					const clean = {};

					for (const [key, q] of Object.entries(saved.coffeeQty)) {
						if (q <= 0) continue;

						if (key === 'curated') {
							clean['curated'] = q;
							continue;
						}

						const colonIdx = key.lastIndexOf(':');

						if (colonIdx !== -1) {
							if (lookupProduct(key.substring(0, colonIdx))) clean[key] = q;
						} else if (lookupProduct(key)) {
							clean[key + ':Drip'] = q; // legacy: default to Drip
						}
					}

					$$invalidate(1, coffeeQty = clean);
				}

				if (saved.curatedRoasts && Array.isArray(saved.curatedRoasts)) {
					$$invalidate(2, curatedRoasts = saved.curatedRoasts);
				} else if (saved.curatedRoast && typeof saved.curatedRoast === 'string') {
					// migrate old single-value format
					$$invalidate(2, curatedRoasts = saved.curatedRoast === 'any'
					? ['Drip', 'Espresso']
					: [saved.curatedRoast]);
				}

				if (Array.isArray(saved.addonItems)) {
					$$invalidate(3, addonItems = mergeAddonItems(saved.addonItems.map(a => {
						// Legacy saves keyed add-ons by bare product id; new ones carry productId.
						const productId = a.productId != null
						? String(a.productId)
						: String(a.id || '').split(':')[0];

						const product = lookupAnyProduct(productId);
						if (!product) return null;

						// A saved roast the product no longer offers is coerced onto one it does,
						// rather than dropped — losing the add-on outright is the worse outcome.
						let roastVal = a.roast || null;

						if (!roastAvailable(product, roastVal)) {
							roastVal = product.hasDrip
							? 'Drip'
							: product.hasEspresso ? 'Espresso' : null;
						}

						// Same for size: coerce onto a size that exists rather than restoring a
						// line that can't be ordered.
						let sizeVal = a.size || '300g';

						if (!sizeVariantAvailable(product, roastVal, sizeVal)) {
							sizeVal = resolveAddonSize(product, roastVal, sizeVal) || sizeVal;
						}

						return {
							id: addonKey(productId, roastVal),
							productId,
							size: sizeVal,
							qty: a.qty || 1,
							roast: roastVal,
							product
						};
					}).filter(Boolean)));
				}

				if (saved.addonRoast === 'Drip' || saved.addonRoast === 'Espresso') {
					$$invalidate(4, addonRoastFilter = saved.addonRoast);
				}

				if (saved.currentStep) $$invalidate(5, currentStep = saved.currentStep);
				if (saved.addedToCart) $$invalidate(68, hasAddedToCart = true);
			}
		} catch(_) {
			
		}

		$$invalidate(69, restored = true);
	}

	/**
 * Re-derive steps 2 and 3 from the cart.
 *
 * Rebuy's drawer edits the Shopify cart directly, so removing a coffee or changing a
 * quantity there has to flow back into the builder — otherwise the summary keeps
 * showing items that are no longer in the cart. The reactive save below then persists
 * the new selection automatically.
 */
	function syncFromCart(cart) {
		const items = cart && cart.items || [];
		const bundleLines = items.filter(l => (l.properties || {})._rc_bundle);
		const addonLines = items.filter(l => (l.properties || {})._addon);
		const totalBundleQty = bundleLines.reduce((sum, l) => sum + l.quantity, 0);

		if (bundleLines.some(l => (l.properties || {})._curated === 'true')) {
			// Keep the "Curated by our team" choice rather than exploding it into the
			// specific coffees the API happened to resolve.
			$$invalidate(1, coffeeQty = totalBundleQty > 0 ? { curated: totalBundleQty } : {});
		} else {
			const nextQty = {};

			bundleLines.forEach(line => {
				const key = `${line.product_id}:${(line.properties || {})._Roast || ''}`;
				nextQty[key] = (nextQty[key] || 0) + line.quantity;
			});

			$$invalidate(1, coffeeQty = nextQty);
		}

		$$invalidate(3, addonItems = mergeAddonItems(addonLines.map(line => {
			const product = lookupAnyProduct(line.product_id);
			if (!product) return null;
			const props = line.properties || {};
			const sizeText = `${props._Size || ''} ${line.variant_title || ''}`;
			const roastVal = props._Roast || null;

			return {
				id: addonKey(line.product_id, roastVal),
				productId: String(line.product_id),
				product,
				size: (/kilo/i).test(sizeText) ? '1 Kilo' : '300g',
				qty: line.quantity,
				roast: roastVal
			};
		}).filter(Boolean)));

		$$invalidate(30, subscriptionInCart = bundleLines.length > 0);
		if (!subscriptionInCart) $$invalidate(2, curatedRoasts = []);

		// Don't leave the customer on step 3 once step 2 is no longer satisfied — the step
		// nav disables step 3 in that state, which would otherwise strand them.
		const nextCount = Object.values(coffeeQty).reduce((a, b) => a + b, 0);

		if (currentStep === 3 && (bagCount === 0 || nextCount !== bagCount)) {
			$$invalidate(5, currentStep = 2);
		}
	}

	/**
 * The cart records what was actually added; localStorage records what the customer was
 * building. Let the cart overwrite the selection only when it holds a subscription, or
 * when one was added earlier and has since been emptied. Otherwise arriving with an
 * in-progress, not-yet-added selection would wipe it.
 */
	function onCartChanged(cart) {
		$$invalidate(30, subscriptionInCart = cartHasBundle(cart));
		if (subscriptionInCart || hasAddedToCart) syncFromCart(cart);
	}

	/** Re-read the cart and reconcile. Safe to call on arrival, on tab focus, or on demand. */
	async function reconcileWithCart() {
		try {
			const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
			if (res.ok) onCartChanged(await res.json());
		} catch(err) {
			console.warn('[Coava] could not re-read the cart:', err);
		}
	}

	function onCartChangedEvent(event) {
		if (event && event.detail) onCartChanged(event.detail);
	}

	function onVisibilityChange() {
		if (document.visibilityState === 'visible') reconcileWithCart();
	}

	function goToStep(n) {
		$$invalidate(5, currentStep = n);

		setTimeout(
			() => {
				if (sbContainer) {
					const top = sbContainer.getBoundingClientRect().top + window.scrollY - 16;
					window.scrollTo({ top, behavior: 'smooth' });
				}
			},
			30
		);
	}

	let freqSection;

	function selectSize(opt) {
		_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.size.set(opt.val);
		_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.sizeDisplayValue.set(opt.val);

		// Changing the bag count invalidates the per-coffee selection — start fresh.
		$$invalidate(1, coffeeQty = {});

		setTimeout(() => freqSection?.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 80);
	}

	(0,svelte__WEBPACK_IMPORTED_MODULE_1__.onMount)(async () => {
		restoreSelection(); // restores the saved selection AND currentStep (lands back on step 3)
		const handle = bundleData.productHandle || 'coffee-subscription-plan-1';

		try {
			const res = await fetch(`/products/${handle}.js`);

			if (res.ok) {
				const d = await res.json();
				const plans = (d.selling_plan_groups || []).flatMap(g => g.selling_plans || []).map(p => ({ id: p.id, name: p.name }));

				bundleData = {
					...bundleData,
					productId: d.id || bundleData.productId,
					variantId: d.variants?.[0]?.id || 0,
					productHandle: d.handle || handle,
					sellingPlans: plans
				};
			}
		} catch(_) {
			
		}

		// Reconcile on arrival. Rebuy's drawer is on every page, so the subscription may have
		// been edited from a product page since we were last here — the cart knows, we don't.
		// This also sets subscriptionInCart, so we update rather than duplicate on the next add.
		await reconcileWithCart();

		// Catches edits made in another tab, or on this page without a reload.
		document.addEventListener('visibilitychange', onVisibilityChange);

		// Catches edits made inside the drawer while we're sitting on this page. main.js runs
		// the single site-wide cart watcher and emits this after its quantity guard has run.
		document.addEventListener('coava:cart-changed', onCartChangedEvent);

		// Lets Rebuy's Event Callbacks push changes instantly instead of waiting for a poll.
		window.coavaSyncBuilderFromCart = reconcileWithCart;
	});

	(0,svelte__WEBPACK_IMPORTED_MODULE_1__.onDestroy)(() => {
		document.removeEventListener('coava:cart-changed', onCartChangedEvent);
		document.removeEventListener('visibilitychange', onVisibilityChange);

		if (typeof window !== 'undefined' && window.coavaSyncBuilderFromCart === reconcileWithCart) {
			delete window.coavaSyncBuilderFromCart;
		}
	});

	// Processing filter chips — driven by the "Subscription Filters" section in the Shopify
	// theme customizer (Themes → Customize → Subscription page). Falls back to hardcoded defaults.
	const PROCESSING_OPTIONS = (() => {
		const processing = typeof window !== 'undefined' && window.coavaProcessing;

		if (processing && processing.length > 0) {
			return processing.map(p => ({
				label: p.label,
				tags: [p.tag.toLowerCase()]
			}));
		}

		return [
			{ label: 'Washed', tags: ['washed'] },
			{ label: 'Natural', tags: ['natural'] },
			{
				label: 'Alternative',
				tags: ['alternative', 'other']
			}
		];
	})();

	const FLAVOR_OPTIONS = [{ label: 'Classic', tags: ['classic'] }, { label: 'Unique', tags: ['unique'] }];

	// Notes filter chips — driven by the "Subscription Filters" section in the Shopify
	// theme customizer (Themes → Customize → Subscription page). Falls back to hardcoded defaults.
	const DESCRIPTOR_OPTIONS = (() => {
		const notes = typeof window !== 'undefined' && window.coavaNotes;

		if (notes && notes.length > 0) {
			return notes.map(n => ({
				label: n.label,
				tags: [n.tag.toLowerCase()]
			}));
		}

		return [
			{
				label: 'Chocolatey',
				tags: ['chocolate', 'chocolatey']
			},
			{ label: 'Fruity', tags: ['fruity'] },
			{ label: 'Floral', tags: ['floral'] },
			{ label: 'Syrupy', tags: ['syrupy'] },
			{ label: 'Rich', tags: ['rich'] },
			{ label: 'Delicate', tags: ['delicate'] },
			{ label: 'Complex', tags: ['complex'] }
		];
	})();

	// Returns ordered tag chips: [Flavor, Processing, ...matching Notes]
	// Notes shown = those matching active descriptor filters; falls back to first note if none active.
	function getCardTags(rawTags, activeDescriptors) {
		const tags = (rawTags || []).map(t => t.toLowerCase());
		const result = [];
		const flavorOpt = FLAVOR_OPTIONS.find(o => o.tags.some(t => tags.includes(t)));
		if (flavorOpt) result.push({ type: 'flavor', label: flavorOpt.label });
		const procOpt = PROCESSING_OPTIONS.find(o => o.tags.some(t => tags.includes(t)));
		if (procOpt) result.push({ type: 'processing', label: procOpt.label });
		const allNotes = DESCRIPTOR_OPTIONS.filter(o => o.tags.some(t => tags.includes(t)));

		if (activeDescriptors && activeDescriptors.length > 0) {
			allNotes.filter(o => activeDescriptors.includes(o.label)).forEach(o => result.push({ type: 'note', label: o.label }));
		} else if (allNotes.length > 0) {
			result.push({ type: 'note', label: allNotes[0].label });
		}

		return result;
	}

	// True when the product supports the currently-selected roast.
	// Products with no roast info at all are always incompatible.
	function roastCompatible(product) {
		if (!product.hasDrip && !product.hasEspresso) return false;
		if ($roast === 'Drip') return !!product.hasDrip;
		if ($roast === 'Espresso') return !!product.hasEspresso;
		return true;
	}

	// Resolve the selling-plan id for a coffee at the chosen frequency.
	async function resolvePlanId(product, freqKey) {
		return matchPlan(product.sellingPlans, freqKey) || matchPlan(bundleData.sellingPlans, freqKey) || (product.handle
		? (await fetchSellingPlanId(product.handle, $shippingFrequencyDisplayValue)).id
		: null);
	}

	// Subscribe & Save applies from MIN_DISCOUNT_BAGS bags up — a single-bag plan pays the
	// full price. `discounted` drives every "5% off" badge and struck-through price.
	function calcPrice(sizeVal, freqVal) {
		if (!sizeVal) return null;
		const lower = sizeVal.toLowerCase();
		const qty = parseInt(sizeVal, 10) || 1;

		const unit = lower.includes('300g')
		? PRICE_300G
		: lower.includes('kilo') ? PRICE_1KILO : null;

		if (unit === null) return null;
		const base = unit * qty;
		const discounted = qty >= MIN_DISCOUNT_BAGS;
		const total = discounted ? base * (1 - DISCOUNT_PCT) : base;

		return {
			total,
			perBag: total / qty,
			discounted,
			base
		};
	}

	function clearFilters() {
		_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.roast.set(null);
		_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.roastDisplayValue.set('');
		_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.processingFilters.set([]);
		_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.flavorFilters.set([]);
		_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.descriptorFilters.set([]);
		announce('Filters cleared.');

		// Focus would otherwise vanish with the "Clear filters" button it was on, since the
		// button disappears once no filter is active — send it to the first Roast option instead.
		setTimeout(
			() => {
				document.querySelector('#sb-lbl-roast')?.parentElement?.querySelector('.sb-segment-btn')?.focus();
			},
			0
		);
	}

	// ── Step 2: per-coffee quantity (total must equal bagCount) ──
	function addCoffee(product, roast) {
		const next = { ...coffeeQty };
		delete next['curated']; // a specific coffee replaces "curated"
		const count = Object.values(next).reduce((a, b) => a + b, 0);
		if (count >= bagCount) return; // already full
		const key = `${product.id}:${roast}`;
		next[key] = (next[key] || 0) + 1;
		$$invalidate(1, coffeeQty = next);
		announce(`${product.title} ${roast} quantity: ${next[key]}. ${selectedCount + 1} of ${bagCount} selected.`);
	}

	function removeCoffee(product, roast) {
		const key = `${product.id}:${roast}`;
		if (!coffeeQty[key]) return;
		const next = { ...coffeeQty };
		next[key] -= 1;
		const newQty = Math.max(next[key], 0);
		if (next[key] <= 0) delete next[key];
		$$invalidate(1, coffeeQty = next);
		announce(`${product.title} ${roast} quantity: ${newQty}. ${selectedCount - 1} of ${bagCount} selected.`);
	}

	// "Curated" fills every bag and clears specific picks (toggle off to clear).
	function toggleCurated() {
		if (hasCurated) {
			$$invalidate(1, coffeeQty = {});
			$$invalidate(2, curatedRoasts = []);
		} else {
			$$invalidate(1, coffeeQty = { curated: bagCount });
		}
	}

	function toggleCuratedRoast(r) {
		if (curatedRoasts.includes(r)) {
			$$invalidate(2, curatedRoasts = curatedRoasts.filter(x => x !== r));
		} else {
			$$invalidate(2, curatedRoasts = [...curatedRoasts, r]);
		}
	}

	// ── Step 3: add-ons (any number, one-time) ──
	// Picked per roast straight from the card, exactly like step 2's coffee steppers. There
	// is no bag-count cap here — add-ons are one-time extras.
	function addAddon(product, roastVal) {
		if (!roastAvailable(product, roastVal)) return;
		const sizeVal = resolveAddonSize(product, roastVal, bagSizeLabel);
		if (!sizeVal) return; // no orderable variant in either size
		const key = addonKey(product.id, roastVal);
		let newQty = 1;

		if (addonItems.some(it => it.id === key)) {
			$$invalidate(3, addonItems = addonItems.map(it => {
				if (it.id !== key) return it;
				newQty = it.qty + 1;
				return { ...it, qty: newQty };
			}));
		} else {
			$$invalidate(3, addonItems = [
				...addonItems,
				{
					id: key,
					productId: String(product.id),
					product,
					size: sizeVal,
					qty: 1,
					roast: roastVal || null
				}
			]);
		}

		const label = roastVal
		? `${product.title} ${roastVal}`
		: product.title;

		announceAfterUpdate(() => `${label} quantity: ${newQty}. Grand total ${grandTotal || '$0.00'}.`);
	}

	function removeAddon(product, roastVal) {
		const key = addonKey(product.id, roastVal);
		let newQty = 0;

		$$invalidate(3, addonItems = addonItems.map(it => {
			if (it.id !== key) return it;
			newQty = it.qty - 1;
			return { ...it, qty: newQty };
		}).filter(it => it.qty > 0));

		const label = roastVal
		? `${product.title} ${roastVal}`
		: product.title;

		announceAfterUpdate(() => `${label} quantity: ${Math.max(newQty, 0)}. Grand total ${grandTotal || '$0.00'}.`);
	}

	/** The ✕ on a selected-add-on row — drops the whole line regardless of quantity. */
	function removeAddonItem(item) {
		const name = item.roast
		? `${item.product.title} ${item.roast}`
		: item.product.title;

		const buttons = Array.from(document.querySelectorAll('.sb-addon-remove'));
		const i = buttons.indexOf(document.activeElement);
		$$invalidate(3, addonItems = addonItems.filter(it => it.id !== item.id));
		announceAfterUpdate(() => `${name} removed. Grand total ${grandTotal || '$0.00'}.`);

		// Focus management: move to the remove button that slid into this row's place, the
		// previous one if this was the last row, or the Add-Ons heading if the list is now empty.
		setTimeout(
			() => {
				const next = Array.from(document.querySelectorAll('.sb-addon-remove'));

				if (next[i]) {
					next[i].focus();
				} else if (next[i - 1]) {
					next[i - 1].focus();
				} else {
					document.querySelector('h2.sb-panel-title')?.focus();
				}
			},
			0
		);
	}

	// Add-ons are one-time purchases with no selling plan, so no bag-count rule applies —
	// quantity is uncapped here and in subscriptionCartGuard.js. Changing size keeps the qty.
	function setAddonSize(item, sizeVal) {
		if (!sizeVariantAvailable(item.product, item.roast, sizeVal)) return;
		$$invalidate(3, addonItems = addonItems.map(it => it.id === item.id ? { ...it, size: sizeVal } : it));
	}

	// Floor of 1 only — dropping to 0 is what the remove button is for.
	function changeAddonQty(item, delta) {
		$$invalidate(3, addonItems = addonItems.map(it => it.id === item.id
		? { ...it, qty: Math.max(1, it.qty + delta) }
		: it));

		const name = item.roast
		? `${item.product.title} ${item.roast}`
		: item.product.title;

		announceAfterUpdate(() => {
			const updated = addonItems.find(it => it.id === item.id);

			const linePrice = updated
			? formatter.format(getVariantPrice(updated.product, updated.size) * updated.qty)
			: '';

			return `${name} quantity: ${updated ? updated.qty : ''}. Line total ${linePrice}. Grand total ${grandTotal || '$0.00'}.`;
		});
	}

	async function handleAddToCart(e) {
		e.preventDefault();
		if (!isReady || submitting) return;
		$$invalidate(20, submitting = true);
		$$invalidate(21, submitError = '');

		try {
			const bundleHandle = bundleData.productHandle || 'coffee-subscription-plan-1';
			const rcRandom = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
			const rcBundleId = rcRandom + ':' + (bundleData.productId || '');

			const collectionId = bundleData.collectionId
			? String(bundleData.collectionId)
			: '316537143362';

			const freqNorm = $shippingFrequencyDisplayValue.toLowerCase().replace(/[\s-]/g, '');

			const rcFreqProps = freqNorm === 'biweekly'
			? { freq: '2', unit: 'Weeks' }
			: { freq: '1', unit: 'Months' };

			const cartItems = [];

			// Resolve coffee list — for curated, fetch admin config and look up the matching product
			let resolvedCoffeeList = selectedCoffeeList;

			if (hasCurated) {
				try {
					const apiBase = window.coavaCuratedApiBase;
					const res = await fetch(`${apiBase}/api/curated`);
					if (!res.ok) throw new Error(`Curated API ${res.status}`);
					const curatedData = await res.json();

					// New format: curatedData[`bag${bagCount}`] = { drip: [...N coffees], espresso: [...N coffees] }
					const bagKey = `bag${bagCount}`;

					const bagData = curatedData[bagKey];

					if (!bagData || typeof bagData !== 'object' || Array.isArray(bagData)) {
						$$invalidate(21, submitError = `Curated selection for ${bagCount} bag(s) isn't configured yet. Please contact us or choose your own coffee.`);
						$$invalidate(20, submitting = false);
						return;
					}

					const resolvedItems = [];

					function resolveFromRoast(roastLower, roastStr, count) {
						const slots = (bagData[roastLower] || []).filter(Boolean);

						if (slots.length < count) {
							$$invalidate(21, submitError = `Not all ${roastStr} curated coffees for ${bagCount} bag(s) are configured. Please contact us or choose your own coffee.`);
							return false;
						}

						for (let si = 0; si < count; si++) {
							const slot = slots[si];
							const prod = coffeeProducts.find(p => String(p.id) === String(slot.shopifyProductId));

							if (!prod) {
								$$invalidate(21, submitError = `A curated coffee isn't available right now. Please choose your own coffee.`);
								return false;
							}

							resolvedItems.push({ product: prod, qty: 1, roast: roastStr });
						}

						return true;
					}

					if (curatedRoasts.length === 2) {
						// Both Drip + Espresso: split half and half
						const dripCount = Math.ceil(bagCount / 2);

						const espCount = bagCount - dripCount;

						if (!resolveFromRoast('drip', 'Drip', dripCount)) {
							$$invalidate(20, submitting = false);
							return;
						}

						if (espCount > 0 && !resolveFromRoast('espresso', 'Espresso', espCount)) {
							$$invalidate(20, submitting = false);
							return;
						}
					} else if (curatedRoasts.length === 1) {
						const roastStr = curatedRoasts[0];
						const roastLower = roastStr.toLowerCase();

						if (!resolveFromRoast(roastLower, roastStr, bagCount)) {
							$$invalidate(20, submitting = false);
							return;
						}
					} else {
						$$invalidate(21, submitError = 'Please select a roast preference for your curated selection.');
						$$invalidate(20, submitting = false);
						return;
					}

					if (!resolvedItems.length) {
						$$invalidate(21, submitError = 'Could not resolve curated coffees. Please choose your own coffee.');
						$$invalidate(20, submitting = false);
						return;
					}

					resolvedCoffeeList = resolvedItems;
				} catch(err) {
					$$invalidate(21, submitError = 'Could not load curated selection. Please try again or choose your own coffee.');
					$$invalidate(20, submitting = false);
					return;
				}
			}

			// Subscription coffees — one shared recurring bundle (same _rc_bundle id)
			for (const { product, qty, roast: itemRoast } of resolvedCoffeeList) {
				// A bundle line synced from another surface can arrive with no _Roast. That's
				// "unspecified", not "unavailable" — fall back to a roast this coffee sells
				// rather than stranding the customer. (With no roast, getCoffeeVariantId() skips
				// straight to variants[0] and ignores the bag size too.)
				const roastForLine = itemRoast || (product.hasDrip
				? 'Drip'
				: product.hasEspresso ? 'Espresso' : null);

				// Check availability before resolving the variant. The !variantId guard below
				// can't do this on its own: getCoffeeVariantId() falls back to variants[0] for
				// any product that has variants, so an unsold roast/size combination would
				// otherwise resolve to an arbitrary variant and ship the wrong coffee. This also
				// catches a curated slot configured with a coffee that doesn't sell that roast.
				if (!roastAvailable(product, roastForLine) || !sizeVariantAvailable(product, roastForLine, bagSizeLabel)) {
					$$invalidate(21, submitError = `"${product.title}" isn't available as ${roastForLine || 'that roast'} / ${bagSizeLabel}. Please choose another coffee.`);
					$$invalidate(20, submitting = false);
					return;
				}

				const variantId = getCoffeeVariantId(product, roastForLine, $sizeDisplayValue);

				if (!variantId) {
					$$invalidate(21, submitError = `"${product.title}" isn't available as ${roastForLine || 'that roast'} / ${bagSizeLabel}. Please choose another coffee.`);
					$$invalidate(20, submitting = false);
					return;
				}

				const planId = await resolvePlanId(product, freqNorm);

				const item = {
					id: variantId,
					quantity: qty,
					properties: {
						_rc_bundle: rcBundleId,
						_rc_bundle_parent: bundleHandle,
						_rc_bundle_variant: String(bundleData.variantId || ''),
						_rc_bundle_collection_id: collectionId,
						_shipping_interval_frequency: rcFreqProps.freq,
						_shipping_interval_unit_type: rcFreqProps.unit,
						_Roast: roastForLine || '',
						_Coffee: product.title,
						_Size: `${qty} x ${bagSizeLabel}`,
						// Plan bag count from step 1. Hidden (underscore-prefixed) and repeated on every
						// line so it survives a line being removed from the cart, which is what the
						// quantity cap and the checkout gate measure against.
						_Bags: String(bagCount),
						'_Processing preference': processingPrefText,
						'_Flavor preference': flavorPrefText,
						...hasCurated ? { _curated: 'true' } : {}
					}
				};

				if (planId) item.selling_plan = planId;
				cartItems.push(item);
			}

			// Add-ons — one-time, no selling plan.
			// The roast comes from the card only. Falling back to $roast (step 2's subscription
			// roast) would ask for a roast this coffee may not sell, and getCoffeeVariantId's
			// last-resort variants[0] fallback would then quietly order the wrong variant.
			for (const it of addonItems) {
				if (!roastAvailable(it.product, it.roast)) {
					$$invalidate(21, submitError = `"${it.product.title}" isn't available as ${it.roast || 'that option'}. Please remove it and pick an available roast.`);
					$$invalidate(20, submitting = false);
					return;
				}

				if (!sizeVariantAvailable(it.product, it.roast, it.size)) {
					$$invalidate(21, submitError = `"${it.product.title}" isn't available in ${it.size}. Please pick another size for it.`);
					$$invalidate(20, submitting = false);
					return;
				}

				const variantId = getCoffeeVariantId(it.product, it.roast, it.size);

				if (!variantId) {
					$$invalidate(21, submitError = `"${it.product.title}" isn't available as ${it.roast || 'that option'} / ${it.size}. Please remove it or choose another size.`);
					$$invalidate(20, submitting = false);
					return;
				}

				cartItems.push({
					id: variantId,
					quantity: it.qty,
					properties: {
						_Roast: it.roast || '',
						_Coffee: it.product.title,
						_Size: `${it.qty} x ${it.size}`,
						_addon: 'one-time'
					}
				});
			}

			if (!cartItems.length) {
				$$invalidate(21, submitError = 'Please choose your coffees before adding to cart.');
				$$invalidate(20, submitting = false);
				return;
			}

			// Only ONE subscription bundle is allowed: remove any existing bundle and
			// previously-added builder add-ons so this add replaces (never duplicates) them.
			try {
				const cartRes = await fetch('/cart.js');

				if (cartRes.ok) {
					const cart = await cartRes.json();
					const updates = {};

					for (const line of cart.items || []) {
						const props = line.properties || {};
						if (props._rc_bundle || props._addon) updates[line.key] = 0;
					}

					if (Object.keys(updates).length) {
						await fetch('/cart/update.js', {
							method: 'POST',
							headers: { 'Content-Type': 'application/json' },
							body: JSON.stringify({ updates })
						});
					}
				}
			} catch(_) {
				
			}

			const response = await fetch('/cart/add.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ items: cartItems })
			});

			if (response.ok) {
				// From here on the cart is the record of this selection, so later visits should
				// reconcile against it even if the customer empties it from another page.
				$$invalidate(68, hasAddedToCart = true);

				$$invalidate(30, subscriptionInCart = true);

				// Rebuy Smart Cart owns the post-add experience. We never navigate to /cart —
				// if Smart Cart can't be opened it logs why and the customer stays on the
				// builder, where the cart icon count still reflects the add.
				await (0,_rebuyCart_js__WEBPACK_IMPORTED_MODULE_3__.openRebuyCart)();
			} else {
				const err = await response.json().catch(() => ({}));
				console.error('[Coava] cart/add.js error:', err);

				$$invalidate(21, submitError = err && err.description
				? err.description
				: `Could not add to cart (${response.status}). Please try again.`);
			}
		} catch(err) {
			console.error('[Coava] handleAddToCart exception:', err);
			$$invalidate(21, submitError = 'Could not add to cart. Please try again.');
		} finally {
			$$invalidate(20, submitting = false);
		}
	}

	$$self.$$.on_mount.push(function () {
		if (debug === undefined && !('debug' in $$props || $$self.$$.bound[$$self.$$.props['debug']])) {
			console_1.warn("<SubscriptionBuilder> was created without expected prop 'debug'");
		}

		if (recurring === undefined && !('recurring' in $$props || $$self.$$.bound[$$self.$$.props['recurring']])) {
			console_1.warn("<SubscriptionBuilder> was created without expected prop 'recurring'");
		}
	});

	const writable_props = ['debug', 'recurring'];

	Object_1.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console_1.warn(`<SubscriptionBuilder> was created with unknown prop '${key}'`);
	});

	const click_handler = s => {
		if (s.n === 1 || s.n === 2 && step1Done || s.n === 3 && step2Done) goToStep(s.n);
	};

	const click_handler_1 = opt => selectSize(opt);
	const click_handler_2 = opt => selectSize(opt);

	const click_handler_3 = () => {
		_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.shippingFrequency.set([2, 'Weeks']);
		_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.shippingFrequencyDisplayValue.set('Bi-Weekly');
	};

	const click_handler_4 = () => {
		_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.shippingFrequency.set([1, 'Months']);
		_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.shippingFrequencyDisplayValue.set('Monthly');
	};

	function div11_binding($$value) {
		svelte_internal__WEBPACK_IMPORTED_MODULE_0__.binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			freqSection = $$value;
			$$invalidate(31, freqSection);
		});
	}

	const click_handler_5 = () => goToStep(2);

	const click_handler_6 = () => {
		_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.roast.set(null);
		_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.roastDisplayValue.set('');
	};

	const click_handler_7 = () => {
		_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.roast.set('Drip');
		_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.roastDisplayValue.set('Drip');
	};

	const click_handler_8 = () => {
		_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.roast.set('Espresso');
		_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.roastDisplayValue.set('Espresso');
	};

	const click_handler_9 = opt => toggleFilter(_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.flavorFilters, opt.label);
	const click_handler_10 = opt => toggleFilter(_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.processingFilters, opt.label);
	const click_handler_11 = opt => toggleFilter(_subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.descriptorFilters, opt.label);
	const click_handler_12 = () => toggleCuratedRoast('Drip');
	const click_handler_13 = () => toggleCuratedRoast('Espresso');

	const keydown_handler = e => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			toggleCurated();
		}
	};

	const click_handler_14 = product => removeCoffee(product, 'Drip');
	const click_handler_15 = (compatible, product) => compatible && addCoffee(product, 'Drip');
	const click_handler_16 = product => removeCoffee(product, 'Espresso');
	const click_handler_17 = (compatible, product) => compatible && addCoffee(product, 'Espresso');
	const click_handler_18 = () => goToStep(1);
	const click_handler_19 = () => goToStep(3);
	const click_handler_20 = () => $$invalidate(4, addonRoastFilter = null);
	const click_handler_21 = () => $$invalidate(4, addonRoastFilter = null);
	const click_handler_22 = () => $$invalidate(4, addonRoastFilter = 'Drip');
	const click_handler_23 = () => $$invalidate(4, addonRoastFilter = 'Espresso');
	const click_handler_24 = product => removeAddon(product, 'Drip');
	const click_handler_25 = product => addAddon(product, 'Drip');
	const click_handler_26 = product => removeAddon(product, 'Espresso');
	const click_handler_27 = product => addAddon(product, 'Espresso');
	const click_handler_28 = product => removeAddon(product, null);
	const click_handler_29 = product => addAddon(product, null);
	const click_handler_30 = (item, opt) => setAddonSize(item, opt.val);
	const click_handler_31 = item => changeAddonQty(item, -1);
	const click_handler_32 = item => changeAddonQty(item, 1);
	const click_handler_33 = item => removeAddonItem(item);
	const click_handler_34 = () => goToStep(2);

	function div3_binding($$value) {
		svelte_internal__WEBPACK_IMPORTED_MODULE_0__.binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			sbContainer = $$value;
			$$invalidate(29, sbContainer);
		});
	}

	$$self.$$set = $$props => {
		if ('debug' in $$props) $$invalidate(0, debug = $$props.debug);
		if ('recurring' in $$props) $$invalidate(65, recurring = $$props.recurring);
	};

	$$self.$capture_state = () => ({
		onDestroy: svelte__WEBPACK_IMPORTED_MODULE_1__.onDestroy,
		onMount: svelte__WEBPACK_IMPORTED_MODULE_1__.onMount,
		tick: svelte__WEBPACK_IMPORTED_MODULE_1__.tick,
		HiddenField: _subscriptions_hiddenField_svelte__WEBPACK_IMPORTED_MODULE_2__["default"],
		openRebuyCart: _rebuyCart_js__WEBPACK_IMPORTED_MODULE_3__.openRebuyCart,
		roast: _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.roast,
		roastDisplayValue: _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.roastDisplayValue,
		processingFilters: _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.processingFilters,
		flavorFilters: _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.flavorFilters,
		descriptorFilters: _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.descriptorFilters,
		size: _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.size,
		sizeDisplayValue: _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.sizeDisplayValue,
		shippingFrequency: _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.shippingFrequency,
		shippingFrequencyDisplayValue: _subscriptions_stores_js__WEBPACK_IMPORTED_MODULE_4__.shippingFrequencyDisplayValue,
		debug,
		recurring,
		PRICE_300G,
		PRICE_1KILO,
		DISCOUNT_PCT,
		MIN_DISCOUNT_BAGS,
		DISCOUNT_LABEL,
		SHIPPING_FLAT_RATE,
		formatter,
		bundleData,
		coffeeProducts,
		addonProducts,
		fmtPrice,
		getProductImage,
		getVariantPrice,
		submitting,
		submitError,
		price,
		priceNum,
		perBagPrice,
		discountApplied,
		grandTotal,
		originalPrice,
		liveMessage,
		announce,
		announceAfterUpdate,
		CURATED,
		coffeeQty,
		curatedRoasts,
		addonItems,
		addonRoastFilter,
		currentStep,
		sbContainer,
		hasAddedToCart,
		lookupProduct,
		lookupAnyProduct,
		roastAvailable,
		variantSizeMatches,
		sizeVariantAvailable,
		resolveAddonSize,
		addonOrderable,
		addonKey,
		mergeAddonItems,
		STORAGE_KEY,
		restored,
		subscriptionInCart,
		restoreSelection,
		syncFromCart,
		cartHasBundle,
		onCartChanged,
		reconcileWithCart,
		onCartChangedEvent,
		onVisibilityChange,
		goToStep,
		freqSection,
		selectSize,
		PROCESSING_OPTIONS,
		FLAVOR_OPTIONS,
		DESCRIPTOR_OPTIONS,
		groupMatches,
		getCardTags,
		roastCompatible,
		fetchSellingPlanId,
		getCoffeeVariantId,
		matchPlan,
		resolvePlanId,
		calcPrice,
		parseBagCount,
		toggleFilter,
		clearFilters,
		addCoffee,
		removeCoffee,
		toggleCurated,
		toggleCuratedRoast,
		addAddon,
		removeAddon,
		removeAddonItem,
		setAddonSize,
		changeAddonQty,
		handleAddToCart,
		hasCurated,
		flavorPrefText,
		processingPrefText,
		bagCount,
		bagSizeLabel,
		selectedCoffeeList,
		isReady,
		selectedCount,
		addonEnabled,
		addonTotalNum,
		addonTotalDisplay,
		addonQtyByKey,
		addonCoffees,
		filteredAddons,
		progressPct,
		curatedApiAvailable,
		step2Done,
		step1Done,
		roastSummaryText,
		coffeeSummaryText,
		filteredCoffees,
		anyFilterActive,
		SIZE_OPTIONS,
		opts1kg,
		opts300g,
		$sizeDisplayValue,
		$shippingFrequencyDisplayValue,
		$flavorFilters,
		$processingFilters,
		$descriptorFilters,
		$shippingFrequency,
		$size,
		$roastDisplayValue,
		$roast
	});

	$$self.$inject_state = $$props => {
		if ('debug' in $$props) $$invalidate(0, debug = $$props.debug);
		if ('recurring' in $$props) $$invalidate(65, recurring = $$props.recurring);
		if ('PRICE_300G' in $$props) $$invalidate(66, PRICE_300G = $$props.PRICE_300G);
		if ('PRICE_1KILO' in $$props) $$invalidate(67, PRICE_1KILO = $$props.PRICE_1KILO);
		if ('bundleData' in $$props) bundleData = $$props.bundleData;
		if ('submitting' in $$props) $$invalidate(20, submitting = $$props.submitting);
		if ('submitError' in $$props) $$invalidate(21, submitError = $$props.submitError);
		if ('price' in $$props) $$invalidate(22, price = $$props.price);
		if ('priceNum' in $$props) $$invalidate(23, priceNum = $$props.priceNum);
		if ('perBagPrice' in $$props) $$invalidate(24, perBagPrice = $$props.perBagPrice);
		if ('discountApplied' in $$props) $$invalidate(25, discountApplied = $$props.discountApplied);
		if ('grandTotal' in $$props) $$invalidate(26, grandTotal = $$props.grandTotal);
		if ('originalPrice' in $$props) $$invalidate(27, originalPrice = $$props.originalPrice);
		if ('liveMessage' in $$props) $$invalidate(28, liveMessage = $$props.liveMessage);
		if ('coffeeQty' in $$props) $$invalidate(1, coffeeQty = $$props.coffeeQty);
		if ('curatedRoasts' in $$props) $$invalidate(2, curatedRoasts = $$props.curatedRoasts);
		if ('addonItems' in $$props) $$invalidate(3, addonItems = $$props.addonItems);
		if ('addonRoastFilter' in $$props) $$invalidate(4, addonRoastFilter = $$props.addonRoastFilter);
		if ('currentStep' in $$props) $$invalidate(5, currentStep = $$props.currentStep);
		if ('sbContainer' in $$props) $$invalidate(29, sbContainer = $$props.sbContainer);
		if ('hasAddedToCart' in $$props) $$invalidate(68, hasAddedToCart = $$props.hasAddedToCart);
		if ('restored' in $$props) $$invalidate(69, restored = $$props.restored);
		if ('subscriptionInCart' in $$props) $$invalidate(30, subscriptionInCart = $$props.subscriptionInCart);
		if ('freqSection' in $$props) $$invalidate(31, freqSection = $$props.freqSection);
		if ('hasCurated' in $$props) $$invalidate(6, hasCurated = $$props.hasCurated);
		if ('flavorPrefText' in $$props) flavorPrefText = $$props.flavorPrefText;
		if ('processingPrefText' in $$props) processingPrefText = $$props.processingPrefText;
		if ('bagCount' in $$props) $$invalidate(7, bagCount = $$props.bagCount);
		if ('bagSizeLabel' in $$props) $$invalidate(32, bagSizeLabel = $$props.bagSizeLabel);
		if ('selectedCoffeeList' in $$props) $$invalidate(70, selectedCoffeeList = $$props.selectedCoffeeList);
		if ('isReady' in $$props) $$invalidate(33, isReady = $$props.isReady);
		if ('selectedCount' in $$props) $$invalidate(8, selectedCount = $$props.selectedCount);
		if ('addonEnabled' in $$props) $$invalidate(9, addonEnabled = $$props.addonEnabled);
		if ('addonTotalNum' in $$props) $$invalidate(71, addonTotalNum = $$props.addonTotalNum);
		if ('addonTotalDisplay' in $$props) $$invalidate(34, addonTotalDisplay = $$props.addonTotalDisplay);
		if ('addonQtyByKey' in $$props) $$invalidate(35, addonQtyByKey = $$props.addonQtyByKey);
		if ('addonCoffees' in $$props) $$invalidate(10, addonCoffees = $$props.addonCoffees);
		if ('filteredAddons' in $$props) $$invalidate(36, filteredAddons = $$props.filteredAddons);
		if ('progressPct' in $$props) $$invalidate(37, progressPct = $$props.progressPct);
		if ('curatedApiAvailable' in $$props) $$invalidate(11, curatedApiAvailable = $$props.curatedApiAvailable);
		if ('step2Done' in $$props) $$invalidate(12, step2Done = $$props.step2Done);
		if ('step1Done' in $$props) $$invalidate(13, step1Done = $$props.step1Done);
		if ('roastSummaryText' in $$props) $$invalidate(38, roastSummaryText = $$props.roastSummaryText);
		if ('coffeeSummaryText' in $$props) $$invalidate(39, coffeeSummaryText = $$props.coffeeSummaryText);
		if ('filteredCoffees' in $$props) $$invalidate(40, filteredCoffees = $$props.filteredCoffees);
		if ('anyFilterActive' in $$props) $$invalidate(41, anyFilterActive = $$props.anyFilterActive);
		if ('SIZE_OPTIONS' in $$props) $$invalidate(72, SIZE_OPTIONS = $$props.SIZE_OPTIONS);
		if ('opts1kg' in $$props) $$invalidate(42, opts1kg = $$props.opts1kg);
		if ('opts300g' in $$props) $$invalidate(43, opts300g = $$props.opts300g);
	};

	if ($$props && "$$inject" in $$props) {
		$$self.$inject_state($$props.$$inject);
	}

	$$self.$$.update = () => {
		if ($$self.$$.dirty[2] & /*PRICE_300G, PRICE_1KILO*/ 48) {
			$: $$invalidate(72, SIZE_OPTIONS = [
				{
					val: '1 x 300g',
					label: '1 × 300g',
					price: PRICE_300G,
					qty: 1,
					badge: false,
					group: '300g'
				},
				{
					val: '2 x 300g',
					label: '2 × 300g',
					price: PRICE_300G * 2,
					qty: 2,
					badge: false,
					group: '300g'
				},
				{
					val: '3 x 300g',
					label: '3 × 300g',
					price: PRICE_300G * 3,
					qty: 3,
					badge: false,
					group: '300g'
				},
				{
					val: '4 x 300g',
					label: '4 × 300g',
					price: PRICE_300G * 4,
					qty: 4,
					badge: false,
					group: '300g'
				},
				{
					val: '1 x 1 Kilo',
					label: '1 × 1 kg',
					price: PRICE_1KILO,
					qty: 1,
					badge: false,
					group: '1kg'
				},
				{
					val: '2 x 1 Kilo',
					label: '2 × 1 kg',
					price: PRICE_1KILO * 2,
					qty: 2,
					badge: false,
					group: '1kg'
				},
				{
					val: '3 x 1 Kilo',
					label: '3 × 1 kg',
					price: PRICE_1KILO * 3,
					qty: 3,
					badge: false,
					group: '1kg'
				}
			]);
		}

		if ($$self.$$.dirty[2] & /*SIZE_OPTIONS*/ 1024) {
			$: $$invalidate(43, opts300g = SIZE_OPTIONS.filter(o => o.group === '300g'));
		}

		if ($$self.$$.dirty[2] & /*SIZE_OPTIONS*/ 1024) {
			$: $$invalidate(42, opts1kg = SIZE_OPTIONS.filter(o => o.group === '1kg'));
		}

		if ($$self.$$.dirty[0] & /*$roast, $processingFilters, $flavorFilters, $descriptorFilters*/ 983040) {
			$: $$invalidate(41, anyFilterActive = !!$roast || $processingFilters.length > 0 || $flavorFilters.length > 0 || $descriptorFilters.length > 0);
		}

		if ($$self.$$.dirty[0] & /*$processingFilters, $flavorFilters, $descriptorFilters, $roast*/ 983040) {
			$: $$invalidate(40, filteredCoffees = coffeeProducts.filter(product => {
				const tags = (product.tags || []).map(t => t.toLowerCase());
				if (!groupMatches(tags, $processingFilters, PROCESSING_OPTIONS)) return false;
				if (!groupMatches(tags, $flavorFilters, FLAVOR_OPTIONS)) return false;
				if (!groupMatches(tags, $descriptorFilters, DESCRIPTOR_OPTIONS)) return false;
				if ($roast === 'Drip' && !product.hasDrip) return false;
				if ($roast === 'Espresso' && !product.hasEspresso) return false;
				return true;
			}));
		}

		if ($$self.$$.dirty[0] & /*$sizeDisplayValue*/ 16384) {
			// How many bags are required (from step 1) and what size they are.
			$: $$invalidate(7, bagCount = $sizeDisplayValue ? parseBagCount($sizeDisplayValue) : 0);
		}

		if ($$self.$$.dirty[0] & /*$sizeDisplayValue*/ 16384) {
			$: $$invalidate(32, bagSizeLabel = ($sizeDisplayValue || '').toLowerCase().includes('kilo')
			? '1 Kilo'
			: '300g');
		}

		if ($$self.$$.dirty[0] & /*coffeeQty*/ 2) {
			// Multi-coffee selection state derived from coffeeQty.
			$: $$invalidate(8, selectedCount = Object.values(coffeeQty).reduce((a, b) => a + b, 0));
		}

		if ($$self.$$.dirty[0] & /*coffeeQty*/ 2) {
			$: $$invalidate(6, hasCurated = (coffeeQty['curated'] || 0) > 0);
		}

		if ($$self.$$.dirty[0] & /*coffeeQty*/ 2) {
			$: $$invalidate(70, selectedCoffeeList = Object.entries(coffeeQty).filter(([,q]) => q > 0).map(([key, q]) => {
				if (key === 'curated') return { product: CURATED, qty: q, roast: null };
				const colonIdx = key.lastIndexOf(':');
				const productId = colonIdx !== -1 ? key.substring(0, colonIdx) : key;
				const itemRoast = colonIdx !== -1 ? key.substring(colonIdx + 1) : '';

				return {
					product: lookupProduct(productId),
					qty: q,
					roast: itemRoast
				};
			}).filter(e => e.product));
		}

		if ($$self.$$.dirty[2] & /*selectedCoffeeList*/ 256) {
			$: $$invalidate(39, coffeeSummaryText = selectedCoffeeList.map(e => e.product.id === 'curated'
			? 'Curated by our team'
			: e.qty > 1
				? `${e.product.title} (${e.roast}) ×${e.qty}`
				: `${e.product.title} (${e.roast})`).join(', '));
		}

		if ($$self.$$.dirty[0] & /*hasCurated, curatedRoasts*/ 68 | $$self.$$.dirty[2] & /*selectedCoffeeList*/ 256) {
			$: $$invalidate(38, roastSummaryText = hasCurated
			? curatedRoasts.length > 0
				? curatedRoasts.join(' + ')
				: '—'
			: [...new Set(selectedCoffeeList.map(e => e.roast).filter(Boolean))].join(' + ') || '—');
		}

		if ($$self.$$.dirty[0] & /*$sizeDisplayValue, $shippingFrequencyDisplayValue*/ 49152) {
			$: {
				const raw = calcPrice($sizeDisplayValue, $shippingFrequencyDisplayValue);
				$$invalidate(22, price = raw ? formatter.format(raw.total) : null);
				$$invalidate(23, priceNum = raw ? raw.total : null);
				$$invalidate(24, perBagPrice = raw ? formatter.format(raw.perBag) : null);
				$$invalidate(25, discountApplied = raw ? raw.discounted : false);

				// Only meaningful when a discount applies — it renders as the struck-through price,
				// and below MIN_DISCOUNT_BAGS it would equal the price actually charged.
				$$invalidate(27, originalPrice = raw && raw.discounted
				? formatter.format(raw.base)
				: null);
			}
		}

		if ($$self.$$.dirty[0] & /*$sizeDisplayValue, $shippingFrequencyDisplayValue*/ 49152) {
			$: $$invalidate(13, step1Done = !!$sizeDisplayValue && !!$shippingFrequencyDisplayValue);
		}

		if ($$self.$$.dirty[0] & /*bagCount, selectedCount, hasCurated, curatedRoasts*/ 452) {
			$: $$invalidate(12, step2Done = bagCount > 0 && selectedCount === bagCount && (!hasCurated || curatedRoasts.length > 0));
		}

		if ($$self.$$.dirty[0] & /*step1Done, step2Done, hasCurated, curatedApiAvailable*/ 14400) {
			$: $$invalidate(33, isReady = step1Done && step2Done && (!hasCurated || curatedApiAvailable));
		}

		if ($$self.$$.dirty[0] & /*bagCount, selectedCount*/ 384) {
			$: $$invalidate(37, progressPct = bagCount > 0
			? Math.min(100, Math.round(selectedCount / bagCount * 100))
			: 0);
		}

		if ($$self.$$.dirty[0] & /*addonCoffees, addonRoastFilter*/ 1040) {
			// Same roast filter behaviour as step 2's filteredCoffees, driven by addonRoastFilter.
			$: $$invalidate(36, filteredAddons = addonCoffees.filter(product => {
				if (addonRoastFilter === 'Drip') return !!product.hasDrip;
				if (addonRoastFilter === 'Espresso') return !!product.hasEspresso;
				return true;
			}));
		}

		if ($$self.$$.dirty[0] & /*addonItems*/ 8) {
			// key ('productId:Roast') -> qty, for the per-roast steppers on each add-on card.
			$: $$invalidate(35, addonQtyByKey = addonItems.reduce(
				(m, it) => {
					m[it.id] = it.qty;
					return m;
				},
				{}
			));
		}

		if ($$self.$$.dirty[0] & /*addonItems*/ 8) {
			$: $$invalidate(9, addonEnabled = addonItems.length > 0);
		}

		if ($$self.$$.dirty[0] & /*addonItems*/ 8) {
			$: $$invalidate(71, addonTotalNum = addonItems.reduce((s, it) => s + getVariantPrice(it.product, it.size) * it.qty, 0));
		}

		if ($$self.$$.dirty[0] & /*addonEnabled*/ 512 | $$self.$$.dirty[2] & /*addonTotalNum*/ 512) {
			$: $$invalidate(34, addonTotalDisplay = addonEnabled ? formatter.format(addonTotalNum) : null);
		}

		if ($$self.$$.dirty[0] & /*$sizeDisplayValue, $shippingFrequencyDisplayValue, addonEnabled*/ 49664 | $$self.$$.dirty[2] & /*addonTotalNum*/ 512) {
			$: {
				const rawNum = calcPrice($sizeDisplayValue, $shippingFrequencyDisplayValue);
				const subNum = rawNum ? rawNum.total : 0;

				// With an add-on in the cart, shipping is no longer a known flat rate — it's
				// calculated at checkout, so it can't be folded into a grand total up front.
				$$invalidate(26, grandTotal = subNum > 0
				? formatter.format(subNum + addonTotalNum + (addonEnabled ? 0 : SHIPPING_FLAT_RATE))
				: null);
			}
		}

		if ($$self.$$.dirty[0] & /*$roast, $sizeDisplayValue, $shippingFrequencyDisplayValue, $processingFilters, $flavorFilters, $descriptorFilters, coffeeQty, curatedRoasts, addonItems, addonRoastFilter, currentStep*/ 1032254 | $$self.$$.dirty[2] & /*restored, $roastDisplayValue, $size, $shippingFrequency, hasAddedToCart*/ 14528) {
			// Save the selection on every change once the initial restore has run.
			$: if (restored && typeof localStorage !== 'undefined') {
				try {
					localStorage.setItem(STORAGE_KEY, JSON.stringify({
						roast: $roast,
						roastDisplay: $roastDisplayValue,
						size: $size,
						sizeDisplay: $sizeDisplayValue,
						freq: $shippingFrequency,
						freqDisplay: $shippingFrequencyDisplayValue,
						processing: $processingFilters,
						flavor: $flavorFilters,
						descriptor: $descriptorFilters,
						coffeeQty,
						curatedRoasts,
						addonItems: addonItems.map(it => ({
							id: it.id,
							productId: it.productId,
							size: it.size,
							qty: it.qty,
							roast: it.roast
						})),
						addonRoast: addonRoastFilter,
						currentStep,
						addedToCart: hasAddedToCart
					}));
				} catch(_) {
					
				}
			}
		}

		if ($$self.$$.dirty[0] & /*$processingFilters*/ 131072) {
			$: processingPrefText = $processingFilters.length
			? $processingFilters.join(', ')
			: 'No preference';
		}

		if ($$self.$$.dirty[0] & /*$flavorFilters*/ 65536) {
			$: flavorPrefText = $flavorFilters.length
			? $flavorFilters.join(', ')
			: 'No preference';
		}
	};

	$: $$invalidate(11, curatedApiAvailable = typeof window !== 'undefined' && !!window.coavaCuratedApiBase);

	// Add-ons — sourced from the dedicated 'addon-coffees' Shopify collection.
	$: $$invalidate(10, addonCoffees = addonProducts);

	return [
		debug,
		coffeeQty,
		curatedRoasts,
		addonItems,
		addonRoastFilter,
		currentStep,
		hasCurated,
		bagCount,
		selectedCount,
		addonEnabled,
		addonCoffees,
		curatedApiAvailable,
		step2Done,
		step1Done,
		$sizeDisplayValue,
		$shippingFrequencyDisplayValue,
		$flavorFilters,
		$processingFilters,
		$descriptorFilters,
		$roast,
		submitting,
		submitError,
		price,
		priceNum,
		perBagPrice,
		discountApplied,
		grandTotal,
		originalPrice,
		liveMessage,
		sbContainer,
		subscriptionInCart,
		freqSection,
		bagSizeLabel,
		isReady,
		addonTotalDisplay,
		addonQtyByKey,
		filteredAddons,
		progressPct,
		roastSummaryText,
		coffeeSummaryText,
		filteredCoffees,
		anyFilterActive,
		opts1kg,
		opts300g,
		DISCOUNT_LABEL,
		formatter,
		getVariantPrice,
		goToStep,
		selectSize,
		PROCESSING_OPTIONS,
		FLAVOR_OPTIONS,
		DESCRIPTOR_OPTIONS,
		getCardTags,
		roastCompatible,
		clearFilters,
		addCoffee,
		removeCoffee,
		toggleCurated,
		toggleCuratedRoast,
		addAddon,
		removeAddon,
		removeAddonItem,
		setAddonSize,
		changeAddonQty,
		handleAddToCart,
		recurring,
		PRICE_300G,
		PRICE_1KILO,
		hasAddedToCart,
		restored,
		selectedCoffeeList,
		addonTotalNum,
		SIZE_OPTIONS,
		$shippingFrequency,
		$size,
		$roastDisplayValue,
		click_handler,
		click_handler_1,
		click_handler_2,
		click_handler_3,
		click_handler_4,
		div11_binding,
		click_handler_5,
		click_handler_6,
		click_handler_7,
		click_handler_8,
		click_handler_9,
		click_handler_10,
		click_handler_11,
		click_handler_12,
		click_handler_13,
		keydown_handler,
		click_handler_14,
		click_handler_15,
		click_handler_16,
		click_handler_17,
		click_handler_18,
		click_handler_19,
		click_handler_20,
		click_handler_21,
		click_handler_22,
		click_handler_23,
		click_handler_24,
		click_handler_25,
		click_handler_26,
		click_handler_27,
		click_handler_28,
		click_handler_29,
		click_handler_30,
		click_handler_31,
		click_handler_32,
		click_handler_33,
		click_handler_34,
		div3_binding
	];
}

class SubscriptionBuilder extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponentDev {
	constructor(options) {
		super(options);
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, { debug: 0, recurring: 65 }, add_css, [-1, -1, -1, -1, -1, -1]);

		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterComponent", {
			component: this,
			tagName: "SubscriptionBuilder",
			options,
			id: create_fragment.name
		});
	}

	get debug() {
		throw new Error_1("<SubscriptionBuilder>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set debug(value) {
		throw new Error_1("<SubscriptionBuilder>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get recurring() {
		throw new Error_1("<SubscriptionBuilder>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set recurring(value) {
		throw new Error_1("<SubscriptionBuilder>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SubscriptionBuilder);

/***/ }),

/***/ "./js/components/subscriptionCartGuard.js":
/*!************************************************!*\
  !*** ./js/components/subscriptionCartGuard.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   enforceCartQuantityRules: () => (/* binding */ enforceCartQuantityRules),
/* harmony export */   isSubscriptionLine: () => (/* binding */ isSubscriptionLine),
/* harmony export */   subscriptionHeadroom: () => (/* binding */ subscriptionHeadroom),
/* harmony export */   subscriptionPlanBags: () => (/* binding */ subscriptionPlanBags)
/* harmony export */ });
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * Keeps cart quantities inside the rules the subscription builder enforces.
 *
 * Rebuy's drawer renders raw Shopify lines with a free-running +/- stepper. Its own limit
 * is a single static per-line min/max for the whole cart, which can't express our rules:
 * the subscription cap is a TOTAL across lines, and it differs by bag size (300g allows 4,
 * 1 Kilo allows 3 — see SIZE_OPTIONS in subscriptionBuilder.svelte).
 *
 * The rule is a TOTAL across all subscription lines, sized by the bags in the cart:
 *   • any 300g bag present → up to 4 bags
 *   • all bags 1 Kilo      → up to 3 bags
 *
 * Subscription lines ONLY. One-time add-ons and ordinary products are deliberately left
 * alone — buying six bags in one order is a legitimate sale, and neither carries a selling
 * plan whose bag count could be contradicted.
 *
 * Only the upper bound is enforced. A decrease is a legitimate "I want fewer bags" signal;
 * the builder reflects it as "3 of 4 selected" and asks the customer to finish step 2.
 */

function isSubscriptionLine(line) {
  return !!((line || {}).properties || {})._rc_bundle;
}
function isKiloLine(line) {
  var size = "".concat((line.properties || {})._Size || '', " ").concat(line.variant_title || '');
  return /kilo/i.test(size);
}

/**
 * Bags the plan holds — the bag count chosen in step 1, written onto every subscription line
 * as `_Bags` at add time. Being on the line means it survives removals (unlike summing the
 * surviving `_Size` values, which shrank the ceiling and stranded freed bags) and works in
 * any browser (unlike localStorage).
 *
 * Carts added before `_Bags` existed fall back to the size ceiling: 4 if any 300g bag is
 * present, 3 if they're all 1 Kilo.
 */
function subscriptionPlanBags(cart) {
  var lines = (cart && cart.items || []).filter(isSubscriptionLine);
  if (!lines.length) return 0;
  for (var i = 0; i < lines.length; i += 1) {
    var bags = parseInt((lines[i].properties || {})._Bags, 10);
    if (Number.isFinite(bags) && bags > 0) return bags;
  }
  return lines.every(isKiloLine) ? 3 : 4;
}
function subscriptionTotal(cart) {
  return (cart && cart.items || []).filter(isSubscriptionLine).reduce(function (sum, line) {
    return sum + line.quantity;
  }, 0);
}

/**
 * Plan bags minus bags in the cart. One number drives all three rules:
 *
 *   > 0  short of the plan  → Rebuy's `+` stays live, and checkout is blocked
 *   = 0  exactly right      → `+` disabled, checkout allowed
 *   < 0  over the plan      → trimmed back by enforceCartQuantityRules
 */
function subscriptionHeadroom(cart) {
  return subscriptionPlanBags(cart) - subscriptionTotal(cart);
}

/**
 * Trims the subscription back to the cap when the TOTAL is exceeded.
 *
 * A total, not a per-line rule: a 4-bag plan built as Araponga Drip ×1 + Araponga Espresso ×1
 * + Robinson ×2 must still let the customer drop Robinson to 1 and put that bag on Araponga.
 * Per-line clamping blocked that redistribution and contradicted the `+` button, which is
 * also total-based.
 *
 * Returns the corrected cart, or null if nothing needed changing.
 */
function enforceCartQuantityRules(_x) {
  return _enforceCartQuantityRules.apply(this, arguments);
}
function _enforceCartQuantityRules() {
  _enforceCartQuantityRules = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(cart) {
    var lines, allowed, excess, updates, res, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          lines = (cart && cart.items || []).filter(isSubscriptionLine);
          if (lines.length) {
            _context.n = 1;
            break;
          }
          return _context.a(2, null);
        case 1:
          allowed = subscriptionPlanBags(cart);
          excess = subscriptionTotal(cart) - allowed;
          if (!(excess <= 0)) {
            _context.n = 2;
            break;
          }
          return _context.a(2, null);
        case 2:
          // Take the overage off the largest lines first — that's where the customer just pushed the
          // quantity up. Never below 1: removing a coffee entirely is what the trash button is for.
          updates = {};
          lines.slice().sort(function (a, b) {
            return b.quantity - a.quantity;
          }).forEach(function (line) {
            if (excess <= 0) return;
            var reducible = Math.min(excess, line.quantity - 1);
            if (reducible > 0) {
              updates[line.key] = line.quantity - reducible;
              excess -= reducible;
            }
          });
          if (Object.keys(updates).length) {
            _context.n = 3;
            break;
          }
          return _context.a(2, null);
        case 3:
          console.info("[Coava] Subscription total exceeded its ".concat(allowed, "-bag plan; trimming. ") + 'Bag count is set in step 1 of the subscription builder.', updates);
          _context.p = 4;
          _context.n = 5;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              updates: updates
            })
          });
        case 5:
          res = _context.v;
          if (res.ok) {
            _context.n = 6;
            break;
          }
          return _context.a(2, null);
        case 6:
          return _context.a(2, res.json());
        case 7:
          _context.p = 7;
          _t = _context.v;
          console.warn('[Coava] could not correct cart quantities:', _t);
          return _context.a(2, null);
      }
    }, _callee, null, [[4, 7]]);
  }));
  return _enforceCartQuantityRules.apply(this, arguments);
}

/***/ }),

/***/ "./js/components/subscriptions/hiddenField.svelte":
/*!********************************************************!*\
  !*** ./js/components/subscriptions/hiddenField.svelte ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/internal/index.mjs");
/* js/components/subscriptions/hiddenField.svelte generated by Svelte v3.59.2 */


const file = "js/components/subscriptions/hiddenField.svelte";

// (7:0) {#if debug}
function create_if_block_1(ctx) {
	let p;
	let t;

	const block = {
		c: function create() {
			p = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("p");
			t = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.text)(/*name*/ ctx[1]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(p, file, 7, 2, 93);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, p, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.append_dev)(p, t);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*name*/ 2) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.set_data_dev)(t, /*name*/ ctx[1]);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(p);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block_1.name,
		type: "if",
		source: "(7:0) {#if debug}",
		ctx
	});

	return block;
}

// (15:0) {#if debug}
function create_if_block(ctx) {
	let br;

	const block = {
		c: function create() {
			br = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("br");
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(br, file, 15, 2, 201);
		},
		m: function mount(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, br, anchor);
		},
		d: function destroy(detaching) {
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(br);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_if_block.name,
		type: "if",
		source: "(15:0) {#if debug}",
		ctx
	});

	return block;
}

function create_fragment(ctx) {
	let t0;
	let input;
	let input_type_value;
	let t1;
	let if_block1_anchor;
	let if_block0 = /*debug*/ ctx[0] && create_if_block_1(ctx);
	let if_block1 = /*debug*/ ctx[0] && create_if_block(ctx);

	const block = {
		c: function create() {
			if (if_block0) if_block0.c();
			t0 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			input = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("input");
			t1 = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.space)();
			if (if_block1) if_block1.c();
			if_block1_anchor = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.empty)();
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(input, "name", /*name*/ ctx[1]);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(input, "type", input_type_value = /*debug*/ ctx[0] ? 'text' : 'hidden');
			input.value = /*value*/ ctx[2];
			input.required = true;
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.add_location)(input, file, 9, 0, 113);
		},
		l: function claim(nodes) {
			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
		},
		m: function mount(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, t0, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, input, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, t1, anchor);
			if (if_block1) if_block1.m(target, anchor);
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert_dev)(target, if_block1_anchor, anchor);
		},
		p: function update(ctx, [dirty]) {
			if (/*debug*/ ctx[0]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_1(ctx);
					if_block0.c();
					if_block0.m(t0.parentNode, t0);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (dirty & /*name*/ 2) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(input, "name", /*name*/ ctx[1]);
			}

			if (dirty & /*debug*/ 1 && input_type_value !== (input_type_value = /*debug*/ ctx[0] ? 'text' : 'hidden')) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr_dev)(input, "type", input_type_value);
			}

			if (dirty & /*value*/ 4 && input.value !== /*value*/ ctx[2]) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.prop_dev)(input, "value", /*value*/ ctx[2]);
			}

			if (/*debug*/ ctx[0]) {
				if (if_block1) {
					
				} else {
					if_block1 = create_if_block(ctx);
					if_block1.c();
					if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}
		},
		i: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		o: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d: function destroy(detaching) {
			if (if_block0) if_block0.d(detaching);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(t0);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(input);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(t1);
			if (if_block1) if_block1.d(detaching);
			if (detaching) (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach_dev)(if_block1_anchor);
		}
	};

	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.validate_slots)('HiddenField', slots, []);
	let { debug } = $$props;
	let { name } = $$props;
	let { value } = $$props;

	$$self.$$.on_mount.push(function () {
		if (debug === undefined && !('debug' in $$props || $$self.$$.bound[$$self.$$.props['debug']])) {
			console.warn("<HiddenField> was created without expected prop 'debug'");
		}

		if (name === undefined && !('name' in $$props || $$self.$$.bound[$$self.$$.props['name']])) {
			console.warn("<HiddenField> was created without expected prop 'name'");
		}

		if (value === undefined && !('value' in $$props || $$self.$$.bound[$$self.$$.props['value']])) {
			console.warn("<HiddenField> was created without expected prop 'value'");
		}
	});

	const writable_props = ['debug', 'name', 'value'];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<HiddenField> was created with unknown prop '${key}'`);
	});

	$$self.$$set = $$props => {
		if ('debug' in $$props) $$invalidate(0, debug = $$props.debug);
		if ('name' in $$props) $$invalidate(1, name = $$props.name);
		if ('value' in $$props) $$invalidate(2, value = $$props.value);
	};

	$$self.$capture_state = () => ({ debug, name, value });

	$$self.$inject_state = $$props => {
		if ('debug' in $$props) $$invalidate(0, debug = $$props.debug);
		if ('name' in $$props) $$invalidate(1, name = $$props.name);
		if ('value' in $$props) $$invalidate(2, value = $$props.value);
	};

	if ($$props && "$$inject" in $$props) {
		$$self.$inject_state($$props.$$inject);
	}

	return [debug, name, value];
}

class HiddenField extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponentDev {
	constructor(options) {
		super(options);
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, { debug: 0, name: 1, value: 2 });

		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.dispatch_dev)("SvelteRegisterComponent", {
			component: this,
			tagName: "HiddenField",
			options,
			id: create_fragment.name
		});
	}

	get debug() {
		throw new Error("<HiddenField>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set debug(value) {
		throw new Error("<HiddenField>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get name() {
		throw new Error("<HiddenField>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set name(value) {
		throw new Error("<HiddenField>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get value() {
		throw new Error("<HiddenField>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set value(value) {
		throw new Error("<HiddenField>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HiddenField);

/***/ }),

/***/ "./js/components/subscriptions/stores.js":
/*!***********************************************!*\
  !*** ./js/components/subscriptions/stores.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   coffee: () => (/* binding */ coffee),
/* harmony export */   coffeeDisplayValue: () => (/* binding */ coffeeDisplayValue),
/* harmony export */   descriptorFilters: () => (/* binding */ descriptorFilters),
/* harmony export */   flavor: () => (/* binding */ flavor),
/* harmony export */   flavorDisplayValue: () => (/* binding */ flavorDisplayValue),
/* harmony export */   flavorFilters: () => (/* binding */ flavorFilters),
/* harmony export */   paymentFrequency: () => (/* binding */ paymentFrequency),
/* harmony export */   paymentFrequencyDisplayValue: () => (/* binding */ paymentFrequencyDisplayValue),
/* harmony export */   processingFilters: () => (/* binding */ processingFilters),
/* harmony export */   roast: () => (/* binding */ roast),
/* harmony export */   roastDisplayValue: () => (/* binding */ roastDisplayValue),
/* harmony export */   shippingFrequency: () => (/* binding */ shippingFrequency),
/* harmony export */   shippingFrequencyDisplayValue: () => (/* binding */ shippingFrequencyDisplayValue),
/* harmony export */   size: () => (/* binding */ size),
/* harmony export */   sizeDisplayValue: () => (/* binding */ sizeDisplayValue),
/* harmony export */   standardizedPaymentFrequency: () => (/* binding */ standardizedPaymentFrequency)
/* harmony export */ });
/* harmony import */ var svelte_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/store */ "./node_modules/svelte/store/index.mjs");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }


// Step 1: Roast (Drip / Espresso) — first step so customers commit to roast profile
var roast = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.writable)('');
var roastDisplayValue = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.writable)('');

// Step 2: Coffee selection from the rotation
// null = "Curated by our team"; product object = specific coffee
var coffee = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.writable)(null);
var coffeeDisplayValue = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.derived)(coffee, function ($coffee) {
  return $coffee ? $coffee.title : '';
});

// Filters for step 2 coffee browsing
var processingFilters = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.writable)([]); // e.g. ['Washed', 'Natural', 'Honey / Alternative']
var flavorFilters = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.writable)([]); // e.g. ['Classic', 'Unique']
var descriptorFilters = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.writable)([]); // e.g. ['Chocolate', 'Fruity', 'Rich', 'Delicate', 'Complex']

// Step 3: Bag size / quantity
var size = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.writable)('');
var sizeDisplayValue = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.writable)('');

// Step 4: Shipping frequency
var shippingFrequency = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.writable)([null, null]);
var shippingFrequencyDisplayValue = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.writable)('');

// Kept for backward-compat with propertyOption; we always use "Pay Per Shipment" now
var paymentFrequency = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.writable)(['Pay Per Shipment', null]);
var paymentFrequencyDisplayValue = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.writable)('Pay Per Shipment');
var standardizedPaymentFrequency = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.derived)([paymentFrequency, shippingFrequency], function (_ref, set) {
  var _ref2 = _slicedToArray(_ref, 2),
    $paymentFrequency = _ref2[0],
    $shippingFrequency = _ref2[1];
  if ($shippingFrequency[1] === 'Weeks' && $paymentFrequency[1] === 'Months') {
    set([$paymentFrequency[0] * 4, 'Weeks']);
  } else {
    set($paymentFrequency);
  }
});

// Flavor store alias kept so propertyOption.svelte doesn't break if it's used elsewhere
var flavor = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.writable)('');
var flavorDisplayValue = (0,svelte_store__WEBPACK_IMPORTED_MODULE_0__.writable)('');

/***/ }),

/***/ "./node_modules/autosize/dist/autosize.js":
/*!************************************************!*\
  !*** ./node_modules/autosize/dist/autosize.js ***!
  \************************************************/
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	autosize 4.0.2
	license: MIT
	http://www.jacklmoore.com/autosize
*/
(function (global, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else // removed by dead control flow
{ var mod; }
})(this, function (module, exports) {
	'use strict';

	var map = typeof Map === "function" ? new Map() : function () {
		var keys = [];
		var values = [];

		return {
			has: function has(key) {
				return keys.indexOf(key) > -1;
			},
			get: function get(key) {
				return values[keys.indexOf(key)];
			},
			set: function set(key, value) {
				if (keys.indexOf(key) === -1) {
					keys.push(key);
					values.push(value);
				}
			},
			delete: function _delete(key) {
				var index = keys.indexOf(key);
				if (index > -1) {
					keys.splice(index, 1);
					values.splice(index, 1);
				}
			}
		};
	}();

	var createEvent = function createEvent(name) {
		return new Event(name, { bubbles: true });
	};
	try {
		new Event('test');
	} catch (e) {
		// IE does not support `new Event()`
		createEvent = function createEvent(name) {
			var evt = document.createEvent('Event');
			evt.initEvent(name, true, false);
			return evt;
		};
	}

	function assign(ta) {
		if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;

		var heightOffset = null;
		var clientWidth = null;
		var cachedHeight = null;

		function init() {
			var style = window.getComputedStyle(ta, null);

			if (style.resize === 'vertical') {
				ta.style.resize = 'none';
			} else if (style.resize === 'both') {
				ta.style.resize = 'horizontal';
			}

			if (style.boxSizing === 'content-box') {
				heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
			} else {
				heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
			}
			// Fix when a textarea is not on document body and heightOffset is Not a Number
			if (isNaN(heightOffset)) {
				heightOffset = 0;
			}

			update();
		}

		function changeOverflow(value) {
			{
				// Chrome/Safari-specific fix:
				// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
				// made available by removing the scrollbar. The following forces the necessary text reflow.
				var width = ta.style.width;
				ta.style.width = '0px';
				// Force reflow:
				/* jshint ignore:start */
				ta.offsetWidth;
				/* jshint ignore:end */
				ta.style.width = width;
			}

			ta.style.overflowY = value;
		}

		function getParentOverflows(el) {
			var arr = [];

			while (el && el.parentNode && el.parentNode instanceof Element) {
				if (el.parentNode.scrollTop) {
					arr.push({
						node: el.parentNode,
						scrollTop: el.parentNode.scrollTop
					});
				}
				el = el.parentNode;
			}

			return arr;
		}

		function resize() {
			if (ta.scrollHeight === 0) {
				// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
				return;
			}

			var overflows = getParentOverflows(ta);
			var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)

			ta.style.height = '';
			ta.style.height = ta.scrollHeight + heightOffset + 'px';

			// used to check if an update is actually necessary on window.resize
			clientWidth = ta.clientWidth;

			// prevents scroll-position jumping
			overflows.forEach(function (el) {
				el.node.scrollTop = el.scrollTop;
			});

			if (docTop) {
				document.documentElement.scrollTop = docTop;
			}
		}

		function update() {
			resize();

			var styleHeight = Math.round(parseFloat(ta.style.height));
			var computed = window.getComputedStyle(ta, null);

			// Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
			var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;

			// The actual height not matching the style height (set via the resize method) indicates that 
			// the max-height has been exceeded, in which case the overflow should be allowed.
			if (actualHeight < styleHeight) {
				if (computed.overflowY === 'hidden') {
					changeOverflow('scroll');
					resize();
					actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
				}
			} else {
				// Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
				if (computed.overflowY !== 'hidden') {
					changeOverflow('hidden');
					resize();
					actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
				}
			}

			if (cachedHeight !== actualHeight) {
				cachedHeight = actualHeight;
				var evt = createEvent('autosize:resized');
				try {
					ta.dispatchEvent(evt);
				} catch (err) {
					// Firefox will throw an error on dispatchEvent for a detached element
					// https://bugzilla.mozilla.org/show_bug.cgi?id=889376
				}
			}
		}

		var pageResize = function pageResize() {
			if (ta.clientWidth !== clientWidth) {
				update();
			}
		};

		var destroy = function (style) {
			window.removeEventListener('resize', pageResize, false);
			ta.removeEventListener('input', update, false);
			ta.removeEventListener('keyup', update, false);
			ta.removeEventListener('autosize:destroy', destroy, false);
			ta.removeEventListener('autosize:update', update, false);

			Object.keys(style).forEach(function (key) {
				ta.style[key] = style[key];
			});

			map.delete(ta);
		}.bind(ta, {
			height: ta.style.height,
			resize: ta.style.resize,
			overflowY: ta.style.overflowY,
			overflowX: ta.style.overflowX,
			wordWrap: ta.style.wordWrap
		});

		ta.addEventListener('autosize:destroy', destroy, false);

		// IE9 does not fire onpropertychange or oninput for deletions,
		// so binding to onkeyup to catch most of those events.
		// There is no way that I know of to detect something like 'cut' in IE9.
		if ('onpropertychange' in ta && 'oninput' in ta) {
			ta.addEventListener('keyup', update, false);
		}

		window.addEventListener('resize', pageResize, false);
		ta.addEventListener('input', update, false);
		ta.addEventListener('autosize:update', update, false);
		ta.style.overflowX = 'hidden';
		ta.style.wordWrap = 'break-word';

		map.set(ta, {
			destroy: destroy,
			update: update
		});

		init();
	}

	function destroy(ta) {
		var methods = map.get(ta);
		if (methods) {
			methods.destroy();
		}
	}

	function update(ta) {
		var methods = map.get(ta);
		if (methods) {
			methods.update();
		}
	}

	var autosize = null;

	// Do nothing in Node.js environment and IE8 (or lower)
	if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
		autosize = function autosize(el) {
			return el;
		};
		autosize.destroy = function (el) {
			return el;
		};
		autosize.update = function (el) {
			return el;
		};
	} else {
		autosize = function autosize(el, options) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], function (x) {
					return assign(x, options);
				});
			}
			return el;
		};
		autosize.destroy = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], destroy);
			}
			return el;
		};
		autosize.update = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], update);
			}
			return el;
		};
	}

	exports.default = autosize;
	module.exports = exports['default'];
});

/***/ }),

/***/ "./node_modules/svelte/index.mjs":
/*!***************************************!*\
  !*** ./node_modules/svelte/index.mjs ***!
  \***************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SvelteComponent: () => (/* reexport safe */ _internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.SvelteComponentDev),
/* harmony export */   SvelteComponentTyped: () => (/* reexport safe */ _internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.SvelteComponentTyped),
/* harmony export */   afterUpdate: () => (/* reexport safe */ _internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.afterUpdate),
/* harmony export */   beforeUpdate: () => (/* reexport safe */ _internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.beforeUpdate),
/* harmony export */   createEventDispatcher: () => (/* reexport safe */ _internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.createEventDispatcher),
/* harmony export */   getAllContexts: () => (/* reexport safe */ _internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.getAllContexts),
/* harmony export */   getContext: () => (/* reexport safe */ _internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.getContext),
/* harmony export */   hasContext: () => (/* reexport safe */ _internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.hasContext),
/* harmony export */   onDestroy: () => (/* reexport safe */ _internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.onDestroy),
/* harmony export */   onMount: () => (/* reexport safe */ _internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.onMount),
/* harmony export */   setContext: () => (/* reexport safe */ _internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.setContext),
/* harmony export */   tick: () => (/* reexport safe */ _internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.tick)
/* harmony export */ });
/* harmony import */ var _internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./internal/index.mjs */ "./node_modules/svelte/internal/index.mjs");



/***/ }),

/***/ "./node_modules/svelte/internal/index.mjs":
/*!************************************************!*\
  !*** ./node_modules/svelte/internal/index.mjs ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   HtmlTag: () => (/* binding */ HtmlTag),
/* harmony export */   HtmlTagHydration: () => (/* binding */ HtmlTagHydration),
/* harmony export */   ResizeObserverSingleton: () => (/* binding */ ResizeObserverSingleton),
/* harmony export */   SvelteComponent: () => (/* binding */ SvelteComponent),
/* harmony export */   SvelteComponentDev: () => (/* binding */ SvelteComponentDev),
/* harmony export */   SvelteComponentTyped: () => (/* binding */ SvelteComponentTyped),
/* harmony export */   SvelteElement: () => (/* binding */ SvelteElement),
/* harmony export */   action_destroyer: () => (/* binding */ action_destroyer),
/* harmony export */   add_attribute: () => (/* binding */ add_attribute),
/* harmony export */   add_classes: () => (/* binding */ add_classes),
/* harmony export */   add_flush_callback: () => (/* binding */ add_flush_callback),
/* harmony export */   add_iframe_resize_listener: () => (/* binding */ add_iframe_resize_listener),
/* harmony export */   add_location: () => (/* binding */ add_location),
/* harmony export */   add_render_callback: () => (/* binding */ add_render_callback),
/* harmony export */   add_styles: () => (/* binding */ add_styles),
/* harmony export */   add_transform: () => (/* binding */ add_transform),
/* harmony export */   afterUpdate: () => (/* binding */ afterUpdate),
/* harmony export */   append: () => (/* binding */ append),
/* harmony export */   append_dev: () => (/* binding */ append_dev),
/* harmony export */   append_empty_stylesheet: () => (/* binding */ append_empty_stylesheet),
/* harmony export */   append_hydration: () => (/* binding */ append_hydration),
/* harmony export */   append_hydration_dev: () => (/* binding */ append_hydration_dev),
/* harmony export */   append_styles: () => (/* binding */ append_styles),
/* harmony export */   assign: () => (/* binding */ assign),
/* harmony export */   attr: () => (/* binding */ attr),
/* harmony export */   attr_dev: () => (/* binding */ attr_dev),
/* harmony export */   attribute_to_object: () => (/* binding */ attribute_to_object),
/* harmony export */   beforeUpdate: () => (/* binding */ beforeUpdate),
/* harmony export */   bind: () => (/* binding */ bind),
/* harmony export */   binding_callbacks: () => (/* binding */ binding_callbacks),
/* harmony export */   blank_object: () => (/* binding */ blank_object),
/* harmony export */   bubble: () => (/* binding */ bubble),
/* harmony export */   check_outros: () => (/* binding */ check_outros),
/* harmony export */   children: () => (/* binding */ children),
/* harmony export */   claim_comment: () => (/* binding */ claim_comment),
/* harmony export */   claim_component: () => (/* binding */ claim_component),
/* harmony export */   claim_element: () => (/* binding */ claim_element),
/* harmony export */   claim_html_tag: () => (/* binding */ claim_html_tag),
/* harmony export */   claim_space: () => (/* binding */ claim_space),
/* harmony export */   claim_svg_element: () => (/* binding */ claim_svg_element),
/* harmony export */   claim_text: () => (/* binding */ claim_text),
/* harmony export */   clear_loops: () => (/* binding */ clear_loops),
/* harmony export */   comment: () => (/* binding */ comment),
/* harmony export */   component_subscribe: () => (/* binding */ component_subscribe),
/* harmony export */   compute_rest_props: () => (/* binding */ compute_rest_props),
/* harmony export */   compute_slots: () => (/* binding */ compute_slots),
/* harmony export */   construct_svelte_component: () => (/* binding */ construct_svelte_component),
/* harmony export */   construct_svelte_component_dev: () => (/* binding */ construct_svelte_component_dev),
/* harmony export */   contenteditable_truthy_values: () => (/* binding */ contenteditable_truthy_values),
/* harmony export */   createEventDispatcher: () => (/* binding */ createEventDispatcher),
/* harmony export */   create_animation: () => (/* binding */ create_animation),
/* harmony export */   create_bidirectional_transition: () => (/* binding */ create_bidirectional_transition),
/* harmony export */   create_component: () => (/* binding */ create_component),
/* harmony export */   create_in_transition: () => (/* binding */ create_in_transition),
/* harmony export */   create_out_transition: () => (/* binding */ create_out_transition),
/* harmony export */   create_slot: () => (/* binding */ create_slot),
/* harmony export */   create_ssr_component: () => (/* binding */ create_ssr_component),
/* harmony export */   current_component: () => (/* binding */ current_component),
/* harmony export */   custom_event: () => (/* binding */ custom_event),
/* harmony export */   dataset_dev: () => (/* binding */ dataset_dev),
/* harmony export */   debug: () => (/* binding */ debug),
/* harmony export */   destroy_block: () => (/* binding */ destroy_block),
/* harmony export */   destroy_component: () => (/* binding */ destroy_component),
/* harmony export */   destroy_each: () => (/* binding */ destroy_each),
/* harmony export */   detach: () => (/* binding */ detach),
/* harmony export */   detach_after_dev: () => (/* binding */ detach_after_dev),
/* harmony export */   detach_before_dev: () => (/* binding */ detach_before_dev),
/* harmony export */   detach_between_dev: () => (/* binding */ detach_between_dev),
/* harmony export */   detach_dev: () => (/* binding */ detach_dev),
/* harmony export */   dirty_components: () => (/* binding */ dirty_components),
/* harmony export */   dispatch_dev: () => (/* binding */ dispatch_dev),
/* harmony export */   each: () => (/* binding */ each),
/* harmony export */   element: () => (/* binding */ element),
/* harmony export */   element_is: () => (/* binding */ element_is),
/* harmony export */   empty: () => (/* binding */ empty),
/* harmony export */   end_hydrating: () => (/* binding */ end_hydrating),
/* harmony export */   escape: () => (/* binding */ escape),
/* harmony export */   escape_attribute_value: () => (/* binding */ escape_attribute_value),
/* harmony export */   escape_object: () => (/* binding */ escape_object),
/* harmony export */   exclude_internal_props: () => (/* binding */ exclude_internal_props),
/* harmony export */   fix_and_destroy_block: () => (/* binding */ fix_and_destroy_block),
/* harmony export */   fix_and_outro_and_destroy_block: () => (/* binding */ fix_and_outro_and_destroy_block),
/* harmony export */   fix_position: () => (/* binding */ fix_position),
/* harmony export */   flush: () => (/* binding */ flush),
/* harmony export */   flush_render_callbacks: () => (/* binding */ flush_render_callbacks),
/* harmony export */   getAllContexts: () => (/* binding */ getAllContexts),
/* harmony export */   getContext: () => (/* binding */ getContext),
/* harmony export */   get_all_dirty_from_scope: () => (/* binding */ get_all_dirty_from_scope),
/* harmony export */   get_binding_group_value: () => (/* binding */ get_binding_group_value),
/* harmony export */   get_current_component: () => (/* binding */ get_current_component),
/* harmony export */   get_custom_elements_slots: () => (/* binding */ get_custom_elements_slots),
/* harmony export */   get_root_for_style: () => (/* binding */ get_root_for_style),
/* harmony export */   get_slot_changes: () => (/* binding */ get_slot_changes),
/* harmony export */   get_spread_object: () => (/* binding */ get_spread_object),
/* harmony export */   get_spread_update: () => (/* binding */ get_spread_update),
/* harmony export */   get_store_value: () => (/* binding */ get_store_value),
/* harmony export */   globals: () => (/* binding */ globals),
/* harmony export */   group_outros: () => (/* binding */ group_outros),
/* harmony export */   handle_promise: () => (/* binding */ handle_promise),
/* harmony export */   hasContext: () => (/* binding */ hasContext),
/* harmony export */   has_prop: () => (/* binding */ has_prop),
/* harmony export */   head_selector: () => (/* binding */ head_selector),
/* harmony export */   identity: () => (/* binding */ identity),
/* harmony export */   init: () => (/* binding */ init),
/* harmony export */   init_binding_group: () => (/* binding */ init_binding_group),
/* harmony export */   init_binding_group_dynamic: () => (/* binding */ init_binding_group_dynamic),
/* harmony export */   insert: () => (/* binding */ insert),
/* harmony export */   insert_dev: () => (/* binding */ insert_dev),
/* harmony export */   insert_hydration: () => (/* binding */ insert_hydration),
/* harmony export */   insert_hydration_dev: () => (/* binding */ insert_hydration_dev),
/* harmony export */   intros: () => (/* binding */ intros),
/* harmony export */   invalid_attribute_name_character: () => (/* binding */ invalid_attribute_name_character),
/* harmony export */   is_client: () => (/* binding */ is_client),
/* harmony export */   is_crossorigin: () => (/* binding */ is_crossorigin),
/* harmony export */   is_empty: () => (/* binding */ is_empty),
/* harmony export */   is_function: () => (/* binding */ is_function),
/* harmony export */   is_promise: () => (/* binding */ is_promise),
/* harmony export */   is_void: () => (/* binding */ is_void),
/* harmony export */   listen: () => (/* binding */ listen),
/* harmony export */   listen_dev: () => (/* binding */ listen_dev),
/* harmony export */   loop: () => (/* binding */ loop),
/* harmony export */   loop_guard: () => (/* binding */ loop_guard),
/* harmony export */   merge_ssr_styles: () => (/* binding */ merge_ssr_styles),
/* harmony export */   missing_component: () => (/* binding */ missing_component),
/* harmony export */   mount_component: () => (/* binding */ mount_component),
/* harmony export */   noop: () => (/* binding */ noop),
/* harmony export */   not_equal: () => (/* binding */ not_equal),
/* harmony export */   now: () => (/* binding */ now),
/* harmony export */   null_to_empty: () => (/* binding */ null_to_empty),
/* harmony export */   object_without_properties: () => (/* binding */ object_without_properties),
/* harmony export */   onDestroy: () => (/* binding */ onDestroy),
/* harmony export */   onMount: () => (/* binding */ onMount),
/* harmony export */   once: () => (/* binding */ once),
/* harmony export */   outro_and_destroy_block: () => (/* binding */ outro_and_destroy_block),
/* harmony export */   prevent_default: () => (/* binding */ prevent_default),
/* harmony export */   prop_dev: () => (/* binding */ prop_dev),
/* harmony export */   query_selector_all: () => (/* binding */ query_selector_all),
/* harmony export */   raf: () => (/* binding */ raf),
/* harmony export */   resize_observer_border_box: () => (/* binding */ resize_observer_border_box),
/* harmony export */   resize_observer_content_box: () => (/* binding */ resize_observer_content_box),
/* harmony export */   resize_observer_device_pixel_content_box: () => (/* binding */ resize_observer_device_pixel_content_box),
/* harmony export */   run: () => (/* binding */ run),
/* harmony export */   run_all: () => (/* binding */ run_all),
/* harmony export */   safe_not_equal: () => (/* binding */ safe_not_equal),
/* harmony export */   schedule_update: () => (/* binding */ schedule_update),
/* harmony export */   select_multiple_value: () => (/* binding */ select_multiple_value),
/* harmony export */   select_option: () => (/* binding */ select_option),
/* harmony export */   select_options: () => (/* binding */ select_options),
/* harmony export */   select_value: () => (/* binding */ select_value),
/* harmony export */   self: () => (/* binding */ self),
/* harmony export */   setContext: () => (/* binding */ setContext),
/* harmony export */   set_attributes: () => (/* binding */ set_attributes),
/* harmony export */   set_current_component: () => (/* binding */ set_current_component),
/* harmony export */   set_custom_element_data: () => (/* binding */ set_custom_element_data),
/* harmony export */   set_custom_element_data_map: () => (/* binding */ set_custom_element_data_map),
/* harmony export */   set_data: () => (/* binding */ set_data),
/* harmony export */   set_data_contenteditable: () => (/* binding */ set_data_contenteditable),
/* harmony export */   set_data_contenteditable_dev: () => (/* binding */ set_data_contenteditable_dev),
/* harmony export */   set_data_dev: () => (/* binding */ set_data_dev),
/* harmony export */   set_data_maybe_contenteditable: () => (/* binding */ set_data_maybe_contenteditable),
/* harmony export */   set_data_maybe_contenteditable_dev: () => (/* binding */ set_data_maybe_contenteditable_dev),
/* harmony export */   set_dynamic_element_data: () => (/* binding */ set_dynamic_element_data),
/* harmony export */   set_input_type: () => (/* binding */ set_input_type),
/* harmony export */   set_input_value: () => (/* binding */ set_input_value),
/* harmony export */   set_now: () => (/* binding */ set_now),
/* harmony export */   set_raf: () => (/* binding */ set_raf),
/* harmony export */   set_store_value: () => (/* binding */ set_store_value),
/* harmony export */   set_style: () => (/* binding */ set_style),
/* harmony export */   set_svg_attributes: () => (/* binding */ set_svg_attributes),
/* harmony export */   space: () => (/* binding */ space),
/* harmony export */   split_css_unit: () => (/* binding */ split_css_unit),
/* harmony export */   spread: () => (/* binding */ spread),
/* harmony export */   src_url_equal: () => (/* binding */ src_url_equal),
/* harmony export */   start_hydrating: () => (/* binding */ start_hydrating),
/* harmony export */   stop_immediate_propagation: () => (/* binding */ stop_immediate_propagation),
/* harmony export */   stop_propagation: () => (/* binding */ stop_propagation),
/* harmony export */   subscribe: () => (/* binding */ subscribe),
/* harmony export */   svg_element: () => (/* binding */ svg_element),
/* harmony export */   text: () => (/* binding */ text),
/* harmony export */   tick: () => (/* binding */ tick),
/* harmony export */   time_ranges_to_array: () => (/* binding */ time_ranges_to_array),
/* harmony export */   to_number: () => (/* binding */ to_number),
/* harmony export */   toggle_class: () => (/* binding */ toggle_class),
/* harmony export */   transition_in: () => (/* binding */ transition_in),
/* harmony export */   transition_out: () => (/* binding */ transition_out),
/* harmony export */   trusted: () => (/* binding */ trusted),
/* harmony export */   update_await_block_branch: () => (/* binding */ update_await_block_branch),
/* harmony export */   update_keyed_each: () => (/* binding */ update_keyed_each),
/* harmony export */   update_slot: () => (/* binding */ update_slot),
/* harmony export */   update_slot_base: () => (/* binding */ update_slot_base),
/* harmony export */   validate_component: () => (/* binding */ validate_component),
/* harmony export */   validate_dynamic_element: () => (/* binding */ validate_dynamic_element),
/* harmony export */   validate_each_argument: () => (/* binding */ validate_each_argument),
/* harmony export */   validate_each_keys: () => (/* binding */ validate_each_keys),
/* harmony export */   validate_slots: () => (/* binding */ validate_slots),
/* harmony export */   validate_store: () => (/* binding */ validate_store),
/* harmony export */   validate_void_dynamic_element: () => (/* binding */ validate_void_dynamic_element),
/* harmony export */   xlink_attr: () => (/* binding */ xlink_attr)
/* harmony export */ });
function noop() { }
const identity = x => x;
function assign(tar, src) {
    // @ts-ignore
    for (const k in src)
        tar[k] = src[k];
    return tar;
}
// Adapted from https://github.com/then/is-promise/blob/master/index.js
// Distributed under MIT License https://github.com/then/is-promise/blob/master/LICENSE
function is_promise(value) {
    return !!value && (typeof value === 'object' || typeof value === 'function') && typeof value.then === 'function';
}
function add_location(element, file, line, column, char) {
    element.__svelte_meta = {
        loc: { file, line, column, char }
    };
}
function run(fn) {
    return fn();
}
function blank_object() {
    return Object.create(null);
}
function run_all(fns) {
    fns.forEach(run);
}
function is_function(thing) {
    return typeof thing === 'function';
}
function safe_not_equal(a, b) {
    return a != a ? b == b : a !== b || ((a && typeof a === 'object') || typeof a === 'function');
}
let src_url_equal_anchor;
function src_url_equal(element_src, url) {
    if (!src_url_equal_anchor) {
        src_url_equal_anchor = document.createElement('a');
    }
    src_url_equal_anchor.href = url;
    return element_src === src_url_equal_anchor.href;
}
function not_equal(a, b) {
    return a != a ? b == b : a !== b;
}
function is_empty(obj) {
    return Object.keys(obj).length === 0;
}
function validate_store(store, name) {
    if (store != null && typeof store.subscribe !== 'function') {
        throw new Error(`'${name}' is not a store with a 'subscribe' method`);
    }
}
function subscribe(store, ...callbacks) {
    if (store == null) {
        return noop;
    }
    const unsub = store.subscribe(...callbacks);
    return unsub.unsubscribe ? () => unsub.unsubscribe() : unsub;
}
function get_store_value(store) {
    let value;
    subscribe(store, _ => value = _)();
    return value;
}
function component_subscribe(component, store, callback) {
    component.$$.on_destroy.push(subscribe(store, callback));
}
function create_slot(definition, ctx, $$scope, fn) {
    if (definition) {
        const slot_ctx = get_slot_context(definition, ctx, $$scope, fn);
        return definition[0](slot_ctx);
    }
}
function get_slot_context(definition, ctx, $$scope, fn) {
    return definition[1] && fn
        ? assign($$scope.ctx.slice(), definition[1](fn(ctx)))
        : $$scope.ctx;
}
function get_slot_changes(definition, $$scope, dirty, fn) {
    if (definition[2] && fn) {
        const lets = definition[2](fn(dirty));
        if ($$scope.dirty === undefined) {
            return lets;
        }
        if (typeof lets === 'object') {
            const merged = [];
            const len = Math.max($$scope.dirty.length, lets.length);
            for (let i = 0; i < len; i += 1) {
                merged[i] = $$scope.dirty[i] | lets[i];
            }
            return merged;
        }
        return $$scope.dirty | lets;
    }
    return $$scope.dirty;
}
function update_slot_base(slot, slot_definition, ctx, $$scope, slot_changes, get_slot_context_fn) {
    if (slot_changes) {
        const slot_context = get_slot_context(slot_definition, ctx, $$scope, get_slot_context_fn);
        slot.p(slot_context, slot_changes);
    }
}
function update_slot(slot, slot_definition, ctx, $$scope, dirty, get_slot_changes_fn, get_slot_context_fn) {
    const slot_changes = get_slot_changes(slot_definition, $$scope, dirty, get_slot_changes_fn);
    update_slot_base(slot, slot_definition, ctx, $$scope, slot_changes, get_slot_context_fn);
}
function get_all_dirty_from_scope($$scope) {
    if ($$scope.ctx.length > 32) {
        const dirty = [];
        const length = $$scope.ctx.length / 32;
        for (let i = 0; i < length; i++) {
            dirty[i] = -1;
        }
        return dirty;
    }
    return -1;
}
function exclude_internal_props(props) {
    const result = {};
    for (const k in props)
        if (k[0] !== '$')
            result[k] = props[k];
    return result;
}
function compute_rest_props(props, keys) {
    const rest = {};
    keys = new Set(keys);
    for (const k in props)
        if (!keys.has(k) && k[0] !== '$')
            rest[k] = props[k];
    return rest;
}
function compute_slots(slots) {
    const result = {};
    for (const key in slots) {
        result[key] = true;
    }
    return result;
}
function once(fn) {
    let ran = false;
    return function (...args) {
        if (ran)
            return;
        ran = true;
        fn.call(this, ...args);
    };
}
function null_to_empty(value) {
    return value == null ? '' : value;
}
function set_store_value(store, ret, value) {
    store.set(value);
    return ret;
}
const has_prop = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
function action_destroyer(action_result) {
    return action_result && is_function(action_result.destroy) ? action_result.destroy : noop;
}
function split_css_unit(value) {
    const split = typeof value === 'string' && value.match(/^\s*(-?[\d.]+)([^\s]*)\s*$/);
    return split ? [parseFloat(split[1]), split[2] || 'px'] : [value, 'px'];
}
const contenteditable_truthy_values = ['', true, 1, 'true', 'contenteditable'];

const is_client = typeof window !== 'undefined';
let now = is_client
    ? () => window.performance.now()
    : () => Date.now();
let raf = is_client ? cb => requestAnimationFrame(cb) : noop;
// used internally for testing
function set_now(fn) {
    now = fn;
}
function set_raf(fn) {
    raf = fn;
}

const tasks = new Set();
function run_tasks(now) {
    tasks.forEach(task => {
        if (!task.c(now)) {
            tasks.delete(task);
            task.f();
        }
    });
    if (tasks.size !== 0)
        raf(run_tasks);
}
/**
 * For testing purposes only!
 */
function clear_loops() {
    tasks.clear();
}
/**
 * Creates a new task that runs on each raf frame
 * until it returns a falsy value or is aborted
 */
function loop(callback) {
    let task;
    if (tasks.size === 0)
        raf(run_tasks);
    return {
        promise: new Promise(fulfill => {
            tasks.add(task = { c: callback, f: fulfill });
        }),
        abort() {
            tasks.delete(task);
        }
    };
}

const globals = (typeof window !== 'undefined'
    ? window
    : typeof globalThis !== 'undefined'
        ? globalThis
        : global);

/**
 * Resize observer singleton.
 * One listener per element only!
 * https://groups.google.com/a/chromium.org/g/blink-dev/c/z6ienONUb5A/m/F5-VcUZtBAAJ
 */
class ResizeObserverSingleton {
    constructor(options) {
        this.options = options;
        this._listeners = 'WeakMap' in globals ? new WeakMap() : undefined;
    }
    observe(element, listener) {
        this._listeners.set(element, listener);
        this._getObserver().observe(element, this.options);
        return () => {
            this._listeners.delete(element);
            this._observer.unobserve(element); // this line can probably be removed
        };
    }
    _getObserver() {
        var _a;
        return (_a = this._observer) !== null && _a !== void 0 ? _a : (this._observer = new ResizeObserver((entries) => {
            var _a;
            for (const entry of entries) {
                ResizeObserverSingleton.entries.set(entry.target, entry);
                (_a = this._listeners.get(entry.target)) === null || _a === void 0 ? void 0 : _a(entry);
            }
        }));
    }
}
// Needs to be written like this to pass the tree-shake-test
ResizeObserverSingleton.entries = 'WeakMap' in globals ? new WeakMap() : undefined;

// Track which nodes are claimed during hydration. Unclaimed nodes can then be removed from the DOM
// at the end of hydration without touching the remaining nodes.
let is_hydrating = false;
function start_hydrating() {
    is_hydrating = true;
}
function end_hydrating() {
    is_hydrating = false;
}
function upper_bound(low, high, key, value) {
    // Return first index of value larger than input value in the range [low, high)
    while (low < high) {
        const mid = low + ((high - low) >> 1);
        if (key(mid) <= value) {
            low = mid + 1;
        }
        else {
            high = mid;
        }
    }
    return low;
}
function init_hydrate(target) {
    if (target.hydrate_init)
        return;
    target.hydrate_init = true;
    // We know that all children have claim_order values since the unclaimed have been detached if target is not <head>
    let children = target.childNodes;
    // If target is <head>, there may be children without claim_order
    if (target.nodeName === 'HEAD') {
        const myChildren = [];
        for (let i = 0; i < children.length; i++) {
            const node = children[i];
            if (node.claim_order !== undefined) {
                myChildren.push(node);
            }
        }
        children = myChildren;
    }
    /*
    * Reorder claimed children optimally.
    * We can reorder claimed children optimally by finding the longest subsequence of
    * nodes that are already claimed in order and only moving the rest. The longest
    * subsequence of nodes that are claimed in order can be found by
    * computing the longest increasing subsequence of .claim_order values.
    *
    * This algorithm is optimal in generating the least amount of reorder operations
    * possible.
    *
    * Proof:
    * We know that, given a set of reordering operations, the nodes that do not move
    * always form an increasing subsequence, since they do not move among each other
    * meaning that they must be already ordered among each other. Thus, the maximal
    * set of nodes that do not move form a longest increasing subsequence.
    */
    // Compute longest increasing subsequence
    // m: subsequence length j => index k of smallest value that ends an increasing subsequence of length j
    const m = new Int32Array(children.length + 1);
    // Predecessor indices + 1
    const p = new Int32Array(children.length);
    m[0] = -1;
    let longest = 0;
    for (let i = 0; i < children.length; i++) {
        const current = children[i].claim_order;
        // Find the largest subsequence length such that it ends in a value less than our current value
        // upper_bound returns first greater value, so we subtract one
        // with fast path for when we are on the current longest subsequence
        const seqLen = ((longest > 0 && children[m[longest]].claim_order <= current) ? longest + 1 : upper_bound(1, longest, idx => children[m[idx]].claim_order, current)) - 1;
        p[i] = m[seqLen] + 1;
        const newLen = seqLen + 1;
        // We can guarantee that current is the smallest value. Otherwise, we would have generated a longer sequence.
        m[newLen] = i;
        longest = Math.max(newLen, longest);
    }
    // The longest increasing subsequence of nodes (initially reversed)
    const lis = [];
    // The rest of the nodes, nodes that will be moved
    const toMove = [];
    let last = children.length - 1;
    for (let cur = m[longest] + 1; cur != 0; cur = p[cur - 1]) {
        lis.push(children[cur - 1]);
        for (; last >= cur; last--) {
            toMove.push(children[last]);
        }
        last--;
    }
    for (; last >= 0; last--) {
        toMove.push(children[last]);
    }
    lis.reverse();
    // We sort the nodes being moved to guarantee that their insertion order matches the claim order
    toMove.sort((a, b) => a.claim_order - b.claim_order);
    // Finally, we move the nodes
    for (let i = 0, j = 0; i < toMove.length; i++) {
        while (j < lis.length && toMove[i].claim_order >= lis[j].claim_order) {
            j++;
        }
        const anchor = j < lis.length ? lis[j] : null;
        target.insertBefore(toMove[i], anchor);
    }
}
function append(target, node) {
    target.appendChild(node);
}
function append_styles(target, style_sheet_id, styles) {
    const append_styles_to = get_root_for_style(target);
    if (!append_styles_to.getElementById(style_sheet_id)) {
        const style = element('style');
        style.id = style_sheet_id;
        style.textContent = styles;
        append_stylesheet(append_styles_to, style);
    }
}
function get_root_for_style(node) {
    if (!node)
        return document;
    const root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
    if (root && root.host) {
        return root;
    }
    return node.ownerDocument;
}
function append_empty_stylesheet(node) {
    const style_element = element('style');
    append_stylesheet(get_root_for_style(node), style_element);
    return style_element.sheet;
}
function append_stylesheet(node, style) {
    append(node.head || node, style);
    return style.sheet;
}
function append_hydration(target, node) {
    if (is_hydrating) {
        init_hydrate(target);
        if ((target.actual_end_child === undefined) || ((target.actual_end_child !== null) && (target.actual_end_child.parentNode !== target))) {
            target.actual_end_child = target.firstChild;
        }
        // Skip nodes of undefined ordering
        while ((target.actual_end_child !== null) && (target.actual_end_child.claim_order === undefined)) {
            target.actual_end_child = target.actual_end_child.nextSibling;
        }
        if (node !== target.actual_end_child) {
            // We only insert if the ordering of this node should be modified or the parent node is not target
            if (node.claim_order !== undefined || node.parentNode !== target) {
                target.insertBefore(node, target.actual_end_child);
            }
        }
        else {
            target.actual_end_child = node.nextSibling;
        }
    }
    else if (node.parentNode !== target || node.nextSibling !== null) {
        target.appendChild(node);
    }
}
function insert(target, node, anchor) {
    target.insertBefore(node, anchor || null);
}
function insert_hydration(target, node, anchor) {
    if (is_hydrating && !anchor) {
        append_hydration(target, node);
    }
    else if (node.parentNode !== target || node.nextSibling != anchor) {
        target.insertBefore(node, anchor || null);
    }
}
function detach(node) {
    if (node.parentNode) {
        node.parentNode.removeChild(node);
    }
}
function destroy_each(iterations, detaching) {
    for (let i = 0; i < iterations.length; i += 1) {
        if (iterations[i])
            iterations[i].d(detaching);
    }
}
function element(name) {
    return document.createElement(name);
}
function element_is(name, is) {
    return document.createElement(name, { is });
}
function object_without_properties(obj, exclude) {
    const target = {};
    for (const k in obj) {
        if (has_prop(obj, k)
            // @ts-ignore
            && exclude.indexOf(k) === -1) {
            // @ts-ignore
            target[k] = obj[k];
        }
    }
    return target;
}
function svg_element(name) {
    return document.createElementNS('http://www.w3.org/2000/svg', name);
}
function text(data) {
    return document.createTextNode(data);
}
function space() {
    return text(' ');
}
function empty() {
    return text('');
}
function comment(content) {
    return document.createComment(content);
}
function listen(node, event, handler, options) {
    node.addEventListener(event, handler, options);
    return () => node.removeEventListener(event, handler, options);
}
function prevent_default(fn) {
    return function (event) {
        event.preventDefault();
        // @ts-ignore
        return fn.call(this, event);
    };
}
function stop_propagation(fn) {
    return function (event) {
        event.stopPropagation();
        // @ts-ignore
        return fn.call(this, event);
    };
}
function stop_immediate_propagation(fn) {
    return function (event) {
        event.stopImmediatePropagation();
        // @ts-ignore
        return fn.call(this, event);
    };
}
function self(fn) {
    return function (event) {
        // @ts-ignore
        if (event.target === this)
            fn.call(this, event);
    };
}
function trusted(fn) {
    return function (event) {
        // @ts-ignore
        if (event.isTrusted)
            fn.call(this, event);
    };
}
function attr(node, attribute, value) {
    if (value == null)
        node.removeAttribute(attribute);
    else if (node.getAttribute(attribute) !== value)
        node.setAttribute(attribute, value);
}
/**
 * List of attributes that should always be set through the attr method,
 * because updating them through the property setter doesn't work reliably.
 * In the example of `width`/`height`, the problem is that the setter only
 * accepts numeric values, but the attribute can also be set to a string like `50%`.
 * If this list becomes too big, rethink this approach.
 */
const always_set_through_set_attribute = ['width', 'height'];
function set_attributes(node, attributes) {
    // @ts-ignore
    const descriptors = Object.getOwnPropertyDescriptors(node.__proto__);
    for (const key in attributes) {
        if (attributes[key] == null) {
            node.removeAttribute(key);
        }
        else if (key === 'style') {
            node.style.cssText = attributes[key];
        }
        else if (key === '__value') {
            node.value = node[key] = attributes[key];
        }
        else if (descriptors[key] && descriptors[key].set && always_set_through_set_attribute.indexOf(key) === -1) {
            node[key] = attributes[key];
        }
        else {
            attr(node, key, attributes[key]);
        }
    }
}
function set_svg_attributes(node, attributes) {
    for (const key in attributes) {
        attr(node, key, attributes[key]);
    }
}
function set_custom_element_data_map(node, data_map) {
    Object.keys(data_map).forEach((key) => {
        set_custom_element_data(node, key, data_map[key]);
    });
}
function set_custom_element_data(node, prop, value) {
    if (prop in node) {
        node[prop] = typeof node[prop] === 'boolean' && value === '' ? true : value;
    }
    else {
        attr(node, prop, value);
    }
}
function set_dynamic_element_data(tag) {
    return (/-/.test(tag)) ? set_custom_element_data_map : set_attributes;
}
function xlink_attr(node, attribute, value) {
    node.setAttributeNS('http://www.w3.org/1999/xlink', attribute, value);
}
function get_binding_group_value(group, __value, checked) {
    const value = new Set();
    for (let i = 0; i < group.length; i += 1) {
        if (group[i].checked)
            value.add(group[i].__value);
    }
    if (!checked) {
        value.delete(__value);
    }
    return Array.from(value);
}
function init_binding_group(group) {
    let _inputs;
    return {
        /* push */ p(...inputs) {
            _inputs = inputs;
            _inputs.forEach(input => group.push(input));
        },
        /* remove */ r() {
            _inputs.forEach(input => group.splice(group.indexOf(input), 1));
        }
    };
}
function init_binding_group_dynamic(group, indexes) {
    let _group = get_binding_group(group);
    let _inputs;
    function get_binding_group(group) {
        for (let i = 0; i < indexes.length; i++) {
            group = group[indexes[i]] = group[indexes[i]] || [];
        }
        return group;
    }
    function push() {
        _inputs.forEach(input => _group.push(input));
    }
    function remove() {
        _inputs.forEach(input => _group.splice(_group.indexOf(input), 1));
    }
    return {
        /* update */ u(new_indexes) {
            indexes = new_indexes;
            const new_group = get_binding_group(group);
            if (new_group !== _group) {
                remove();
                _group = new_group;
                push();
            }
        },
        /* push */ p(...inputs) {
            _inputs = inputs;
            push();
        },
        /* remove */ r: remove
    };
}
function to_number(value) {
    return value === '' ? null : +value;
}
function time_ranges_to_array(ranges) {
    const array = [];
    for (let i = 0; i < ranges.length; i += 1) {
        array.push({ start: ranges.start(i), end: ranges.end(i) });
    }
    return array;
}
function children(element) {
    return Array.from(element.childNodes);
}
function init_claim_info(nodes) {
    if (nodes.claim_info === undefined) {
        nodes.claim_info = { last_index: 0, total_claimed: 0 };
    }
}
function claim_node(nodes, predicate, processNode, createNode, dontUpdateLastIndex = false) {
    // Try to find nodes in an order such that we lengthen the longest increasing subsequence
    init_claim_info(nodes);
    const resultNode = (() => {
        // We first try to find an element after the previous one
        for (let i = nodes.claim_info.last_index; i < nodes.length; i++) {
            const node = nodes[i];
            if (predicate(node)) {
                const replacement = processNode(node);
                if (replacement === undefined) {
                    nodes.splice(i, 1);
                }
                else {
                    nodes[i] = replacement;
                }
                if (!dontUpdateLastIndex) {
                    nodes.claim_info.last_index = i;
                }
                return node;
            }
        }
        // Otherwise, we try to find one before
        // We iterate in reverse so that we don't go too far back
        for (let i = nodes.claim_info.last_index - 1; i >= 0; i--) {
            const node = nodes[i];
            if (predicate(node)) {
                const replacement = processNode(node);
                if (replacement === undefined) {
                    nodes.splice(i, 1);
                }
                else {
                    nodes[i] = replacement;
                }
                if (!dontUpdateLastIndex) {
                    nodes.claim_info.last_index = i;
                }
                else if (replacement === undefined) {
                    // Since we spliced before the last_index, we decrease it
                    nodes.claim_info.last_index--;
                }
                return node;
            }
        }
        // If we can't find any matching node, we create a new one
        return createNode();
    })();
    resultNode.claim_order = nodes.claim_info.total_claimed;
    nodes.claim_info.total_claimed += 1;
    return resultNode;
}
function claim_element_base(nodes, name, attributes, create_element) {
    return claim_node(nodes, (node) => node.nodeName === name, (node) => {
        const remove = [];
        for (let j = 0; j < node.attributes.length; j++) {
            const attribute = node.attributes[j];
            if (!attributes[attribute.name]) {
                remove.push(attribute.name);
            }
        }
        remove.forEach(v => node.removeAttribute(v));
        return undefined;
    }, () => create_element(name));
}
function claim_element(nodes, name, attributes) {
    return claim_element_base(nodes, name, attributes, element);
}
function claim_svg_element(nodes, name, attributes) {
    return claim_element_base(nodes, name, attributes, svg_element);
}
function claim_text(nodes, data) {
    return claim_node(nodes, (node) => node.nodeType === 3, (node) => {
        const dataStr = '' + data;
        if (node.data.startsWith(dataStr)) {
            if (node.data.length !== dataStr.length) {
                return node.splitText(dataStr.length);
            }
        }
        else {
            node.data = dataStr;
        }
    }, () => text(data), true // Text nodes should not update last index since it is likely not worth it to eliminate an increasing subsequence of actual elements
    );
}
function claim_space(nodes) {
    return claim_text(nodes, ' ');
}
function claim_comment(nodes, data) {
    return claim_node(nodes, (node) => node.nodeType === 8, (node) => {
        node.data = '' + data;
        return undefined;
    }, () => comment(data), true);
}
function find_comment(nodes, text, start) {
    for (let i = start; i < nodes.length; i += 1) {
        const node = nodes[i];
        if (node.nodeType === 8 /* comment node */ && node.textContent.trim() === text) {
            return i;
        }
    }
    return nodes.length;
}
function claim_html_tag(nodes, is_svg) {
    // find html opening tag
    const start_index = find_comment(nodes, 'HTML_TAG_START', 0);
    const end_index = find_comment(nodes, 'HTML_TAG_END', start_index);
    if (start_index === end_index) {
        return new HtmlTagHydration(undefined, is_svg);
    }
    init_claim_info(nodes);
    const html_tag_nodes = nodes.splice(start_index, end_index - start_index + 1);
    detach(html_tag_nodes[0]);
    detach(html_tag_nodes[html_tag_nodes.length - 1]);
    const claimed_nodes = html_tag_nodes.slice(1, html_tag_nodes.length - 1);
    for (const n of claimed_nodes) {
        n.claim_order = nodes.claim_info.total_claimed;
        nodes.claim_info.total_claimed += 1;
    }
    return new HtmlTagHydration(claimed_nodes, is_svg);
}
function set_data(text, data) {
    data = '' + data;
    if (text.data === data)
        return;
    text.data = data;
}
function set_data_contenteditable(text, data) {
    data = '' + data;
    if (text.wholeText === data)
        return;
    text.data = data;
}
function set_data_maybe_contenteditable(text, data, attr_value) {
    if (~contenteditable_truthy_values.indexOf(attr_value)) {
        set_data_contenteditable(text, data);
    }
    else {
        set_data(text, data);
    }
}
function set_input_value(input, value) {
    input.value = value == null ? '' : value;
}
function set_input_type(input, type) {
    try {
        input.type = type;
    }
    catch (e) {
        // do nothing
    }
}
function set_style(node, key, value, important) {
    if (value == null) {
        node.style.removeProperty(key);
    }
    else {
        node.style.setProperty(key, value, important ? 'important' : '');
    }
}
function select_option(select, value, mounting) {
    for (let i = 0; i < select.options.length; i += 1) {
        const option = select.options[i];
        if (option.__value === value) {
            option.selected = true;
            return;
        }
    }
    if (!mounting || value !== undefined) {
        select.selectedIndex = -1; // no option should be selected
    }
}
function select_options(select, value) {
    for (let i = 0; i < select.options.length; i += 1) {
        const option = select.options[i];
        option.selected = ~value.indexOf(option.__value);
    }
}
function select_value(select) {
    const selected_option = select.querySelector(':checked');
    return selected_option && selected_option.__value;
}
function select_multiple_value(select) {
    return [].map.call(select.querySelectorAll(':checked'), option => option.__value);
}
// unfortunately this can't be a constant as that wouldn't be tree-shakeable
// so we cache the result instead
let crossorigin;
function is_crossorigin() {
    if (crossorigin === undefined) {
        crossorigin = false;
        try {
            if (typeof window !== 'undefined' && window.parent) {
                void window.parent.document;
            }
        }
        catch (error) {
            crossorigin = true;
        }
    }
    return crossorigin;
}
function add_iframe_resize_listener(node, fn) {
    const computed_style = getComputedStyle(node);
    if (computed_style.position === 'static') {
        node.style.position = 'relative';
    }
    const iframe = element('iframe');
    iframe.setAttribute('style', 'display: block; position: absolute; top: 0; left: 0; width: 100%; height: 100%; ' +
        'overflow: hidden; border: 0; opacity: 0; pointer-events: none; z-index: -1;');
    iframe.setAttribute('aria-hidden', 'true');
    iframe.tabIndex = -1;
    const crossorigin = is_crossorigin();
    let unsubscribe;
    if (crossorigin) {
        iframe.src = "data:text/html,<script>onresize=function(){parent.postMessage(0,'*')}</script>";
        unsubscribe = listen(window, 'message', (event) => {
            if (event.source === iframe.contentWindow)
                fn();
        });
    }
    else {
        iframe.src = 'about:blank';
        iframe.onload = () => {
            unsubscribe = listen(iframe.contentWindow, 'resize', fn);
            // make sure an initial resize event is fired _after_ the iframe is loaded (which is asynchronous)
            // see https://github.com/sveltejs/svelte/issues/4233
            fn();
        };
    }
    append(node, iframe);
    return () => {
        if (crossorigin) {
            unsubscribe();
        }
        else if (unsubscribe && iframe.contentWindow) {
            unsubscribe();
        }
        detach(iframe);
    };
}
const resize_observer_content_box = /* @__PURE__ */ new ResizeObserverSingleton({ box: 'content-box' });
const resize_observer_border_box = /* @__PURE__ */ new ResizeObserverSingleton({ box: 'border-box' });
const resize_observer_device_pixel_content_box = /* @__PURE__ */ new ResizeObserverSingleton({ box: 'device-pixel-content-box' });
function toggle_class(element, name, toggle) {
    element.classList[toggle ? 'add' : 'remove'](name);
}
function custom_event(type, detail, { bubbles = false, cancelable = false } = {}) {
    const e = document.createEvent('CustomEvent');
    e.initCustomEvent(type, bubbles, cancelable, detail);
    return e;
}
function query_selector_all(selector, parent = document.body) {
    return Array.from(parent.querySelectorAll(selector));
}
function head_selector(nodeId, head) {
    const result = [];
    let started = 0;
    for (const node of head.childNodes) {
        if (node.nodeType === 8 /* comment node */) {
            const comment = node.textContent.trim();
            if (comment === `HEAD_${nodeId}_END`) {
                started -= 1;
                result.push(node);
            }
            else if (comment === `HEAD_${nodeId}_START`) {
                started += 1;
                result.push(node);
            }
        }
        else if (started > 0) {
            result.push(node);
        }
    }
    return result;
}
class HtmlTag {
    constructor(is_svg = false) {
        this.is_svg = false;
        this.is_svg = is_svg;
        this.e = this.n = null;
    }
    c(html) {
        this.h(html);
    }
    m(html, target, anchor = null) {
        if (!this.e) {
            if (this.is_svg)
                this.e = svg_element(target.nodeName);
            /** #7364  target for <template> may be provided as #document-fragment(11) */
            else
                this.e = element((target.nodeType === 11 ? 'TEMPLATE' : target.nodeName));
            this.t = target.tagName !== 'TEMPLATE' ? target : target.content;
            this.c(html);
        }
        this.i(anchor);
    }
    h(html) {
        this.e.innerHTML = html;
        this.n = Array.from(this.e.nodeName === 'TEMPLATE' ? this.e.content.childNodes : this.e.childNodes);
    }
    i(anchor) {
        for (let i = 0; i < this.n.length; i += 1) {
            insert(this.t, this.n[i], anchor);
        }
    }
    p(html) {
        this.d();
        this.h(html);
        this.i(this.a);
    }
    d() {
        this.n.forEach(detach);
    }
}
class HtmlTagHydration extends HtmlTag {
    constructor(claimed_nodes, is_svg = false) {
        super(is_svg);
        this.e = this.n = null;
        this.l = claimed_nodes;
    }
    c(html) {
        if (this.l) {
            this.n = this.l;
        }
        else {
            super.c(html);
        }
    }
    i(anchor) {
        for (let i = 0; i < this.n.length; i += 1) {
            insert_hydration(this.t, this.n[i], anchor);
        }
    }
}
function attribute_to_object(attributes) {
    const result = {};
    for (const attribute of attributes) {
        result[attribute.name] = attribute.value;
    }
    return result;
}
function get_custom_elements_slots(element) {
    const result = {};
    element.childNodes.forEach((node) => {
        result[node.slot || 'default'] = true;
    });
    return result;
}
function construct_svelte_component(component, props) {
    return new component(props);
}

// we need to store the information for multiple documents because a Svelte application could also contain iframes
// https://github.com/sveltejs/svelte/issues/3624
const managed_styles = new Map();
let active = 0;
// https://github.com/darkskyapp/string-hash/blob/master/index.js
function hash(str) {
    let hash = 5381;
    let i = str.length;
    while (i--)
        hash = ((hash << 5) - hash) ^ str.charCodeAt(i);
    return hash >>> 0;
}
function create_style_information(doc, node) {
    const info = { stylesheet: append_empty_stylesheet(node), rules: {} };
    managed_styles.set(doc, info);
    return info;
}
function create_rule(node, a, b, duration, delay, ease, fn, uid = 0) {
    const step = 16.666 / duration;
    let keyframes = '{\n';
    for (let p = 0; p <= 1; p += step) {
        const t = a + (b - a) * ease(p);
        keyframes += p * 100 + `%{${fn(t, 1 - t)}}\n`;
    }
    const rule = keyframes + `100% {${fn(b, 1 - b)}}\n}`;
    const name = `__svelte_${hash(rule)}_${uid}`;
    const doc = get_root_for_style(node);
    const { stylesheet, rules } = managed_styles.get(doc) || create_style_information(doc, node);
    if (!rules[name]) {
        rules[name] = true;
        stylesheet.insertRule(`@keyframes ${name} ${rule}`, stylesheet.cssRules.length);
    }
    const animation = node.style.animation || '';
    node.style.animation = `${animation ? `${animation}, ` : ''}${name} ${duration}ms linear ${delay}ms 1 both`;
    active += 1;
    return name;
}
function delete_rule(node, name) {
    const previous = (node.style.animation || '').split(', ');
    const next = previous.filter(name
        ? anim => anim.indexOf(name) < 0 // remove specific animation
        : anim => anim.indexOf('__svelte') === -1 // remove all Svelte animations
    );
    const deleted = previous.length - next.length;
    if (deleted) {
        node.style.animation = next.join(', ');
        active -= deleted;
        if (!active)
            clear_rules();
    }
}
function clear_rules() {
    raf(() => {
        if (active)
            return;
        managed_styles.forEach(info => {
            const { ownerNode } = info.stylesheet;
            // there is no ownerNode if it runs on jsdom.
            if (ownerNode)
                detach(ownerNode);
        });
        managed_styles.clear();
    });
}

function create_animation(node, from, fn, params) {
    if (!from)
        return noop;
    const to = node.getBoundingClientRect();
    if (from.left === to.left && from.right === to.right && from.top === to.top && from.bottom === to.bottom)
        return noop;
    const { delay = 0, duration = 300, easing = identity, 
    // @ts-ignore todo: should this be separated from destructuring? Or start/end added to public api and documentation?
    start: start_time = now() + delay, 
    // @ts-ignore todo:
    end = start_time + duration, tick = noop, css } = fn(node, { from, to }, params);
    let running = true;
    let started = false;
    let name;
    function start() {
        if (css) {
            name = create_rule(node, 0, 1, duration, delay, easing, css);
        }
        if (!delay) {
            started = true;
        }
    }
    function stop() {
        if (css)
            delete_rule(node, name);
        running = false;
    }
    loop(now => {
        if (!started && now >= start_time) {
            started = true;
        }
        if (started && now >= end) {
            tick(1, 0);
            stop();
        }
        if (!running) {
            return false;
        }
        if (started) {
            const p = now - start_time;
            const t = 0 + 1 * easing(p / duration);
            tick(t, 1 - t);
        }
        return true;
    });
    start();
    tick(0, 1);
    return stop;
}
function fix_position(node) {
    const style = getComputedStyle(node);
    if (style.position !== 'absolute' && style.position !== 'fixed') {
        const { width, height } = style;
        const a = node.getBoundingClientRect();
        node.style.position = 'absolute';
        node.style.width = width;
        node.style.height = height;
        add_transform(node, a);
    }
}
function add_transform(node, a) {
    const b = node.getBoundingClientRect();
    if (a.left !== b.left || a.top !== b.top) {
        const style = getComputedStyle(node);
        const transform = style.transform === 'none' ? '' : style.transform;
        node.style.transform = `${transform} translate(${a.left - b.left}px, ${a.top - b.top}px)`;
    }
}

let current_component;
function set_current_component(component) {
    current_component = component;
}
function get_current_component() {
    if (!current_component)
        throw new Error('Function called outside component initialization');
    return current_component;
}
/**
 * Schedules a callback to run immediately before the component is updated after any state change.
 *
 * The first time the callback runs will be before the initial `onMount`
 *
 * https://svelte.dev/docs#run-time-svelte-beforeupdate
 */
function beforeUpdate(fn) {
    get_current_component().$$.before_update.push(fn);
}
/**
 * The `onMount` function schedules a callback to run as soon as the component has been mounted to the DOM.
 * It must be called during the component's initialisation (but doesn't need to live *inside* the component;
 * it can be called from an external module).
 *
 * `onMount` does not run inside a [server-side component](/docs#run-time-server-side-component-api).
 *
 * https://svelte.dev/docs#run-time-svelte-onmount
 */
function onMount(fn) {
    get_current_component().$$.on_mount.push(fn);
}
/**
 * Schedules a callback to run immediately after the component has been updated.
 *
 * The first time the callback runs will be after the initial `onMount`
 */
function afterUpdate(fn) {
    get_current_component().$$.after_update.push(fn);
}
/**
 * Schedules a callback to run immediately before the component is unmounted.
 *
 * Out of `onMount`, `beforeUpdate`, `afterUpdate` and `onDestroy`, this is the
 * only one that runs inside a server-side component.
 *
 * https://svelte.dev/docs#run-time-svelte-ondestroy
 */
function onDestroy(fn) {
    get_current_component().$$.on_destroy.push(fn);
}
/**
 * Creates an event dispatcher that can be used to dispatch [component events](/docs#template-syntax-component-directives-on-eventname).
 * Event dispatchers are functions that can take two arguments: `name` and `detail`.
 *
 * Component events created with `createEventDispatcher` create a
 * [CustomEvent](https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent).
 * These events do not [bubble](https://developer.mozilla.org/en-US/docs/Learn/JavaScript/Building_blocks/Events#Event_bubbling_and_capture).
 * The `detail` argument corresponds to the [CustomEvent.detail](https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/detail)
 * property and can contain any type of data.
 *
 * https://svelte.dev/docs#run-time-svelte-createeventdispatcher
 */
function createEventDispatcher() {
    const component = get_current_component();
    return (type, detail, { cancelable = false } = {}) => {
        const callbacks = component.$$.callbacks[type];
        if (callbacks) {
            // TODO are there situations where events could be dispatched
            // in a server (non-DOM) environment?
            const event = custom_event(type, detail, { cancelable });
            callbacks.slice().forEach(fn => {
                fn.call(component, event);
            });
            return !event.defaultPrevented;
        }
        return true;
    };
}
/**
 * Associates an arbitrary `context` object with the current component and the specified `key`
 * and returns that object. The context is then available to children of the component
 * (including slotted content) with `getContext`.
 *
 * Like lifecycle functions, this must be called during component initialisation.
 *
 * https://svelte.dev/docs#run-time-svelte-setcontext
 */
function setContext(key, context) {
    get_current_component().$$.context.set(key, context);
    return context;
}
/**
 * Retrieves the context that belongs to the closest parent component with the specified `key`.
 * Must be called during component initialisation.
 *
 * https://svelte.dev/docs#run-time-svelte-getcontext
 */
function getContext(key) {
    return get_current_component().$$.context.get(key);
}
/**
 * Retrieves the whole context map that belongs to the closest parent component.
 * Must be called during component initialisation. Useful, for example, if you
 * programmatically create a component and want to pass the existing context to it.
 *
 * https://svelte.dev/docs#run-time-svelte-getallcontexts
 */
function getAllContexts() {
    return get_current_component().$$.context;
}
/**
 * Checks whether a given `key` has been set in the context of a parent component.
 * Must be called during component initialisation.
 *
 * https://svelte.dev/docs#run-time-svelte-hascontext
 */
function hasContext(key) {
    return get_current_component().$$.context.has(key);
}
// TODO figure out if we still want to support
// shorthand events, or if we want to implement
// a real bubbling mechanism
function bubble(component, event) {
    const callbacks = component.$$.callbacks[event.type];
    if (callbacks) {
        // @ts-ignore
        callbacks.slice().forEach(fn => fn.call(this, event));
    }
}

const dirty_components = [];
const intros = { enabled: false };
const binding_callbacks = [];
let render_callbacks = [];
const flush_callbacks = [];
const resolved_promise = /* @__PURE__ */ Promise.resolve();
let update_scheduled = false;
function schedule_update() {
    if (!update_scheduled) {
        update_scheduled = true;
        resolved_promise.then(flush);
    }
}
function tick() {
    schedule_update();
    return resolved_promise;
}
function add_render_callback(fn) {
    render_callbacks.push(fn);
}
function add_flush_callback(fn) {
    flush_callbacks.push(fn);
}
// flush() calls callbacks in this order:
// 1. All beforeUpdate callbacks, in order: parents before children
// 2. All bind:this callbacks, in reverse order: children before parents.
// 3. All afterUpdate callbacks, in order: parents before children. EXCEPT
//    for afterUpdates called during the initial onMount, which are called in
//    reverse order: children before parents.
// Since callbacks might update component values, which could trigger another
// call to flush(), the following steps guard against this:
// 1. During beforeUpdate, any updated components will be added to the
//    dirty_components array and will cause a reentrant call to flush(). Because
//    the flush index is kept outside the function, the reentrant call will pick
//    up where the earlier call left off and go through all dirty components. The
//    current_component value is saved and restored so that the reentrant call will
//    not interfere with the "parent" flush() call.
// 2. bind:this callbacks cannot trigger new flush() calls.
// 3. During afterUpdate, any updated components will NOT have their afterUpdate
//    callback called a second time; the seen_callbacks set, outside the flush()
//    function, guarantees this behavior.
const seen_callbacks = new Set();
let flushidx = 0; // Do *not* move this inside the flush() function
function flush() {
    // Do not reenter flush while dirty components are updated, as this can
    // result in an infinite loop. Instead, let the inner flush handle it.
    // Reentrancy is ok afterwards for bindings etc.
    if (flushidx !== 0) {
        return;
    }
    const saved_component = current_component;
    do {
        // first, call beforeUpdate functions
        // and update components
        try {
            while (flushidx < dirty_components.length) {
                const component = dirty_components[flushidx];
                flushidx++;
                set_current_component(component);
                update(component.$$);
            }
        }
        catch (e) {
            // reset dirty state to not end up in a deadlocked state and then rethrow
            dirty_components.length = 0;
            flushidx = 0;
            throw e;
        }
        set_current_component(null);
        dirty_components.length = 0;
        flushidx = 0;
        while (binding_callbacks.length)
            binding_callbacks.pop()();
        // then, once components are updated, call
        // afterUpdate functions. This may cause
        // subsequent updates...
        for (let i = 0; i < render_callbacks.length; i += 1) {
            const callback = render_callbacks[i];
            if (!seen_callbacks.has(callback)) {
                // ...so guard against infinite loops
                seen_callbacks.add(callback);
                callback();
            }
        }
        render_callbacks.length = 0;
    } while (dirty_components.length);
    while (flush_callbacks.length) {
        flush_callbacks.pop()();
    }
    update_scheduled = false;
    seen_callbacks.clear();
    set_current_component(saved_component);
}
function update($$) {
    if ($$.fragment !== null) {
        $$.update();
        run_all($$.before_update);
        const dirty = $$.dirty;
        $$.dirty = [-1];
        $$.fragment && $$.fragment.p($$.ctx, dirty);
        $$.after_update.forEach(add_render_callback);
    }
}
/**
 * Useful for example to execute remaining `afterUpdate` callbacks before executing `destroy`.
 */
function flush_render_callbacks(fns) {
    const filtered = [];
    const targets = [];
    render_callbacks.forEach((c) => fns.indexOf(c) === -1 ? filtered.push(c) : targets.push(c));
    targets.forEach((c) => c());
    render_callbacks = filtered;
}

let promise;
function wait() {
    if (!promise) {
        promise = Promise.resolve();
        promise.then(() => {
            promise = null;
        });
    }
    return promise;
}
function dispatch(node, direction, kind) {
    node.dispatchEvent(custom_event(`${direction ? 'intro' : 'outro'}${kind}`));
}
const outroing = new Set();
let outros;
function group_outros() {
    outros = {
        r: 0,
        c: [],
        p: outros // parent group
    };
}
function check_outros() {
    if (!outros.r) {
        run_all(outros.c);
    }
    outros = outros.p;
}
function transition_in(block, local) {
    if (block && block.i) {
        outroing.delete(block);
        block.i(local);
    }
}
function transition_out(block, local, detach, callback) {
    if (block && block.o) {
        if (outroing.has(block))
            return;
        outroing.add(block);
        outros.c.push(() => {
            outroing.delete(block);
            if (callback) {
                if (detach)
                    block.d(1);
                callback();
            }
        });
        block.o(local);
    }
    else if (callback) {
        callback();
    }
}
const null_transition = { duration: 0 };
function create_in_transition(node, fn, params) {
    const options = { direction: 'in' };
    let config = fn(node, params, options);
    let running = false;
    let animation_name;
    let task;
    let uid = 0;
    function cleanup() {
        if (animation_name)
            delete_rule(node, animation_name);
    }
    function go() {
        const { delay = 0, duration = 300, easing = identity, tick = noop, css } = config || null_transition;
        if (css)
            animation_name = create_rule(node, 0, 1, duration, delay, easing, css, uid++);
        tick(0, 1);
        const start_time = now() + delay;
        const end_time = start_time + duration;
        if (task)
            task.abort();
        running = true;
        add_render_callback(() => dispatch(node, true, 'start'));
        task = loop(now => {
            if (running) {
                if (now >= end_time) {
                    tick(1, 0);
                    dispatch(node, true, 'end');
                    cleanup();
                    return running = false;
                }
                if (now >= start_time) {
                    const t = easing((now - start_time) / duration);
                    tick(t, 1 - t);
                }
            }
            return running;
        });
    }
    let started = false;
    return {
        start() {
            if (started)
                return;
            started = true;
            delete_rule(node);
            if (is_function(config)) {
                config = config(options);
                wait().then(go);
            }
            else {
                go();
            }
        },
        invalidate() {
            started = false;
        },
        end() {
            if (running) {
                cleanup();
                running = false;
            }
        }
    };
}
function create_out_transition(node, fn, params) {
    const options = { direction: 'out' };
    let config = fn(node, params, options);
    let running = true;
    let animation_name;
    const group = outros;
    group.r += 1;
    function go() {
        const { delay = 0, duration = 300, easing = identity, tick = noop, css } = config || null_transition;
        if (css)
            animation_name = create_rule(node, 1, 0, duration, delay, easing, css);
        const start_time = now() + delay;
        const end_time = start_time + duration;
        add_render_callback(() => dispatch(node, false, 'start'));
        loop(now => {
            if (running) {
                if (now >= end_time) {
                    tick(0, 1);
                    dispatch(node, false, 'end');
                    if (!--group.r) {
                        // this will result in `end()` being called,
                        // so we don't need to clean up here
                        run_all(group.c);
                    }
                    return false;
                }
                if (now >= start_time) {
                    const t = easing((now - start_time) / duration);
                    tick(1 - t, t);
                }
            }
            return running;
        });
    }
    if (is_function(config)) {
        wait().then(() => {
            // @ts-ignore
            config = config(options);
            go();
        });
    }
    else {
        go();
    }
    return {
        end(reset) {
            if (reset && config.tick) {
                config.tick(1, 0);
            }
            if (running) {
                if (animation_name)
                    delete_rule(node, animation_name);
                running = false;
            }
        }
    };
}
function create_bidirectional_transition(node, fn, params, intro) {
    const options = { direction: 'both' };
    let config = fn(node, params, options);
    let t = intro ? 0 : 1;
    let running_program = null;
    let pending_program = null;
    let animation_name = null;
    function clear_animation() {
        if (animation_name)
            delete_rule(node, animation_name);
    }
    function init(program, duration) {
        const d = (program.b - t);
        duration *= Math.abs(d);
        return {
            a: t,
            b: program.b,
            d,
            duration,
            start: program.start,
            end: program.start + duration,
            group: program.group
        };
    }
    function go(b) {
        const { delay = 0, duration = 300, easing = identity, tick = noop, css } = config || null_transition;
        const program = {
            start: now() + delay,
            b
        };
        if (!b) {
            // @ts-ignore todo: improve typings
            program.group = outros;
            outros.r += 1;
        }
        if (running_program || pending_program) {
            pending_program = program;
        }
        else {
            // if this is an intro, and there's a delay, we need to do
            // an initial tick and/or apply CSS animation immediately
            if (css) {
                clear_animation();
                animation_name = create_rule(node, t, b, duration, delay, easing, css);
            }
            if (b)
                tick(0, 1);
            running_program = init(program, duration);
            add_render_callback(() => dispatch(node, b, 'start'));
            loop(now => {
                if (pending_program && now > pending_program.start) {
                    running_program = init(pending_program, duration);
                    pending_program = null;
                    dispatch(node, running_program.b, 'start');
                    if (css) {
                        clear_animation();
                        animation_name = create_rule(node, t, running_program.b, running_program.duration, 0, easing, config.css);
                    }
                }
                if (running_program) {
                    if (now >= running_program.end) {
                        tick(t = running_program.b, 1 - t);
                        dispatch(node, running_program.b, 'end');
                        if (!pending_program) {
                            // we're done
                            if (running_program.b) {
                                // intro — we can tidy up immediately
                                clear_animation();
                            }
                            else {
                                // outro — needs to be coordinated
                                if (!--running_program.group.r)
                                    run_all(running_program.group.c);
                            }
                        }
                        running_program = null;
                    }
                    else if (now >= running_program.start) {
                        const p = now - running_program.start;
                        t = running_program.a + running_program.d * easing(p / running_program.duration);
                        tick(t, 1 - t);
                    }
                }
                return !!(running_program || pending_program);
            });
        }
    }
    return {
        run(b) {
            if (is_function(config)) {
                wait().then(() => {
                    // @ts-ignore
                    config = config(options);
                    go(b);
                });
            }
            else {
                go(b);
            }
        },
        end() {
            clear_animation();
            running_program = pending_program = null;
        }
    };
}

function handle_promise(promise, info) {
    const token = info.token = {};
    function update(type, index, key, value) {
        if (info.token !== token)
            return;
        info.resolved = value;
        let child_ctx = info.ctx;
        if (key !== undefined) {
            child_ctx = child_ctx.slice();
            child_ctx[key] = value;
        }
        const block = type && (info.current = type)(child_ctx);
        let needs_flush = false;
        if (info.block) {
            if (info.blocks) {
                info.blocks.forEach((block, i) => {
                    if (i !== index && block) {
                        group_outros();
                        transition_out(block, 1, 1, () => {
                            if (info.blocks[i] === block) {
                                info.blocks[i] = null;
                            }
                        });
                        check_outros();
                    }
                });
            }
            else {
                info.block.d(1);
            }
            block.c();
            transition_in(block, 1);
            block.m(info.mount(), info.anchor);
            needs_flush = true;
        }
        info.block = block;
        if (info.blocks)
            info.blocks[index] = block;
        if (needs_flush) {
            flush();
        }
    }
    if (is_promise(promise)) {
        const current_component = get_current_component();
        promise.then(value => {
            set_current_component(current_component);
            update(info.then, 1, info.value, value);
            set_current_component(null);
        }, error => {
            set_current_component(current_component);
            update(info.catch, 2, info.error, error);
            set_current_component(null);
            if (!info.hasCatch) {
                throw error;
            }
        });
        // if we previously had a then/catch block, destroy it
        if (info.current !== info.pending) {
            update(info.pending, 0);
            return true;
        }
    }
    else {
        if (info.current !== info.then) {
            update(info.then, 1, info.value, promise);
            return true;
        }
        info.resolved = promise;
    }
}
function update_await_block_branch(info, ctx, dirty) {
    const child_ctx = ctx.slice();
    const { resolved } = info;
    if (info.current === info.then) {
        child_ctx[info.value] = resolved;
    }
    if (info.current === info.catch) {
        child_ctx[info.error] = resolved;
    }
    info.block.p(child_ctx, dirty);
}

function destroy_block(block, lookup) {
    block.d(1);
    lookup.delete(block.key);
}
function outro_and_destroy_block(block, lookup) {
    transition_out(block, 1, 1, () => {
        lookup.delete(block.key);
    });
}
function fix_and_destroy_block(block, lookup) {
    block.f();
    destroy_block(block, lookup);
}
function fix_and_outro_and_destroy_block(block, lookup) {
    block.f();
    outro_and_destroy_block(block, lookup);
}
function update_keyed_each(old_blocks, dirty, get_key, dynamic, ctx, list, lookup, node, destroy, create_each_block, next, get_context) {
    let o = old_blocks.length;
    let n = list.length;
    let i = o;
    const old_indexes = {};
    while (i--)
        old_indexes[old_blocks[i].key] = i;
    const new_blocks = [];
    const new_lookup = new Map();
    const deltas = new Map();
    const updates = [];
    i = n;
    while (i--) {
        const child_ctx = get_context(ctx, list, i);
        const key = get_key(child_ctx);
        let block = lookup.get(key);
        if (!block) {
            block = create_each_block(key, child_ctx);
            block.c();
        }
        else if (dynamic) {
            // defer updates until all the DOM shuffling is done
            updates.push(() => block.p(child_ctx, dirty));
        }
        new_lookup.set(key, new_blocks[i] = block);
        if (key in old_indexes)
            deltas.set(key, Math.abs(i - old_indexes[key]));
    }
    const will_move = new Set();
    const did_move = new Set();
    function insert(block) {
        transition_in(block, 1);
        block.m(node, next);
        lookup.set(block.key, block);
        next = block.first;
        n--;
    }
    while (o && n) {
        const new_block = new_blocks[n - 1];
        const old_block = old_blocks[o - 1];
        const new_key = new_block.key;
        const old_key = old_block.key;
        if (new_block === old_block) {
            // do nothing
            next = new_block.first;
            o--;
            n--;
        }
        else if (!new_lookup.has(old_key)) {
            // remove old block
            destroy(old_block, lookup);
            o--;
        }
        else if (!lookup.has(new_key) || will_move.has(new_key)) {
            insert(new_block);
        }
        else if (did_move.has(old_key)) {
            o--;
        }
        else if (deltas.get(new_key) > deltas.get(old_key)) {
            did_move.add(new_key);
            insert(new_block);
        }
        else {
            will_move.add(old_key);
            o--;
        }
    }
    while (o--) {
        const old_block = old_blocks[o];
        if (!new_lookup.has(old_block.key))
            destroy(old_block, lookup);
    }
    while (n)
        insert(new_blocks[n - 1]);
    run_all(updates);
    return new_blocks;
}
function validate_each_keys(ctx, list, get_context, get_key) {
    const keys = new Set();
    for (let i = 0; i < list.length; i++) {
        const key = get_key(get_context(ctx, list, i));
        if (keys.has(key)) {
            throw new Error('Cannot have duplicate keys in a keyed each');
        }
        keys.add(key);
    }
}

function get_spread_update(levels, updates) {
    const update = {};
    const to_null_out = {};
    const accounted_for = { $$scope: 1 };
    let i = levels.length;
    while (i--) {
        const o = levels[i];
        const n = updates[i];
        if (n) {
            for (const key in o) {
                if (!(key in n))
                    to_null_out[key] = 1;
            }
            for (const key in n) {
                if (!accounted_for[key]) {
                    update[key] = n[key];
                    accounted_for[key] = 1;
                }
            }
            levels[i] = n;
        }
        else {
            for (const key in o) {
                accounted_for[key] = 1;
            }
        }
    }
    for (const key in to_null_out) {
        if (!(key in update))
            update[key] = undefined;
    }
    return update;
}
function get_spread_object(spread_props) {
    return typeof spread_props === 'object' && spread_props !== null ? spread_props : {};
}

const _boolean_attributes = [
    'allowfullscreen',
    'allowpaymentrequest',
    'async',
    'autofocus',
    'autoplay',
    'checked',
    'controls',
    'default',
    'defer',
    'disabled',
    'formnovalidate',
    'hidden',
    'inert',
    'ismap',
    'loop',
    'multiple',
    'muted',
    'nomodule',
    'novalidate',
    'open',
    'playsinline',
    'readonly',
    'required',
    'reversed',
    'selected'
];
/**
 * List of HTML boolean attributes (e.g. `<input disabled>`).
 * Source: https://html.spec.whatwg.org/multipage/indices.html
 */
const boolean_attributes = new Set([..._boolean_attributes]);

/** regex of all html void element names */
const void_element_names = /^(?:area|base|br|col|command|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)$/;
function is_void(name) {
    return void_element_names.test(name) || name.toLowerCase() === '!doctype';
}

const invalid_attribute_name_character = /[\s'">/=\u{FDD0}-\u{FDEF}\u{FFFE}\u{FFFF}\u{1FFFE}\u{1FFFF}\u{2FFFE}\u{2FFFF}\u{3FFFE}\u{3FFFF}\u{4FFFE}\u{4FFFF}\u{5FFFE}\u{5FFFF}\u{6FFFE}\u{6FFFF}\u{7FFFE}\u{7FFFF}\u{8FFFE}\u{8FFFF}\u{9FFFE}\u{9FFFF}\u{AFFFE}\u{AFFFF}\u{BFFFE}\u{BFFFF}\u{CFFFE}\u{CFFFF}\u{DFFFE}\u{DFFFF}\u{EFFFE}\u{EFFFF}\u{FFFFE}\u{FFFFF}\u{10FFFE}\u{10FFFF}]/u;
// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
// https://infra.spec.whatwg.org/#noncharacter
function spread(args, attrs_to_add) {
    const attributes = Object.assign({}, ...args);
    if (attrs_to_add) {
        const classes_to_add = attrs_to_add.classes;
        const styles_to_add = attrs_to_add.styles;
        if (classes_to_add) {
            if (attributes.class == null) {
                attributes.class = classes_to_add;
            }
            else {
                attributes.class += ' ' + classes_to_add;
            }
        }
        if (styles_to_add) {
            if (attributes.style == null) {
                attributes.style = style_object_to_string(styles_to_add);
            }
            else {
                attributes.style = style_object_to_string(merge_ssr_styles(attributes.style, styles_to_add));
            }
        }
    }
    let str = '';
    Object.keys(attributes).forEach(name => {
        if (invalid_attribute_name_character.test(name))
            return;
        const value = attributes[name];
        if (value === true)
            str += ' ' + name;
        else if (boolean_attributes.has(name.toLowerCase())) {
            if (value)
                str += ' ' + name;
        }
        else if (value != null) {
            str += ` ${name}="${value}"`;
        }
    });
    return str;
}
function merge_ssr_styles(style_attribute, style_directive) {
    const style_object = {};
    for (const individual_style of style_attribute.split(';')) {
        const colon_index = individual_style.indexOf(':');
        const name = individual_style.slice(0, colon_index).trim();
        const value = individual_style.slice(colon_index + 1).trim();
        if (!name)
            continue;
        style_object[name] = value;
    }
    for (const name in style_directive) {
        const value = style_directive[name];
        if (value) {
            style_object[name] = value;
        }
        else {
            delete style_object[name];
        }
    }
    return style_object;
}
const ATTR_REGEX = /[&"]/g;
const CONTENT_REGEX = /[&<]/g;
/**
 * Note: this method is performance sensitive and has been optimized
 * https://github.com/sveltejs/svelte/pull/5701
 */
function escape(value, is_attr = false) {
    const str = String(value);
    const pattern = is_attr ? ATTR_REGEX : CONTENT_REGEX;
    pattern.lastIndex = 0;
    let escaped = '';
    let last = 0;
    while (pattern.test(str)) {
        const i = pattern.lastIndex - 1;
        const ch = str[i];
        escaped += str.substring(last, i) + (ch === '&' ? '&amp;' : (ch === '"' ? '&quot;' : '&lt;'));
        last = i + 1;
    }
    return escaped + str.substring(last);
}
function escape_attribute_value(value) {
    // keep booleans, null, and undefined for the sake of `spread`
    const should_escape = typeof value === 'string' || (value && typeof value === 'object');
    return should_escape ? escape(value, true) : value;
}
function escape_object(obj) {
    const result = {};
    for (const key in obj) {
        result[key] = escape_attribute_value(obj[key]);
    }
    return result;
}
function each(items, fn) {
    let str = '';
    for (let i = 0; i < items.length; i += 1) {
        str += fn(items[i], i);
    }
    return str;
}
const missing_component = {
    $$render: () => ''
};
function validate_component(component, name) {
    if (!component || !component.$$render) {
        if (name === 'svelte:component')
            name += ' this={...}';
        throw new Error(`<${name}> is not a valid SSR component. You may need to review your build config to ensure that dependencies are compiled, rather than imported as pre-compiled modules. Otherwise you may need to fix a <${name}>.`);
    }
    return component;
}
function debug(file, line, column, values) {
    console.log(`{@debug} ${file ? file + ' ' : ''}(${line}:${column})`); // eslint-disable-line no-console
    console.log(values); // eslint-disable-line no-console
    return '';
}
let on_destroy;
function create_ssr_component(fn) {
    function $$render(result, props, bindings, slots, context) {
        const parent_component = current_component;
        const $$ = {
            on_destroy,
            context: new Map(context || (parent_component ? parent_component.$$.context : [])),
            // these will be immediately discarded
            on_mount: [],
            before_update: [],
            after_update: [],
            callbacks: blank_object()
        };
        set_current_component({ $$ });
        const html = fn(result, props, bindings, slots);
        set_current_component(parent_component);
        return html;
    }
    return {
        render: (props = {}, { $$slots = {}, context = new Map() } = {}) => {
            on_destroy = [];
            const result = { title: '', head: '', css: new Set() };
            const html = $$render(result, props, {}, $$slots, context);
            run_all(on_destroy);
            return {
                html,
                css: {
                    code: Array.from(result.css).map(css => css.code).join('\n'),
                    map: null // TODO
                },
                head: result.title + result.head
            };
        },
        $$render
    };
}
function add_attribute(name, value, boolean) {
    if (value == null || (boolean && !value))
        return '';
    const assignment = (boolean && value === true) ? '' : `="${escape(value, true)}"`;
    return ` ${name}${assignment}`;
}
function add_classes(classes) {
    return classes ? ` class="${classes}"` : '';
}
function style_object_to_string(style_object) {
    return Object.keys(style_object)
        .filter(key => style_object[key])
        .map(key => `${key}: ${escape_attribute_value(style_object[key])};`)
        .join(' ');
}
function add_styles(style_object) {
    const styles = style_object_to_string(style_object);
    return styles ? ` style="${styles}"` : '';
}

function bind(component, name, callback) {
    const index = component.$$.props[name];
    if (index !== undefined) {
        component.$$.bound[index] = callback;
        callback(component.$$.ctx[index]);
    }
}
function create_component(block) {
    block && block.c();
}
function claim_component(block, parent_nodes) {
    block && block.l(parent_nodes);
}
function mount_component(component, target, anchor, customElement) {
    const { fragment, after_update } = component.$$;
    fragment && fragment.m(target, anchor);
    if (!customElement) {
        // onMount happens before the initial afterUpdate
        add_render_callback(() => {
            const new_on_destroy = component.$$.on_mount.map(run).filter(is_function);
            // if the component was destroyed immediately
            // it will update the `$$.on_destroy` reference to `null`.
            // the destructured on_destroy may still reference to the old array
            if (component.$$.on_destroy) {
                component.$$.on_destroy.push(...new_on_destroy);
            }
            else {
                // Edge case - component was destroyed immediately,
                // most likely as a result of a binding initialising
                run_all(new_on_destroy);
            }
            component.$$.on_mount = [];
        });
    }
    after_update.forEach(add_render_callback);
}
function destroy_component(component, detaching) {
    const $$ = component.$$;
    if ($$.fragment !== null) {
        flush_render_callbacks($$.after_update);
        run_all($$.on_destroy);
        $$.fragment && $$.fragment.d(detaching);
        // TODO null out other refs, including component.$$ (but need to
        // preserve final state?)
        $$.on_destroy = $$.fragment = null;
        $$.ctx = [];
    }
}
function make_dirty(component, i) {
    if (component.$$.dirty[0] === -1) {
        dirty_components.push(component);
        schedule_update();
        component.$$.dirty.fill(0);
    }
    component.$$.dirty[(i / 31) | 0] |= (1 << (i % 31));
}
function init(component, options, instance, create_fragment, not_equal, props, append_styles, dirty = [-1]) {
    const parent_component = current_component;
    set_current_component(component);
    const $$ = component.$$ = {
        fragment: null,
        ctx: [],
        // state
        props,
        update: noop,
        not_equal,
        bound: blank_object(),
        // lifecycle
        on_mount: [],
        on_destroy: [],
        on_disconnect: [],
        before_update: [],
        after_update: [],
        context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
        // everything else
        callbacks: blank_object(),
        dirty,
        skip_bound: false,
        root: options.target || parent_component.$$.root
    };
    append_styles && append_styles($$.root);
    let ready = false;
    $$.ctx = instance
        ? instance(component, options.props || {}, (i, ret, ...rest) => {
            const value = rest.length ? rest[0] : ret;
            if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
                if (!$$.skip_bound && $$.bound[i])
                    $$.bound[i](value);
                if (ready)
                    make_dirty(component, i);
            }
            return ret;
        })
        : [];
    $$.update();
    ready = true;
    run_all($$.before_update);
    // `false` as a special case of no DOM component
    $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
    if (options.target) {
        if (options.hydrate) {
            start_hydrating();
            const nodes = children(options.target);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            $$.fragment && $$.fragment.l(nodes);
            nodes.forEach(detach);
        }
        else {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            $$.fragment && $$.fragment.c();
        }
        if (options.intro)
            transition_in(component.$$.fragment);
        mount_component(component, options.target, options.anchor, options.customElement);
        end_hydrating();
        flush();
    }
    set_current_component(parent_component);
}
let SvelteElement;
if (typeof HTMLElement === 'function') {
    SvelteElement = class extends HTMLElement {
        constructor() {
            super();
            this.attachShadow({ mode: 'open' });
        }
        connectedCallback() {
            const { on_mount } = this.$$;
            this.$$.on_disconnect = on_mount.map(run).filter(is_function);
            // @ts-ignore todo: improve typings
            for (const key in this.$$.slotted) {
                // @ts-ignore todo: improve typings
                this.appendChild(this.$$.slotted[key]);
            }
        }
        attributeChangedCallback(attr, _oldValue, newValue) {
            this[attr] = newValue;
        }
        disconnectedCallback() {
            run_all(this.$$.on_disconnect);
        }
        $destroy() {
            destroy_component(this, 1);
            this.$destroy = noop;
        }
        $on(type, callback) {
            // TODO should this delegate to addEventListener?
            if (!is_function(callback)) {
                return noop;
            }
            const callbacks = (this.$$.callbacks[type] || (this.$$.callbacks[type] = []));
            callbacks.push(callback);
            return () => {
                const index = callbacks.indexOf(callback);
                if (index !== -1)
                    callbacks.splice(index, 1);
            };
        }
        $set($$props) {
            if (this.$$set && !is_empty($$props)) {
                this.$$.skip_bound = true;
                this.$$set($$props);
                this.$$.skip_bound = false;
            }
        }
    };
}
/**
 * Base class for Svelte components. Used when dev=false.
 */
class SvelteComponent {
    $destroy() {
        destroy_component(this, 1);
        this.$destroy = noop;
    }
    $on(type, callback) {
        if (!is_function(callback)) {
            return noop;
        }
        const callbacks = (this.$$.callbacks[type] || (this.$$.callbacks[type] = []));
        callbacks.push(callback);
        return () => {
            const index = callbacks.indexOf(callback);
            if (index !== -1)
                callbacks.splice(index, 1);
        };
    }
    $set($$props) {
        if (this.$$set && !is_empty($$props)) {
            this.$$.skip_bound = true;
            this.$$set($$props);
            this.$$.skip_bound = false;
        }
    }
}

function dispatch_dev(type, detail) {
    document.dispatchEvent(custom_event(type, Object.assign({ version: '3.59.2' }, detail), { bubbles: true }));
}
function append_dev(target, node) {
    dispatch_dev('SvelteDOMInsert', { target, node });
    append(target, node);
}
function append_hydration_dev(target, node) {
    dispatch_dev('SvelteDOMInsert', { target, node });
    append_hydration(target, node);
}
function insert_dev(target, node, anchor) {
    dispatch_dev('SvelteDOMInsert', { target, node, anchor });
    insert(target, node, anchor);
}
function insert_hydration_dev(target, node, anchor) {
    dispatch_dev('SvelteDOMInsert', { target, node, anchor });
    insert_hydration(target, node, anchor);
}
function detach_dev(node) {
    dispatch_dev('SvelteDOMRemove', { node });
    detach(node);
}
function detach_between_dev(before, after) {
    while (before.nextSibling && before.nextSibling !== after) {
        detach_dev(before.nextSibling);
    }
}
function detach_before_dev(after) {
    while (after.previousSibling) {
        detach_dev(after.previousSibling);
    }
}
function detach_after_dev(before) {
    while (before.nextSibling) {
        detach_dev(before.nextSibling);
    }
}
function listen_dev(node, event, handler, options, has_prevent_default, has_stop_propagation, has_stop_immediate_propagation) {
    const modifiers = options === true ? ['capture'] : options ? Array.from(Object.keys(options)) : [];
    if (has_prevent_default)
        modifiers.push('preventDefault');
    if (has_stop_propagation)
        modifiers.push('stopPropagation');
    if (has_stop_immediate_propagation)
        modifiers.push('stopImmediatePropagation');
    dispatch_dev('SvelteDOMAddEventListener', { node, event, handler, modifiers });
    const dispose = listen(node, event, handler, options);
    return () => {
        dispatch_dev('SvelteDOMRemoveEventListener', { node, event, handler, modifiers });
        dispose();
    };
}
function attr_dev(node, attribute, value) {
    attr(node, attribute, value);
    if (value == null)
        dispatch_dev('SvelteDOMRemoveAttribute', { node, attribute });
    else
        dispatch_dev('SvelteDOMSetAttribute', { node, attribute, value });
}
function prop_dev(node, property, value) {
    node[property] = value;
    dispatch_dev('SvelteDOMSetProperty', { node, property, value });
}
function dataset_dev(node, property, value) {
    node.dataset[property] = value;
    dispatch_dev('SvelteDOMSetDataset', { node, property, value });
}
function set_data_dev(text, data) {
    data = '' + data;
    if (text.data === data)
        return;
    dispatch_dev('SvelteDOMSetData', { node: text, data });
    text.data = data;
}
function set_data_contenteditable_dev(text, data) {
    data = '' + data;
    if (text.wholeText === data)
        return;
    dispatch_dev('SvelteDOMSetData', { node: text, data });
    text.data = data;
}
function set_data_maybe_contenteditable_dev(text, data, attr_value) {
    if (~contenteditable_truthy_values.indexOf(attr_value)) {
        set_data_contenteditable_dev(text, data);
    }
    else {
        set_data_dev(text, data);
    }
}
function validate_each_argument(arg) {
    if (typeof arg !== 'string' && !(arg && typeof arg === 'object' && 'length' in arg)) {
        let msg = '{#each} only iterates over array-like objects.';
        if (typeof Symbol === 'function' && arg && Symbol.iterator in arg) {
            msg += ' You can use a spread to convert this iterable into an array.';
        }
        throw new Error(msg);
    }
}
function validate_slots(name, slot, keys) {
    for (const slot_key of Object.keys(slot)) {
        if (!~keys.indexOf(slot_key)) {
            console.warn(`<${name}> received an unexpected slot "${slot_key}".`);
        }
    }
}
function validate_dynamic_element(tag) {
    const is_string = typeof tag === 'string';
    if (tag && !is_string) {
        throw new Error('<svelte:element> expects "this" attribute to be a string.');
    }
}
function validate_void_dynamic_element(tag) {
    if (tag && is_void(tag)) {
        console.warn(`<svelte:element this="${tag}"> is self-closing and cannot have content.`);
    }
}
function construct_svelte_component_dev(component, props) {
    const error_message = 'this={...} of <svelte:component> should specify a Svelte component.';
    try {
        const instance = new component(props);
        if (!instance.$$ || !instance.$set || !instance.$on || !instance.$destroy) {
            throw new Error(error_message);
        }
        return instance;
    }
    catch (err) {
        const { message } = err;
        if (typeof message === 'string' && message.indexOf('is not a constructor') !== -1) {
            throw new Error(error_message);
        }
        else {
            throw err;
        }
    }
}
/**
 * Base class for Svelte components with some minor dev-enhancements. Used when dev=true.
 */
class SvelteComponentDev extends SvelteComponent {
    constructor(options) {
        if (!options || (!options.target && !options.$$inline)) {
            throw new Error("'target' is a required option");
        }
        super();
    }
    $destroy() {
        super.$destroy();
        this.$destroy = () => {
            console.warn('Component was already destroyed'); // eslint-disable-line no-console
        };
    }
    $capture_state() { }
    $inject_state() { }
}
/**
 * Base class to create strongly typed Svelte components.
 * This only exists for typing purposes and should be used in `.d.ts` files.
 *
 * ### Example:
 *
 * You have component library on npm called `component-library`, from which
 * you export a component called `MyComponent`. For Svelte+TypeScript users,
 * you want to provide typings. Therefore you create a `index.d.ts`:
 * ```ts
 * import { SvelteComponentTyped } from "svelte";
 * export class MyComponent extends SvelteComponentTyped<{foo: string}> {}
 * ```
 * Typing this makes it possible for IDEs like VS Code with the Svelte extension
 * to provide intellisense and to use the component like this in a Svelte file
 * with TypeScript:
 * ```svelte
 * <script lang="ts">
 * 	import { MyComponent } from "component-library";
 * </script>
 * <MyComponent foo={'bar'} />
 * ```
 *
 * #### Why not make this part of `SvelteComponent(Dev)`?
 * Because
 * ```ts
 * class ASubclassOfSvelteComponent extends SvelteComponent<{foo: string}> {}
 * const component: typeof SvelteComponent = ASubclassOfSvelteComponent;
 * ```
 * will throw a type error, so we need to separate the more strictly typed class.
 */
class SvelteComponentTyped extends SvelteComponentDev {
    constructor(options) {
        super(options);
    }
}
function loop_guard(timeout) {
    const start = Date.now();
    return () => {
        if (Date.now() - start > timeout) {
            throw new Error('Infinite loop detected');
        }
    };
}




/***/ }),

/***/ "./node_modules/svelte/store/index.mjs":
/*!*********************************************!*\
  !*** ./node_modules/svelte/store/index.mjs ***!
  \*********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   derived: () => (/* binding */ derived),
/* harmony export */   get: () => (/* reexport safe */ _internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.get_store_value),
/* harmony export */   readable: () => (/* binding */ readable),
/* harmony export */   readonly: () => (/* binding */ readonly),
/* harmony export */   writable: () => (/* binding */ writable)
/* harmony export */ });
/* harmony import */ var _internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../internal/index.mjs */ "./node_modules/svelte/internal/index.mjs");



const subscriber_queue = [];
/**
 * Creates a `Readable` store that allows reading by subscription.
 * @param value initial value
 * @param {StartStopNotifier} [start]
 */
function readable(value, start) {
    return {
        subscribe: writable(value, start).subscribe
    };
}
/**
 * Create a `Writable` store that allows both updating and reading by subscription.
 * @param {*=}value initial value
 * @param {StartStopNotifier=} start
 */
function writable(value, start = _internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.noop) {
    let stop;
    const subscribers = new Set();
    function set(new_value) {
        if ((0,_internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal)(value, new_value)) {
            value = new_value;
            if (stop) { // store is ready
                const run_queue = !subscriber_queue.length;
                for (const subscriber of subscribers) {
                    subscriber[1]();
                    subscriber_queue.push(subscriber, value);
                }
                if (run_queue) {
                    for (let i = 0; i < subscriber_queue.length; i += 2) {
                        subscriber_queue[i][0](subscriber_queue[i + 1]);
                    }
                    subscriber_queue.length = 0;
                }
            }
        }
    }
    function update(fn) {
        set(fn(value));
    }
    function subscribe(run, invalidate = _internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.noop) {
        const subscriber = [run, invalidate];
        subscribers.add(subscriber);
        if (subscribers.size === 1) {
            stop = start(set) || _internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.noop;
        }
        run(value);
        return () => {
            subscribers.delete(subscriber);
            if (subscribers.size === 0 && stop) {
                stop();
                stop = null;
            }
        };
    }
    return { set, update, subscribe };
}
function derived(stores, fn, initial_value) {
    const single = !Array.isArray(stores);
    const stores_array = single
        ? [stores]
        : stores;
    const auto = fn.length < 2;
    return readable(initial_value, (set) => {
        let started = false;
        const values = [];
        let pending = 0;
        let cleanup = _internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.noop;
        const sync = () => {
            if (pending) {
                return;
            }
            cleanup();
            const result = fn(single ? values[0] : values, set);
            if (auto) {
                set(result);
            }
            else {
                cleanup = (0,_internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.is_function)(result) ? result : _internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.noop;
            }
        };
        const unsubscribers = stores_array.map((store, i) => (0,_internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.subscribe)(store, (value) => {
            values[i] = value;
            pending &= ~(1 << i);
            if (started) {
                sync();
            }
        }, () => {
            pending |= (1 << i);
        }));
        started = true;
        sync();
        return function stop() {
            (0,_internal_index_mjs__WEBPACK_IMPORTED_MODULE_0__.run_all)(unsubscribers);
            cleanup();
            // We need to set this to false because callbacks can still happen despite having unsubscribed:
            // Callbacks might already be placed in the queue which doesn't know it should no longer
            // invoke this derived store.
            started = false;
        };
    });
}
/**
 * Takes a store and returns a new one derived from the old one that is readable.
 *
 * @param store - store to make readonly
 */
function readonly(store) {
    return {
        subscribe: store.subscribe.bind(store)
    };
}




/***/ }),

/***/ "./node_modules/swiper/modules/a11y.mjs":
/*!**********************************************!*\
  !*** ./node_modules/swiper/modules/a11y.mjs ***!
  \**********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ A11y)
/* harmony export */ });
/* harmony import */ var _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs");
/* harmony import */ var _shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/classes-to-selector.mjs */ "./node_modules/swiper/shared/classes-to-selector.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs");




function A11y(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
      slideLabelMessage: '{{index}} / {{slidesLength}}',
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      containerRole: null,
      itemRoleDescriptionMessage: null,
      slideRole: 'group',
      id: null,
      scrollOnFocus: true
    }
  });
  swiper.a11y = {
    clicked: false
  };
  let liveRegion = null;
  let preventFocusHandler;
  let focusTargetSlideEl;
  let visibilityChangedTimestamp = new Date().getTime();
  function notify(message) {
    const notification = liveRegion;
    if (notification.length === 0) return;
    (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.s)(notification, message);
  }
  function getRandomNumber(size) {
    if (size === void 0) {
      size = 16;
    }
    const randomChar = () => Math.round(16 * Math.random()).toString(16);
    return 'x'.repeat(size).replace(/x/g, randomChar);
  }
  function makeElFocusable(el) {
    el = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('tabIndex', '0');
    });
  }
  function makeElNotFocusable(el) {
    el = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('tabIndex', '-1');
    });
  }
  function addElRole(el, role) {
    el = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('role', role);
    });
  }
  function addElRoleDescription(el, description) {
    el = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-roledescription', description);
    });
  }
  function addElControls(el, controls) {
    el = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-controls', controls);
    });
  }
  function addElLabel(el, label) {
    el = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-label', label);
    });
  }
  function addElId(el, id) {
    el = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('id', id);
    });
  }
  function addElLive(el, live) {
    el = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-live', live);
    });
  }
  function disableEl(el) {
    el = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-disabled', true);
    });
  }
  function enableEl(el) {
    el = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-disabled', false);
    });
  }
  function onEnterOrSpaceKey(e) {
    if (e.keyCode !== 13 && e.keyCode !== 32) return;
    const params = swiper.params.a11y;
    const targetEl = e.target;
    if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
      if (!e.target.matches((0,_shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(swiper.params.pagination.bulletClass))) return;
    }
    if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
      const prevEls = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(swiper.navigation.prevEl);
      const nextEls = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(swiper.navigation.nextEl);
      if (nextEls.includes(targetEl)) {
        if (!(swiper.isEnd && !swiper.params.loop)) {
          swiper.slideNext();
        }
        if (swiper.isEnd) {
          notify(params.lastSlideMessage);
        } else {
          notify(params.nextSlideMessage);
        }
      }
      if (prevEls.includes(targetEl)) {
        if (!(swiper.isBeginning && !swiper.params.loop)) {
          swiper.slidePrev();
        }
        if (swiper.isBeginning) {
          notify(params.firstSlideMessage);
        } else {
          notify(params.prevSlideMessage);
        }
      }
    }
    if (swiper.pagination && targetEl.matches((0,_shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(swiper.params.pagination.bulletClass))) {
      targetEl.click();
    }
  }
  function updateNavigation() {
    if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
    const {
      nextEl,
      prevEl
    } = swiper.navigation;
    if (prevEl) {
      if (swiper.isBeginning) {
        disableEl(prevEl);
        makeElNotFocusable(prevEl);
      } else {
        enableEl(prevEl);
        makeElFocusable(prevEl);
      }
    }
    if (nextEl) {
      if (swiper.isEnd) {
        disableEl(nextEl);
        makeElNotFocusable(nextEl);
      } else {
        enableEl(nextEl);
        makeElFocusable(nextEl);
      }
    }
  }
  function hasPagination() {
    return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
  }
  function hasClickablePagination() {
    return hasPagination() && swiper.params.pagination.clickable;
  }
  function updatePagination() {
    const params = swiper.params.a11y;
    if (!hasPagination()) return;
    swiper.pagination.bullets.forEach(bulletEl => {
      if (swiper.params.pagination.clickable) {
        makeElFocusable(bulletEl);
        if (!swiper.params.pagination.renderBullet) {
          addElRole(bulletEl, 'button');
          addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.i)(bulletEl) + 1));
        }
      }
      if (bulletEl.matches((0,_shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(swiper.params.pagination.bulletActiveClass))) {
        bulletEl.setAttribute('aria-current', 'true');
      } else {
        bulletEl.removeAttribute('aria-current');
      }
    });
  }
  const initNavEl = (el, wrapperId, message) => {
    makeElFocusable(el);
    if (el.tagName !== 'BUTTON') {
      addElRole(el, 'button');
      el.addEventListener('keydown', onEnterOrSpaceKey);
    }
    addElLabel(el, message);
    addElControls(el, wrapperId);
  };
  const handlePointerDown = e => {
    if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) {
      preventFocusHandler = true;
    }
    swiper.a11y.clicked = true;
  };
  const handlePointerUp = () => {
    preventFocusHandler = false;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!swiper.destroyed) {
          swiper.a11y.clicked = false;
        }
      });
    });
  };
  const onVisibilityChange = e => {
    visibilityChangedTimestamp = new Date().getTime();
  };
  const handleFocus = e => {
    if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
    if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
    const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
    if (!slideEl || !swiper.slides.includes(slideEl)) return;
    focusTargetSlideEl = slideEl;
    const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
    const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
    if (isActive || isVisible) return;
    if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
    if (swiper.isHorizontal()) {
      swiper.el.scrollLeft = 0;
    } else {
      swiper.el.scrollTop = 0;
    }
    requestAnimationFrame(() => {
      if (preventFocusHandler) return;
      if (swiper.params.loop) {
        swiper.slideToLoop(parseInt(slideEl.getAttribute('data-swiper-slide-index')), 0);
      } else {
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
      }
      preventFocusHandler = false;
    });
  };
  const initSlides = () => {
    const params = swiper.params.a11y;
    if (params.itemRoleDescriptionMessage) {
      addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
    }
    if (params.slideRole) {
      addElRole(swiper.slides, params.slideRole);
    }
    const slidesLength = swiper.slides.length;
    if (params.slideLabelMessage) {
      swiper.slides.forEach((slideEl, index) => {
        const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : index;
        const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
        addElLabel(slideEl, ariaLabelMessage);
      });
    }
  };
  const init = () => {
    const params = swiper.params.a11y;
    swiper.el.append(liveRegion);

    // Container
    const containerEl = swiper.el;
    if (params.containerRoleDescriptionMessage) {
      addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
    }
    if (params.containerMessage) {
      addElLabel(containerEl, params.containerMessage);
    }
    if (params.containerRole) {
      addElRole(containerEl, params.containerRole);
    }

    // Wrapper
    const wrapperEl = swiper.wrapperEl;
    const wrapperId = params.id || wrapperEl.getAttribute('id') || `swiper-wrapper-${getRandomNumber(16)}`;
    const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
    addElId(wrapperEl, wrapperId);
    addElLive(wrapperEl, live);

    // Slide
    initSlides();

    // Navigation
    let {
      nextEl,
      prevEl
    } = swiper.navigation ? swiper.navigation : {};
    nextEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(nextEl);
    prevEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(prevEl);
    if (nextEl) {
      nextEl.forEach(el => initNavEl(el, wrapperId, params.nextSlideMessage));
    }
    if (prevEl) {
      prevEl.forEach(el => initNavEl(el, wrapperId, params.prevSlideMessage));
    }

    // Pagination
    if (hasClickablePagination()) {
      const paginationEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(swiper.pagination.el);
      paginationEl.forEach(el => {
        el.addEventListener('keydown', onEnterOrSpaceKey);
      });
    }

    // Tab focus
    const document = (0,_shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
    document.addEventListener('visibilitychange', onVisibilityChange);
    swiper.el.addEventListener('focus', handleFocus, true);
    swiper.el.addEventListener('focus', handleFocus, true);
    swiper.el.addEventListener('pointerdown', handlePointerDown, true);
    swiper.el.addEventListener('pointerup', handlePointerUp, true);
  };
  function destroy() {
    if (liveRegion) liveRegion.remove();
    let {
      nextEl,
      prevEl
    } = swiper.navigation ? swiper.navigation : {};
    nextEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(nextEl);
    prevEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(prevEl);
    if (nextEl) {
      nextEl.forEach(el => el.removeEventListener('keydown', onEnterOrSpaceKey));
    }
    if (prevEl) {
      prevEl.forEach(el => el.removeEventListener('keydown', onEnterOrSpaceKey));
    }

    // Pagination
    if (hasClickablePagination()) {
      const paginationEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(swiper.pagination.el);
      paginationEl.forEach(el => {
        el.removeEventListener('keydown', onEnterOrSpaceKey);
      });
    }
    const document = (0,_shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
    document.removeEventListener('visibilitychange', onVisibilityChange);
    // Tab focus
    if (swiper.el && typeof swiper.el !== 'string') {
      swiper.el.removeEventListener('focus', handleFocus, true);
      swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
      swiper.el.removeEventListener('pointerup', handlePointerUp, true);
    }
  }
  on('beforeInit', () => {
    liveRegion = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.c)('span', swiper.params.a11y.notificationClass);
    liveRegion.setAttribute('aria-live', 'assertive');
    liveRegion.setAttribute('aria-atomic', 'true');
  });
  on('afterInit', () => {
    if (!swiper.params.a11y.enabled) return;
    init();
  });
  on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', () => {
    if (!swiper.params.a11y.enabled) return;
    initSlides();
  });
  on('fromEdge toEdge afterInit lock unlock', () => {
    if (!swiper.params.a11y.enabled) return;
    updateNavigation();
  });
  on('paginationUpdate', () => {
    if (!swiper.params.a11y.enabled) return;
    updatePagination();
  });
  on('destroy', () => {
    if (!swiper.params.a11y.enabled) return;
    destroy();
  });
}




/***/ }),

/***/ "./node_modules/swiper/modules/autoplay.mjs":
/*!**************************************************!*\
  !*** ./node_modules/swiper/modules/autoplay.mjs ***!
  \**************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Autoplay)
/* harmony export */ });
/* harmony import */ var _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs");


/* eslint no-underscore-dangle: "off" */
/* eslint no-use-before-define: "off" */
function Autoplay(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit,
    params
  } = _ref;
  swiper.autoplay = {
    running: false,
    paused: false,
    timeLeft: 0
  };
  extendParams({
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: false,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false
    }
  });
  let timeout;
  let raf;
  let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
  let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
  let autoplayTimeLeft;
  let autoplayStartTime = new Date().getTime();
  let wasPaused;
  let isTouched;
  let pausedByTouch;
  let touchStartTimeout;
  let slideChanged;
  let pausedByInteraction;
  let pausedByPointerEnter;
  function onTransitionEnd(e) {
    if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
    if (e.target !== swiper.wrapperEl) return;
    swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
    if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) {
      return;
    }
    resume();
  }
  const calcTimeLeft = () => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    if (swiper.autoplay.paused) {
      wasPaused = true;
    } else if (wasPaused) {
      autoplayDelayCurrent = autoplayTimeLeft;
      wasPaused = false;
    }
    const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
    swiper.autoplay.timeLeft = timeLeft;
    emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
    raf = requestAnimationFrame(() => {
      calcTimeLeft();
    });
  };
  const getSlideDelay = () => {
    let activeSlideEl;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      activeSlideEl = swiper.slides.find(slideEl => slideEl.classList.contains('swiper-slide-active'));
    } else {
      activeSlideEl = swiper.slides[swiper.activeIndex];
    }
    if (!activeSlideEl) return undefined;
    const currentSlideDelay = parseInt(activeSlideEl.getAttribute('data-swiper-autoplay'), 10);
    return currentSlideDelay;
  };
  const run = delayForce => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    cancelAnimationFrame(raf);
    calcTimeLeft();
    let delay = typeof delayForce === 'undefined' ? swiper.params.autoplay.delay : delayForce;
    autoplayDelayTotal = swiper.params.autoplay.delay;
    autoplayDelayCurrent = swiper.params.autoplay.delay;
    const currentSlideDelay = getSlideDelay();
    if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === 'undefined') {
      delay = currentSlideDelay;
      autoplayDelayTotal = currentSlideDelay;
      autoplayDelayCurrent = currentSlideDelay;
    }
    autoplayTimeLeft = delay;
    const speed = swiper.params.speed;
    const proceed = () => {
      if (!swiper || swiper.destroyed) return;
      if (swiper.params.autoplay.reverseDirection) {
        if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
          swiper.slidePrev(speed, true, true);
          emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(swiper.slides.length - 1, speed, true, true);
          emit('autoplay');
        }
      } else {
        if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
          swiper.slideNext(speed, true, true);
          emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(0, speed, true, true);
          emit('autoplay');
        }
      }
      if (swiper.params.cssMode) {
        autoplayStartTime = new Date().getTime();
        requestAnimationFrame(() => {
          run();
        });
      }
    };
    if (delay > 0) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        proceed();
      }, delay);
    } else {
      requestAnimationFrame(() => {
        proceed();
      });
    }

    // eslint-disable-next-line
    return delay;
  };
  const start = () => {
    autoplayStartTime = new Date().getTime();
    swiper.autoplay.running = true;
    run();
    emit('autoplayStart');
  };
  const stop = () => {
    swiper.autoplay.running = false;
    clearTimeout(timeout);
    cancelAnimationFrame(raf);
    emit('autoplayStop');
  };
  const pause = (internal, reset) => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    clearTimeout(timeout);
    if (!internal) {
      pausedByInteraction = true;
    }
    const proceed = () => {
      emit('autoplayPause');
      if (swiper.params.autoplay.waitForTransition) {
        swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
      } else {
        resume();
      }
    };
    swiper.autoplay.paused = true;
    if (reset) {
      if (slideChanged) {
        autoplayTimeLeft = swiper.params.autoplay.delay;
      }
      slideChanged = false;
      proceed();
      return;
    }
    const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
    autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
    if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
    if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
    proceed();
  };
  const resume = () => {
    if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
    autoplayStartTime = new Date().getTime();
    if (pausedByInteraction) {
      pausedByInteraction = false;
      run(autoplayTimeLeft);
    } else {
      run();
    }
    swiper.autoplay.paused = false;
    emit('autoplayResume');
  };
  const onVisibilityChange = () => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    const document = (0,_shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
    if (document.visibilityState === 'hidden') {
      pausedByInteraction = true;
      pause(true);
    }
    if (document.visibilityState === 'visible') {
      resume();
    }
  };
  const onPointerEnter = e => {
    if (e.pointerType !== 'mouse') return;
    pausedByInteraction = true;
    pausedByPointerEnter = true;
    if (swiper.animating || swiper.autoplay.paused) return;
    pause(true);
  };
  const onPointerLeave = e => {
    if (e.pointerType !== 'mouse') return;
    pausedByPointerEnter = false;
    if (swiper.autoplay.paused) {
      resume();
    }
  };
  const attachMouseEvents = () => {
    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.el.addEventListener('pointerenter', onPointerEnter);
      swiper.el.addEventListener('pointerleave', onPointerLeave);
    }
  };
  const detachMouseEvents = () => {
    if (swiper.el && typeof swiper.el !== 'string') {
      swiper.el.removeEventListener('pointerenter', onPointerEnter);
      swiper.el.removeEventListener('pointerleave', onPointerLeave);
    }
  };
  const attachDocumentEvents = () => {
    const document = (0,_shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
    document.addEventListener('visibilitychange', onVisibilityChange);
  };
  const detachDocumentEvents = () => {
    const document = (0,_shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
    document.removeEventListener('visibilitychange', onVisibilityChange);
  };
  on('init', () => {
    if (swiper.params.autoplay.enabled) {
      attachMouseEvents();
      attachDocumentEvents();
      start();
    }
  });
  on('destroy', () => {
    detachMouseEvents();
    detachDocumentEvents();
    if (swiper.autoplay.running) {
      stop();
    }
  });
  on('_freeModeStaticRelease', () => {
    if (pausedByTouch || pausedByInteraction) {
      resume();
    }
  });
  on('_freeModeNoMomentumRelease', () => {
    if (!swiper.params.autoplay.disableOnInteraction) {
      pause(true, true);
    } else {
      stop();
    }
  });
  on('beforeTransitionStart', (_s, speed, internal) => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    if (internal || !swiper.params.autoplay.disableOnInteraction) {
      pause(true, true);
    } else {
      stop();
    }
  });
  on('sliderFirstMove', () => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    if (swiper.params.autoplay.disableOnInteraction) {
      stop();
      return;
    }
    isTouched = true;
    pausedByTouch = false;
    pausedByInteraction = false;
    touchStartTimeout = setTimeout(() => {
      pausedByInteraction = true;
      pausedByTouch = true;
      pause(true);
    }, 200);
  });
  on('touchEnd', () => {
    if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
    clearTimeout(touchStartTimeout);
    clearTimeout(timeout);
    if (swiper.params.autoplay.disableOnInteraction) {
      pausedByTouch = false;
      isTouched = false;
      return;
    }
    if (pausedByTouch && swiper.params.cssMode) resume();
    pausedByTouch = false;
    isTouched = false;
  });
  on('slideChange', () => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    slideChanged = true;
  });
  Object.assign(swiper.autoplay, {
    start,
    stop,
    pause,
    resume
  });
}




/***/ }),

/***/ "./node_modules/swiper/modules/controller.mjs":
/*!****************************************************!*\
  !*** ./node_modules/swiper/modules/controller.mjs ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Controller)
/* harmony export */ });
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs");


/* eslint no-bitwise: ["error", { "allow": [">>"] }] */
function Controller(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    controller: {
      control: undefined,
      inverse: false,
      by: 'slide' // or 'container'
    }
  });

  swiper.controller = {
    control: undefined
  };
  function LinearSpline(x, y) {
    const binarySearch = function search() {
      let maxIndex;
      let minIndex;
      let guess;
      return (array, val) => {
        minIndex = -1;
        maxIndex = array.length;
        while (maxIndex - minIndex > 1) {
          guess = maxIndex + minIndex >> 1;
          if (array[guess] <= val) {
            minIndex = guess;
          } else {
            maxIndex = guess;
          }
        }
        return maxIndex;
      };
    }();
    this.x = x;
    this.y = y;
    this.lastIndex = x.length - 1;
    // Given an x value (x2), return the expected y2 value:
    // (x1,y1) is the known point before given value,
    // (x3,y3) is the known point after given value.
    let i1;
    let i3;
    this.interpolate = function interpolate(x2) {
      if (!x2) return 0;

      // Get the indexes of x1 and x3 (the array indexes before and after given x2):
      i3 = binarySearch(this.x, x2);
      i1 = i3 - 1;

      // We have our indexes i1 & i3, so we can calculate already:
      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
      return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
    };
    return this;
  }
  function getInterpolateFunction(c) {
    swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
  }
  function setTranslate(_t, byController) {
    const controlled = swiper.controller.control;
    let multiplier;
    let controlledTranslate;
    const Swiper = swiper.constructor;
    function setControlledTranslate(c) {
      if (c.destroyed) return;

      // this will create an Interpolate function based on the snapGrids
      // x is the Grid of the scrolled scroller and y will be the controlled scroller
      // it makes sense to create this only once and recall it for the interpolation
      // the function does a lot of value caching for performance
      const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
      if (swiper.params.controller.by === 'slide') {
        getInterpolateFunction(c);
        // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
        // but it did not work out
        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
      }
      if (!controlledTranslate || swiper.params.controller.by === 'container') {
        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
        if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) {
          multiplier = 1;
        }
        controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
      }
      if (swiper.params.controller.inverse) {
        controlledTranslate = c.maxTranslate() - controlledTranslate;
      }
      c.updateProgress(controlledTranslate);
      c.setTranslate(controlledTranslate, swiper);
      c.updateActiveIndex();
      c.updateSlidesClasses();
    }
    if (Array.isArray(controlled)) {
      for (let i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTranslate(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTranslate(controlled);
    }
  }
  function setTransition(duration, byController) {
    const Swiper = swiper.constructor;
    const controlled = swiper.controller.control;
    let i;
    function setControlledTransition(c) {
      if (c.destroyed) return;
      c.setTransition(duration, swiper);
      if (duration !== 0) {
        c.transitionStart();
        if (c.params.autoHeight) {
          (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.n)(() => {
            c.updateAutoHeight();
          });
        }
        (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.l)(c.wrapperEl, () => {
          if (!controlled) return;
          c.transitionEnd();
        });
      }
    }
    if (Array.isArray(controlled)) {
      for (i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTransition(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTransition(controlled);
    }
  }
  function removeSpline() {
    if (!swiper.controller.control) return;
    if (swiper.controller.spline) {
      swiper.controller.spline = undefined;
      delete swiper.controller.spline;
    }
  }
  on('beforeInit', () => {
    if (typeof window !== 'undefined' && (
    // eslint-disable-line
    typeof swiper.params.controller.control === 'string' || swiper.params.controller.control instanceof HTMLElement)) {
      const controlElements = typeof swiper.params.controller.control === 'string' ? [...document.querySelectorAll(swiper.params.controller.control)] : [swiper.params.controller.control];
      controlElements.forEach(controlElement => {
        if (!swiper.controller.control) swiper.controller.control = [];
        if (controlElement && controlElement.swiper) {
          swiper.controller.control.push(controlElement.swiper);
        } else if (controlElement) {
          const eventName = `${swiper.params.eventsPrefix}init`;
          const onControllerSwiper = e => {
            swiper.controller.control.push(e.detail[0]);
            swiper.update();
            controlElement.removeEventListener(eventName, onControllerSwiper);
          };
          controlElement.addEventListener(eventName, onControllerSwiper);
        }
      });
      return;
    }
    swiper.controller.control = swiper.params.controller.control;
  });
  on('update', () => {
    removeSpline();
  });
  on('resize', () => {
    removeSpline();
  });
  on('observerUpdate', () => {
    removeSpline();
  });
  on('setTranslate', (_s, translate, byController) => {
    if (!swiper.controller.control || swiper.controller.control.destroyed) return;
    swiper.controller.setTranslate(translate, byController);
  });
  on('setTransition', (_s, duration, byController) => {
    if (!swiper.controller.control || swiper.controller.control.destroyed) return;
    swiper.controller.setTransition(duration, byController);
  });
  Object.assign(swiper.controller, {
    setTranslate,
    setTransition
  });
}




/***/ }),

/***/ "./node_modules/swiper/modules/effect-cards.mjs":
/*!******************************************************!*\
  !*** ./node_modules/swiper/modules/effect-cards.mjs ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EffectCards)
/* harmony export */ });
/* harmony import */ var _shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/create-shadow.mjs */ "./node_modules/swiper/shared/create-shadow.mjs");
/* harmony import */ var _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/effect-init.mjs */ "./node_modules/swiper/shared/effect-init.mjs");
/* harmony import */ var _shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/effect-target.mjs */ "./node_modules/swiper/shared/effect-target.mjs");
/* harmony import */ var _shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../shared/effect-virtual-transition-end.mjs */ "./node_modules/swiper/shared/effect-virtual-transition-end.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs");






function EffectCards(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    cardsEffect: {
      slideShadows: true,
      rotate: true,
      perSlideRotate: 2,
      perSlideOffset: 8
    }
  });
  const setTranslate = () => {
    const {
      slides,
      activeIndex,
      rtlTranslate: rtl
    } = swiper;
    const params = swiper.params.cardsEffect;
    const {
      startTranslate,
      isTouched
    } = swiper.touchEventsData;
    const currentTranslate = rtl ? -swiper.translate : swiper.translate;
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i];
      const slideProgress = slideEl.progress;
      const progress = Math.min(Math.max(slideProgress, -4), 4);
      let offset = slideEl.swiperSlideOffset;
      if (swiper.params.centeredSlides && !swiper.params.cssMode) {
        swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
      }
      if (swiper.params.centeredSlides && swiper.params.cssMode) {
        offset -= slides[0].swiperSlideOffset;
      }
      let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
      let tY = 0;
      const tZ = -100 * Math.abs(progress);
      let scale = 1;
      let rotate = -params.perSlideRotate * progress;
      let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
      const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
      const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
      const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
      if (isSwipeToNext || isSwipeToPrev) {
        const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
        rotate += -28 * progress * subProgress;
        scale += -0.5 * subProgress;
        tXAdd += 96 * subProgress;
        tY = `${-25 * subProgress * Math.abs(progress)}%`;
      }
      if (progress < 0) {
        // next
        tX = `calc(${tX}px ${rtl ? '-' : '+'} (${tXAdd * Math.abs(progress)}%))`;
      } else if (progress > 0) {
        // prev
        tX = `calc(${tX}px ${rtl ? '-' : '+'} (-${tXAdd * Math.abs(progress)}%))`;
      } else {
        tX = `${tX}px`;
      }
      if (!swiper.isHorizontal()) {
        const prevY = tY;
        tY = tX;
        tX = prevY;
      }
      const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;

      /* eslint-disable */
      const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
      /* eslint-enable */

      if (params.slideShadows) {
        // Set shadows
        let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
        if (!shadowEl) {
          shadowEl = (0,_shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__.c)('cards', slideEl);
        }
        if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
      }
      slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      const targetEl = (0,_shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__.e)(params, slideEl);
      targetEl.style.transform = transform;
    }
  };
  const setTransition = duration => {
    const transformElements = swiper.slides.map(slideEl => (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__.g)(slideEl));
    transformElements.forEach(el => {
      el.style.transitionDuration = `${duration}ms`;
      el.querySelectorAll('.swiper-slide-shadow').forEach(shadowEl => {
        shadowEl.style.transitionDuration = `${duration}ms`;
      });
    });
    (0,_shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_3__.e)({
      swiper,
      duration,
      transformElements
    });
  };
  (0,_shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__.e)({
    effect: 'cards',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => true,
    overwriteParams: () => ({
      _loopSwapReset: false,
      watchSlidesProgress: true,
      loopAdditionalSlides: swiper.params.cardsEffect.rotate ? 3 : 2,
      centeredSlides: true,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}




/***/ }),

/***/ "./node_modules/swiper/modules/effect-coverflow.mjs":
/*!**********************************************************!*\
  !*** ./node_modules/swiper/modules/effect-coverflow.mjs ***!
  \**********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EffectCoverflow)
/* harmony export */ });
/* harmony import */ var _shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/create-shadow.mjs */ "./node_modules/swiper/shared/create-shadow.mjs");
/* harmony import */ var _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/effect-init.mjs */ "./node_modules/swiper/shared/effect-init.mjs");
/* harmony import */ var _shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/effect-target.mjs */ "./node_modules/swiper/shared/effect-target.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs");





function EffectCoverflow(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: true
    }
  });
  const setTranslate = () => {
    const {
      width: swiperWidth,
      height: swiperHeight,
      slides,
      slidesSizesGrid
    } = swiper;
    const params = swiper.params.coverflowEffect;
    const isHorizontal = swiper.isHorizontal();
    const transform = swiper.translate;
    const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
    const rotate = isHorizontal ? params.rotate : -params.rotate;
    const translate = params.depth;
    const r = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_3__.p)(swiper);
    // Each slide offset from center
    for (let i = 0, length = slides.length; i < length; i += 1) {
      const slideEl = slides[i];
      const slideSize = slidesSizesGrid[i];
      const slideOffset = slideEl.swiperSlideOffset;
      const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
      const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
      let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
      let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
      // var rotateZ = 0
      let translateZ = -translate * Math.abs(offsetMultiplier);
      let stretch = params.stretch;
      // Allow percentage to make a relative stretch for responsive sliders
      if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
        stretch = parseFloat(params.stretch) / 100 * slideSize;
      }
      let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
      let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
      let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);

      // Fix for ultra small values
      if (Math.abs(translateX) < 0.001) translateX = 0;
      if (Math.abs(translateY) < 0.001) translateY = 0;
      if (Math.abs(translateZ) < 0.001) translateZ = 0;
      if (Math.abs(rotateY) < 0.001) rotateY = 0;
      if (Math.abs(rotateX) < 0.001) rotateX = 0;
      if (Math.abs(scale) < 0.001) scale = 0;
      const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
      const targetEl = (0,_shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__.e)(params, slideEl);
      targetEl.style.transform = slideTransform;
      slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
      if (params.slideShadows) {
        // Set shadows
        let shadowBeforeEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfterEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBeforeEl) {
          shadowBeforeEl = (0,_shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__.c)('coverflow', slideEl, isHorizontal ? 'left' : 'top');
        }
        if (!shadowAfterEl) {
          shadowAfterEl = (0,_shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__.c)('coverflow', slideEl, isHorizontal ? 'right' : 'bottom');
        }
        if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
        if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
      }
    }
  };
  const setTransition = duration => {
    const transformElements = swiper.slides.map(slideEl => (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_3__.g)(slideEl));
    transformElements.forEach(el => {
      el.style.transitionDuration = `${duration}ms`;
      el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(shadowEl => {
        shadowEl.style.transitionDuration = `${duration}ms`;
      });
    });
  };
  (0,_shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__.e)({
    effect: 'coverflow',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => true,
    overwriteParams: () => ({
      watchSlidesProgress: true
    })
  });
}




/***/ }),

/***/ "./node_modules/swiper/modules/effect-creative.mjs":
/*!*********************************************************!*\
  !*** ./node_modules/swiper/modules/effect-creative.mjs ***!
  \*********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EffectCreative)
/* harmony export */ });
/* harmony import */ var _shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/create-shadow.mjs */ "./node_modules/swiper/shared/create-shadow.mjs");
/* harmony import */ var _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/effect-init.mjs */ "./node_modules/swiper/shared/effect-init.mjs");
/* harmony import */ var _shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/effect-target.mjs */ "./node_modules/swiper/shared/effect-target.mjs");
/* harmony import */ var _shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../shared/effect-virtual-transition-end.mjs */ "./node_modules/swiper/shared/effect-virtual-transition-end.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs");






function EffectCreative(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    creativeEffect: {
      limitProgress: 1,
      shadowPerProgress: false,
      progressMultiplier: 1,
      perspective: true,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });
  const getTranslateValue = value => {
    if (typeof value === 'string') return value;
    return `${value}px`;
  };
  const setTranslate = () => {
    const {
      slides,
      wrapperEl,
      slidesSizesGrid
    } = swiper;
    const params = swiper.params.creativeEffect;
    const {
      progressMultiplier: multiplier
    } = params;
    const isCenteredSlides = swiper.params.centeredSlides;
    const rotateFix = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__.p)(swiper);
    if (isCenteredSlides) {
      const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
      wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
    }
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i];
      const slideProgress = slideEl.progress;
      const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
      let originalProgress = progress;
      if (!isCenteredSlides) {
        originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
      }
      const offset = slideEl.swiperSlideOffset;
      const t = [swiper.params.cssMode ? -offset - swiper.translate : -offset, 0, 0];
      const r = [0, 0, 0];
      let custom = false;
      if (!swiper.isHorizontal()) {
        t[1] = t[0];
        t[0] = 0;
      }
      let data = {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        scale: 1,
        opacity: 1
      };
      if (progress < 0) {
        data = params.next;
        custom = true;
      } else if (progress > 0) {
        data = params.prev;
        custom = true;
      }
      // set translate
      t.forEach((value, index) => {
        t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
      });
      // set rotates
      r.forEach((value, index) => {
        let val = data.rotate[index] * Math.abs(progress * multiplier);
        r[index] = val;
      });
      slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      const translateString = t.join(', ');
      const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
      const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
      const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
      const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;

      // Set shadows
      if (custom && data.shadow || !custom) {
        let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
        if (!shadowEl && data.shadow) {
          shadowEl = (0,_shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__.c)('creative', slideEl);
        }
        if (shadowEl) {
          const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
          shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
        }
      }
      const targetEl = (0,_shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__.e)(params, slideEl);
      targetEl.style.transform = transform;
      targetEl.style.opacity = opacityString;
      if (data.origin) {
        targetEl.style.transformOrigin = data.origin;
      }
    }
  };
  const setTransition = duration => {
    const transformElements = swiper.slides.map(slideEl => (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__.g)(slideEl));
    transformElements.forEach(el => {
      el.style.transitionDuration = `${duration}ms`;
      el.querySelectorAll('.swiper-slide-shadow').forEach(shadowEl => {
        shadowEl.style.transitionDuration = `${duration}ms`;
      });
    });
    (0,_shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_3__.e)({
      swiper,
      duration,
      transformElements,
      allSlides: true
    });
  };
  (0,_shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__.e)({
    effect: 'creative',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => swiper.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: true,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}




/***/ }),

/***/ "./node_modules/swiper/modules/effect-cube.mjs":
/*!*****************************************************!*\
  !*** ./node_modules/swiper/modules/effect-cube.mjs ***!
  \*****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EffectCube)
/* harmony export */ });
/* harmony import */ var _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/effect-init.mjs */ "./node_modules/swiper/shared/effect-init.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs");



function EffectCube(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    cubeEffect: {
      slideShadows: true,
      shadow: true,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  });
  const createSlideShadows = (slideEl, progress, isHorizontal) => {
    let shadowBefore = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
    let shadowAfter = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
    if (!shadowBefore) {
      shadowBefore = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}`.split(' '));
      slideEl.append(shadowBefore);
    }
    if (!shadowAfter) {
      shadowAfter = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}`.split(' '));
      slideEl.append(shadowAfter);
    }
    if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
    if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
  };
  const recreateShadows = () => {
    // create new ones
    const isHorizontal = swiper.isHorizontal();
    swiper.slides.forEach(slideEl => {
      const progress = Math.max(Math.min(slideEl.progress, 1), -1);
      createSlideShadows(slideEl, progress, isHorizontal);
    });
  };
  const setTranslate = () => {
    const {
      el,
      wrapperEl,
      slides,
      width: swiperWidth,
      height: swiperHeight,
      rtlTranslate: rtl,
      size: swiperSize,
      browser
    } = swiper;
    const r = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.p)(swiper);
    const params = swiper.params.cubeEffect;
    const isHorizontal = swiper.isHorizontal();
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let wrapperRotate = 0;
    let cubeShadowEl;
    if (params.shadow) {
      if (isHorizontal) {
        cubeShadowEl = swiper.wrapperEl.querySelector('.swiper-cube-shadow');
        if (!cubeShadowEl) {
          cubeShadowEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)('div', 'swiper-cube-shadow');
          swiper.wrapperEl.append(cubeShadowEl);
        }
        cubeShadowEl.style.height = `${swiperWidth}px`;
      } else {
        cubeShadowEl = el.querySelector('.swiper-cube-shadow');
        if (!cubeShadowEl) {
          cubeShadowEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)('div', 'swiper-cube-shadow');
          el.append(cubeShadowEl);
        }
      }
    }
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i];
      let slideIndex = i;
      if (isVirtual) {
        slideIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10);
      }
      let slideAngle = slideIndex * 90;
      let round = Math.floor(slideAngle / 360);
      if (rtl) {
        slideAngle = -slideAngle;
        round = Math.floor(-slideAngle / 360);
      }
      const progress = Math.max(Math.min(slideEl.progress, 1), -1);
      let tx = 0;
      let ty = 0;
      let tz = 0;
      if (slideIndex % 4 === 0) {
        tx = -round * 4 * swiperSize;
        tz = 0;
      } else if ((slideIndex - 1) % 4 === 0) {
        tx = 0;
        tz = -round * 4 * swiperSize;
      } else if ((slideIndex - 2) % 4 === 0) {
        tx = swiperSize + round * 4 * swiperSize;
        tz = swiperSize;
      } else if ((slideIndex - 3) % 4 === 0) {
        tx = -swiperSize;
        tz = 3 * swiperSize + swiperSize * 4 * round;
      }
      if (rtl) {
        tx = -tx;
      }
      if (!isHorizontal) {
        ty = tx;
        tx = 0;
      }
      const transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
      if (progress <= 1 && progress > -1) {
        wrapperRotate = slideIndex * 90 + progress * 90;
        if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
      }
      slideEl.style.transform = transform;
      if (params.slideShadows) {
        createSlideShadows(slideEl, progress, isHorizontal);
      }
    }
    wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
    wrapperEl.style['-webkit-transform-origin'] = `50% 50% -${swiperSize / 2}px`;
    if (params.shadow) {
      if (isHorizontal) {
        cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
      } else {
        const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
        const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
        const scale1 = params.shadowScale;
        const scale2 = params.shadowScale / multiplier;
        const offset = params.shadowOffset;
        cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
      }
    }
    const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
    wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
    wrapperEl.style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
  };
  const setTransition = duration => {
    const {
      el,
      slides
    } = swiper;
    slides.forEach(slideEl => {
      slideEl.style.transitionDuration = `${duration}ms`;
      slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(subEl => {
        subEl.style.transitionDuration = `${duration}ms`;
      });
    });
    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
      const shadowEl = el.querySelector('.swiper-cube-shadow');
      if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
    }
  };
  (0,_shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_0__.e)({
    effect: 'cube',
    swiper,
    on,
    setTranslate,
    setTransition,
    recreateShadows,
    getEffectParams: () => swiper.params.cubeEffect,
    perspective: () => true,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      resistanceRatio: 0,
      spaceBetween: 0,
      centeredSlides: false,
      virtualTranslate: true
    })
  });
}




/***/ }),

/***/ "./node_modules/swiper/modules/effect-fade.mjs":
/*!*****************************************************!*\
  !*** ./node_modules/swiper/modules/effect-fade.mjs ***!
  \*****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EffectFade)
/* harmony export */ });
/* harmony import */ var _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/effect-init.mjs */ "./node_modules/swiper/shared/effect-init.mjs");
/* harmony import */ var _shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/effect-target.mjs */ "./node_modules/swiper/shared/effect-target.mjs");
/* harmony import */ var _shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/effect-virtual-transition-end.mjs */ "./node_modules/swiper/shared/effect-virtual-transition-end.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs");





function EffectFade(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    fadeEffect: {
      crossFade: false
    }
  });
  const setTranslate = () => {
    const {
      slides
    } = swiper;
    const params = swiper.params.fadeEffect;
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = swiper.slides[i];
      const offset = slideEl.swiperSlideOffset;
      let tx = -offset;
      if (!swiper.params.virtualTranslate) tx -= swiper.translate;
      let ty = 0;
      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
      }
      const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
      const targetEl = (0,_shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(params, slideEl);
      targetEl.style.opacity = slideOpacity;
      targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
    }
  };
  const setTransition = duration => {
    const transformElements = swiper.slides.map(slideEl => (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_3__.g)(slideEl));
    transformElements.forEach(el => {
      el.style.transitionDuration = `${duration}ms`;
    });
    (0,_shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_2__.e)({
      swiper,
      duration,
      transformElements,
      allSlides: true
    });
  };
  (0,_shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_0__.e)({
    effect: 'fade',
    swiper,
    on,
    setTranslate,
    setTransition,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}




/***/ }),

/***/ "./node_modules/swiper/modules/effect-flip.mjs":
/*!*****************************************************!*\
  !*** ./node_modules/swiper/modules/effect-flip.mjs ***!
  \*****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EffectFlip)
/* harmony export */ });
/* harmony import */ var _shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/create-shadow.mjs */ "./node_modules/swiper/shared/create-shadow.mjs");
/* harmony import */ var _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/effect-init.mjs */ "./node_modules/swiper/shared/effect-init.mjs");
/* harmony import */ var _shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/effect-target.mjs */ "./node_modules/swiper/shared/effect-target.mjs");
/* harmony import */ var _shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../shared/effect-virtual-transition-end.mjs */ "./node_modules/swiper/shared/effect-virtual-transition-end.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs");






function EffectFlip(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    flipEffect: {
      slideShadows: true,
      limitRotation: true
    }
  });
  const createSlideShadows = (slideEl, progress) => {
    let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
    let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
    if (!shadowBefore) {
      shadowBefore = (0,_shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__.c)('flip', slideEl, swiper.isHorizontal() ? 'left' : 'top');
    }
    if (!shadowAfter) {
      shadowAfter = (0,_shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__.c)('flip', slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
    }
    if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
    if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
  };
  const recreateShadows = () => {
    // Set shadows
    swiper.params.flipEffect;
    swiper.slides.forEach(slideEl => {
      let progress = slideEl.progress;
      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min(slideEl.progress, 1), -1);
      }
      createSlideShadows(slideEl, progress);
    });
  };
  const setTranslate = () => {
    const {
      slides,
      rtlTranslate: rtl
    } = swiper;
    const params = swiper.params.flipEffect;
    const rotateFix = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__.p)(swiper);
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i];
      let progress = slideEl.progress;
      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min(slideEl.progress, 1), -1);
      }
      const offset = slideEl.swiperSlideOffset;
      const rotate = -180 * progress;
      let rotateY = rotate;
      let rotateX = 0;
      let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
      let ty = 0;
      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
        rotateX = -rotateY;
        rotateY = 0;
      } else if (rtl) {
        rotateY = -rotateY;
      }
      slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
      if (params.slideShadows) {
        createSlideShadows(slideEl, progress);
      }
      const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
      const targetEl = (0,_shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__.e)(params, slideEl);
      targetEl.style.transform = transform;
    }
  };
  const setTransition = duration => {
    const transformElements = swiper.slides.map(slideEl => (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__.g)(slideEl));
    transformElements.forEach(el => {
      el.style.transitionDuration = `${duration}ms`;
      el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(shadowEl => {
        shadowEl.style.transitionDuration = `${duration}ms`;
      });
    });
    (0,_shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_3__.e)({
      swiper,
      duration,
      transformElements
    });
  };
  (0,_shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__.e)({
    effect: 'flip',
    swiper,
    on,
    setTranslate,
    setTransition,
    recreateShadows,
    getEffectParams: () => swiper.params.flipEffect,
    perspective: () => true,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}




/***/ }),

/***/ "./node_modules/swiper/modules/free-mode.mjs":
/*!***************************************************!*\
  !*** ./node_modules/swiper/modules/free-mode.mjs ***!
  \***************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ freeMode)
/* harmony export */ });
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs");


function freeMode(_ref) {
  let {
    swiper,
    extendParams,
    emit,
    once
  } = _ref;
  extendParams({
    freeMode: {
      enabled: false,
      momentum: true,
      momentumRatio: 1,
      momentumBounce: true,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: false,
      minimumVelocity: 0.02
    }
  });
  function onTouchStart() {
    if (swiper.params.cssMode) return;
    const translate = swiper.getTranslate();
    swiper.setTranslate(translate);
    swiper.setTransition(0);
    swiper.touchEventsData.velocities.length = 0;
    swiper.freeMode.onTouchEnd({
      currentPos: swiper.rtl ? swiper.translate : -swiper.translate
    });
  }
  function onTouchMove() {
    if (swiper.params.cssMode) return;
    const {
      touchEventsData: data,
      touches
    } = swiper;
    // Velocity
    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }
    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.f)()
    });
  }
  function onTouchEnd(_ref2) {
    let {
      currentPos
    } = _ref2;
    if (swiper.params.cssMode) return;
    const {
      params,
      wrapperEl,
      rtlTranslate: rtl,
      snapGrid,
      touchEventsData: data
    } = swiper;
    // Time diff
    const touchEndTime = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.f)();
    const timeDiff = touchEndTime - data.touchStartTime;
    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }
      return;
    }
    if (params.freeMode.momentum) {
      if (data.velocities.length > 1) {
        const lastMoveEvent = data.velocities.pop();
        const velocityEvent = data.velocities.pop();
        const distance = lastMoveEvent.position - velocityEvent.position;
        const time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;
        if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) {
          swiper.velocity = 0;
        }
        // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.
        if (time > 150 || (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.f)() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }
      swiper.velocity *= params.freeMode.momentumVelocityRatio;
      data.velocities.length = 0;
      let momentumDuration = 1000 * params.freeMode.momentumRatio;
      const momentumDistance = swiper.velocity * momentumDuration;
      let newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;
      let doBounce = false;
      let afterBouncePosition;
      const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
      let needsLoopFix;
      if (newPosition < swiper.maxTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }
          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }
        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }
          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }
        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeMode.sticky) {
        let nextSlide;
        for (let j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }
        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }
        newPosition = -newPosition;
      }
      if (needsLoopFix) {
        once('transitionEnd', () => {
          swiper.loopFix();
        });
      }
      // Fix duration
      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }
        if (params.freeMode.sticky) {
          // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
          // It's easy to see this when simulating touch with mouse events. To fix this,
          // limit single-slide swipes to the default slide duration. This also has the
          // nice side effect of matching slide speed if the user stopped moving before
          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
          // For faster swipes, also apply limits (albeit higher ones).
          const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeMode.sticky) {
        swiper.slideToClosest();
        return;
      }
      if (params.freeMode.momentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.l)(wrapperEl, () => {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          emit('momentumBounce');
          swiper.setTransition(params.speed);
          setTimeout(() => {
            swiper.setTranslate(afterBouncePosition);
            (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.l)(wrapperEl, () => {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        emit('_freeModeNoMomentumRelease');
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        if (!swiper.animating) {
          swiper.animating = true;
          (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.l)(wrapperEl, () => {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.updateProgress(newPosition);
      }
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeMode.sticky) {
      swiper.slideToClosest();
      return;
    } else if (params.freeMode) {
      emit('_freeModeNoMomentumRelease');
    }
    if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
      emit('_freeModeStaticRelease');
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
  }
  Object.assign(swiper, {
    freeMode: {
      onTouchStart,
      onTouchMove,
      onTouchEnd
    }
  });
}




/***/ }),

/***/ "./node_modules/swiper/modules/grid.mjs":
/*!**********************************************!*\
  !*** ./node_modules/swiper/modules/grid.mjs ***!
  \**********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Grid)
/* harmony export */ });
function Grid(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    grid: {
      rows: 1,
      fill: 'column'
    }
  });
  let slidesNumberEvenToRows;
  let slidesPerRow;
  let numFullColumns;
  let wasMultiRow;
  const getSpaceBetween = () => {
    let spaceBetween = swiper.params.spaceBetween;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
      spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
    } else if (typeof spaceBetween === 'string') {
      spaceBetween = parseFloat(spaceBetween);
    }
    return spaceBetween;
  };
  const initSlides = slides => {
    const {
      slidesPerView
    } = swiper.params;
    const {
      rows,
      fill
    } = swiper.params.grid;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
    numFullColumns = Math.floor(slidesLength / rows);
    if (Math.floor(slidesLength / rows) === slidesLength / rows) {
      slidesNumberEvenToRows = slidesLength;
    } else {
      slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
    }
    if (slidesPerView !== 'auto' && fill === 'row') {
      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
    }
    slidesPerRow = slidesNumberEvenToRows / rows;
  };
  const unsetSlides = () => {
    if (swiper.slides) {
      swiper.slides.forEach(slide => {
        if (slide.swiperSlideGridSet) {
          slide.style.height = '';
          slide.style[swiper.getDirectionLabel('margin-top')] = '';
        }
      });
    }
  };
  const updateSlide = (i, slide, slides) => {
    const {
      slidesPerGroup
    } = swiper.params;
    const spaceBetween = getSpaceBetween();
    const {
      rows,
      fill
    } = swiper.params.grid;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
    // Set slides order
    let newSlideOrderIndex;
    let column;
    let row;
    if (fill === 'row' && slidesPerGroup > 1) {
      const groupIndex = Math.floor(i / (slidesPerGroup * rows));
      const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
      const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
      row = Math.floor(slideIndexInGroup / columnsInGroup);
      column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
      newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
      slide.style.order = newSlideOrderIndex;
    } else if (fill === 'column') {
      column = Math.floor(i / rows);
      row = i - column * rows;
      if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
        row += 1;
        if (row >= rows) {
          row = 0;
          column += 1;
        }
      }
    } else {
      row = Math.floor(i / slidesPerRow);
      column = i - row * slidesPerRow;
    }
    slide.row = row;
    slide.column = column;
    slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
    slide.style[swiper.getDirectionLabel('margin-top')] = row !== 0 ? spaceBetween && `${spaceBetween}px` : '';
    slide.swiperSlideGridSet = true;
  };
  const updateWrapperSize = (slideSize, snapGrid) => {
    const {
      centeredSlides,
      roundLengths
    } = swiper.params;
    const spaceBetween = getSpaceBetween();
    const {
      rows
    } = swiper.params.grid;
    swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
    swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
    if (!swiper.params.cssMode) {
      swiper.wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
    }
    if (centeredSlides) {
      const newSlidesGrid = [];
      for (let i = 0; i < snapGrid.length; i += 1) {
        let slidesGridItem = snapGrid[i];
        if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
        if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
      }
      snapGrid.splice(0, snapGrid.length);
      snapGrid.push(...newSlidesGrid);
    }
  };
  const onInit = () => {
    wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
  };
  const onUpdate = () => {
    const {
      params,
      el
    } = swiper;
    const isMultiRow = params.grid && params.grid.rows > 1;
    if (wasMultiRow && !isMultiRow) {
      el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
      numFullColumns = 1;
      swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
      el.classList.add(`${params.containerModifierClass}grid`);
      if (params.grid.fill === 'column') {
        el.classList.add(`${params.containerModifierClass}grid-column`);
      }
      swiper.emitContainerClasses();
    }
    wasMultiRow = isMultiRow;
  };
  on('init', onInit);
  on('update', onUpdate);
  swiper.grid = {
    initSlides,
    unsetSlides,
    updateSlide,
    updateWrapperSize
  };
}




/***/ }),

/***/ "./node_modules/swiper/modules/hash-navigation.mjs":
/*!*********************************************************!*\
  !*** ./node_modules/swiper/modules/hash-navigation.mjs ***!
  \*********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ HashNavigation)
/* harmony export */ });
/* harmony import */ var _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs");



function HashNavigation(_ref) {
  let {
    swiper,
    extendParams,
    emit,
    on
  } = _ref;
  let initialized = false;
  const document = (0,_shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
  const window = (0,_shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  extendParams({
    hashNavigation: {
      enabled: false,
      replaceState: false,
      watchState: false,
      getSlideIndex(_s, hash) {
        if (swiper.virtual && swiper.params.virtual.enabled) {
          const slideWithHash = swiper.slides.find(slideEl => slideEl.getAttribute('data-hash') === hash);
          if (!slideWithHash) return 0;
          const index = parseInt(slideWithHash.getAttribute('data-swiper-slide-index'), 10);
          return index;
        }
        return swiper.getSlideIndex((0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
      }
    }
  });
  const onHashChange = () => {
    emit('hashChange');
    const newHash = document.location.hash.replace('#', '');
    const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
    const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') : '';
    if (newHash !== activeSlideHash) {
      const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
      if (typeof newIndex === 'undefined' || Number.isNaN(newIndex)) return;
      swiper.slideTo(newIndex);
    }
  };
  const setHash = () => {
    if (!initialized || !swiper.params.hashNavigation.enabled) return;
    const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
    const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') || activeSlideEl.getAttribute('data-history') : '';
    if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
      window.history.replaceState(null, null, `#${activeSlideHash}` || '');
      emit('hashSet');
    } else {
      document.location.hash = activeSlideHash || '';
      emit('hashSet');
    }
  };
  const init = () => {
    if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
    initialized = true;
    const hash = document.location.hash.replace('#', '');
    if (hash) {
      const speed = 0;
      const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
      swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
    }
    if (swiper.params.hashNavigation.watchState) {
      window.addEventListener('hashchange', onHashChange);
    }
  };
  const destroy = () => {
    if (swiper.params.hashNavigation.watchState) {
      window.removeEventListener('hashchange', onHashChange);
    }
  };
  on('init', () => {
    if (swiper.params.hashNavigation.enabled) {
      init();
    }
  });
  on('destroy', () => {
    if (swiper.params.hashNavigation.enabled) {
      destroy();
    }
  });
  on('transitionEnd _freeModeNoMomentumRelease', () => {
    if (initialized) {
      setHash();
    }
  });
  on('slideChange', () => {
    if (initialized && swiper.params.cssMode) {
      setHash();
    }
  });
}




/***/ }),

/***/ "./node_modules/swiper/modules/history.mjs":
/*!*************************************************!*\
  !*** ./node_modules/swiper/modules/history.mjs ***!
  \*************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ History)
/* harmony export */ });
/* harmony import */ var _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs");


function History(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    history: {
      enabled: false,
      root: '',
      replaceState: false,
      key: 'slides',
      keepQuery: false
    }
  });
  let initialized = false;
  let paths = {};
  const slugify = text => {
    return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
  };
  const getPathValues = urlOverride => {
    const window = (0,_shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
    let location;
    if (urlOverride) {
      location = new URL(urlOverride);
    } else {
      location = window.location;
    }
    const pathArray = location.pathname.slice(1).split('/').filter(part => part !== '');
    const total = pathArray.length;
    const key = pathArray[total - 2];
    const value = pathArray[total - 1];
    return {
      key,
      value
    };
  };
  const setHistory = (key, index) => {
    const window = (0,_shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
    if (!initialized || !swiper.params.history.enabled) return;
    let location;
    if (swiper.params.url) {
      location = new URL(swiper.params.url);
    } else {
      location = window.location;
    }
    const slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
    let value = slugify(slide.getAttribute('data-history'));
    if (swiper.params.history.root.length > 0) {
      let root = swiper.params.history.root;
      if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
      value = `${root}/${key ? `${key}/` : ''}${value}`;
    } else if (!location.pathname.includes(key)) {
      value = `${key ? `${key}/` : ''}${value}`;
    }
    if (swiper.params.history.keepQuery) {
      value += location.search;
    }
    const currentState = window.history.state;
    if (currentState && currentState.value === value) {
      return;
    }
    if (swiper.params.history.replaceState) {
      window.history.replaceState({
        value
      }, null, value);
    } else {
      window.history.pushState({
        value
      }, null, value);
    }
  };
  const scrollToSlide = (speed, value, runCallbacks) => {
    if (value) {
      for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
        const slide = swiper.slides[i];
        const slideHistory = slugify(slide.getAttribute('data-history'));
        if (slideHistory === value) {
          const index = swiper.getSlideIndex(slide);
          swiper.slideTo(index, speed, runCallbacks);
        }
      }
    } else {
      swiper.slideTo(0, speed, runCallbacks);
    }
  };
  const setHistoryPopState = () => {
    paths = getPathValues(swiper.params.url);
    scrollToSlide(swiper.params.speed, paths.value, false);
  };
  const init = () => {
    const window = (0,_shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
    if (!swiper.params.history) return;
    if (!window.history || !window.history.pushState) {
      swiper.params.history.enabled = false;
      swiper.params.hashNavigation.enabled = true;
      return;
    }
    initialized = true;
    paths = getPathValues(swiper.params.url);
    if (!paths.key && !paths.value) {
      if (!swiper.params.history.replaceState) {
        window.addEventListener('popstate', setHistoryPopState);
      }
      return;
    }
    scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
    if (!swiper.params.history.replaceState) {
      window.addEventListener('popstate', setHistoryPopState);
    }
  };
  const destroy = () => {
    const window = (0,_shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
    if (!swiper.params.history.replaceState) {
      window.removeEventListener('popstate', setHistoryPopState);
    }
  };
  on('init', () => {
    if (swiper.params.history.enabled) {
      init();
    }
  });
  on('destroy', () => {
    if (swiper.params.history.enabled) {
      destroy();
    }
  });
  on('transitionEnd _freeModeNoMomentumRelease', () => {
    if (initialized) {
      setHistory(swiper.params.history.key, swiper.activeIndex);
    }
  });
  on('slideChange', () => {
    if (initialized && swiper.params.cssMode) {
      setHistory(swiper.params.history.key, swiper.activeIndex);
    }
  });
}




/***/ }),

/***/ "./node_modules/swiper/modules/index.mjs":
/*!***********************************************!*\
  !*** ./node_modules/swiper/modules/index.mjs ***!
  \***********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A11y: () => (/* reexport safe */ _a11y_mjs__WEBPACK_IMPORTED_MODULE_9__["default"]),
/* harmony export */   Autoplay: () => (/* reexport safe */ _autoplay_mjs__WEBPACK_IMPORTED_MODULE_12__["default"]),
/* harmony export */   Controller: () => (/* reexport safe */ _controller_mjs__WEBPACK_IMPORTED_MODULE_8__["default"]),
/* harmony export */   EffectCards: () => (/* reexport safe */ _effect_cards_mjs__WEBPACK_IMPORTED_MODULE_22__["default"]),
/* harmony export */   EffectCoverflow: () => (/* reexport safe */ _effect_coverflow_mjs__WEBPACK_IMPORTED_MODULE_20__["default"]),
/* harmony export */   EffectCreative: () => (/* reexport safe */ _effect_creative_mjs__WEBPACK_IMPORTED_MODULE_21__["default"]),
/* harmony export */   EffectCube: () => (/* reexport safe */ _effect_cube_mjs__WEBPACK_IMPORTED_MODULE_18__["default"]),
/* harmony export */   EffectFade: () => (/* reexport safe */ _effect_fade_mjs__WEBPACK_IMPORTED_MODULE_17__["default"]),
/* harmony export */   EffectFlip: () => (/* reexport safe */ _effect_flip_mjs__WEBPACK_IMPORTED_MODULE_19__["default"]),
/* harmony export */   FreeMode: () => (/* reexport safe */ _free_mode_mjs__WEBPACK_IMPORTED_MODULE_14__["default"]),
/* harmony export */   Grid: () => (/* reexport safe */ _grid_mjs__WEBPACK_IMPORTED_MODULE_15__["default"]),
/* harmony export */   HashNavigation: () => (/* reexport safe */ _hash_navigation_mjs__WEBPACK_IMPORTED_MODULE_11__["default"]),
/* harmony export */   History: () => (/* reexport safe */ _history_mjs__WEBPACK_IMPORTED_MODULE_10__["default"]),
/* harmony export */   Keyboard: () => (/* reexport safe */ _keyboard_mjs__WEBPACK_IMPORTED_MODULE_1__["default"]),
/* harmony export */   Manipulation: () => (/* reexport safe */ _manipulation_mjs__WEBPACK_IMPORTED_MODULE_16__["default"]),
/* harmony export */   Mousewheel: () => (/* reexport safe */ _mousewheel_mjs__WEBPACK_IMPORTED_MODULE_2__["default"]),
/* harmony export */   Navigation: () => (/* reexport safe */ _navigation_mjs__WEBPACK_IMPORTED_MODULE_3__["default"]),
/* harmony export */   Pagination: () => (/* reexport safe */ _pagination_mjs__WEBPACK_IMPORTED_MODULE_4__["default"]),
/* harmony export */   Parallax: () => (/* reexport safe */ _parallax_mjs__WEBPACK_IMPORTED_MODULE_6__["default"]),
/* harmony export */   Scrollbar: () => (/* reexport safe */ _scrollbar_mjs__WEBPACK_IMPORTED_MODULE_5__["default"]),
/* harmony export */   Thumbs: () => (/* reexport safe */ _thumbs_mjs__WEBPACK_IMPORTED_MODULE_13__["default"]),
/* harmony export */   Virtual: () => (/* reexport safe */ _virtual_mjs__WEBPACK_IMPORTED_MODULE_0__["default"]),
/* harmony export */   Zoom: () => (/* reexport safe */ _zoom_mjs__WEBPACK_IMPORTED_MODULE_7__["default"])
/* harmony export */ });
/* harmony import */ var _virtual_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./virtual.mjs */ "./node_modules/swiper/modules/virtual.mjs");
/* harmony import */ var _keyboard_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./keyboard.mjs */ "./node_modules/swiper/modules/keyboard.mjs");
/* harmony import */ var _mousewheel_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mousewheel.mjs */ "./node_modules/swiper/modules/mousewheel.mjs");
/* harmony import */ var _navigation_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./navigation.mjs */ "./node_modules/swiper/modules/navigation.mjs");
/* harmony import */ var _pagination_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./pagination.mjs */ "./node_modules/swiper/modules/pagination.mjs");
/* harmony import */ var _scrollbar_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./scrollbar.mjs */ "./node_modules/swiper/modules/scrollbar.mjs");
/* harmony import */ var _parallax_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./parallax.mjs */ "./node_modules/swiper/modules/parallax.mjs");
/* harmony import */ var _zoom_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./zoom.mjs */ "./node_modules/swiper/modules/zoom.mjs");
/* harmony import */ var _controller_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./controller.mjs */ "./node_modules/swiper/modules/controller.mjs");
/* harmony import */ var _a11y_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./a11y.mjs */ "./node_modules/swiper/modules/a11y.mjs");
/* harmony import */ var _history_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./history.mjs */ "./node_modules/swiper/modules/history.mjs");
/* harmony import */ var _hash_navigation_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./hash-navigation.mjs */ "./node_modules/swiper/modules/hash-navigation.mjs");
/* harmony import */ var _autoplay_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./autoplay.mjs */ "./node_modules/swiper/modules/autoplay.mjs");
/* harmony import */ var _thumbs_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./thumbs.mjs */ "./node_modules/swiper/modules/thumbs.mjs");
/* harmony import */ var _free_mode_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./free-mode.mjs */ "./node_modules/swiper/modules/free-mode.mjs");
/* harmony import */ var _grid_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./grid.mjs */ "./node_modules/swiper/modules/grid.mjs");
/* harmony import */ var _manipulation_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./manipulation.mjs */ "./node_modules/swiper/modules/manipulation.mjs");
/* harmony import */ var _effect_fade_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./effect-fade.mjs */ "./node_modules/swiper/modules/effect-fade.mjs");
/* harmony import */ var _effect_cube_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./effect-cube.mjs */ "./node_modules/swiper/modules/effect-cube.mjs");
/* harmony import */ var _effect_flip_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./effect-flip.mjs */ "./node_modules/swiper/modules/effect-flip.mjs");
/* harmony import */ var _effect_coverflow_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./effect-coverflow.mjs */ "./node_modules/swiper/modules/effect-coverflow.mjs");
/* harmony import */ var _effect_creative_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./effect-creative.mjs */ "./node_modules/swiper/modules/effect-creative.mjs");
/* harmony import */ var _effect_cards_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./effect-cards.mjs */ "./node_modules/swiper/modules/effect-cards.mjs");
























/***/ }),

/***/ "./node_modules/swiper/modules/keyboard.mjs":
/*!**************************************************!*\
  !*** ./node_modules/swiper/modules/keyboard.mjs ***!
  \**************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Keyboard)
/* harmony export */ });
/* harmony import */ var _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs");



/* eslint-disable consistent-return */
function Keyboard(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const document = (0,_shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
  const window = (0,_shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  swiper.keyboard = {
    enabled: false
  };
  extendParams({
    keyboard: {
      enabled: false,
      onlyInViewport: true,
      pageUpDown: true
    }
  });
  function handle(event) {
    if (!swiper.enabled) return;
    const {
      rtlTranslate: rtl
    } = swiper;
    let e = event;
    if (e.originalEvent) e = e.originalEvent; // jquery fix
    const kc = e.keyCode || e.charCode;
    const pageUpDown = swiper.params.keyboard.pageUpDown;
    const isPageUp = pageUpDown && kc === 33;
    const isPageDown = pageUpDown && kc === 34;
    const isArrowLeft = kc === 37;
    const isArrowRight = kc === 39;
    const isArrowUp = kc === 38;
    const isArrowDown = kc === 40;
    // Directions locks
    if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) {
      return false;
    }
    if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) {
      return false;
    }
    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
      return undefined;
    }
    if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
      return undefined;
    }
    if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
      let inView = false;
      // Check that swiper should be inside of visible area of window
      if ((0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.b)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.b)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) {
        return undefined;
      }
      const el = swiper.el;
      const swiperWidth = el.clientWidth;
      const swiperHeight = el.clientHeight;
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const swiperOffset = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.d)(el);
      if (rtl) swiperOffset.left -= el.scrollLeft;
      const swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiperWidth, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiperHeight], [swiperOffset.left + swiperWidth, swiperOffset.top + swiperHeight]];
      for (let i = 0; i < swiperCoord.length; i += 1) {
        const point = swiperCoord[i];
        if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
          if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
          inView = true;
        }
      }
      if (!inView) return undefined;
    }
    if (swiper.isHorizontal()) {
      if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }
      if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
      if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
    } else {
      if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }
      if (isPageDown || isArrowDown) swiper.slideNext();
      if (isPageUp || isArrowUp) swiper.slidePrev();
    }
    emit('keyPress', kc);
    return undefined;
  }
  function enable() {
    if (swiper.keyboard.enabled) return;
    document.addEventListener('keydown', handle);
    swiper.keyboard.enabled = true;
  }
  function disable() {
    if (!swiper.keyboard.enabled) return;
    document.removeEventListener('keydown', handle);
    swiper.keyboard.enabled = false;
  }
  on('init', () => {
    if (swiper.params.keyboard.enabled) {
      enable();
    }
  });
  on('destroy', () => {
    if (swiper.keyboard.enabled) {
      disable();
    }
  });
  Object.assign(swiper.keyboard, {
    enable,
    disable
  });
}




/***/ }),

/***/ "./node_modules/swiper/modules/manipulation.mjs":
/*!******************************************************!*\
  !*** ./node_modules/swiper/modules/manipulation.mjs ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Manipulation)
/* harmony export */ });
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs");


function appendSlide(slides) {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  if (params.loop) {
    swiper.loopDestroy();
  }
  const appendElement = slideEl => {
    if (typeof slideEl === 'string') {
      const tempDOM = document.createElement('div');
      (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.s)(tempDOM, slideEl);
      slidesEl.append(tempDOM.children[0]);
      (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.s)(tempDOM, '');
    } else {
      slidesEl.append(slideEl);
    }
  };
  if (typeof slides === 'object' && 'length' in slides) {
    for (let i = 0; i < slides.length; i += 1) {
      if (slides[i]) appendElement(slides[i]);
    }
  } else {
    appendElement(slides);
  }
  swiper.recalcSlides();
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!params.observer || swiper.isElement) {
    swiper.update();
  }
}

function prependSlide(slides) {
  const swiper = this;
  const {
    params,
    activeIndex,
    slidesEl
  } = swiper;
  if (params.loop) {
    swiper.loopDestroy();
  }
  let newActiveIndex = activeIndex + 1;
  const prependElement = slideEl => {
    if (typeof slideEl === 'string') {
      const tempDOM = document.createElement('div');
      (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.s)(tempDOM, slideEl);
      slidesEl.prepend(tempDOM.children[0]);
      (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.s)(tempDOM, '');
    } else {
      slidesEl.prepend(slideEl);
    }
  };
  if (typeof slides === 'object' && 'length' in slides) {
    for (let i = 0; i < slides.length; i += 1) {
      if (slides[i]) prependElement(slides[i]);
    }
    newActiveIndex = activeIndex + slides.length;
  } else {
    prependElement(slides);
  }
  swiper.recalcSlides();
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!params.observer || swiper.isElement) {
    swiper.update();
  }
  swiper.slideTo(newActiveIndex, 0, false);
}

function addSlide(index, slides) {
  const swiper = this;
  const {
    params,
    activeIndex,
    slidesEl
  } = swiper;
  let activeIndexBuffer = activeIndex;
  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.recalcSlides();
  }
  const baseLength = swiper.slides.length;
  if (index <= 0) {
    swiper.prependSlide(slides);
    return;
  }
  if (index >= baseLength) {
    swiper.appendSlide(slides);
    return;
  }
  let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
  const slidesBuffer = [];
  for (let i = baseLength - 1; i >= index; i -= 1) {
    const currentSlide = swiper.slides[i];
    currentSlide.remove();
    slidesBuffer.unshift(currentSlide);
  }
  if (typeof slides === 'object' && 'length' in slides) {
    for (let i = 0; i < slides.length; i += 1) {
      if (slides[i]) slidesEl.append(slides[i]);
    }
    newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
  } else {
    slidesEl.append(slides);
  }
  for (let i = 0; i < slidesBuffer.length; i += 1) {
    slidesEl.append(slidesBuffer[i]);
  }
  swiper.recalcSlides();
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!params.observer || swiper.isElement) {
    swiper.update();
  }
  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeSlide(slidesIndexes) {
  const swiper = this;
  const {
    params,
    activeIndex
  } = swiper;
  let activeIndexBuffer = activeIndex;
  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
  }
  let newActiveIndex = activeIndexBuffer;
  let indexToRemove;
  if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
    for (let i = 0; i < slidesIndexes.length; i += 1) {
      indexToRemove = slidesIndexes[i];
      if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    }
    newActiveIndex = Math.max(newActiveIndex, 0);
  } else {
    indexToRemove = slidesIndexes;
    if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    newActiveIndex = Math.max(newActiveIndex, 0);
  }
  swiper.recalcSlides();
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!params.observer || swiper.isElement) {
    swiper.update();
  }
  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeAllSlides() {
  const swiper = this;
  const slidesIndexes = [];
  for (let i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }
  swiper.removeSlide(slidesIndexes);
}

function Manipulation(_ref) {
  let {
    swiper
  } = _ref;
  Object.assign(swiper, {
    appendSlide: appendSlide.bind(swiper),
    prependSlide: prependSlide.bind(swiper),
    addSlide: addSlide.bind(swiper),
    removeSlide: removeSlide.bind(swiper),
    removeAllSlides: removeAllSlides.bind(swiper)
  });
}




/***/ }),

/***/ "./node_modules/swiper/modules/mousewheel.mjs":
/*!****************************************************!*\
  !*** ./node_modules/swiper/modules/mousewheel.mjs ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Mousewheel)
/* harmony export */ });
/* harmony import */ var _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs");



/* eslint-disable consistent-return */
function Mousewheel(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const window = (0,_shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  extendParams({
    mousewheel: {
      enabled: false,
      releaseOnEdges: false,
      invert: false,
      forceToAxis: false,
      sensitivity: 1,
      eventsTarget: 'container',
      thresholdDelta: null,
      thresholdTime: null,
      noMousewheelClass: 'swiper-no-mousewheel'
    }
  });
  swiper.mousewheel = {
    enabled: false
  };
  let timeout;
  let lastScrollTime = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.f)();
  let lastEventBeforeSnap;
  const recentWheelEvents = [];
  function normalize(e) {
    // Reasonable defaults
    const PIXEL_STEP = 10;
    const LINE_HEIGHT = 40;
    const PAGE_HEIGHT = 800;
    let sX = 0;
    let sY = 0; // spinX, spinY
    let pX = 0;
    let pY = 0; // pixelX, pixelY

    // Legacy
    if ('detail' in e) {
      sY = e.detail;
    }
    if ('wheelDelta' in e) {
      sY = -e.wheelDelta / 120;
    }
    if ('wheelDeltaY' in e) {
      sY = -e.wheelDeltaY / 120;
    }
    if ('wheelDeltaX' in e) {
      sX = -e.wheelDeltaX / 120;
    }

    // side scrolling on FF with DOMMouseScroll
    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
      sX = sY;
      sY = 0;
    }
    pX = sX * PIXEL_STEP;
    pY = sY * PIXEL_STEP;
    if ('deltaY' in e) {
      pY = e.deltaY;
    }
    if ('deltaX' in e) {
      pX = e.deltaX;
    }
    if (e.shiftKey && !pX) {
      // if user scrolls with shift he wants horizontal scroll
      pX = pY;
      pY = 0;
    }
    if ((pX || pY) && e.deltaMode) {
      if (e.deltaMode === 1) {
        // delta in LINE units
        pX *= LINE_HEIGHT;
        pY *= LINE_HEIGHT;
      } else {
        // delta in PAGE units
        pX *= PAGE_HEIGHT;
        pY *= PAGE_HEIGHT;
      }
    }

    // Fall-back if spin cannot be determined
    if (pX && !sX) {
      sX = pX < 1 ? -1 : 1;
    }
    if (pY && !sY) {
      sY = pY < 1 ? -1 : 1;
    }
    return {
      spinX: sX,
      spinY: sY,
      pixelX: pX,
      pixelY: pY
    };
  }
  function handleMouseEnter() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = true;
  }
  function handleMouseLeave() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = false;
  }
  function animateSlider(newEvent) {
    if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) {
      // Prevent if delta of wheel scroll delta is below configured threshold
      return false;
    }
    if (swiper.params.mousewheel.thresholdTime && (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.f)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) {
      // Prevent if time between scrolls is below configured threshold
      return false;
    }

    // If the movement is NOT big enough and
    // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
    //   Don't go any further (avoid insignificant scroll movement).
    if (newEvent.delta >= 6 && (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.f)() - lastScrollTime < 60) {
      // Return false as a default
      return true;
    }
    // If user is scrolling towards the end:
    //   If the slider hasn't hit the latest slide or
    //   if the slider is a loop and
    //   if the slider isn't moving right now:
    //     Go to next slide and
    //     emit a scroll event.
    // Else (the user is scrolling towards the beginning) and
    // if the slider hasn't hit the first slide or
    // if the slider is a loop and
    // if the slider isn't moving right now:
    //   Go to prev slide and
    //   emit a scroll event.
    if (newEvent.direction < 0) {
      if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
        swiper.slideNext();
        emit('scroll', newEvent.raw);
      }
    } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
      swiper.slidePrev();
      emit('scroll', newEvent.raw);
    }
    // If you got here is because an animation has been triggered so store the current time
    lastScrollTime = new window.Date().getTime();
    // Return false as a default
    return false;
  }
  function releaseScroll(newEvent) {
    const params = swiper.params.mousewheel;
    if (newEvent.direction < 0) {
      if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
        // Return true to animate scroll on edges
        return true;
      }
    } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
      // Return true to animate scroll on edges
      return true;
    }
    return false;
  }
  function handle(event) {
    let e = event;
    let disableParentSwiper = true;
    if (!swiper.enabled) return;

    // Ignore event if the target or its parents have the swiper-no-mousewheel class
    if (event.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
    const params = swiper.params.mousewheel;
    if (swiper.params.cssMode) {
      e.preventDefault();
    }
    let targetEl = swiper.el;
    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
    }
    const targetElContainsTarget = targetEl && targetEl.contains(e.target);
    if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
    if (e.originalEvent) e = e.originalEvent; // jquery fix
    let delta = 0;
    const rtlFactor = swiper.rtlTranslate ? -1 : 1;
    const data = normalize(e);
    if (params.forceToAxis) {
      if (swiper.isHorizontal()) {
        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;else return true;
      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;else return true;
    } else {
      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
    }
    if (delta === 0) return true;
    if (params.invert) delta = -delta;

    // Get the scroll positions
    let positions = swiper.getTranslate() + delta * params.sensitivity;
    if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
    if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();

    // When loop is true:
    //     the disableParentSwiper will be true.
    // When loop is false:
    //     if the scroll positions is not on edge,
    //     then the disableParentSwiper will be true.
    //     if the scroll on edge positions,
    //     then the disableParentSwiper will be false.
    disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
    if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
    if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
      // Register the new event in a variable which stores the relevant data
      const newEvent = {
        time: (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.f)(),
        delta: Math.abs(delta),
        direction: Math.sign(delta),
        raw: event
      };

      // Keep the most recent events
      if (recentWheelEvents.length >= 2) {
        recentWheelEvents.shift(); // only store the last N events
      }

      const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
      recentWheelEvents.push(newEvent);

      // If there is at least one previous recorded event:
      //   If direction has changed or
      //   if the scroll is quicker than the previous one:
      //     Animate the slider.
      // Else (this is the first time the wheel is moved):
      //     Animate the slider.
      if (prevEvent) {
        if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
          animateSlider(newEvent);
        }
      } else {
        animateSlider(newEvent);
      }

      // If it's time to release the scroll:
      //   Return now so you don't hit the preventDefault.
      if (releaseScroll(newEvent)) {
        return true;
      }
    } else {
      // Freemode or scrollContainer:

      // If we recently snapped after a momentum scroll, then ignore wheel events
      // to give time for the deceleration to finish. Stop ignoring after 500 msecs
      // or if it's a new scroll (larger delta or inverse sign as last event before
      // an end-of-momentum snap).
      const newEvent = {
        time: (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.f)(),
        delta: Math.abs(delta),
        direction: Math.sign(delta)
      };
      const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
      if (!ignoreWheelEvents) {
        lastEventBeforeSnap = undefined;
        let position = swiper.getTranslate() + delta * params.sensitivity;
        const wasBeginning = swiper.isBeginning;
        const wasEnd = swiper.isEnd;
        if (position >= swiper.minTranslate()) position = swiper.minTranslate();
        if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
        if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
          swiper.updateSlidesClasses();
        }
        if (swiper.params.loop) {
          swiper.loopFix({
            direction: newEvent.direction < 0 ? 'next' : 'prev',
            byMousewheel: true
          });
        }
        if (swiper.params.freeMode.sticky) {
          // When wheel scrolling starts with sticky (aka snap) enabled, then detect
          // the end of a momentum scroll by storing recent (N=15?) wheel events.
          // 1. do all N events have decreasing or same (absolute value) delta?
          // 2. did all N events arrive in the last M (M=500?) msecs?
          // 3. does the earliest event have an (absolute value) delta that's
          //    at least P (P=1?) larger than the most recent event's delta?
          // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
          // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
          // Snap immediately and ignore remaining wheel events in this scroll.
          // See comment above for "remaining wheel events in this scroll" determination.
          // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
          clearTimeout(timeout);
          timeout = undefined;
          if (recentWheelEvents.length >= 15) {
            recentWheelEvents.shift(); // only store the last N events
          }

          const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
          const firstEvent = recentWheelEvents[0];
          recentWheelEvents.push(newEvent);
          if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) {
            // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
            recentWheelEvents.splice(0);
          } else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
            // We're at the end of the deceleration of a momentum scroll, so there's no need
            // to wait for more events. Snap ASAP on the next tick.
            // Also, because there's some remaining momentum we'll bias the snap in the
            // direction of the ongoing scroll because it's better UX for the scroll to snap
            // in the same direction as the scroll instead of reversing to snap.  Therefore,
            // if it's already scrolled more than 20% in the current direction, keep going.
            const snapToThreshold = delta > 0 ? 0.8 : 0.2;
            lastEventBeforeSnap = newEvent;
            recentWheelEvents.splice(0);
            timeout = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.n)(() => {
              if (swiper.destroyed || !swiper.params) return;
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 0); // no delay; move on next tick
          }

          if (!timeout) {
            // if we get here, then we haven't detected the end of a momentum scroll, so
            // we'll consider a scroll "complete" when there haven't been any wheel events
            // for 500ms.
            timeout = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.n)(() => {
              if (swiper.destroyed || !swiper.params) return;
              const snapToThreshold = 0.5;
              lastEventBeforeSnap = newEvent;
              recentWheelEvents.splice(0);
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 500);
          }
        }

        // Emit event
        if (!ignoreWheelEvents) emit('scroll', e);

        // Stop autoplay
        if (swiper.params.autoplay && swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
        // Return page scroll on edge positions
        if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) {
          return true;
        }
      }
    }
    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    return false;
  }
  function events(method) {
    let targetEl = swiper.el;
    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
    }
    targetEl[method]('mouseenter', handleMouseEnter);
    targetEl[method]('mouseleave', handleMouseLeave);
    targetEl[method]('wheel', handle);
  }
  function enable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.removeEventListener('wheel', handle);
      return true;
    }
    if (swiper.mousewheel.enabled) return false;
    events('addEventListener');
    swiper.mousewheel.enabled = true;
    return true;
  }
  function disable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.addEventListener(event, handle);
      return true;
    }
    if (!swiper.mousewheel.enabled) return false;
    events('removeEventListener');
    swiper.mousewheel.enabled = false;
    return true;
  }
  on('init', () => {
    if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
      disable();
    }
    if (swiper.params.mousewheel.enabled) enable();
  });
  on('destroy', () => {
    if (swiper.params.cssMode) {
      enable();
    }
    if (swiper.mousewheel.enabled) disable();
  });
  Object.assign(swiper.mousewheel, {
    enable,
    disable
  });
}




/***/ }),

/***/ "./node_modules/swiper/modules/navigation.mjs":
/*!****************************************************!*\
  !*** ./node_modules/swiper/modules/navigation.mjs ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Navigation)
/* harmony export */ });
/* harmony import */ var _shared_create_element_if_not_defined_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/create-element-if-not-defined.mjs */ "./node_modules/swiper/shared/create-element-if-not-defined.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs");



function Navigation(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  extendParams({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock',
      navigationDisabledClass: 'swiper-navigation-disabled'
    }
  });
  swiper.navigation = {
    nextEl: null,
    prevEl: null
  };
  function getEl(el) {
    let res;
    if (el && typeof el === 'string' && swiper.isElement) {
      res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
      if (res) return res;
    }
    if (el) {
      if (typeof el === 'string') res = [...document.querySelectorAll(el)];
      if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) {
        res = swiper.el.querySelector(el);
      } else if (res && res.length === 1) {
        res = res[0];
      }
    }
    if (el && !res) return el;
    // if (Array.isArray(res) && res.length === 1) res = res[0];
    return res;
  }
  function toggleEl(el, disabled) {
    const params = swiper.params.navigation;
    el = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.m)(el);
    el.forEach(subEl => {
      if (subEl) {
        subEl.classList[disabled ? 'add' : 'remove'](...params.disabledClass.split(' '));
        if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
        if (swiper.params.watchOverflow && swiper.enabled) {
          subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        }
      }
    });
  }
  function update() {
    // Update Navigation Buttons
    const {
      nextEl,
      prevEl
    } = swiper.navigation;
    if (swiper.params.loop) {
      toggleEl(prevEl, false);
      toggleEl(nextEl, false);
      return;
    }
    toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
    toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
  }
  function onPrevClick(e) {
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slidePrev();
    emit('navigationPrev');
  }
  function onNextClick(e) {
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slideNext();
    emit('navigationNext');
  }
  function init() {
    const params = swiper.params.navigation;
    swiper.params.navigation = (0,_shared_create_element_if_not_defined_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
      nextEl: 'swiper-button-next',
      prevEl: 'swiper-button-prev'
    });
    if (!(params.nextEl || params.prevEl)) return;
    let nextEl = getEl(params.nextEl);
    let prevEl = getEl(params.prevEl);
    Object.assign(swiper.navigation, {
      nextEl,
      prevEl
    });
    nextEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.m)(nextEl);
    prevEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.m)(prevEl);
    const initButton = (el, dir) => {
      if (el) {
        el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
      }
      if (!swiper.enabled && el) {
        el.classList.add(...params.lockClass.split(' '));
      }
    };
    nextEl.forEach(el => initButton(el, 'next'));
    prevEl.forEach(el => initButton(el, 'prev'));
  }
  function destroy() {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.m)(nextEl);
    prevEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.m)(prevEl);
    const destroyButton = (el, dir) => {
      el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
      el.classList.remove(...swiper.params.navigation.disabledClass.split(' '));
    };
    nextEl.forEach(el => destroyButton(el, 'next'));
    prevEl.forEach(el => destroyButton(el, 'prev'));
  }
  on('init', () => {
    if (swiper.params.navigation.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      update();
    }
  });
  on('toEdge fromEdge lock unlock', () => {
    update();
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.m)(nextEl);
    prevEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.m)(prevEl);
    if (swiper.enabled) {
      update();
      return;
    }
    [...nextEl, ...prevEl].filter(el => !!el).forEach(el => el.classList.add(swiper.params.navigation.lockClass));
  });
  on('click', (_s, e) => {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.m)(nextEl);
    prevEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.m)(prevEl);
    const targetEl = e.target;
    let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
    if (swiper.isElement && !targetIsButton) {
      const path = e.path || e.composedPath && e.composedPath();
      if (path) {
        targetIsButton = path.find(pathEl => nextEl.includes(pathEl) || prevEl.includes(pathEl));
      }
    }
    if (swiper.params.navigation.hideOnClick && !targetIsButton) {
      if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
      let isHidden;
      if (nextEl.length) {
        isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
      } else if (prevEl.length) {
        isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
      }
      if (isHidden === true) {
        emit('navigationShow');
      } else {
        emit('navigationHide');
      }
      [...nextEl, ...prevEl].filter(el => !!el).forEach(el => el.classList.toggle(swiper.params.navigation.hiddenClass));
    }
  });
  const enable = () => {
    swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(' '));
    init();
    update();
  };
  const disable = () => {
    swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(' '));
    destroy();
  };
  Object.assign(swiper.navigation, {
    enable,
    disable,
    update,
    init,
    destroy
  });
}




/***/ }),

/***/ "./node_modules/swiper/modules/pagination.mjs":
/*!****************************************************!*\
  !*** ./node_modules/swiper/modules/pagination.mjs ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Pagination)
/* harmony export */ });
/* harmony import */ var _shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/classes-to-selector.mjs */ "./node_modules/swiper/shared/classes-to-selector.mjs");
/* harmony import */ var _shared_create_element_if_not_defined_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/create-element-if-not-defined.mjs */ "./node_modules/swiper/shared/create-element-if-not-defined.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs");




function Pagination(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const pfx = 'swiper-pagination';
  extendParams({
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: number => number,
      formatFractionTotal: number => number,
      bulletClass: `${pfx}-bullet`,
      bulletActiveClass: `${pfx}-bullet-active`,
      modifierClass: `${pfx}-`,
      currentClass: `${pfx}-current`,
      totalClass: `${pfx}-total`,
      hiddenClass: `${pfx}-hidden`,
      progressbarFillClass: `${pfx}-progressbar-fill`,
      progressbarOppositeClass: `${pfx}-progressbar-opposite`,
      clickableClass: `${pfx}-clickable`,
      lockClass: `${pfx}-lock`,
      horizontalClass: `${pfx}-horizontal`,
      verticalClass: `${pfx}-vertical`,
      paginationDisabledClass: `${pfx}-disabled`
    }
  });
  swiper.pagination = {
    el: null,
    bullets: []
  };
  let bulletSize;
  let dynamicBulletIndex = 0;
  function isPaginationDisabled() {
    return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
  }
  function setSideBullets(bulletEl, position) {
    const {
      bulletActiveClass
    } = swiper.params.pagination;
    if (!bulletEl) return;
    bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
    if (bulletEl) {
      bulletEl.classList.add(`${bulletActiveClass}-${position}`);
      bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
      if (bulletEl) {
        bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
      }
    }
  }
  function getMoveDirection(prevIndex, nextIndex, length) {
    prevIndex = prevIndex % length;
    nextIndex = nextIndex % length;
    if (nextIndex === prevIndex + 1) {
      return 'next';
    } else if (nextIndex === prevIndex - 1) {
      return 'previous';
    }
    return;
  }
  function onBulletClick(e) {
    const bulletEl = e.target.closest((0,_shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(swiper.params.pagination.bulletClass));
    if (!bulletEl) {
      return;
    }
    e.preventDefault();
    const index = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.i)(bulletEl) * swiper.params.slidesPerGroup;
    if (swiper.params.loop) {
      if (swiper.realIndex === index) return;
      const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
      if (moveDirection === 'next') {
        swiper.slideNext();
      } else if (moveDirection === 'previous') {
        swiper.slidePrev();
      } else {
        swiper.slideToLoop(index);
      }
    } else {
      swiper.slideTo(index);
    }
  }
  function update() {
    // Render || Update Pagination bullets/items
    const rtl = swiper.rtl;
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    let el = swiper.pagination.el;
    el = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(el);
    // Current/Total
    let current;
    let previousIndex;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
    if (swiper.params.loop) {
      previousIndex = swiper.previousRealIndex || 0;
      current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
      previousIndex = swiper.previousSnapIndex;
    } else {
      previousIndex = swiper.previousIndex || 0;
      current = swiper.activeIndex || 0;
    }
    // Types
    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      const bullets = swiper.pagination.bullets;
      let firstIndex;
      let lastIndex;
      let midIndex;
      if (params.dynamicBullets) {
        bulletSize = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.h)(bullets[0], swiper.isHorizontal() ? 'width' : 'height', true);
        el.forEach(subEl => {
          subEl.style[swiper.isHorizontal() ? 'width' : 'height'] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
        });
        if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
          dynamicBulletIndex += current - (previousIndex || 0);
          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
            dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (dynamicBulletIndex < 0) {
            dynamicBulletIndex = 0;
          }
        }
        firstIndex = Math.max(current - dynamicBulletIndex, 0);
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }
      bullets.forEach(bulletEl => {
        const classesToRemove = [...['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(suffix => `${params.bulletActiveClass}${suffix}`)].map(s => typeof s === 'string' && s.includes(' ') ? s.split(' ') : s).flat();
        bulletEl.classList.remove(...classesToRemove);
      });
      if (el.length > 1) {
        bullets.forEach(bullet => {
          const bulletIndex = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.i)(bullet);
          if (bulletIndex === current) {
            bullet.classList.add(...params.bulletActiveClass.split(' '));
          } else if (swiper.isElement) {
            bullet.setAttribute('part', 'bullet');
          }
          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              bullet.classList.add(...`${params.bulletActiveClass}-main`.split(' '));
            }
            if (bulletIndex === firstIndex) {
              setSideBullets(bullet, 'prev');
            }
            if (bulletIndex === lastIndex) {
              setSideBullets(bullet, 'next');
            }
          }
        });
      } else {
        const bullet = bullets[current];
        if (bullet) {
          bullet.classList.add(...params.bulletActiveClass.split(' '));
        }
        if (swiper.isElement) {
          bullets.forEach((bulletEl, bulletIndex) => {
            bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
          });
        }
        if (params.dynamicBullets) {
          const firstDisplayedBullet = bullets[firstIndex];
          const lastDisplayedBullet = bullets[lastIndex];
          for (let i = firstIndex; i <= lastIndex; i += 1) {
            if (bullets[i]) {
              bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(' '));
            }
          }
          setSideBullets(firstDisplayedBullet, 'prev');
          setSideBullets(lastDisplayedBullet, 'next');
        }
      }
      if (params.dynamicBullets) {
        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
        const offsetProp = rtl ? 'right' : 'left';
        bullets.forEach(bullet => {
          bullet.style[swiper.isHorizontal() ? offsetProp : 'top'] = `${bulletsOffset}px`;
        });
      }
    }
    el.forEach((subEl, subElIndex) => {
      if (params.type === 'fraction') {
        subEl.querySelectorAll((0,_shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(params.currentClass)).forEach(fractionEl => {
          fractionEl.textContent = params.formatFractionCurrent(current + 1);
        });
        subEl.querySelectorAll((0,_shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(params.totalClass)).forEach(totalEl => {
          totalEl.textContent = params.formatFractionTotal(total);
        });
      }
      if (params.type === 'progressbar') {
        let progressbarDirection;
        if (params.progressbarOpposite) {
          progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
        } else {
          progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
        }
        const scale = (current + 1) / total;
        let scaleX = 1;
        let scaleY = 1;
        if (progressbarDirection === 'horizontal') {
          scaleX = scale;
        } else {
          scaleY = scale;
        }
        subEl.querySelectorAll((0,_shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(params.progressbarFillClass)).forEach(progressEl => {
          progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
          progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
        });
      }
      if (params.type === 'custom' && params.renderCustom) {
        (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.s)(subEl, params.renderCustom(swiper, current + 1, total));
        if (subElIndex === 0) emit('paginationRender', subEl);
      } else {
        if (subElIndex === 0) emit('paginationRender', subEl);
        emit('paginationUpdate', subEl);
      }
      if (swiper.params.watchOverflow && swiper.enabled) {
        subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
      }
    });
  }
  function render() {
    // Render Container
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
    let el = swiper.pagination.el;
    el = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(el);
    let paginationHTML = '';
    if (params.type === 'bullets') {
      let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }
      for (let i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          // prettier-ignore
          paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
      }
    }
    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
      }
    }
    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
      }
    }
    swiper.pagination.bullets = [];
    el.forEach(subEl => {
      if (params.type !== 'custom') {
        (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.s)(subEl, paginationHTML || '');
      }
      if (params.type === 'bullets') {
        swiper.pagination.bullets.push(...subEl.querySelectorAll((0,_shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(params.bulletClass)));
      }
    });
    if (params.type !== 'custom') {
      emit('paginationRender', el[0]);
    }
  }
  function init() {
    swiper.params.pagination = (0,_shared_create_element_if_not_defined_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
      el: 'swiper-pagination'
    });
    const params = swiper.params.pagination;
    if (!params.el) return;
    let el;
    if (typeof params.el === 'string' && swiper.isElement) {
      el = swiper.el.querySelector(params.el);
    }
    if (!el && typeof params.el === 'string') {
      el = [...document.querySelectorAll(params.el)];
    }
    if (!el) {
      el = params.el;
    }
    if (!el || el.length === 0) return;
    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
      el = [...swiper.el.querySelectorAll(params.el)];
      // check if it belongs to another nested Swiper
      if (el.length > 1) {
        el = el.find(subEl => {
          if ((0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.b)(subEl, '.swiper')[0] !== swiper.el) return false;
          return true;
        });
      }
    }
    if (Array.isArray(el) && el.length === 1) el = el[0];
    Object.assign(swiper.pagination, {
      el
    });
    el = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(el);
    el.forEach(subEl => {
      if (params.type === 'bullets' && params.clickable) {
        subEl.classList.add(...(params.clickableClass || '').split(' '));
      }
      subEl.classList.add(params.modifierClass + params.type);
      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
      if (params.type === 'bullets' && params.dynamicBullets) {
        subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
        dynamicBulletIndex = 0;
        if (params.dynamicMainBullets < 1) {
          params.dynamicMainBullets = 1;
        }
      }
      if (params.type === 'progressbar' && params.progressbarOpposite) {
        subEl.classList.add(params.progressbarOppositeClass);
      }
      if (params.clickable) {
        subEl.addEventListener('click', onBulletClick);
      }
      if (!swiper.enabled) {
        subEl.classList.add(params.lockClass);
      }
    });
  }
  function destroy() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    let el = swiper.pagination.el;
    if (el) {
      el = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(el);
      el.forEach(subEl => {
        subEl.classList.remove(params.hiddenClass);
        subEl.classList.remove(params.modifierClass + params.type);
        subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.clickable) {
          subEl.classList.remove(...(params.clickableClass || '').split(' '));
          subEl.removeEventListener('click', onBulletClick);
        }
      });
    }
    if (swiper.pagination.bullets) swiper.pagination.bullets.forEach(subEl => subEl.classList.remove(...params.bulletActiveClass.split(' ')));
  }
  on('changeDirection', () => {
    if (!swiper.pagination || !swiper.pagination.el) return;
    const params = swiper.params.pagination;
    let {
      el
    } = swiper.pagination;
    el = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(el);
    el.forEach(subEl => {
      subEl.classList.remove(params.horizontalClass, params.verticalClass);
      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    });
  });
  on('init', () => {
    if (swiper.params.pagination.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      render();
      update();
    }
  });
  on('activeIndexChange', () => {
    if (typeof swiper.snapIndex === 'undefined') {
      update();
    }
  });
  on('snapIndexChange', () => {
    update();
  });
  on('snapGridLengthChange', () => {
    render();
    update();
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(el);
      el.forEach(subEl => subEl.classList[swiper.enabled ? 'remove' : 'add'](swiper.params.pagination.lockClass));
    }
  });
  on('lock unlock', () => {
    update();
  });
  on('click', (_s, e) => {
    const targetEl = e.target;
    const el = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(swiper.pagination.el);
    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
      const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
      if (isHidden === true) {
        emit('paginationShow');
      } else {
        emit('paginationHide');
      }
      el.forEach(subEl => subEl.classList.toggle(swiper.params.pagination.hiddenClass));
    }
  });
  const enable = () => {
    swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(el);
      el.forEach(subEl => subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
    }
    init();
    render();
    update();
  };
  const disable = () => {
    swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.m)(el);
      el.forEach(subEl => subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
    }
    destroy();
  };
  Object.assign(swiper.pagination, {
    enable,
    disable,
    render,
    update,
    init,
    destroy
  });
}




/***/ }),

/***/ "./node_modules/swiper/modules/parallax.mjs":
/*!**************************************************!*\
  !*** ./node_modules/swiper/modules/parallax.mjs ***!
  \**************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Parallax)
/* harmony export */ });
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs");


function Parallax(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    parallax: {
      enabled: false
    }
  });
  const elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
  const setTransform = (el, progress) => {
    const {
      rtl
    } = swiper;
    const rtlFactor = rtl ? -1 : 1;
    const p = el.getAttribute('data-swiper-parallax') || '0';
    let x = el.getAttribute('data-swiper-parallax-x');
    let y = el.getAttribute('data-swiper-parallax-y');
    const scale = el.getAttribute('data-swiper-parallax-scale');
    const opacity = el.getAttribute('data-swiper-parallax-opacity');
    const rotate = el.getAttribute('data-swiper-parallax-rotate');
    if (x || y) {
      x = x || '0';
      y = y || '0';
    } else if (swiper.isHorizontal()) {
      x = p;
      y = '0';
    } else {
      y = p;
      x = '0';
    }
    if (x.indexOf('%') >= 0) {
      x = `${parseInt(x, 10) * progress * rtlFactor}%`;
    } else {
      x = `${x * progress * rtlFactor}px`;
    }
    if (y.indexOf('%') >= 0) {
      y = `${parseInt(y, 10) * progress}%`;
    } else {
      y = `${y * progress}px`;
    }
    if (typeof opacity !== 'undefined' && opacity !== null) {
      const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
      el.style.opacity = currentOpacity;
    }
    let transform = `translate3d(${x}, ${y}, 0px)`;
    if (typeof scale !== 'undefined' && scale !== null) {
      const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
      transform += ` scale(${currentScale})`;
    }
    if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
      const currentRotate = rotate * progress * -1;
      transform += ` rotate(${currentRotate}deg)`;
    }
    el.style.transform = transform;
  };
  const setTranslate = () => {
    const {
      el,
      slides,
      progress,
      snapGrid,
      isElement
    } = swiper;
    const elements = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(el, elementsSelector);
    if (swiper.isElement) {
      elements.push(...(0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(swiper.hostEl, elementsSelector));
    }
    elements.forEach(subEl => {
      setTransform(subEl, progress);
    });
    slides.forEach((slideEl, slideIndex) => {
      let slideProgress = slideEl.progress;
      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
        slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
      }
      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
      slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach(subEl => {
        setTransform(subEl, slideProgress);
      });
    });
  };
  const setTransition = function (duration) {
    if (duration === void 0) {
      duration = swiper.params.speed;
    }
    const {
      el,
      hostEl
    } = swiper;
    const elements = [...el.querySelectorAll(elementsSelector)];
    if (swiper.isElement) {
      elements.push(...hostEl.querySelectorAll(elementsSelector));
    }
    elements.forEach(parallaxEl => {
      let parallaxDuration = parseInt(parallaxEl.getAttribute('data-swiper-parallax-duration'), 10) || duration;
      if (duration === 0) parallaxDuration = 0;
      parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
    });
  };
  on('beforeInit', () => {
    if (!swiper.params.parallax.enabled) return;
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;
  });
  on('init', () => {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTranslate', () => {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTransition', (_swiper, duration) => {
    if (!swiper.params.parallax.enabled) return;
    setTransition(duration);
  });
}




/***/ }),

/***/ "./node_modules/swiper/modules/scrollbar.mjs":
/*!***************************************************!*\
  !*** ./node_modules/swiper/modules/scrollbar.mjs ***!
  \***************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Scrollbar)
/* harmony export */ });
/* harmony import */ var _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs");
/* harmony import */ var _shared_create_element_if_not_defined_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/create-element-if-not-defined.mjs */ "./node_modules/swiper/shared/create-element-if-not-defined.mjs");
/* harmony import */ var _shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../shared/classes-to-selector.mjs */ "./node_modules/swiper/shared/classes-to-selector.mjs");





function Scrollbar(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const document = (0,_shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
  let isTouched = false;
  let timeout = null;
  let dragTimeout = null;
  let dragStartPos;
  let dragSize;
  let trackSize;
  let divider;
  extendParams({
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag',
      scrollbarDisabledClass: 'swiper-scrollbar-disabled',
      horizontalClass: `swiper-scrollbar-horizontal`,
      verticalClass: `swiper-scrollbar-vertical`
    }
  });
  swiper.scrollbar = {
    el: null,
    dragEl: null
  };
  function setTranslate() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    const {
      scrollbar,
      rtlTranslate: rtl
    } = swiper;
    const {
      dragEl,
      el
    } = scrollbar;
    const params = swiper.params.scrollbar;
    const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
    let newSize = dragSize;
    let newPos = (trackSize - dragSize) * progress;
    if (rtl) {
      newPos = -newPos;
      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }
    if (swiper.isHorizontal()) {
      dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
      dragEl.style.width = `${newSize}px`;
    } else {
      dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
      dragEl.style.height = `${newSize}px`;
    }
    if (params.hide) {
      clearTimeout(timeout);
      el.style.opacity = 1;
      timeout = setTimeout(() => {
        el.style.opacity = 0;
        el.style.transitionDuration = '400ms';
      }, 1000);
    }
  }
  function setTransition(duration) {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
  }
  function updateSize() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    const {
      scrollbar
    } = swiper;
    const {
      dragEl,
      el
    } = scrollbar;
    dragEl.style.width = '';
    dragEl.style.height = '';
    trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
    divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
    if (swiper.params.scrollbar.dragSize === 'auto') {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }
    if (swiper.isHorizontal()) {
      dragEl.style.width = `${dragSize}px`;
    } else {
      dragEl.style.height = `${dragSize}px`;
    }
    if (divider >= 1) {
      el.style.display = 'none';
    } else {
      el.style.display = '';
    }
    if (swiper.params.scrollbar.hide) {
      el.style.opacity = 0;
    }
    if (swiper.params.watchOverflow && swiper.enabled) {
      scrollbar.el.classList[swiper.isLocked ? 'add' : 'remove'](swiper.params.scrollbar.lockClass);
    }
  }
  function getPointerPosition(e) {
    return swiper.isHorizontal() ? e.clientX : e.clientY;
  }
  function setDragPosition(e) {
    const {
      scrollbar,
      rtlTranslate: rtl
    } = swiper;
    const {
      el
    } = scrollbar;
    let positionRatio;
    positionRatio = (getPointerPosition(e) - (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.d)(el)[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);
    if (rtl) {
      positionRatio = 1 - positionRatio;
    }
    const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  function onDragStart(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      wrapperEl
    } = swiper;
    const {
      el,
      dragEl
    } = scrollbar;
    isTouched = true;
    dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
    e.preventDefault();
    e.stopPropagation();
    wrapperEl.style.transitionDuration = '100ms';
    dragEl.style.transitionDuration = '100ms';
    setDragPosition(e);
    clearTimeout(dragTimeout);
    el.style.transitionDuration = '0ms';
    if (params.hide) {
      el.style.opacity = 1;
    }
    if (swiper.params.cssMode) {
      swiper.wrapperEl.style['scroll-snap-type'] = 'none';
    }
    emit('scrollbarDragStart', e);
  }
  function onDragMove(e) {
    const {
      scrollbar,
      wrapperEl
    } = swiper;
    const {
      el,
      dragEl
    } = scrollbar;
    if (!isTouched) return;
    if (e.preventDefault && e.cancelable) e.preventDefault();else e.returnValue = false;
    setDragPosition(e);
    wrapperEl.style.transitionDuration = '0ms';
    el.style.transitionDuration = '0ms';
    dragEl.style.transitionDuration = '0ms';
    emit('scrollbarDragMove', e);
  }
  function onDragEnd(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      wrapperEl
    } = swiper;
    const {
      el
    } = scrollbar;
    if (!isTouched) return;
    isTouched = false;
    if (swiper.params.cssMode) {
      swiper.wrapperEl.style['scroll-snap-type'] = '';
      wrapperEl.style.transitionDuration = '';
    }
    if (params.hide) {
      clearTimeout(dragTimeout);
      dragTimeout = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.n)(() => {
        el.style.opacity = 0;
        el.style.transitionDuration = '400ms';
      }, 1000);
    }
    emit('scrollbarDragEnd', e);
    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  }
  function events(method) {
    const {
      scrollbar,
      params
    } = swiper;
    const el = scrollbar.el;
    if (!el) return;
    const target = el;
    const activeListener = params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    const passiveListener = params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    if (!target) return;
    const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    target[eventMethod]('pointerdown', onDragStart, activeListener);
    document[eventMethod]('pointermove', onDragMove, activeListener);
    document[eventMethod]('pointerup', onDragEnd, passiveListener);
  }
  function enableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    events('on');
  }
  function disableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    events('off');
  }
  function init() {
    const {
      scrollbar,
      el: swiperEl
    } = swiper;
    swiper.params.scrollbar = (0,_shared_create_element_if_not_defined_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
      el: 'swiper-scrollbar'
    });
    const params = swiper.params.scrollbar;
    if (!params.el) return;
    let el;
    if (typeof params.el === 'string' && swiper.isElement) {
      el = swiper.el.querySelector(params.el);
    }
    if (!el && typeof params.el === 'string') {
      el = document.querySelectorAll(params.el);
      if (!el.length) return;
    } else if (!el) {
      el = params.el;
    }
    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) {
      el = swiperEl.querySelector(params.el);
    }
    if (el.length > 0) el = el[0];
    el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    let dragEl;
    if (el) {
      dragEl = el.querySelector((0,_shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_3__.c)(swiper.params.scrollbar.dragClass));
      if (!dragEl) {
        dragEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)('div', swiper.params.scrollbar.dragClass);
        el.append(dragEl);
      }
    }
    Object.assign(scrollbar, {
      el,
      dragEl
    });
    if (params.draggable) {
      enableDraggable();
    }
    if (el) {
      el.classList[swiper.enabled ? 'remove' : 'add'](...(0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.j)(swiper.params.scrollbar.lockClass));
    }
  }
  function destroy() {
    const params = swiper.params.scrollbar;
    const el = swiper.scrollbar.el;
    if (el) {
      el.classList.remove(...(0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.j)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
    }
    disableDraggable();
  }
  on('changeDirection', () => {
    if (!swiper.scrollbar || !swiper.scrollbar.el) return;
    const params = swiper.params.scrollbar;
    let {
      el
    } = swiper.scrollbar;
    el = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.m)(el);
    el.forEach(subEl => {
      subEl.classList.remove(params.horizontalClass, params.verticalClass);
      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    });
  });
  on('init', () => {
    if (swiper.params.scrollbar.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      updateSize();
      setTranslate();
    }
  });
  on('update resize observerUpdate lock unlock changeDirection', () => {
    updateSize();
  });
  on('setTranslate', () => {
    setTranslate();
  });
  on('setTransition', (_s, duration) => {
    setTransition(duration);
  });
  on('enable disable', () => {
    const {
      el
    } = swiper.scrollbar;
    if (el) {
      el.classList[swiper.enabled ? 'remove' : 'add'](...(0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.j)(swiper.params.scrollbar.lockClass));
    }
  });
  on('destroy', () => {
    destroy();
  });
  const enable = () => {
    swiper.el.classList.remove(...(0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.j)(swiper.params.scrollbar.scrollbarDisabledClass));
    if (swiper.scrollbar.el) {
      swiper.scrollbar.el.classList.remove(...(0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.j)(swiper.params.scrollbar.scrollbarDisabledClass));
    }
    init();
    updateSize();
    setTranslate();
  };
  const disable = () => {
    swiper.el.classList.add(...(0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.j)(swiper.params.scrollbar.scrollbarDisabledClass));
    if (swiper.scrollbar.el) {
      swiper.scrollbar.el.classList.add(...(0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.j)(swiper.params.scrollbar.scrollbarDisabledClass));
    }
    destroy();
  };
  Object.assign(swiper.scrollbar, {
    enable,
    disable,
    updateSize,
    setTranslate,
    init,
    destroy
  });
}




/***/ }),

/***/ "./node_modules/swiper/modules/thumbs.mjs":
/*!************************************************!*\
  !*** ./node_modules/swiper/modules/thumbs.mjs ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Thumb)
/* harmony export */ });
/* harmony import */ var _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs");



function Thumb(_ref) {
  let {
    swiper,
    extendParams,
    on
  } = _ref;
  extendParams({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: true,
      autoScrollOffset: 0,
      slideThumbActiveClass: 'swiper-slide-thumb-active',
      thumbsContainerClass: 'swiper-thumbs'
    }
  });
  let initialized = false;
  let swiperCreated = false;
  swiper.thumbs = {
    swiper: null
  };
  function onThumbClick() {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    const clickedIndex = thumbsSwiper.clickedIndex;
    const clickedSlide = thumbsSwiper.clickedSlide;
    if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
    if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
    let slideToIndex;
    if (thumbsSwiper.params.loop) {
      slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
    } else {
      slideToIndex = clickedIndex;
    }
    if (swiper.params.loop) {
      swiper.slideToLoop(slideToIndex);
    } else {
      swiper.slideTo(slideToIndex);
    }
  }
  function init() {
    const {
      thumbs: thumbsParams
    } = swiper.params;
    if (initialized) return false;
    initialized = true;
    const SwiperClass = swiper.constructor;
    if (thumbsParams.swiper instanceof SwiperClass) {
      if (thumbsParams.swiper.destroyed) {
        initialized = false;
        return false;
      }
      swiper.thumbs.swiper = thumbsParams.swiper;
      Object.assign(swiper.thumbs.swiper.originalParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      Object.assign(swiper.thumbs.swiper.params, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      swiper.thumbs.swiper.update();
    } else if ((0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.o)(thumbsParams.swiper)) {
      const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
      Object.assign(thumbsSwiperParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
      swiperCreated = true;
    }
    swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
    swiper.thumbs.swiper.on('tap', onThumbClick);
    return true;
  }
  function update(initial) {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;

    // Activate thumbs
    let thumbsToActivate = 1;
    const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
      thumbsToActivate = swiper.params.slidesPerView;
    }
    if (!swiper.params.thumbs.multipleActiveThumbs) {
      thumbsToActivate = 1;
    }
    thumbsToActivate = Math.floor(thumbsToActivate);
    thumbsSwiper.slides.forEach(slideEl => slideEl.classList.remove(thumbActiveClass));
    if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach(slideEl => {
          slideEl.classList.add(thumbActiveClass);
        });
      }
    } else {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        if (thumbsSwiper.slides[swiper.realIndex + i]) {
          thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
      }
    }
    const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
    const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
    if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
      const currentThumbsIndex = thumbsSwiper.activeIndex;
      let newThumbsIndex;
      let direction;
      if (thumbsSwiper.params.loop) {
        const newThumbsSlide = thumbsSwiper.slides.find(slideEl => slideEl.getAttribute('data-swiper-slide-index') === `${swiper.realIndex}`);
        newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
        direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
      } else {
        newThumbsIndex = swiper.realIndex;
        direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
      }
      if (useOffset) {
        newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
      }
      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
        if (thumbsSwiper.params.centeredSlides) {
          if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
          } else {
            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
          }
        } else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup === 1) ;
        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
      }
    }
  }
  on('beforeInit', () => {
    const {
      thumbs
    } = swiper.params;
    if (!thumbs || !thumbs.swiper) return;
    if (typeof thumbs.swiper === 'string' || thumbs.swiper instanceof HTMLElement) {
      const document = (0,_shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
      const getThumbsElementAndInit = () => {
        const thumbsElement = typeof thumbs.swiper === 'string' ? document.querySelector(thumbs.swiper) : thumbs.swiper;
        if (thumbsElement && thumbsElement.swiper) {
          thumbs.swiper = thumbsElement.swiper;
          init();
          update(true);
        } else if (thumbsElement) {
          const eventName = `${swiper.params.eventsPrefix}init`;
          const onThumbsSwiper = e => {
            thumbs.swiper = e.detail[0];
            thumbsElement.removeEventListener(eventName, onThumbsSwiper);
            init();
            update(true);
            thumbs.swiper.update();
            swiper.update();
          };
          thumbsElement.addEventListener(eventName, onThumbsSwiper);
        }
        return thumbsElement;
      };
      const watchForThumbsToAppear = () => {
        if (swiper.destroyed) return;
        const thumbsElement = getThumbsElementAndInit();
        if (!thumbsElement) {
          requestAnimationFrame(watchForThumbsToAppear);
        }
      };
      requestAnimationFrame(watchForThumbsToAppear);
    } else {
      init();
      update(true);
    }
  });
  on('slideChange update resize observerUpdate', () => {
    update();
  });
  on('setTransition', (_s, duration) => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    thumbsSwiper.setTransition(duration);
  });
  on('beforeDestroy', () => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    if (swiperCreated) {
      thumbsSwiper.destroy();
    }
  });
  Object.assign(swiper.thumbs, {
    init,
    update
  });
}




/***/ }),

/***/ "./node_modules/swiper/modules/virtual.mjs":
/*!*************************************************!*\
  !*** ./node_modules/swiper/modules/virtual.mjs ***!
  \*************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Virtual)
/* harmony export */ });
/* harmony import */ var _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs");



function Virtual(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  extendParams({
    virtual: {
      enabled: false,
      slides: [],
      cache: true,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: true,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  let cssModeTimeout;
  const document = (0,_shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
  swiper.virtual = {
    cache: {},
    from: undefined,
    to: undefined,
    slides: [],
    offset: 0,
    slidesGrid: []
  };
  const tempDOM = document.createElement('div');
  function renderSlide(slide, index) {
    const params = swiper.params.virtual;
    if (params.cache && swiper.virtual.cache[index]) {
      return swiper.virtual.cache[index];
    }
    // eslint-disable-next-line
    let slideEl;
    if (params.renderSlide) {
      slideEl = params.renderSlide.call(swiper, slide, index);
      if (typeof slideEl === 'string') {
        (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(tempDOM, slideEl);
        slideEl = tempDOM.children[0];
      }
    } else if (swiper.isElement) {
      slideEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)('swiper-slide');
    } else {
      slideEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)('div', swiper.params.slideClass);
    }
    slideEl.setAttribute('data-swiper-slide-index', index);
    if (!params.renderSlide) {
      (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(slideEl, slide);
    }
    if (params.cache) {
      swiper.virtual.cache[index] = slideEl;
    }
    return slideEl;
  }
  function update(force, beforeInit, forceActiveIndex) {
    const {
      slidesPerView,
      slidesPerGroup,
      centeredSlides,
      loop: isLoop,
      initialSlide
    } = swiper.params;
    if (beforeInit && !isLoop && initialSlide > 0) {
      return;
    }
    const {
      addSlidesBefore,
      addSlidesAfter
    } = swiper.params.virtual;
    const {
      from: previousFrom,
      to: previousTo,
      slides,
      slidesGrid: previousSlidesGrid,
      offset: previousOffset
    } = swiper.virtual;
    if (!swiper.params.cssMode) {
      swiper.updateActiveIndex();
    }
    const activeIndex = typeof forceActiveIndex === 'undefined' ? swiper.activeIndex || 0 : forceActiveIndex;
    let offsetProp;
    if (swiper.rtlTranslate) offsetProp = 'right';else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
    let slidesAfter;
    let slidesBefore;
    if (centeredSlides) {
      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
    } else {
      slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
      slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
    }
    let from = activeIndex - slidesBefore;
    let to = activeIndex + slidesAfter;
    if (!isLoop) {
      from = Math.max(from, 0);
      to = Math.min(to, slides.length - 1);
    }
    let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
    if (isLoop && activeIndex >= slidesBefore) {
      from -= slidesBefore;
      if (!centeredSlides) offset += swiper.slidesGrid[0];
    } else if (isLoop && activeIndex < slidesBefore) {
      from = -slidesBefore;
      if (centeredSlides) offset += swiper.slidesGrid[0];
    }
    Object.assign(swiper.virtual, {
      from,
      to,
      offset,
      slidesGrid: swiper.slidesGrid,
      slidesBefore,
      slidesAfter
    });
    function onRendered() {
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      emit('virtualUpdate');
    }
    if (previousFrom === from && previousTo === to && !force) {
      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
        swiper.slides.forEach(slideEl => {
          slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
      }
      swiper.updateProgress();
      emit('virtualUpdate');
      return;
    }
    if (swiper.params.virtual.renderExternal) {
      swiper.params.virtual.renderExternal.call(swiper, {
        offset,
        from,
        to,
        slides: function getSlides() {
          const slidesToRender = [];
          for (let i = from; i <= to; i += 1) {
            slidesToRender.push(slides[i]);
          }
          return slidesToRender;
        }()
      });
      if (swiper.params.virtual.renderExternalUpdate) {
        onRendered();
      } else {
        emit('virtualUpdate');
      }
      return;
    }
    const prependIndexes = [];
    const appendIndexes = [];
    const getSlideIndex = index => {
      let slideIndex = index;
      if (index < 0) {
        slideIndex = slides.length + index;
      } else if (slideIndex >= slides.length) {
        // eslint-disable-next-line
        slideIndex = slideIndex - slides.length;
      }
      return slideIndex;
    };
    if (force) {
      swiper.slides.filter(el => el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach(slideEl => {
        slideEl.remove();
      });
    } else {
      for (let i = previousFrom; i <= previousTo; i += 1) {
        if (i < from || i > to) {
          const slideIndex = getSlideIndex(i);
          swiper.slides.filter(el => el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach(slideEl => {
            slideEl.remove();
          });
        }
      }
    }
    const loopFrom = isLoop ? -slides.length : 0;
    const loopTo = isLoop ? slides.length * 2 : slides.length;
    for (let i = loopFrom; i < loopTo; i += 1) {
      if (i >= from && i <= to) {
        const slideIndex = getSlideIndex(i);
        if (typeof previousTo === 'undefined' || force) {
          appendIndexes.push(slideIndex);
        } else {
          if (i > previousTo) appendIndexes.push(slideIndex);
          if (i < previousFrom) prependIndexes.push(slideIndex);
        }
      }
    }
    appendIndexes.forEach(index => {
      swiper.slidesEl.append(renderSlide(slides[index], index));
    });
    if (isLoop) {
      for (let i = prependIndexes.length - 1; i >= 0; i -= 1) {
        const index = prependIndexes[i];
        swiper.slidesEl.prepend(renderSlide(slides[index], index));
      }
    } else {
      prependIndexes.sort((a, b) => b - a);
      prependIndexes.forEach(index => {
        swiper.slidesEl.prepend(renderSlide(slides[index], index));
      });
    }
    (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(swiper.slidesEl, '.swiper-slide, swiper-slide').forEach(slideEl => {
      slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
    });
    onRendered();
  }
  function appendSlide(slides) {
    if (typeof slides === 'object' && 'length' in slides) {
      for (let i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.push(slides[i]);
      }
    } else {
      swiper.virtual.slides.push(slides);
    }
    update(true);
  }
  function prependSlide(slides) {
    const activeIndex = swiper.activeIndex;
    let newActiveIndex = activeIndex + 1;
    let numberOfNewSlides = 1;
    if (Array.isArray(slides)) {
      for (let i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
      }
      newActiveIndex = activeIndex + slides.length;
      numberOfNewSlides = slides.length;
    } else {
      swiper.virtual.slides.unshift(slides);
    }
    if (swiper.params.virtual.cache) {
      const cache = swiper.virtual.cache;
      const newCache = {};
      Object.keys(cache).forEach(cachedIndex => {
        const cachedEl = cache[cachedIndex];
        const cachedElIndex = cachedEl.getAttribute('data-swiper-slide-index');
        if (cachedElIndex) {
          cachedEl.setAttribute('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
        }
        newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
      });
      swiper.virtual.cache = newCache;
    }
    update(true);
    swiper.slideTo(newActiveIndex, 0);
  }
  function removeSlide(slidesIndexes) {
    if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
    let activeIndex = swiper.activeIndex;
    if (Array.isArray(slidesIndexes)) {
      for (let i = slidesIndexes.length - 1; i >= 0; i -= 1) {
        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes[i]];
          // shift cache indexes
          Object.keys(swiper.virtual.cache).forEach(key => {
            if (key > slidesIndexes) {
              swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
              swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
              delete swiper.virtual.cache[key];
            }
          });
        }
        swiper.virtual.slides.splice(slidesIndexes[i], 1);
        if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
        activeIndex = Math.max(activeIndex, 0);
      }
    } else {
      if (swiper.params.virtual.cache) {
        delete swiper.virtual.cache[slidesIndexes];
        // shift cache indexes
        Object.keys(swiper.virtual.cache).forEach(key => {
          if (key > slidesIndexes) {
            swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
            swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
            delete swiper.virtual.cache[key];
          }
        });
      }
      swiper.virtual.slides.splice(slidesIndexes, 1);
      if (slidesIndexes < activeIndex) activeIndex -= 1;
      activeIndex = Math.max(activeIndex, 0);
    }
    update(true);
    swiper.slideTo(activeIndex, 0);
  }
  function removeAllSlides() {
    swiper.virtual.slides = [];
    if (swiper.params.virtual.cache) {
      swiper.virtual.cache = {};
    }
    update(true);
    swiper.slideTo(0, 0);
  }
  on('beforeInit', () => {
    if (!swiper.params.virtual.enabled) return;
    let domSlidesAssigned;
    if (typeof swiper.passedParams.virtual.slides === 'undefined') {
      const slides = [...swiper.slidesEl.children].filter(el => el.matches(`.${swiper.params.slideClass}, swiper-slide`));
      if (slides && slides.length) {
        swiper.virtual.slides = [...slides];
        domSlidesAssigned = true;
        slides.forEach((slideEl, slideIndex) => {
          slideEl.setAttribute('data-swiper-slide-index', slideIndex);
          swiper.virtual.cache[slideIndex] = slideEl;
          slideEl.remove();
        });
      }
    }
    if (!domSlidesAssigned) {
      swiper.virtual.slides = swiper.params.virtual.slides;
    }
    swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;
    update(false, true);
  });
  on('setTranslate', () => {
    if (!swiper.params.virtual.enabled) return;
    if (swiper.params.cssMode && !swiper._immediateVirtual) {
      clearTimeout(cssModeTimeout);
      cssModeTimeout = setTimeout(() => {
        update();
      }, 100);
    } else {
      update();
    }
  });
  on('init update resize', () => {
    if (!swiper.params.virtual.enabled) return;
    if (swiper.params.cssMode) {
      (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.a)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    }
  });
  Object.assign(swiper.virtual, {
    appendSlide,
    prependSlide,
    removeSlide,
    removeAllSlides,
    update
  });
}




/***/ }),

/***/ "./node_modules/swiper/modules/zoom.mjs":
/*!**********************************************!*\
  !*** ./node_modules/swiper/modules/zoom.mjs ***!
  \**********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Zoom)
/* harmony export */ });
/* harmony import */ var _shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/swiper/shared/utils.mjs");



function Zoom(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const window = (0,_shared_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  extendParams({
    zoom: {
      enabled: false,
      limitToOriginalSize: false,
      maxRatio: 3,
      minRatio: 1,
      panOnMouseMove: false,
      toggle: true,
      containerClass: 'swiper-zoom-container',
      zoomedSlideClass: 'swiper-slide-zoomed'
    }
  });
  swiper.zoom = {
    enabled: false
  };
  let currentScale = 1;
  let isScaling = false;
  let isPanningWithMouse = false;
  let mousePanStart = {
    x: 0,
    y: 0
  };
  const mousePanSensitivity = -3; // Negative to invert pan direction
  let fakeGestureTouched;
  let fakeGestureMoved;
  const evCache = [];
  const gesture = {
    originX: 0,
    originY: 0,
    slideEl: undefined,
    slideWidth: undefined,
    slideHeight: undefined,
    imageEl: undefined,
    imageWrapEl: undefined,
    maxRatio: 3
  };
  const image = {
    isTouched: undefined,
    isMoved: undefined,
    currentX: undefined,
    currentY: undefined,
    minX: undefined,
    minY: undefined,
    maxX: undefined,
    maxY: undefined,
    width: undefined,
    height: undefined,
    startX: undefined,
    startY: undefined,
    touchesStart: {},
    touchesCurrent: {}
  };
  const velocity = {
    x: undefined,
    y: undefined,
    prevPositionX: undefined,
    prevPositionY: undefined,
    prevTime: undefined
  };
  let scale = 1;
  Object.defineProperty(swiper.zoom, 'scale', {
    get() {
      return scale;
    },
    set(value) {
      if (scale !== value) {
        const imageEl = gesture.imageEl;
        const slideEl = gesture.slideEl;
        emit('zoomChange', value, imageEl, slideEl);
      }
      scale = value;
    }
  });
  function getDistanceBetweenTouches() {
    if (evCache.length < 2) return 1;
    const x1 = evCache[0].pageX;
    const y1 = evCache[0].pageY;
    const x2 = evCache[1].pageX;
    const y2 = evCache[1].pageY;
    const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
    return distance;
  }
  function getMaxRatio() {
    const params = swiper.params.zoom;
    const maxRatio = gesture.imageWrapEl.getAttribute('data-swiper-zoom') || params.maxRatio;
    if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
      const imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
      return Math.min(imageMaxRatio, maxRatio);
    }
    return maxRatio;
  }
  function getScaleOrigin() {
    if (evCache.length < 2) return {
      x: null,
      y: null
    };
    const box = gesture.imageEl.getBoundingClientRect();
    return [(evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale, (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale];
  }
  function getSlideSelector() {
    return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
  }
  function eventWithinSlide(e) {
    const slideSelector = getSlideSelector();
    if (e.target.matches(slideSelector)) return true;
    if (swiper.slides.filter(slideEl => slideEl.contains(e.target)).length > 0) return true;
    return false;
  }
  function eventWithinZoomContainer(e) {
    const selector = `.${swiper.params.zoom.containerClass}`;
    if (e.target.matches(selector)) return true;
    if ([...swiper.hostEl.querySelectorAll(selector)].filter(containerEl => containerEl.contains(e.target)).length > 0) return true;
    return false;
  }

  // Events
  function onGestureStart(e) {
    if (e.pointerType === 'mouse') {
      evCache.splice(0, evCache.length);
    }
    if (!eventWithinSlide(e)) return;
    const params = swiper.params.zoom;
    fakeGestureTouched = false;
    fakeGestureMoved = false;
    evCache.push(e);
    if (evCache.length < 2) {
      return;
    }
    fakeGestureTouched = true;
    gesture.scaleStart = getDistanceBetweenTouches();
    if (!gesture.slideEl) {
      gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
      if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
      let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
      if (imageEl) {
        imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
      }
      gesture.imageEl = imageEl;
      if (imageEl) {
        gesture.imageWrapEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.b)(gesture.imageEl, `.${params.containerClass}`)[0];
      } else {
        gesture.imageWrapEl = undefined;
      }
      if (!gesture.imageWrapEl) {
        gesture.imageEl = undefined;
        return;
      }
      gesture.maxRatio = getMaxRatio();
    }
    if (gesture.imageEl) {
      const [originX, originY] = getScaleOrigin();
      gesture.originX = originX;
      gesture.originY = originY;
      gesture.imageEl.style.transitionDuration = '0ms';
    }
    isScaling = true;
  }
  function onGestureChange(e) {
    if (!eventWithinSlide(e)) return;
    const params = swiper.params.zoom;
    const zoom = swiper.zoom;
    const pointerIndex = evCache.findIndex(cachedEv => cachedEv.pointerId === e.pointerId);
    if (pointerIndex >= 0) evCache[pointerIndex] = e;
    if (evCache.length < 2) {
      return;
    }
    fakeGestureMoved = true;
    gesture.scaleMove = getDistanceBetweenTouches();
    if (!gesture.imageEl) {
      return;
    }
    zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
    if (zoom.scale > gesture.maxRatio) {
      zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
    }
    if (zoom.scale < params.minRatio) {
      zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
    }
    gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
  }
  function onGestureEnd(e) {
    if (!eventWithinSlide(e)) return;
    if (e.pointerType === 'mouse' && e.type === 'pointerout') return;
    const params = swiper.params.zoom;
    const zoom = swiper.zoom;
    const pointerIndex = evCache.findIndex(cachedEv => cachedEv.pointerId === e.pointerId);
    if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
    if (!fakeGestureTouched || !fakeGestureMoved) {
      return;
    }
    fakeGestureTouched = false;
    fakeGestureMoved = false;
    if (!gesture.imageEl) return;
    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
    gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
    gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    currentScale = zoom.scale;
    isScaling = false;
    if (zoom.scale > 1 && gesture.slideEl) {
      gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
    } else if (zoom.scale <= 1 && gesture.slideEl) {
      gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
    }
    if (zoom.scale === 1) {
      gesture.originX = 0;
      gesture.originY = 0;
      gesture.slideEl = undefined;
    }
  }
  let allowTouchMoveTimeout;
  function allowTouchMove() {
    swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
  }
  function preventTouchMove() {
    clearTimeout(allowTouchMoveTimeout);
    swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
    allowTouchMoveTimeout = setTimeout(() => {
      if (swiper.destroyed) return;
      allowTouchMove();
    });
  }
  function onTouchStart(e) {
    const device = swiper.device;
    if (!gesture.imageEl) return;
    if (image.isTouched) return;
    if (device.android && e.cancelable) e.preventDefault();
    image.isTouched = true;
    const event = evCache.length > 0 ? evCache[0] : e;
    image.touchesStart.x = event.pageX;
    image.touchesStart.y = event.pageY;
  }
  function onTouchMove(e) {
    const isMouseEvent = e.pointerType === 'mouse';
    const isMousePan = isMouseEvent && swiper.params.zoom.panOnMouseMove;
    if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) {
      return;
    }
    const zoom = swiper.zoom;
    if (!gesture.imageEl) {
      return;
    }
    if (!image.isTouched || !gesture.slideEl) {
      if (isMousePan) onMouseMove(e);
      return;
    }
    if (isMousePan) {
      onMouseMove(e);
      return;
    }
    if (!image.isMoved) {
      image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
      image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
      image.startX = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.k)(gesture.imageWrapEl, 'x') || 0;
      image.startY = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.k)(gesture.imageWrapEl, 'y') || 0;
      gesture.slideWidth = gesture.slideEl.offsetWidth;
      gesture.slideHeight = gesture.slideEl.offsetHeight;
      gesture.imageWrapEl.style.transitionDuration = '0ms';
    }
    // Define if we need image drag
    const scaledWidth = image.width * zoom.scale;
    const scaledHeight = image.height * zoom.scale;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
    image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
    const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
    if (touchesDiff > 5) {
      swiper.allowClick = false;
    }
    if (!image.isMoved && !isScaling) {
      if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
        image.isTouched = false;
        allowTouchMove();
        return;
      }
      if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
        image.isTouched = false;
        allowTouchMove();
        return;
      }
    }
    if (e.cancelable) {
      e.preventDefault();
    }
    e.stopPropagation();
    preventTouchMove();
    image.isMoved = true;
    const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
    const {
      originX,
      originY
    } = gesture;
    image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
    image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
    if (image.currentX < image.minX) {
      image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
    }
    if (image.currentX > image.maxX) {
      image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
    }
    if (image.currentY < image.minY) {
      image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
    }
    if (image.currentY > image.maxY) {
      image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
    }

    // Velocity
    if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
    if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
    if (!velocity.prevTime) velocity.prevTime = Date.now();
    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
    velocity.prevPositionX = image.touchesCurrent.x;
    velocity.prevPositionY = image.touchesCurrent.y;
    velocity.prevTime = Date.now();
    gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
  }
  function onTouchEnd() {
    const zoom = swiper.zoom;
    evCache.length = 0;
    if (!gesture.imageEl) return;
    if (!image.isTouched || !image.isMoved) {
      image.isTouched = false;
      image.isMoved = false;
      return;
    }
    image.isTouched = false;
    image.isMoved = false;
    let momentumDurationX = 300;
    let momentumDurationY = 300;
    const momentumDistanceX = velocity.x * momentumDurationX;
    const newPositionX = image.currentX + momentumDistanceX;
    const momentumDistanceY = velocity.y * momentumDurationY;
    const newPositionY = image.currentY + momentumDistanceY;

    // Fix duration
    if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
    if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
    const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
    image.currentX = newPositionX;
    image.currentY = newPositionY;
    // Define if we need image drag
    const scaledWidth = image.width * zoom.scale;
    const scaledHeight = image.height * zoom.scale;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
    gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
    gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
  }
  function onTransitionEnd() {
    const zoom = swiper.zoom;
    if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
      if (gesture.imageEl) {
        gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
      }
      if (gesture.imageWrapEl) {
        gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
      }
      gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
      zoom.scale = 1;
      currentScale = 1;
      gesture.slideEl = undefined;
      gesture.imageEl = undefined;
      gesture.imageWrapEl = undefined;
      gesture.originX = 0;
      gesture.originY = 0;
    }
  }
  function onMouseMove(e) {
    // Only pan if zoomed in and mouse panning is enabled
    if (currentScale <= 1 || !gesture.imageWrapEl) return;
    if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
    const currentTransform = window.getComputedStyle(gesture.imageWrapEl).transform;
    const matrix = new window.DOMMatrix(currentTransform);
    if (!isPanningWithMouse) {
      isPanningWithMouse = true;
      mousePanStart.x = e.clientX;
      mousePanStart.y = e.clientY;
      image.startX = matrix.e;
      image.startY = matrix.f;
      image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
      image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
      gesture.slideWidth = gesture.slideEl.offsetWidth;
      gesture.slideHeight = gesture.slideEl.offsetHeight;
      return;
    }
    const deltaX = (e.clientX - mousePanStart.x) * mousePanSensitivity;
    const deltaY = (e.clientY - mousePanStart.y) * mousePanSensitivity;
    const scaledWidth = image.width * currentScale;
    const scaledHeight = image.height * currentScale;
    const slideWidth = gesture.slideWidth;
    const slideHeight = gesture.slideHeight;
    const minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
    const maxX = -minX;
    const minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
    const maxY = -minY;
    const newX = Math.max(Math.min(image.startX + deltaX, maxX), minX);
    const newY = Math.max(Math.min(image.startY + deltaY, maxY), minY);
    gesture.imageWrapEl.style.transitionDuration = '0ms';
    gesture.imageWrapEl.style.transform = `translate3d(${newX}px, ${newY}px, 0)`;
    mousePanStart.x = e.clientX;
    mousePanStart.y = e.clientY;
    image.startX = newX;
    image.startY = newY;
    image.currentX = newX;
    image.currentY = newY;
  }
  function zoomIn(e) {
    const zoom = swiper.zoom;
    const params = swiper.params.zoom;
    if (!gesture.slideEl) {
      if (e && e.target) {
        gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
      }
      if (!gesture.slideEl) {
        if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
          gesture.slideEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
        } else {
          gesture.slideEl = swiper.slides[swiper.activeIndex];
        }
      }
      let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
      if (imageEl) {
        imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
      }
      gesture.imageEl = imageEl;
      if (imageEl) {
        gesture.imageWrapEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.b)(gesture.imageEl, `.${params.containerClass}`)[0];
      } else {
        gesture.imageWrapEl = undefined;
      }
    }
    if (!gesture.imageEl || !gesture.imageWrapEl) return;
    if (swiper.params.cssMode) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.touchAction = 'none';
    }
    gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
    let touchX;
    let touchY;
    let offsetX;
    let offsetY;
    let diffX;
    let diffY;
    let translateX;
    let translateY;
    let imageWidth;
    let imageHeight;
    let scaledWidth;
    let scaledHeight;
    let translateMinX;
    let translateMinY;
    let translateMaxX;
    let translateMaxY;
    let slideWidth;
    let slideHeight;
    if (typeof image.touchesStart.x === 'undefined' && e) {
      touchX = e.pageX;
      touchY = e.pageY;
    } else {
      touchX = image.touchesStart.x;
      touchY = image.touchesStart.y;
    }
    const prevScale = currentScale;
    const forceZoomRatio = typeof e === 'number' ? e : null;
    if (currentScale === 1 && forceZoomRatio) {
      touchX = undefined;
      touchY = undefined;
      image.touchesStart.x = undefined;
      image.touchesStart.y = undefined;
    }
    const maxRatio = getMaxRatio();
    zoom.scale = forceZoomRatio || maxRatio;
    currentScale = forceZoomRatio || maxRatio;
    if (e && !(currentScale === 1 && forceZoomRatio)) {
      slideWidth = gesture.slideEl.offsetWidth;
      slideHeight = gesture.slideEl.offsetHeight;
      offsetX = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.d)(gesture.slideEl).left + window.scrollX;
      offsetY = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.d)(gesture.slideEl).top + window.scrollY;
      diffX = offsetX + slideWidth / 2 - touchX;
      diffY = offsetY + slideHeight / 2 - touchY;
      imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
      imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
      scaledWidth = imageWidth * zoom.scale;
      scaledHeight = imageHeight * zoom.scale;
      translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
      translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
      translateMaxX = -translateMinX;
      translateMaxY = -translateMinY;
      if (prevScale > 0 && forceZoomRatio && typeof image.currentX === 'number' && typeof image.currentY === 'number') {
        translateX = image.currentX * zoom.scale / prevScale;
        translateY = image.currentY * zoom.scale / prevScale;
      } else {
        translateX = diffX * zoom.scale;
        translateY = diffY * zoom.scale;
      }
      if (translateX < translateMinX) {
        translateX = translateMinX;
      }
      if (translateX > translateMaxX) {
        translateX = translateMaxX;
      }
      if (translateY < translateMinY) {
        translateY = translateMinY;
      }
      if (translateY > translateMaxY) {
        translateY = translateMaxY;
      }
    } else {
      translateX = 0;
      translateY = 0;
    }
    if (forceZoomRatio && zoom.scale === 1) {
      gesture.originX = 0;
      gesture.originY = 0;
    }
    image.currentX = translateX;
    image.currentY = translateY;
    gesture.imageWrapEl.style.transitionDuration = '300ms';
    gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
    gesture.imageEl.style.transitionDuration = '300ms';
    gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
  }
  function zoomOut() {
    const zoom = swiper.zoom;
    const params = swiper.params.zoom;
    if (!gesture.slideEl) {
      if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
        gesture.slideEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
      } else {
        gesture.slideEl = swiper.slides[swiper.activeIndex];
      }
      let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
      if (imageEl) {
        imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
      }
      gesture.imageEl = imageEl;
      if (imageEl) {
        gesture.imageWrapEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.b)(gesture.imageEl, `.${params.containerClass}`)[0];
      } else {
        gesture.imageWrapEl = undefined;
      }
    }
    if (!gesture.imageEl || !gesture.imageWrapEl) return;
    if (swiper.params.cssMode) {
      swiper.wrapperEl.style.overflow = '';
      swiper.wrapperEl.style.touchAction = '';
    }
    zoom.scale = 1;
    currentScale = 1;
    image.currentX = undefined;
    image.currentY = undefined;
    image.touchesStart.x = undefined;
    image.touchesStart.y = undefined;
    gesture.imageWrapEl.style.transitionDuration = '300ms';
    gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
    gesture.imageEl.style.transitionDuration = '300ms';
    gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
    gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
    gesture.slideEl = undefined;
    gesture.originX = 0;
    gesture.originY = 0;
    if (swiper.params.zoom.panOnMouseMove) {
      mousePanStart = {
        x: 0,
        y: 0
      };
      if (isPanningWithMouse) {
        isPanningWithMouse = false;
        image.startX = 0;
        image.startY = 0;
      }
    }
  }

  // Toggle Zoom
  function zoomToggle(e) {
    const zoom = swiper.zoom;
    if (zoom.scale && zoom.scale !== 1) {
      // Zoom Out
      zoomOut();
    } else {
      // Zoom In
      zoomIn(e);
    }
  }
  function getListeners() {
    const passiveListener = swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    const activeListenerWithCapture = swiper.params.passiveListeners ? {
      passive: false,
      capture: true
    } : true;
    return {
      passiveListener,
      activeListenerWithCapture
    };
  }

  // Attach/Detach Events
  function enable() {
    const zoom = swiper.zoom;
    if (zoom.enabled) return;
    zoom.enabled = true;
    const {
      passiveListener,
      activeListenerWithCapture
    } = getListeners();

    // Scale image
    swiper.wrapperEl.addEventListener('pointerdown', onGestureStart, passiveListener);
    swiper.wrapperEl.addEventListener('pointermove', onGestureChange, activeListenerWithCapture);
    ['pointerup', 'pointercancel', 'pointerout'].forEach(eventName => {
      swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
    });

    // Move image
    swiper.wrapperEl.addEventListener('pointermove', onTouchMove, activeListenerWithCapture);
  }
  function disable() {
    const zoom = swiper.zoom;
    if (!zoom.enabled) return;
    zoom.enabled = false;
    const {
      passiveListener,
      activeListenerWithCapture
    } = getListeners();

    // Scale image
    swiper.wrapperEl.removeEventListener('pointerdown', onGestureStart, passiveListener);
    swiper.wrapperEl.removeEventListener('pointermove', onGestureChange, activeListenerWithCapture);
    ['pointerup', 'pointercancel', 'pointerout'].forEach(eventName => {
      swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
    });

    // Move image
    swiper.wrapperEl.removeEventListener('pointermove', onTouchMove, activeListenerWithCapture);
  }
  on('init', () => {
    if (swiper.params.zoom.enabled) {
      enable();
    }
  });
  on('destroy', () => {
    disable();
  });
  on('touchStart', (_s, e) => {
    if (!swiper.zoom.enabled) return;
    onTouchStart(e);
  });
  on('touchEnd', (_s, e) => {
    if (!swiper.zoom.enabled) return;
    onTouchEnd();
  });
  on('doubleTap', (_s, e) => {
    if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
      zoomToggle(e);
    }
  });
  on('transitionEnd', () => {
    if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
      onTransitionEnd();
    }
  });
  on('slideChange', () => {
    if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
      onTransitionEnd();
    }
  });
  Object.assign(swiper.zoom, {
    enable,
    disable,
    in: zoomIn,
    out: zoomOut,
    toggle: zoomToggle
  });
}




/***/ }),

/***/ "./node_modules/swiper/shared/classes-to-selector.mjs":
/*!************************************************************!*\
  !*** ./node_modules/swiper/shared/classes-to-selector.mjs ***!
  \************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   c: () => (/* binding */ classesToSelector)
/* harmony export */ });
function classesToSelector(classes) {
  if (classes === void 0) {
    classes = '';
  }
  return `.${classes.trim().replace(/([\.:!+\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.')}`;
}




/***/ }),

/***/ "./node_modules/swiper/shared/create-element-if-not-defined.mjs":
/*!**********************************************************************!*\
  !*** ./node_modules/swiper/shared/create-element-if-not-defined.mjs ***!
  \**********************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   c: () => (/* binding */ createElementIfNotDefined)
/* harmony export */ });
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils.mjs */ "./node_modules/swiper/shared/utils.mjs");


function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
  if (swiper.params.createElements) {
    Object.keys(checkProps).forEach(key => {
      if (!params[key] && params.auto === true) {
        let element = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(swiper.el, `.${checkProps[key]}`)[0];
        if (!element) {
          element = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.c)('div', checkProps[key]);
          element.className = checkProps[key];
          swiper.el.append(element);
        }
        params[key] = element;
        originalParams[key] = element;
      }
    });
  }
  return params;
}




/***/ }),

/***/ "./node_modules/swiper/shared/create-shadow.mjs":
/*!******************************************************!*\
  !*** ./node_modules/swiper/shared/create-shadow.mjs ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   c: () => (/* binding */ createShadow)
/* harmony export */ });
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils.mjs */ "./node_modules/swiper/shared/utils.mjs");


function createShadow(suffix, slideEl, side) {
  const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}${suffix ? ` swiper-slide-shadow-${suffix}` : ''}`;
  const shadowContainer = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.g)(slideEl);
  let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(' ').join('.')}`);
  if (!shadowEl) {
    shadowEl = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.c)('div', shadowClass.split(' '));
    shadowContainer.append(shadowEl);
  }
  return shadowEl;
}




/***/ }),

/***/ "./node_modules/swiper/shared/effect-init.mjs":
/*!****************************************************!*\
  !*** ./node_modules/swiper/shared/effect-init.mjs ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   e: () => (/* binding */ effectInit)
/* harmony export */ });
function effectInit(params) {
  const {
    effect,
    swiper,
    on,
    setTranslate,
    setTransition,
    overwriteParams,
    perspective,
    recreateShadows,
    getEffectParams
  } = params;
  on('beforeInit', () => {
    if (swiper.params.effect !== effect) return;
    swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
    if (perspective && perspective()) {
      swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
    }
    const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
    Object.assign(swiper.params, overwriteParamsResult);
    Object.assign(swiper.originalParams, overwriteParamsResult);
  });
  on('setTranslate _virtualUpdated', () => {
    if (swiper.params.effect !== effect) return;
    setTranslate();
  });
  on('setTransition', (_s, duration) => {
    if (swiper.params.effect !== effect) return;
    setTransition(duration);
  });
  on('transitionEnd', () => {
    if (swiper.params.effect !== effect) return;
    if (recreateShadows) {
      if (!getEffectParams || !getEffectParams().slideShadows) return;
      // remove shadows
      swiper.slides.forEach(slideEl => {
        slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(shadowEl => shadowEl.remove());
      });
      // create new one
      recreateShadows();
    }
  });
  let requireUpdateOnVirtual;
  on('virtualUpdate', () => {
    if (swiper.params.effect !== effect) return;
    if (!swiper.slides.length) {
      requireUpdateOnVirtual = true;
    }
    requestAnimationFrame(() => {
      if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
        setTranslate();
        requireUpdateOnVirtual = false;
      }
    });
  });
}




/***/ }),

/***/ "./node_modules/swiper/shared/effect-target.mjs":
/*!******************************************************!*\
  !*** ./node_modules/swiper/shared/effect-target.mjs ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   e: () => (/* binding */ effectTarget)
/* harmony export */ });
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils.mjs */ "./node_modules/swiper/shared/utils.mjs");


function effectTarget(effectParams, slideEl) {
  const transformEl = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.g)(slideEl);
  if (transformEl !== slideEl) {
    transformEl.style.backfaceVisibility = 'hidden';
    transformEl.style['-webkit-backface-visibility'] = 'hidden';
  }
  return transformEl;
}




/***/ }),

/***/ "./node_modules/swiper/shared/effect-virtual-transition-end.mjs":
/*!**********************************************************************!*\
  !*** ./node_modules/swiper/shared/effect-virtual-transition-end.mjs ***!
  \**********************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   e: () => (/* binding */ effectVirtualTransitionEnd)
/* harmony export */ });
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils.mjs */ "./node_modules/swiper/shared/utils.mjs");


function effectVirtualTransitionEnd(_ref) {
  let {
    swiper,
    duration,
    transformElements,
    allSlides
  } = _ref;
  const {
    activeIndex
  } = swiper;
  const getSlide = el => {
    if (!el.parentElement) {
      // assume shadow root
      const slide = swiper.slides.find(slideEl => slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
      return slide;
    }
    return el.parentElement;
  };
  if (swiper.params.virtualTranslate && duration !== 0) {
    let eventTriggered = false;
    let transitionEndTarget;
    if (allSlides) {
      transitionEndTarget = transformElements;
    } else {
      transitionEndTarget = transformElements.filter(transformEl => {
        const el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
        return swiper.getSlideIndex(el) === activeIndex;
      });
    }
    transitionEndTarget.forEach(el => {
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.l)(el, () => {
        if (eventTriggered) return;
        if (!swiper || swiper.destroyed) return;
        eventTriggered = true;
        swiper.animating = false;
        const evt = new window.CustomEvent('transitionend', {
          bubbles: true,
          cancelable: true
        });
        swiper.wrapperEl.dispatchEvent(evt);
      });
    });
  }
}




/***/ }),

/***/ "./node_modules/swiper/shared/ssr-window.esm.mjs":
/*!*******************************************************!*\
  !*** ./node_modules/swiper/shared/ssr-window.esm.mjs ***!
  \*******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   a: () => (/* binding */ getWindow),
/* harmony export */   g: () => (/* binding */ getDocument)
/* harmony export */ });
/**
 * SSR Window 5.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2025, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 12, 2025
 */
/* eslint-disable no-param-reassign */
function isObject(obj) {
  return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function extend(target, src) {
  if (target === void 0) {
    target = {};
  }
  if (src === void 0) {
    src = {};
  }
  const noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(key => noExtend.indexOf(key) < 0).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      extend(target[key], src[key]);
    }
  });
}
const ssrDocument = {
  body: {},
  addEventListener() {},
  removeEventListener() {},
  activeElement: {
    blur() {},
    nodeName: ''
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {}
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  }
};
function getDocument() {
  const doc = typeof document !== 'undefined' ? document : {};
  extend(doc, ssrDocument);
  return doc;
}
const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ''
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  },
  history: {
    replaceState() {},
    pushState() {},
    go() {},
    back() {}
  },
  CustomEvent: function CustomEvent() {
    return this;
  },
  addEventListener() {},
  removeEventListener() {},
  getComputedStyle() {
    return {
      getPropertyValue() {
        return '';
      }
    };
  },
  Image() {},
  Date() {},
  screen: {},
  setTimeout() {},
  clearTimeout() {},
  matchMedia() {
    return {};
  },
  requestAnimationFrame(callback) {
    if (typeof setTimeout === 'undefined') {
      callback();
      return null;
    }
    return setTimeout(callback, 0);
  },
  cancelAnimationFrame(id) {
    if (typeof setTimeout === 'undefined') {
      return;
    }
    clearTimeout(id);
  }
};
function getWindow() {
  const win = typeof window !== 'undefined' ? window : {};
  extend(win, ssrWindow);
  return win;
}




/***/ }),

/***/ "./node_modules/swiper/shared/swiper-core.mjs":
/*!****************************************************!*\
  !*** ./node_modules/swiper/shared/swiper-core.mjs ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   S: () => (/* binding */ Swiper),
/* harmony export */   d: () => (/* binding */ defaults)
/* harmony export */ });
/* harmony import */ var _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs");
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./utils.mjs */ "./node_modules/swiper/shared/utils.mjs");



let support;
function calcSupport() {
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  const document = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
  return {
    smoothScroll: document.documentElement && document.documentElement.style && 'scrollBehavior' in document.documentElement.style,
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch)
  };
}
function getSupport() {
  if (!support) {
    support = calcSupport();
  }
  return support;
}

let deviceCached;
function calcDevice(_temp) {
  let {
    userAgent
  } = _temp === void 0 ? {} : _temp;
  const support = getSupport();
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  const platform = window.navigator.platform;
  const ua = userAgent || window.navigator.userAgent;
  const device = {
    ios: false,
    android: false
  };
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const windows = platform === 'Win32';
  let macos = platform === 'MacIntel';

  // iPadOs 13 fix
  const iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];
  if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  }

  // Android
  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }
  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  }

  // Export object
  return device;
}
function getDevice(overrides) {
  if (overrides === void 0) {
    overrides = {};
  }
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }
  return deviceCached;
}

let browser;
function calcBrowser() {
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  const device = getDevice();
  let needPerspectiveFix = false;
  function isSafari() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }
  if (isSafari()) {
    const ua = String(window.navigator.userAgent);
    if (ua.includes('Version/')) {
      const [major, minor] = ua.split('Version/')[1].split(' ')[0].split('.').map(num => Number(num));
      needPerspectiveFix = major < 16 || major === 16 && minor < 2;
    }
  }
  const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent);
  const isSafariBrowser = isSafari();
  const need3dFix = isSafariBrowser || isWebView && device.ios;
  return {
    isSafari: needPerspectiveFix || isSafariBrowser,
    needPerspectiveFix,
    need3dFix,
    isWebView
  };
}
function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }
  return browser;
}

function Resize(_ref) {
  let {
    swiper,
    on,
    emit
  } = _ref;
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  let observer = null;
  let animationFrame = null;
  const resizeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('beforeResize');
    emit('resize');
  };
  const createObserver = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    observer = new ResizeObserver(entries => {
      animationFrame = window.requestAnimationFrame(() => {
        const {
          width,
          height
        } = swiper;
        let newWidth = width;
        let newHeight = height;
        entries.forEach(_ref2 => {
          let {
            contentBoxSize,
            contentRect,
            target
          } = _ref2;
          if (target && target !== swiper.el) return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });
        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };
  const removeObserver = () => {
    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
    }
    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };
  const orientationChangeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('orientationchange');
  };
  on('init', () => {
    if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
      createObserver();
      return;
    }
    window.addEventListener('resize', resizeHandler);
    window.addEventListener('orientationchange', orientationChangeHandler);
  });
  on('destroy', () => {
    removeObserver();
    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('orientationchange', orientationChangeHandler);
  });
}

function Observer(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const observers = [];
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  const attach = function (target, options) {
    if (options === void 0) {
      options = {};
    }
    const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    const observer = new ObserverFunc(mutations => {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (swiper.__preventObserver__) return;
      if (mutations.length === 1) {
        emit('observerUpdate', mutations[0]);
        return;
      }
      const observerUpdate = function observerUpdate() {
        emit('observerUpdate', mutations[0]);
      };
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options).childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    observers.push(observer);
  };
  const init = () => {
    if (!swiper.params.observer) return;
    if (swiper.params.observeParents) {
      const containerParents = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.b)(swiper.hostEl);
      for (let i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    }
    // Observe container
    attach(swiper.hostEl, {
      childList: swiper.params.observeSlideChildren
    });

    // Observe wrapper
    attach(swiper.wrapperEl, {
      attributes: false
    });
  };
  const destroy = () => {
    observers.forEach(observer => {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };
  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on('init', init);
  on('destroy', destroy);
}

/* eslint-disable no-underscore-dangle */

var eventsEmitter = {
  on(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(event => {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },
  once(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    function onceHandler() {
      self.off(events, onceHandler);
      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      handler.apply(self, args);
    }
    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },
  onAny(handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';
    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }
    return self;
  },
  offAny(handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsAnyListeners) return self;
    const index = self.eventsAnyListeners.indexOf(handler);
    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }
    return self;
  },
  off(events, handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(event => {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach((eventHandler, index) => {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },
  emit() {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    let events;
    let data;
    let context;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }
    data.unshift(context);
    const eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(event => {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(eventHandler => {
          eventHandler.apply(context, [event, ...data]);
        });
      }
      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(eventHandler => {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }
};

function updateSize() {
  const swiper = this;
  let width;
  let height;
  const el = swiper.el;
  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = el.clientWidth;
  }
  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = el.clientHeight;
  }
  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  }

  // Subtract paddings
  width = width - parseInt((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.q)(el, 'padding-left') || 0, 10) - parseInt((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.q)(el, 'padding-right') || 0, 10);
  height = height - parseInt((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.q)(el, 'padding-top') || 0, 10) - parseInt((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.q)(el, 'padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  Object.assign(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height
  });
}

function updateSlides() {
  const swiper = this;
  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
  }
  const params = swiper.params;
  const {
    wrapperEl,
    slidesEl,
    size: swiperSize,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  const slides = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [];
  const slidesSizesGrid = [];
  let offsetBefore = params.slidesOffsetBefore;
  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }
  let offsetAfter = params.slidesOffsetAfter;
  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }
  const previousSnapGridLength = swiper.snapGrid.length;
  const previousSlidesGridLength = swiper.slidesGrid.length;
  let spaceBetween = params.spaceBetween;
  let slidePosition = -offsetBefore;
  let prevSlideSize = 0;
  let index = 0;
  if (typeof swiperSize === 'undefined') {
    return;
  }
  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  } else if (typeof spaceBetween === 'string') {
    spaceBetween = parseFloat(spaceBetween);
  }
  swiper.virtualSize = -spaceBetween;

  // reset margins
  slides.forEach(slideEl => {
    if (rtl) {
      slideEl.style.marginLeft = '';
    } else {
      slideEl.style.marginRight = '';
    }
    slideEl.style.marginBottom = '';
    slideEl.style.marginTop = '';
  });

  // reset cssMode offsets
  if (params.centeredSlides && params.cssMode) {
    (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.a)(wrapperEl, '--swiper-centered-offset-before', '');
    (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.a)(wrapperEl, '--swiper-centered-offset-after', '');
  }
  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
  if (gridEnabled) {
    swiper.grid.initSlides(slides);
  } else if (swiper.grid) {
    swiper.grid.unsetSlides();
  }

  // Calc slides
  let slideSize;
  const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(key => {
    return typeof params.breakpoints[key].slidesPerView !== 'undefined';
  }).length > 0;
  for (let i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    let slide;
    if (slides[i]) slide = slides[i];
    if (gridEnabled) {
      swiper.grid.updateSlide(i, slide, slides);
    }
    if (slides[i] && (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.q)(slide, 'display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      if (shouldResetSlideSize) {
        slides[i].style[swiper.getDirectionLabel('width')] = ``;
      }
      const slideStyles = getComputedStyle(slide);
      const currentTransform = slide.style.transform;
      const currentWebKitTransform = slide.style.webkitTransform;
      if (currentTransform) {
        slide.style.transform = 'none';
      }
      if (currentWebKitTransform) {
        slide.style.webkitTransform = 'none';
      }
      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.h)(slide, 'width', true) : (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.h)(slide, 'height', true);
      } else {
        // eslint-disable-next-line
        const width = getDirectionPropertyValue(slideStyles, 'width');
        const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        const boxSizing = slideStyles.getPropertyValue('box-sizing');
        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          const {
            clientWidth,
            offsetWidth
          } = slide;
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }
      if (currentTransform) {
        slide.style.transform = currentTransform;
      }
      if (currentWebKitTransform) {
        slide.style.webkitTransform = currentWebKitTransform;
      }
      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);
      if (slides[i]) {
        slides[i].style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
      }
    }
    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }
    slidesSizesGrid.push(slideSize);
    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }
    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }
  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
  }
  if (params.setWrapperSize) {
    wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
  }
  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid);
  }

  // Remove last grid elements depending on width
  if (!params.centeredSlides) {
    const newSlidesGrid = [];
    for (let i = 0; i < snapGrid.length; i += 1) {
      let slidesGridItem = snapGrid[i];
      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
      if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }
    snapGrid = newSlidesGrid;
    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }
  if (isVirtual && params.loop) {
    const size = slidesSizesGrid[0] + spaceBetween;
    if (params.slidesPerGroup > 1) {
      const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
      const groupSize = size * params.slidesPerGroup;
      for (let i = 0; i < groups; i += 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
      }
    }
    for (let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1) {
      if (params.slidesPerGroup === 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + size);
      }
      slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
      swiper.virtualSize += size;
    }
  }
  if (snapGrid.length === 0) snapGrid = [0];
  if (spaceBetween !== 0) {
    const key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
    slides.filter((_, slideIndex) => {
      if (!params.cssMode || params.loop) return true;
      if (slideIndex === slides.length - 1) {
        return false;
      }
      return true;
    }).forEach(slideEl => {
      slideEl.style[key] = `${spaceBetween}px`;
    });
  }
  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
    snapGrid = snapGrid.map(snap => {
      if (snap <= 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }
  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    const offsetSize = (params.slidesOffsetBefore || 0) + (params.slidesOffsetAfter || 0);
    if (allSlidesSize + offsetSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize - offsetSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }
  Object.assign(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  });
  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.a)(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
    (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.a)(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
    const addToSnapGrid = -swiper.snapGrid[0];
    const addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map(v => v + addToSnapGrid);
    swiper.slidesGrid = swiper.slidesGrid.map(v => v + addToSlidesGrid);
  }
  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }
  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }
  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  swiper.emit('slidesUpdated');
  if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
    const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.el.classList.remove(backFaceHiddenClass);
    }
  }
}

function updateAutoHeight(speed) {
  const swiper = this;
  const activeSlides = [];
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  let newHeight = 0;
  let i;
  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }
  const getSlideByIndex = index => {
    if (isVirtual) {
      return swiper.slides[swiper.getSlideIndexByData(index)];
    }
    return swiper.slides[index];
  };
  // Find slides currently in view
  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || []).forEach(slide => {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        const index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  }

  // Find new height from highest slide in view
  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      const height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  }

  // Update Height
  if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}

function updateSlidesOffset() {
  const swiper = this;
  const slides = swiper.slides;
  // eslint-disable-next-line
  const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
  for (let i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
  }
}

const toggleSlideClasses$1 = (slideEl, condition, className) => {
  if (condition && !slideEl.classList.contains(className)) {
    slideEl.classList.add(className);
  } else if (!condition && slideEl.classList.contains(className)) {
    slideEl.classList.remove(className);
  }
};
function updateSlidesProgress(translate) {
  if (translate === void 0) {
    translate = this && this.translate || 0;
  }
  const swiper = this;
  const params = swiper.params;
  const {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  let offsetCenter = -translate;
  if (rtl) offsetCenter = translate;
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];
  let spaceBetween = params.spaceBetween;
  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
  } else if (typeof spaceBetween === 'string') {
    spaceBetween = parseFloat(spaceBetween);
  }
  for (let i = 0; i < slides.length; i += 1) {
    const slide = slides[i];
    let slideOffset = slide.swiperSlideOffset;
    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }
    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
    const slideBefore = -(offsetCenter - slideOffset);
    const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
    const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
    if (isVisible) {
      swiper.visibleSlides.push(slide);
      swiper.visibleSlidesIndexes.push(i);
    }
    toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
    toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
    slide.progress = rtl ? -slideProgress : slideProgress;
    slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }
}

function updateProgress(translate) {
  const swiper = this;
  if (typeof translate === 'undefined') {
    const multiplier = swiper.rtlTranslate ? -1 : 1;
    // eslint-disable-next-line
    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }
  const params = swiper.params;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  let {
    progress,
    isBeginning,
    isEnd,
    progressLoop
  } = swiper;
  const wasBeginning = isBeginning;
  const wasEnd = isEnd;
  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
    const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
    isBeginning = isBeginningRounded || progress <= 0;
    isEnd = isEndRounded || progress >= 1;
    if (isBeginningRounded) progress = 0;
    if (isEndRounded) progress = 1;
  }
  if (params.loop) {
    const firstSlideIndex = swiper.getSlideIndexByData(0);
    const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
    const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
    const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
    const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
    const translateAbs = Math.abs(translate);
    if (translateAbs >= firstSlideTranslate) {
      progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
    } else {
      progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
    }
    if (progressLoop > 1) progressLoop -= 1;
  }
  Object.assign(swiper, {
    progress,
    progressLoop,
    isBeginning,
    isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }
  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }
  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }
  swiper.emit('progress', progress);
}

const toggleSlideClasses = (slideEl, condition, className) => {
  if (condition && !slideEl.classList.contains(className)) {
    slideEl.classList.add(className);
  } else if (!condition && slideEl.classList.contains(className)) {
    slideEl.classList.remove(className);
  }
};
function updateSlidesClasses() {
  const swiper = this;
  const {
    slides,
    params,
    slidesEl,
    activeIndex
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  const getFilteredSlide = selector => {
    return (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
  };
  let activeSlide;
  let prevSlide;
  let nextSlide;
  if (isVirtual) {
    if (params.loop) {
      let slideIndex = activeIndex - swiper.virtual.slidesBefore;
      if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
      if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
    } else {
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    }
  } else {
    if (gridEnabled) {
      activeSlide = slides.find(slideEl => slideEl.column === activeIndex);
      nextSlide = slides.find(slideEl => slideEl.column === activeIndex + 1);
      prevSlide = slides.find(slideEl => slideEl.column === activeIndex - 1);
    } else {
      activeSlide = slides[activeIndex];
    }
  }
  if (activeSlide) {
    if (!gridEnabled) {
      // Next Slide
      nextSlide = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.r)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
      if (params.loop && !nextSlide) {
        nextSlide = slides[0];
      }

      // Prev Slide
      prevSlide = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.t)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
      if (params.loop && !prevSlide === 0) {
        prevSlide = slides[slides.length - 1];
      }
    }
  }
  slides.forEach(slideEl => {
    toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
    toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
    toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
  });
  swiper.emitSlidesClasses();
}

const processLazyPreloader = (swiper, imageEl) => {
  if (!swiper || swiper.destroyed || !swiper.params) return;
  const slideSelector = () => swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
  const slideEl = imageEl.closest(slideSelector());
  if (slideEl) {
    let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
    if (!lazyEl && swiper.isElement) {
      if (slideEl.shadowRoot) {
        lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
      } else {
        // init later
        requestAnimationFrame(() => {
          if (slideEl.shadowRoot) {
            lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            if (lazyEl) lazyEl.remove();
          }
        });
      }
    }
    if (lazyEl) lazyEl.remove();
  }
};
const unlazy = (swiper, index) => {
  if (!swiper.slides[index]) return;
  const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
  if (imageEl) imageEl.removeAttribute('loading');
};
const preload = swiper => {
  if (!swiper || swiper.destroyed || !swiper.params) return;
  let amount = swiper.params.lazyPreloadPrevNext;
  const len = swiper.slides.length;
  if (!len || !amount || amount < 0) return;
  amount = Math.min(amount, len);
  const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
  const activeIndex = swiper.activeIndex;
  if (swiper.params.grid && swiper.params.grid.rows > 1) {
    const activeColumn = activeIndex;
    const preloadColumns = [activeColumn - amount];
    preloadColumns.push(...Array.from({
      length: amount
    }).map((_, i) => {
      return activeColumn + slidesPerView + i;
    }));
    swiper.slides.forEach((slideEl, i) => {
      if (preloadColumns.includes(slideEl.column)) unlazy(swiper, i);
    });
    return;
  }
  const slideIndexLastInView = activeIndex + slidesPerView - 1;
  if (swiper.params.rewind || swiper.params.loop) {
    for (let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1) {
      const realIndex = (i % len + len) % len;
      if (realIndex < activeIndex || realIndex > slideIndexLastInView) unlazy(swiper, realIndex);
    }
  } else {
    for (let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1) {
      if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) {
        unlazy(swiper, i);
      }
    }
  }
};

function getActiveIndexByTranslate(swiper) {
  const {
    slidesGrid,
    params
  } = swiper;
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  let activeIndex;
  for (let i = 0; i < slidesGrid.length; i += 1) {
    if (typeof slidesGrid[i + 1] !== 'undefined') {
      if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
        activeIndex = i;
      } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
        activeIndex = i + 1;
      }
    } else if (translate >= slidesGrid[i]) {
      activeIndex = i;
    }
  }
  // Normalize slideIndex
  if (params.normalizeSlideIndex) {
    if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
  }
  return activeIndex;
}
function updateActiveIndex(newActiveIndex) {
  const swiper = this;
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  const {
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper;
  let activeIndex = newActiveIndex;
  let snapIndex;
  const getVirtualRealIndex = aIndex => {
    let realIndex = aIndex - swiper.virtual.slidesBefore;
    if (realIndex < 0) {
      realIndex = swiper.virtual.slides.length + realIndex;
    }
    if (realIndex >= swiper.virtual.slides.length) {
      realIndex -= swiper.virtual.slides.length;
    }
    return realIndex;
  };
  if (typeof activeIndex === 'undefined') {
    activeIndex = getActiveIndexByTranslate(swiper);
  }
  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  if (activeIndex === previousIndex && !swiper.params.loop) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }
    return;
  }
  if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
    swiper.realIndex = getVirtualRealIndex(activeIndex);
    return;
  }
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;

  // Get real index
  let realIndex;
  if (swiper.virtual && params.virtual.enabled && params.loop) {
    realIndex = getVirtualRealIndex(activeIndex);
  } else if (gridEnabled) {
    const firstSlideInColumn = swiper.slides.find(slideEl => slideEl.column === activeIndex);
    let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
    if (Number.isNaN(activeSlideIndex)) {
      activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
    }
    realIndex = Math.floor(activeSlideIndex / params.grid.rows);
  } else if (swiper.slides[activeIndex]) {
    const slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
    if (slideIndex) {
      realIndex = parseInt(slideIndex, 10);
    } else {
      realIndex = activeIndex;
    }
  } else {
    realIndex = activeIndex;
  }
  Object.assign(swiper, {
    previousSnapIndex,
    snapIndex,
    previousRealIndex,
    realIndex,
    previousIndex,
    activeIndex
  });
  if (swiper.initialized) {
    preload(swiper);
  }
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');
  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    if (previousRealIndex !== realIndex) {
      swiper.emit('realIndexChange');
    }
    swiper.emit('slideChange');
  }
}

function updateClickedSlide(el, path) {
  const swiper = this;
  const params = swiper.params;
  let slide = el.closest(`.${params.slideClass}, swiper-slide`);
  if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) {
    [...path.slice(path.indexOf(el) + 1, path.length)].forEach(pathEl => {
      if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) {
        slide = pathEl;
      }
    });
  }
  let slideFound = false;
  let slideIndex;
  if (slide) {
    for (let i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }
  if (slide && slideFound) {
    swiper.clickedSlide = slide;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }
  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

var update = {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide
};

function getSwiperTranslate(axis) {
  if (axis === void 0) {
    axis = this.isHorizontal() ? 'x' : 'y';
  }
  const swiper = this;
  const {
    params,
    rtlTranslate: rtl,
    translate,
    wrapperEl
  } = swiper;
  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }
  if (params.cssMode) {
    return translate;
  }
  let currentTranslate = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.k)(wrapperEl, axis);
  currentTranslate += swiper.cssOverflowAdjustment();
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}

function setTranslate(translate, byController) {
  const swiper = this;
  const {
    rtlTranslate: rtl,
    params,
    wrapperEl,
    progress
  } = swiper;
  let x = 0;
  let y = 0;
  const z = 0;
  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }
  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }
  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y;
  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    if (swiper.isHorizontal()) {
      x -= swiper.cssOverflowAdjustment();
    } else {
      y -= swiper.cssOverflowAdjustment();
    }
    wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
  }

  // Check if we need to update progress
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }
  swiper.emit('setTranslate', swiper.translate, byController);
}

function minTranslate() {
  return -this.snapGrid[0];
}

function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}

function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
  if (translate === void 0) {
    translate = 0;
  }
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (translateBounds === void 0) {
    translateBounds = true;
  }
  const swiper = this;
  const {
    params,
    wrapperEl
  } = swiper;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  const minTranslate = swiper.minTranslate();
  const maxTranslate = swiper.maxTranslate();
  let newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate;

  // Update progress
  swiper.updateProgress(newTranslate);
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      if (!swiper.support.smoothScroll) {
        (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.u)({
          swiper,
          targetPosition: -newTranslate,
          side: isH ? 'left' : 'top'
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: -newTranslate,
        behavior: 'smooth'
      });
    }
    return true;
  }
  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }
    if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;
          swiper.animating = false;
          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }
      swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
    }
  }
  return true;
}

var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo
};

function setTransition(duration, byController) {
  const swiper = this;
  if (!swiper.params.cssMode) {
    swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
    swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
  }
  swiper.emit('setTransition', duration, byController);
}

function transitionEmit(_ref) {
  let {
    swiper,
    runCallbacks,
    direction,
    step
  } = _ref;
  const {
    activeIndex,
    previousIndex
  } = swiper;
  let dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }
  swiper.emit(`transition${step}`);
  if (runCallbacks && dir === 'reset') {
    swiper.emit(`slideResetTransition${step}`);
  } else if (runCallbacks && activeIndex !== previousIndex) {
    swiper.emit(`slideChangeTransition${step}`);
    if (dir === 'next') {
      swiper.emit(`slideNextTransition${step}`);
    } else {
      swiper.emit(`slidePrevTransition${step}`);
    }
  }
}

function transitionStart(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    params
  } = swiper;
  if (params.cssMode) return;
  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'Start'
  });
}

function transitionEnd(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'End'
  });
}

var transition = {
  setTransition,
  transitionStart,
  transitionEnd
};

function slideTo(index, speed, runCallbacks, internal, initial) {
  if (index === void 0) {
    index = 0;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (typeof index === 'string') {
    index = parseInt(index, 10);
  }
  const swiper = this;
  let slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  const {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper;
  if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  const translate = -snapGrid[snapIndex];
  // Normalize slideIndex
  if (params.normalizeSlideIndex) {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      const normalizedTranslate = -Math.floor(translate * 100);
      const normalizedGrid = Math.floor(slidesGrid[i] * 100);
      const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  }
  // Directions locks
  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) {
      return false;
    }
    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) {
        return false;
      }
    }
  }
  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  // Update progress
  swiper.updateProgress(translate);
  let direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset';

  // initial virtual
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  const isInitialVirtual = isVirtual && initial;
  // Update Index
  if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
    swiper.updateActiveIndex(slideIndex);
    // Update Height
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    swiper.updateSlidesClasses();
    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }
    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }
    return false;
  }
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    const t = rtl ? translate : -translate;
    if (speed === 0) {
      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = 'none';
        swiper._immediateVirtual = true;
      }
      if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
        swiper._cssModeVirtualInitialSet = true;
        requestAnimationFrame(() => {
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
        });
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
      }
      if (isVirtual) {
        requestAnimationFrame(() => {
          swiper.wrapperEl.style.scrollSnapType = '';
          swiper._immediateVirtual = false;
        });
      }
    } else {
      if (!swiper.support.smoothScroll) {
        (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.u)({
          swiper,
          targetPosition: t,
          side: isH ? 'left' : 'top'
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: t,
        behavior: 'smooth'
      });
    }
    return true;
  }
  const browser = getBrowser();
  const isSafari = browser.isSafari;
  if (isVirtual && !initial && isSafari && swiper.isElement) {
    swiper.virtual.update(false, false, slideIndex);
  }
  swiper.setTransition(speed);
  swiper.setTranslate(translate);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit('beforeTransitionStart', speed, internal);
  swiper.transitionStart(runCallbacks, direction);
  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;
    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
        if (!swiper || swiper.destroyed) return;
        if (e.target !== this) return;
        swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }
    swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
  }
  return true;
}

function slideToLoop(index, speed, runCallbacks, internal) {
  if (index === void 0) {
    index = 0;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (typeof index === 'string') {
    const indexAsNumber = parseInt(index, 10);
    index = indexAsNumber;
  }
  const swiper = this;
  if (swiper.destroyed) return;
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
  let newIndex = index;
  if (swiper.params.loop) {
    if (swiper.virtual && swiper.params.virtual.enabled) {
      // eslint-disable-next-line
      newIndex = newIndex + swiper.virtual.slidesBefore;
    } else {
      let targetSlideIndex;
      if (gridEnabled) {
        const slideIndex = newIndex * swiper.params.grid.rows;
        targetSlideIndex = swiper.slides.find(slideEl => slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
      } else {
        targetSlideIndex = swiper.getSlideIndexByData(newIndex);
      }
      const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
      const {
        centeredSlides
      } = swiper.params;
      let slidesPerView = swiper.params.slidesPerView;
      if (slidesPerView === 'auto') {
        slidesPerView = swiper.slidesPerViewDynamic();
      } else {
        slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) {
          slidesPerView = slidesPerView + 1;
        }
      }
      let needLoopFix = cols - targetSlideIndex < slidesPerView;
      if (centeredSlides) {
        needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
      }
      if (internal && centeredSlides && swiper.params.slidesPerView !== 'auto' && !gridEnabled) {
        needLoopFix = false;
      }
      if (needLoopFix) {
        const direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
        swiper.loopFix({
          direction,
          slideTo: true,
          activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
          slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
        });
      }
      if (gridEnabled) {
        const slideIndex = newIndex * swiper.params.grid.rows;
        newIndex = swiper.slides.find(slideEl => slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
      } else {
        newIndex = swiper.getSlideIndexByData(newIndex);
      }
    }
  }
  requestAnimationFrame(() => {
    swiper.slideTo(newIndex, speed, runCallbacks, internal);
  });
  return swiper;
}

/* eslint no-unused-vars: "off" */
function slideNext(speed, runCallbacks, internal) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    enabled,
    params,
    animating
  } = swiper;
  if (!enabled || swiper.destroyed) return swiper;
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  let perGroup = params.slidesPerGroup;
  if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
  }
  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding) return false;
    swiper.loopFix({
      direction: 'next'
    });
    // eslint-disable-next-line
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
    if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
      requestAnimationFrame(() => {
        swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
      });
      return true;
    }
  }
  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }
  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slidePrev(speed, runCallbacks, internal) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    params,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled,
    animating
  } = swiper;
  if (!enabled || swiper.destroyed) return swiper;
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  const isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding) return false;
    swiper.loopFix({
      direction: 'prev'
    });
    // eslint-disable-next-line
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
  }
  const translate = rtlTranslate ? swiper.translate : -swiper.translate;
  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }
  const normalizedTranslate = normalize(translate);
  const normalizedSnapGrid = snapGrid.map(val => normalize(val));
  const isFreeMode = params.freeMode && params.freeMode.enabled;
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
    let prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      if (normalizedTranslate >= snap) {
        // prevSnap = snap;
        prevSnapIndex = snapIndex;
      }
    });
    if (typeof prevSnapIndex !== 'undefined') {
      prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }
  let prevIndex = 0;
  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }
  if (params.rewind && swiper.isBeginning) {
    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
    requestAnimationFrame(() => {
      swiper.slideTo(prevIndex, speed, runCallbacks, internal);
    });
    return true;
  }
  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideReset(speed, runCallbacks, internal) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  if (swiper.destroyed) return;
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideToClosest(speed, runCallbacks, internal, threshold) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (threshold === void 0) {
    threshold = 0.5;
  }
  const swiper = this;
  if (swiper.destroyed) return;
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  let index = swiper.activeIndex;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    const currentSnap = swiper.snapGrid[snapIndex];
    const nextSnap = swiper.snapGrid[snapIndex + 1];
    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    const prevSnap = swiper.snapGrid[snapIndex - 1];
    const currentSnap = swiper.snapGrid[snapIndex];
    if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }
  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}

function slideToClickedSlide() {
  const swiper = this;
  if (swiper.destroyed) return;
  const {
    params,
    slidesEl
  } = swiper;
  const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper.clickedIndex;
  let realIndex;
  const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = swiper.getSlideIndex((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
        (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.n)(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = swiper.getSlideIndex((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.n)(() => {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

var slide = {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide
};

function loopCreate(slideRealIndex, initial) {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
  const initSlides = () => {
    const slides = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
    slides.forEach((el, index) => {
      el.setAttribute('data-swiper-slide-index', index);
    });
  };
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
  const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
  const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
  const addBlankSlides = amountOfSlides => {
    for (let i = 0; i < amountOfSlides; i += 1) {
      const slideEl = swiper.isElement ? (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)('swiper-slide', [params.slideBlankClass]) : (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)('div', [params.slideClass, params.slideBlankClass]);
      swiper.slidesEl.append(slideEl);
    }
  };
  if (shouldFillGroup) {
    if (params.loopAddBlankSlides) {
      const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
      addBlankSlides(slidesToAdd);
      swiper.recalcSlides();
      swiper.updateSlides();
    } else {
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.v)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
    }
    initSlides();
  } else if (shouldFillGrid) {
    if (params.loopAddBlankSlides) {
      const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
      addBlankSlides(slidesToAdd);
      swiper.recalcSlides();
      swiper.updateSlides();
    } else {
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.v)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
    }
    initSlides();
  } else {
    initSlides();
  }
  swiper.loopFix({
    slideRealIndex,
    direction: params.centeredSlides ? undefined : 'next',
    initial
  });
}

function loopFix(_temp) {
  let {
    slideRealIndex,
    slideTo = true,
    direction,
    setTranslate,
    activeSlideIndex,
    initial,
    byController,
    byMousewheel
  } = _temp === void 0 ? {} : _temp;
  const swiper = this;
  if (!swiper.params.loop) return;
  swiper.emit('beforeLoopFix');
  const {
    slides,
    allowSlidePrev,
    allowSlideNext,
    slidesEl,
    params
  } = swiper;
  const {
    centeredSlides,
    initialSlide
  } = params;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  if (swiper.virtual && params.virtual.enabled) {
    if (slideTo) {
      if (!params.centeredSlides && swiper.snapIndex === 0) {
        swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
      } else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) {
        swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
      } else if (swiper.snapIndex === swiper.snapGrid.length - 1) {
        swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit('loopFix');
    return;
  }
  let slidesPerView = params.slidesPerView;
  if (slidesPerView === 'auto') {
    slidesPerView = swiper.slidesPerViewDynamic();
  } else {
    slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
    if (centeredSlides && slidesPerView % 2 === 0) {
      slidesPerView = slidesPerView + 1;
    }
  }
  const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
  let loopedSlides = slidesPerGroup;
  if (loopedSlides % slidesPerGroup !== 0) {
    loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
  }
  loopedSlides += params.loopAdditionalSlides;
  swiper.loopedSlides = loopedSlides;
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
    (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.v)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
  } else if (gridEnabled && params.grid.fill === 'row') {
    (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.v)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
  }
  const prependSlidesIndexes = [];
  const appendSlidesIndexes = [];
  const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
  const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !centeredSlides;
  let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
  if (typeof activeSlideIndex === 'undefined') {
    activeSlideIndex = swiper.getSlideIndex(slides.find(el => el.classList.contains(params.slideActiveClass)));
  } else {
    activeIndex = activeSlideIndex;
  }
  const isNext = direction === 'next' || !direction;
  const isPrev = direction === 'prev' || !direction;
  let slidesPrepended = 0;
  let slidesAppended = 0;
  const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
  const activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
  // prepend last slides before start
  if (activeColIndexWithShift < loopedSlides) {
    slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
    for (let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1) {
      const index = i - Math.floor(i / cols) * cols;
      if (gridEnabled) {
        const colIndexToPrepend = cols - index - 1;
        for (let i = slides.length - 1; i >= 0; i -= 1) {
          if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
        }
        // slides.forEach((slide, slideIndex) => {
        //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
        // });
      } else {
        prependSlidesIndexes.push(cols - index - 1);
      }
    }
  } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
    slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
    if (isInitialOverflow) {
      slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
    }
    for (let i = 0; i < slidesAppended; i += 1) {
      const index = i - Math.floor(i / cols) * cols;
      if (gridEnabled) {
        slides.forEach((slide, slideIndex) => {
          if (slide.column === index) appendSlidesIndexes.push(slideIndex);
        });
      } else {
        appendSlidesIndexes.push(index);
      }
    }
  }
  swiper.__preventObserver__ = true;
  requestAnimationFrame(() => {
    swiper.__preventObserver__ = false;
  });
  if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
    if (appendSlidesIndexes.includes(activeSlideIndex)) {
      appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (prependSlidesIndexes.includes(activeSlideIndex)) {
      prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
  }
  if (isPrev) {
    prependSlidesIndexes.forEach(index => {
      slides[index].swiperLoopMoveDOM = true;
      slidesEl.prepend(slides[index]);
      slides[index].swiperLoopMoveDOM = false;
    });
  }
  if (isNext) {
    appendSlidesIndexes.forEach(index => {
      slides[index].swiperLoopMoveDOM = true;
      slidesEl.append(slides[index]);
      slides[index].swiperLoopMoveDOM = false;
    });
  }
  swiper.recalcSlides();
  if (params.slidesPerView === 'auto') {
    swiper.updateSlides();
  } else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) {
    swiper.slides.forEach((slide, slideIndex) => {
      swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  if (slideTo) {
    if (prependSlidesIndexes.length > 0 && isPrev) {
      if (typeof slideRealIndex === 'undefined') {
        const currentSlideTranslate = swiper.slidesGrid[activeIndex];
        const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
        const diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - diff);
        } else {
          swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
          if (setTranslate) {
            swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
            swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
          }
        }
      } else {
        if (setTranslate) {
          const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
          swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
          swiper.touchEventsData.currentTranslate = swiper.translate;
        }
      }
    } else if (appendSlidesIndexes.length > 0 && isNext) {
      if (typeof slideRealIndex === 'undefined') {
        const currentSlideTranslate = swiper.slidesGrid[activeIndex];
        const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
        const diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - diff);
        } else {
          swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
          if (setTranslate) {
            swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
            swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
          }
        }
      } else {
        const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
        swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
      }
    }
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.controller && swiper.controller.control && !byController) {
    const loopParams = {
      slideRealIndex,
      direction,
      setTranslate,
      activeSlideIndex,
      byController: true
    };
    if (Array.isArray(swiper.controller.control)) {
      swiper.controller.control.forEach(c => {
        if (!c.destroyed && c.params.loop) c.loopFix({
          ...loopParams,
          slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
      });
    } else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) {
      swiper.controller.control.loopFix({
        ...loopParams,
        slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
      });
    }
  }
  swiper.emit('loopFix');
}

function loopDestroy() {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
  swiper.recalcSlides();
  const newSlidesOrder = [];
  swiper.slides.forEach(slideEl => {
    const index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
    newSlidesOrder[index] = slideEl;
  });
  swiper.slides.forEach(slideEl => {
    slideEl.removeAttribute('data-swiper-slide-index');
  });
  newSlidesOrder.forEach(slideEl => {
    slidesEl.append(slideEl);
  });
  swiper.recalcSlides();
  swiper.slideTo(swiper.realIndex, 0);
}

var loop = {
  loopCreate,
  loopFix,
  loopDestroy
};

function setGrabCursor(moving) {
  const swiper = this;
  if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  el.style.cursor = 'move';
  el.style.cursor = moving ? 'grabbing' : 'grab';
  if (swiper.isElement) {
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
  }
}

function unsetGrabCursor() {
  const swiper = this;
  if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
  if (swiper.isElement) {
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
  }
}

var grabCursor = {
  setGrabCursor,
  unsetGrabCursor
};

// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function closestElement(selector, base) {
  if (base === void 0) {
    base = this;
  }
  function __closestFrom(el) {
    if (!el || el === (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)() || el === (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    const found = el.closest(selector);
    if (!found && !el.getRootNode) {
      return null;
    }
    return found || __closestFrom(el.getRootNode().host);
  }
  return __closestFrom(base);
}
function preventEdgeSwipe(swiper, event, startX) {
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  const {
    params
  } = swiper;
  const edgeSwipeDetection = params.edgeSwipeDetection;
  const edgeSwipeThreshold = params.edgeSwipeThreshold;
  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
      return true;
    }
    return false;
  }
  return true;
}
function onTouchStart(event) {
  const swiper = this;
  const document = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  const data = swiper.touchEventsData;
  if (e.type === 'pointerdown') {
    if (data.pointerId !== null && data.pointerId !== e.pointerId) {
      return;
    }
    data.pointerId = e.pointerId;
  } else if (e.type === 'touchstart' && e.targetTouches.length === 1) {
    data.touchId = e.targetTouches[0].identifier;
  }
  if (e.type === 'touchstart') {
    // don't proceed touch event
    preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
    return;
  }
  const {
    params,
    touches,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && e.pointerType === 'mouse') return;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }
  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }
  let targetEl = e.target;
  if (params.touchEventsTarget === 'wrapper') {
    if (!(0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.w)(targetEl, swiper.wrapperEl)) return;
  }
  if ('which' in e && e.which === 3) return;
  if ('button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return;

  // change target el for shadow root component
  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
  // eslint-disable-next-line
  const eventPath = e.composedPath ? e.composedPath() : e.path;
  if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
    targetEl = eventPath[0];
  }
  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
  const isTargetShadow = !!(e.target && e.target.shadowRoot);

  // use closestElement for shadow root element to get the actual closest for nested shadow root element
  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
    swiper.allowClick = true;
    return;
  }
  if (params.swipeHandler) {
    if (!targetEl.closest(params.swipeHandler)) return;
  }
  touches.currentX = e.pageX;
  touches.currentY = e.pageY;
  const startX = touches.currentX;
  const startY = touches.currentY;

  // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  if (!preventEdgeSwipe(swiper, e, startX)) {
    return;
  }
  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.f)();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;
  let preventDefault = true;
  if (targetEl.matches(data.focusableElements)) {
    preventDefault = false;
    if (targetEl.nodeName === 'SELECT') {
      data.isTouched = false;
    }
  }
  if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== targetEl && (e.pointerType === 'mouse' || e.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) {
    document.activeElement.blur();
  }
  const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
  if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) {
    e.preventDefault();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }
  swiper.emit('touchStart', e);
}

function onTouchMove(event) {
  const document = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && event.pointerType === 'mouse') return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  if (e.type === 'pointermove') {
    if (data.touchId !== null) return; // return from pointer if we use touch
    const id = e.pointerId;
    if (id !== data.pointerId) return;
  }
  let targetTouch;
  if (e.type === 'touchmove') {
    targetTouch = [...e.changedTouches].find(t => t.identifier === data.touchId);
    if (!targetTouch || targetTouch.identifier !== data.touchId) return;
  } else {
    targetTouch = e;
  }
  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    return;
  }
  const pageX = targetTouch.pageX;
  const pageY = targetTouch.pageY;
  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }
  if (!swiper.allowTouchMove) {
    if (!e.target.matches(data.focusableElements)) {
      swiper.allowClick = false;
    }
    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.f)();
    }
    return;
  }
  if (params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) {
      return;
    } else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) {
      return;
    }
  }
  if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== e.target && e.pointerType !== 'mouse') {
    document.activeElement.blur();
  }
  if (document.activeElement) {
    if (e.target === document.activeElement && e.target.matches(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }
  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }
  touches.previousX = touches.currentX;
  touches.previousY = touches.currentY;
  touches.currentX = pageX;
  touches.currentY = pageY;
  const diffX = touches.currentX - touches.startX;
  const diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
  if (typeof data.isScrolling === 'undefined') {
    let touchAngle;
    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }
  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }
  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }
  if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
    data.isTouched = false;
    return;
  }
  if (!data.startMoving) {
    return;
  }
  swiper.allowClick = false;
  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }
  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }
  let diff = swiper.isHorizontal() ? diffX : diffY;
  let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
  if (params.oneWayMovement) {
    diff = Math.abs(diff) * (rtl ? 1 : -1);
    touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
  }
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) {
    diff = -diff;
    touchesDiff = -touchesDiff;
  }
  const prevTouchesDirection = swiper.touchesDirection;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
  const isLoop = swiper.params.loop && !params.cssMode;
  const allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
  if (!data.isMoved) {
    if (isLoop && allowLoopFix) {
      swiper.loopFix({
        direction: swiper.swipeDirection
      });
    }
    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);
    if (swiper.animating) {
      const evt = new window.CustomEvent('transitionend', {
        bubbles: true,
        cancelable: true,
        detail: {
          bySwiperTouchMove: true
        }
      });
      swiper.wrapperEl.dispatchEvent(evt);
    }
    data.allowMomentumBounce = false;
    // Grab Cursor
    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }
    swiper.emit('sliderFirstMove', e);
  }
  let loopFixed;
  new Date().getTime();
  if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
    Object.assign(touches, {
      startX: pageX,
      startY: pageY,
      currentX: pageX,
      currentY: pageY,
      startTranslate: data.currentTranslate
    });
    data.loopSwapReset = true;
    data.startTranslate = data.currentTranslate;
    return;
  }
  swiper.emit('sliderMove', e);
  data.isMoved = true;
  data.currentTranslate = diff + data.startTranslate;
  let disableParentSwiper = true;
  let resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }
  if (diff > 0) {
    if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) {
      swiper.loopFix({
        direction: 'prev',
        setTranslate: true,
        activeSlideIndex: 0
      });
    }
    if (data.currentTranslate > swiper.minTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
      }
    }
  } else if (diff < 0) {
    if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) {
      swiper.loopFix({
        direction: 'next',
        setTranslate: true,
        activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
      });
    }
    if (data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
      }
    }
  }
  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  }

  // Directions locks
  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  }

  // Threshold
  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }
  if (!params.followFinger || params.cssMode) return;

  // Update active index in free mode
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  }
  // Update progress
  swiper.updateProgress(data.currentTranslate);
  // Update translate
  swiper.setTranslate(data.currentTranslate);
}

function onTouchEnd(event) {
  const swiper = this;
  const data = swiper.touchEventsData;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  let targetTouch;
  const isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
  if (!isTouchEvent) {
    if (data.touchId !== null) return; // return from pointer if we use touch
    if (e.pointerId !== data.pointerId) return;
    targetTouch = e;
  } else {
    targetTouch = [...e.changedTouches].find(t => t.identifier === data.touchId);
    if (!targetTouch || targetTouch.identifier !== data.touchId) return;
  }
  if (['pointercancel', 'pointerout', 'pointerleave', 'contextmenu'].includes(e.type)) {
    const proceed = ['pointercancel', 'contextmenu'].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
    if (!proceed) {
      return;
    }
  }
  data.pointerId = null;
  data.touchId = null;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && e.pointerType === 'mouse') return;
  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }
  data.allowTouchCallbacks = false;
  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  // Return Grab Cursor
  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  }

  // Time diff
  const touchEndTime = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.f)();
  const timeDiff = touchEndTime - data.touchStartTime;

  // Tap, doubleTap, Click
  if (swiper.allowClick) {
    const pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
    swiper.emit('tap click', e);
    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }
  data.lastClickTime = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.f)();
  (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.n)(() => {
    if (!swiper.destroyed) swiper.allowClick = true;
  });
  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  let currentPos;
  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }
  if (params.cssMode) {
    return;
  }
  if (params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos
    });
    return;
  }

  // Find current slide
  const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
  let stopIndex = 0;
  let groupSize = swiper.slidesSizesGrid[0];
  for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (typeof slidesGrid[i + increment] !== 'undefined') {
      if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + increment] - slidesGrid[i];
      }
    } else if (swipeToLast || currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }
  let rewindFirstIndex = null;
  let rewindLastIndex = null;
  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  }
  // Find current slide size
  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);else swiper.slideTo(stopIndex);
    }
    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }
      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}

function onResize() {
  const swiper = this;
  const {
    params,
    el
  } = swiper;
  if (el && el.offsetWidth === 0) return;

  // Breakpoints
  if (params.breakpoints) {
    swiper.setBreakpoint();
  }

  // Save locks
  const {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper;
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;

  // Disable locks on resize
  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();
  const isVirtualLoop = isVirtual && params.loop;
  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    if (swiper.params.loop && !isVirtual) {
      swiper.slideToLoop(swiper.realIndex, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }
  }
  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    clearTimeout(swiper.autoplay.resizeTimeout);
    swiper.autoplay.resizeTimeout = setTimeout(() => {
      if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        swiper.autoplay.resume();
      }
    }, 500);
  }
  // Return locks after resize
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

function onClick(e) {
  const swiper = this;
  if (!swiper.enabled) return;
  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();
    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

function onScroll() {
  const swiper = this;
  const {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;
  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  }
  // eslint-disable-next-line
  if (swiper.translate === 0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }
  swiper.emit('setTranslate', swiper.translate, false);
}

function onLoad(e) {
  const swiper = this;
  processLazyPreloader(swiper, e.target);
  if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) {
    return;
  }
  swiper.update();
}

function onDocumentTouchStart() {
  const swiper = this;
  if (swiper.documentTouchHandlerProceeded) return;
  swiper.documentTouchHandlerProceeded = true;
  if (swiper.params.touchReleaseOnEdges) {
    swiper.el.style.touchAction = 'auto';
  }
}

const events = (swiper, method) => {
  const document = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
  const {
    params,
    el,
    wrapperEl,
    device
  } = swiper;
  const capture = !!params.nested;
  const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
  const swiperMethod = method;
  if (!el || typeof el === 'string') return;

  // Touch Events
  document[domMethod]('touchstart', swiper.onDocumentTouchStart, {
    passive: false,
    capture
  });
  el[domMethod]('touchstart', swiper.onTouchStart, {
    passive: false
  });
  el[domMethod]('pointerdown', swiper.onTouchStart, {
    passive: false
  });
  document[domMethod]('touchmove', swiper.onTouchMove, {
    passive: false,
    capture
  });
  document[domMethod]('pointermove', swiper.onTouchMove, {
    passive: false,
    capture
  });
  document[domMethod]('touchend', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointerup', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointercancel', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('touchcancel', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointerout', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointerleave', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('contextmenu', swiper.onTouchEnd, {
    passive: true
  });

  // Prevent Links Clicks
  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]('click', swiper.onClick, true);
  }
  if (params.cssMode) {
    wrapperEl[domMethod]('scroll', swiper.onScroll);
  }

  // Resize handler
  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper[swiperMethod]('observerUpdate', onResize, true);
  }

  // Images loader
  el[domMethod]('load', swiper.onLoad, {
    capture: true
  });
};
function attachEvents() {
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);
  swiper.onDocumentTouchStart = onDocumentTouchStart.bind(swiper);
  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }
  swiper.onClick = onClick.bind(swiper);
  swiper.onLoad = onLoad.bind(swiper);
  events(swiper, 'on');
}
function detachEvents() {
  const swiper = this;
  events(swiper, 'off');
}
var events$1 = {
  attachEvents,
  detachEvents
};

const isGridEnabled = (swiper, params) => {
  return swiper.grid && params.grid && params.grid.rows > 1;
};
function setBreakpoint() {
  const swiper = this;
  const {
    realIndex,
    initialized,
    params,
    el
  } = swiper;
  const breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
  const document = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();

  // Get breakpoint for window/container width and update parameters
  const breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase ? params.breakpointsBase : 'container';
  const breakpointContainer = ['window', 'container'].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document.querySelector(params.breakpointsBase);
  const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
  const breakpointParams = breakpointOnlyParams || swiper.originalParams;
  const wasMultiRow = isGridEnabled(swiper, params);
  const isMultiRow = isGridEnabled(swiper, breakpointParams);
  const wasGrabCursor = swiper.params.grabCursor;
  const isGrabCursor = breakpointParams.grabCursor;
  const wasEnabled = params.enabled;
  if (wasMultiRow && !isMultiRow) {
    el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    el.classList.add(`${params.containerModifierClass}grid`);
    if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
      el.classList.add(`${params.containerModifierClass}grid-column`);
    }
    swiper.emitContainerClasses();
  }
  if (wasGrabCursor && !isGrabCursor) {
    swiper.unsetGrabCursor();
  } else if (!wasGrabCursor && isGrabCursor) {
    swiper.setGrabCursor();
  }

  // Toggle navigation, pagination, scrollbar
  ['navigation', 'pagination', 'scrollbar'].forEach(prop => {
    if (typeof breakpointParams[prop] === 'undefined') return;
    const wasModuleEnabled = params[prop] && params[prop].enabled;
    const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }
    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
  const wasLoop = params.loop;
  if (directionChanged && initialized) {
    swiper.changeDirection();
  }
  (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.x)(swiper.params, breakpointParams);
  const isEnabled = swiper.params.enabled;
  const hasLoop = swiper.params.loop;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });
  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }
  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);
  if (initialized) {
    if (needsReLoop) {
      swiper.loopDestroy();
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (!wasLoop && hasLoop) {
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (wasLoop && !hasLoop) {
      swiper.loopDestroy();
    }
  }
  swiper.emit('breakpoint', breakpointParams);
}

function getBreakpoint(breakpoints, base, containerEl) {
  if (base === void 0) {
    base = 'window';
  }
  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  let breakpoint = false;
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  const points = Object.keys(breakpoints).map(point => {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      const minRatio = parseFloat(point.substr(1));
      const value = currentHeight * minRatio;
      return {
        value,
        point
      };
    }
    return {
      value: point,
      point
    };
  });
  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
  for (let i = 0; i < points.length; i += 1) {
    const {
      point,
      value
    } = points[i];
    if (base === 'window') {
      if (window.matchMedia(`(min-width: ${value}px)`).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }
  return breakpoint || 'max';
}

var breakpoints = {
  setBreakpoint,
  getBreakpoint
};

function prepareClasses(entries, prefix) {
  const resultClasses = [];
  entries.forEach(item => {
    if (typeof item === 'object') {
      Object.keys(item).forEach(classNames => {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}
function addClasses() {
  const swiper = this;
  const {
    classNames,
    params,
    rtl,
    el,
    device
  } = swiper;
  // prettier-ignore
  const suffixes = prepareClasses(['initialized', params.direction, {
    'free-mode': swiper.params.freeMode && params.freeMode.enabled
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'grid': params.grid && params.grid.rows > 1
  }, {
    'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }, {
    'centered': params.cssMode && params.centeredSlides
  }, {
    'watch-progress': params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push(...suffixes);
  el.classList.add(...classNames);
  swiper.emitContainerClasses();
}

function removeClasses() {
  const swiper = this;
  const {
    el,
    classNames
  } = swiper;
  if (!el || typeof el === 'string') return;
  el.classList.remove(...classNames);
  swiper.emitContainerClasses();
}

var classes = {
  addClasses,
  removeClasses
};

function checkOverflow() {
  const swiper = this;
  const {
    isLocked: wasLocked,
    params
  } = swiper;
  const {
    slidesOffsetBefore
  } = params;
  if (slidesOffsetBefore) {
    const lastSlideIndex = swiper.slides.length - 1;
    const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }
  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }
  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }
  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }
  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
  }
}
var checkOverflow$1 = {
  checkOverflow
};

var defaults = {
  init: true,
  direction: 'horizontal',
  oneWayMovement: false,
  swiperElementNodeName: 'SWIPER-CONTAINER',
  touchEventsTarget: 'wrapper',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  eventsPrefix: 'swiper',
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 5,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // loop
  loop: false,
  loopAddBlankSlides: true,
  loopAdditionalSlides: 0,
  loopPreventsSliding: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: 'swiper-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-blank',
  slideActiveClass: 'swiper-slide-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideFullyVisibleClass: 'swiper-slide-fully-visible',
  slideNextClass: 'swiper-slide-next',
  slidePrevClass: 'swiper-slide-prev',
  wrapperClass: 'swiper-wrapper',
  lazyPreloaderClass: 'swiper-lazy-preloader',
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};

function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj) {
    if (obj === void 0) {
      obj = {};
    }
    const moduleParamName = Object.keys(obj)[0];
    const moduleParams = obj[moduleParamName];
    if (typeof moduleParams !== 'object' || moduleParams === null) {
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.x)(allModulesParams, obj);
      return;
    }
    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }
    if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) {
      params[moduleParamName].auto = true;
    }
    if (['pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) {
      params[moduleParamName].auto = true;
    }
    if (!(moduleParamName in params && 'enabled' in moduleParams)) {
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.x)(allModulesParams, obj);
      return;
    }
    if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }
    if (!params[moduleParamName]) params[moduleParamName] = {
      enabled: false
    };
    (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.x)(allModulesParams, obj);
  };
}

/* eslint no-param-reassign: "off" */
const prototypes = {
  eventsEmitter,
  update,
  translate,
  transition,
  slide,
  loop,
  grabCursor,
  events: events$1,
  breakpoints,
  checkOverflow: checkOverflow$1,
  classes
};
const extendedDefaults = {};
class Swiper {
  constructor() {
    let el;
    let params;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      [el, params] = args;
    }
    if (!params) params = {};
    params = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.x)({}, params);
    if (el && !params.el) params.el = el;
    const document = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
    if (params.el && typeof params.el === 'string' && document.querySelectorAll(params.el).length > 1) {
      const swipers = [];
      document.querySelectorAll(params.el).forEach(containerEl => {
        const newParams = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.x)({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      // eslint-disable-next-line no-constructor-return
      return swipers;
    }

    // Swiper Instance
    const swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [...swiper.__modules__];
    if (params.modules && Array.isArray(params.modules)) {
      swiper.modules.push(...params.modules);
    }
    const allModulesParams = {};
    swiper.modules.forEach(mod => {
      mod({
        params,
        swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    });

    // Extend defaults with modules params
    const swiperParams = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.x)({}, defaults, allModulesParams);

    // Extend defaults with passed params
    swiper.params = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.x)({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.x)({}, swiper.params);
    swiper.passedParams = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.x)({}, params);

    // add event listeners
    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(eventName => {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }
    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    }

    // Extend Swiper
    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical() {
        return swiper.params.direction === 'vertical';
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      cssOverflowAdjustment() {
        // Returns 0 unless `translate` is > 2**23
        // Should be subtracted from css values to prevent overflow
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        startMoving: undefined,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit('_swiper');

    // Init
    if (swiper.params.init) {
      swiper.init();
    }

    // Return app instance
    // eslint-disable-next-line no-constructor-return
    return swiper;
  }
  getDirectionLabel(property) {
    if (this.isHorizontal()) {
      return property;
    }
    // prettier-ignore
    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }
  getSlideIndex(slideEl) {
    const {
      slidesEl,
      params
    } = this;
    const slides = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
    const firstSlideIndex = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.i)(slides[0]);
    return (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.i)(slideEl) - firstSlideIndex;
  }
  getSlideIndexByData(index) {
    return this.getSlideIndex(this.slides.find(slideEl => slideEl.getAttribute('data-swiper-slide-index') * 1 === index));
  }
  recalcSlides() {
    const swiper = this;
    const {
      slidesEl,
      params
    } = swiper;
    swiper.slides = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
  }
  enable() {
    const swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;
    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }
    swiper.emit('enable');
  }
  disable() {
    const swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;
    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }
    swiper.emit('disable');
  }
  setProgress(progress, speed) {
    const swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    const min = swiper.minTranslate();
    const max = swiper.maxTranslate();
    const current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  emitContainerClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const cls = swiper.el.className.split(' ').filter(className => {
      return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit('_containerClasses', cls.join(' '));
  }
  getSlideClasses(slideEl) {
    const swiper = this;
    if (swiper.destroyed) return '';
    return slideEl.className.split(' ').filter(className => {
      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(' ');
  }
  emitSlidesClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const updates = [];
    swiper.slides.forEach(slideEl => {
      const classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames
      });
      swiper.emit('_slideClass', slideEl, classNames);
    });
    swiper.emit('_slideClasses', updates);
  }
  slidesPerViewDynamic(view, exact) {
    if (view === void 0) {
      view = 'current';
    }
    if (exact === void 0) {
      exact = false;
    }
    const swiper = this;
    const {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper;
    let spv = 1;
    if (typeof params.slidesPerView === 'number') return params.slidesPerView;
    if (params.centeredSlides) {
      let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
      let breakLoop;
      for (let i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += Math.ceil(slides[i].swiperSlideSize);
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
      for (let i = activeIndex - 1; i >= 0; i -= 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      // eslint-disable-next-line
      if (view === 'current') {
        for (let i = activeIndex + 1; i < slides.length; i += 1) {
          const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      } else {
        // previous
        for (let i = activeIndex - 1; i >= 0; i -= 1) {
          const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      }
    }
    return spv;
  }
  update() {
    const swiper = this;
    if (!swiper || swiper.destroyed) return;
    const {
      snapGrid,
      params
    } = swiper;
    // Breakpoints
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }
    [...swiper.el.querySelectorAll('[loading="lazy"]')].forEach(imageEl => {
      if (imageEl.complete) {
        processLazyPreloader(swiper, imageEl);
      }
    });
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();
    function setTranslate() {
      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    let translated;
    if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
      setTranslate();
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
        const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
        translated = swiper.slideTo(slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
      if (!translated) {
        setTranslate();
      }
    }
    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
    swiper.emit('update');
  }
  changeDirection(newDirection, needUpdate) {
    if (needUpdate === void 0) {
      needUpdate = true;
    }
    const swiper = this;
    const currentDirection = swiper.params.direction;
    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }
    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
      return swiper;
    }
    swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
    swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.forEach(slideEl => {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });
    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();
    return swiper;
  }
  changeLanguageDirection(direction) {
    const swiper = this;
    if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
    swiper.rtl = direction === 'rtl';
    swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
    if (swiper.rtl) {
      swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'rtl';
    } else {
      swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'ltr';
    }
    swiper.update();
  }
  mount(element) {
    const swiper = this;
    if (swiper.mounted) return true;

    // Find el
    let el = element || swiper.params.el;
    if (typeof el === 'string') {
      el = document.querySelector(el);
    }
    if (!el) {
      return false;
    }
    el.swiper = swiper;
    if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) {
      swiper.isElement = true;
    }
    const getWrapperSelector = () => {
      return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
    };
    const getWrapper = () => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        const res = el.shadowRoot.querySelector(getWrapperSelector());
        // Children needs to return slot items
        return res;
      }
      return (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(el, getWrapperSelector())[0];
    };
    // Find Wrapper
    let wrapperEl = getWrapper();
    if (!wrapperEl && swiper.params.createElements) {
      wrapperEl = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)('div', swiper.params.wrapperClass);
      el.append(wrapperEl);
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(el, `.${swiper.params.slideClass}`).forEach(slideEl => {
        wrapperEl.append(slideEl);
      });
    }
    Object.assign(swiper, {
      el,
      wrapperEl,
      slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
      hostEl: swiper.isElement ? el.parentNode.host : el,
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.q)(el, 'direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.q)(el, 'direction') === 'rtl'),
      wrongRTL: (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.q)(wrapperEl, 'display') === '-webkit-box'
    });
    return true;
  }
  init(el) {
    const swiper = this;
    if (swiper.initialized) return swiper;
    const mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit('beforeInit');

    // Set breakpoint
    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    }

    // Add Classes
    swiper.addClasses();

    // Update size
    swiper.updateSize();

    // Update slides
    swiper.updateSlides();
    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    }

    // Set Grab Cursor
    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }

    // Slide To Initial Slide
    if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
      swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    }

    // Create loop
    if (swiper.params.loop) {
      swiper.loopCreate(undefined, true);
    }

    // Attach events
    swiper.attachEvents();
    const lazyElements = [...swiper.el.querySelectorAll('[loading="lazy"]')];
    if (swiper.isElement) {
      lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
    }
    lazyElements.forEach(imageEl => {
      if (imageEl.complete) {
        processLazyPreloader(swiper, imageEl);
      } else {
        imageEl.addEventListener('load', e => {
          processLazyPreloader(swiper, e.target);
        });
      }
    });
    preload(swiper);

    // Init Flag
    swiper.initialized = true;
    preload(swiper);

    // Emit
    swiper.emit('init');
    swiper.emit('afterInit');
    return swiper;
  }
  destroy(deleteInstance, cleanStyles) {
    if (deleteInstance === void 0) {
      deleteInstance = true;
    }
    if (cleanStyles === void 0) {
      cleanStyles = true;
    }
    const swiper = this;
    const {
      params,
      el,
      wrapperEl,
      slides
    } = swiper;
    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }
    swiper.emit('beforeDestroy');

    // Init Flag
    swiper.initialized = false;

    // Detach events
    swiper.detachEvents();

    // Destroy loop
    if (params.loop) {
      swiper.loopDestroy();
    }

    // Cleanup styles
    if (cleanStyles) {
      swiper.removeClasses();
      if (el && typeof el !== 'string') {
        el.removeAttribute('style');
      }
      if (wrapperEl) {
        wrapperEl.removeAttribute('style');
      }
      if (slides && slides.length) {
        slides.forEach(slideEl => {
          slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
          slideEl.removeAttribute('style');
          slideEl.removeAttribute('data-swiper-slide-index');
        });
      }
    }
    swiper.emit('destroy');

    // Detach emitter events
    Object.keys(swiper.eventsListeners).forEach(eventName => {
      swiper.off(eventName);
    });
    if (deleteInstance !== false) {
      if (swiper.el && typeof swiper.el !== 'string') {
        swiper.el.swiper = null;
      }
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.y)(swiper);
    }
    swiper.destroyed = true;
    return null;
  }
  static extendDefaults(newDefaults) {
    (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.x)(extendedDefaults, newDefaults);
  }
  static get extendedDefaults() {
    return extendedDefaults;
  }
  static get defaults() {
    return defaults;
  }
  static installModule(mod) {
    if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
    const modules = Swiper.prototype.__modules__;
    if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
      modules.push(mod);
    }
  }
  static use(module) {
    if (Array.isArray(module)) {
      module.forEach(m => Swiper.installModule(m));
      return Swiper;
    }
    Swiper.installModule(module);
    return Swiper;
  }
}
Object.keys(prototypes).forEach(prototypeGroup => {
  Object.keys(prototypes[prototypeGroup]).forEach(protoMethod => {
    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper.use([Resize, Observer]);




/***/ }),

/***/ "./node_modules/swiper/shared/utils.mjs":
/*!**********************************************!*\
  !*** ./node_modules/swiper/shared/utils.mjs ***!
  \**********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   a: () => (/* binding */ setCSSProperty),
/* harmony export */   b: () => (/* binding */ elementParents),
/* harmony export */   c: () => (/* binding */ createElement),
/* harmony export */   d: () => (/* binding */ elementOffset),
/* harmony export */   e: () => (/* binding */ elementChildren),
/* harmony export */   f: () => (/* binding */ now),
/* harmony export */   g: () => (/* binding */ getSlideTransformEl),
/* harmony export */   h: () => (/* binding */ elementOuterSize),
/* harmony export */   i: () => (/* binding */ elementIndex),
/* harmony export */   j: () => (/* binding */ classesToTokens),
/* harmony export */   k: () => (/* binding */ getTranslate),
/* harmony export */   l: () => (/* binding */ elementTransitionEnd),
/* harmony export */   m: () => (/* binding */ makeElementsArray),
/* harmony export */   n: () => (/* binding */ nextTick),
/* harmony export */   o: () => (/* binding */ isObject),
/* harmony export */   p: () => (/* binding */ getRotateFix),
/* harmony export */   q: () => (/* binding */ elementStyle),
/* harmony export */   r: () => (/* binding */ elementNextAll),
/* harmony export */   s: () => (/* binding */ setInnerHTML),
/* harmony export */   t: () => (/* binding */ elementPrevAll),
/* harmony export */   u: () => (/* binding */ animateCSSModeScroll),
/* harmony export */   v: () => (/* binding */ showWarning),
/* harmony export */   w: () => (/* binding */ elementIsChildOf),
/* harmony export */   x: () => (/* binding */ extend),
/* harmony export */   y: () => (/* binding */ deleteProps)
/* harmony export */ });
/* harmony import */ var _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ssr-window.esm.mjs */ "./node_modules/swiper/shared/ssr-window.esm.mjs");


function classesToTokens(classes) {
  if (classes === void 0) {
    classes = '';
  }
  return classes.trim().split(' ').filter(c => !!c.trim());
}

function deleteProps(obj) {
  const object = obj;
  Object.keys(object).forEach(key => {
    try {
      object[key] = null;
    } catch (e) {
      // no getter for object
    }
    try {
      delete object[key];
    } catch (e) {
      // something got wrong
    }
  });
}
function nextTick(callback, delay) {
  if (delay === void 0) {
    delay = 0;
  }
  return setTimeout(callback, delay);
}
function now() {
  return Date.now();
}
function getComputedStyle(el) {
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  let style;
  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }
  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }
  if (!style) {
    style = el.style;
  }
  return style;
}
function getTranslate(el, axis) {
  if (axis === void 0) {
    axis = 'x';
  }
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  let matrix;
  let curTransform;
  let transformMatrix;
  const curStyle = getComputedStyle(el);
  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;
    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(a => a.replace(',', '.')).join(', ');
    }
    // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case
    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }
  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41;
    // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
    // Normal Browsers
    else curTransform = parseFloat(matrix[4]);
  }
  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42;
    // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
    // Normal Browsers
    else curTransform = parseFloat(matrix[5]);
  }
  return curTransform || 0;
}
function isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }
  return node && (node.nodeType === 1 || node.nodeType === 11);
}
function extend() {
  const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
  const noExtend = ['__proto__', 'constructor', 'prototype'];
  for (let i = 1; i < arguments.length; i += 1) {
    const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      const keysArray = Object.keys(Object(nextSource)).filter(key => noExtend.indexOf(key) < 0);
      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        const nextKey = keysArray[nextIndex];
        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
        if (desc !== undefined && desc.enumerable) {
          if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
            to[nextKey] = {};
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }
  return to;
}
function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll(_ref) {
  let {
    swiper,
    targetPosition,
    side
  } = _ref;
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  const startPosition = -swiper.translate;
  let startTime = null;
  let time;
  const duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = 'none';
  window.cancelAnimationFrame(swiper.cssModeFrameID);
  const dir = targetPosition > startPosition ? 'next' : 'prev';
  const isOutOfBound = (current, target) => {
    return dir === 'next' && current >= target || dir === 'prev' && current <= target;
  };
  const animate = () => {
    time = new Date().getTime();
    if (startTime === null) {
      startTime = time;
    }
    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }
    swiper.wrapperEl.scrollTo({
      [side]: currentPosition
    });
    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.scrollSnapType = '';
      setTimeout(() => {
        swiper.wrapperEl.style.overflow = '';
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      });
      window.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }
    swiper.cssModeFrameID = window.requestAnimationFrame(animate);
  };
  animate();
}
function getSlideTransformEl(slideEl) {
  return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
}
function elementChildren(element, selector) {
  if (selector === void 0) {
    selector = '';
  }
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  const children = [...element.children];
  if (window.HTMLSlotElement && element instanceof HTMLSlotElement) {
    children.push(...element.assignedElements());
  }
  if (!selector) {
    return children;
  }
  return children.filter(el => el.matches(selector));
}
function elementIsChildOfSlot(el, slot) {
  // Breadth-first search through all parent's children and assigned elements
  const elementsQueue = [slot];
  while (elementsQueue.length > 0) {
    const elementToCheck = elementsQueue.shift();
    if (el === elementToCheck) {
      return true;
    }
    elementsQueue.push(...elementToCheck.children, ...(elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : []), ...(elementToCheck.assignedElements ? elementToCheck.assignedElements() : []));
  }
}
function elementIsChildOf(el, parent) {
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  let isChild = parent.contains(el);
  if (!isChild && window.HTMLSlotElement && parent instanceof HTMLSlotElement) {
    const children = [...parent.assignedElements()];
    isChild = children.includes(el);
    if (!isChild) {
      isChild = elementIsChildOfSlot(el, parent);
    }
  }
  return isChild;
}
function showWarning(text) {
  try {
    console.warn(text);
    return;
  } catch (err) {
    // err
  }
}
function createElement(tag, classes) {
  if (classes === void 0) {
    classes = [];
  }
  const el = document.createElement(tag);
  el.classList.add(...(Array.isArray(classes) ? classes : classesToTokens(classes)));
  return el;
}
function elementOffset(el) {
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  const document = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.g)();
  const box = el.getBoundingClientRect();
  const body = document.body;
  const clientTop = el.clientTop || body.clientTop || 0;
  const clientLeft = el.clientLeft || body.clientLeft || 0;
  const scrollTop = el === window ? window.scrollY : el.scrollTop;
  const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
  return {
    top: box.top + scrollTop - clientTop,
    left: box.left + scrollLeft - clientLeft
  };
}
function elementPrevAll(el, selector) {
  const prevEls = [];
  while (el.previousElementSibling) {
    const prev = el.previousElementSibling; // eslint-disable-line
    if (selector) {
      if (prev.matches(selector)) prevEls.push(prev);
    } else prevEls.push(prev);
    el = prev;
  }
  return prevEls;
}
function elementNextAll(el, selector) {
  const nextEls = [];
  while (el.nextElementSibling) {
    const next = el.nextElementSibling; // eslint-disable-line
    if (selector) {
      if (next.matches(selector)) nextEls.push(next);
    } else nextEls.push(next);
    el = next;
  }
  return nextEls;
}
function elementStyle(el, prop) {
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  return window.getComputedStyle(el, null).getPropertyValue(prop);
}
function elementIndex(el) {
  let child = el;
  let i;
  if (child) {
    i = 0;
    // eslint-disable-next-line
    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }
    return i;
  }
  return undefined;
}
function elementParents(el, selector) {
  const parents = []; // eslint-disable-line
  let parent = el.parentElement; // eslint-disable-line
  while (parent) {
    if (selector) {
      if (parent.matches(selector)) parents.push(parent);
    } else {
      parents.push(parent);
    }
    parent = parent.parentElement;
  }
  return parents;
}
function elementTransitionEnd(el, callback) {
  function fireCallBack(e) {
    if (e.target !== el) return;
    callback.call(el, e);
    el.removeEventListener('transitionend', fireCallBack);
  }
  if (callback) {
    el.addEventListener('transitionend', fireCallBack);
  }
}
function elementOuterSize(el, size, includeMargins) {
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  if (includeMargins) {
    return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
  }
  return el.offsetWidth;
}
function makeElementsArray(el) {
  return (Array.isArray(el) ? el : [el]).filter(e => !!e);
}
function getRotateFix(swiper) {
  return v => {
    if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) {
      return v + 0.001;
    }
    return v;
  };
}
function setInnerHTML(el, html) {
  if (html === void 0) {
    html = '';
  }
  if (typeof trustedTypes !== 'undefined') {
    el.innerHTML = trustedTypes.createPolicy('html', {
      createHTML: s => s
    }).createHTML(html);
  } else {
    el.innerHTML = html;
  }
}




/***/ }),

/***/ "./node_modules/swiper/swiper.mjs":
/*!****************************************!*\
  !*** ./node_modules/swiper/swiper.mjs ***!
  \****************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Swiper: () => (/* reexport safe */ _shared_swiper_core_mjs__WEBPACK_IMPORTED_MODULE_0__.S),
/* harmony export */   "default": () => (/* reexport safe */ _shared_swiper_core_mjs__WEBPACK_IMPORTED_MODULE_0__.S)
/* harmony export */ });
/* harmony import */ var _shared_swiper_core_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./shared/swiper-core.mjs */ "./node_modules/swiper/shared/swiper-core.mjs");
/**
 * Swiper 11.2.8
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2025 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: May 23, 2025
 */




/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
/*!********************!*\
  !*** ./js/main.js ***!
  \********************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var autosize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! autosize */ "./node_modules/autosize/dist/autosize.js");
/* harmony import */ var autosize__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(autosize__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_cart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/cart */ "./js/components/cart.js");
/* harmony import */ var _components_rebuyCart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./components/rebuyCart */ "./js/components/rebuyCart.js");
/* harmony import */ var _components_subscriptionCartGuard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/subscriptionCartGuard */ "./js/components/subscriptionCartGuard.js");
/* harmony import */ var _components_contactForm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/contactForm */ "./js/components/contactForm.js");
/* harmony import */ var _components_equalHeight__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./components/equalHeight */ "./js/components/equalHeight.js");
/* harmony import */ var _components_giftSubscriptionForm__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./components/giftSubscriptionForm */ "./js/components/giftSubscriptionForm.js");
/* harmony import */ var _components_newsletterSignup__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./components/newsletterSignup */ "./js/components/newsletterSignup.js");
/* harmony import */ var _components_producer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./components/producer */ "./js/components/producer.js");
/* harmony import */ var _components_sharePopup__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./components/sharePopup */ "./js/components/sharePopup.js");
/* harmony import */ var _components_slider__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./components/slider */ "./js/components/slider.js");
/* harmony import */ var _components_subscriptionBuilder_svelte__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./components/subscriptionBuilder.svelte */ "./js/components/subscriptionBuilder.svelte");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }













/* eslint-disable no-unused-vars */
var contactForm = new _components_contactForm__WEBPACK_IMPORTED_MODULE_4__["default"]();
var producer = new _components_producer__WEBPACK_IMPORTED_MODULE_8__["default"]();
var giftSubscriptionForm = new _components_giftSubscriptionForm__WEBPACK_IMPORTED_MODULE_6__["default"]();
var cart = new _components_cart__WEBPACK_IMPORTED_MODULE_1__["default"]();
/* eslint-enable no-unused-vars */

var slider = _components_slider__WEBPACK_IMPORTED_MODULE_10__["default"].init();
_components_equalHeight__WEBPACK_IMPORTED_MODULE_5__["default"].init();
_components_newsletterSignup__WEBPACK_IMPORTED_MODULE_7__["default"].init();
var subscriptionBuilderContainer = document.querySelector('.js-subscription_builder');
if (subscriptionBuilderContainer) {
  // eslint-disable-next-line no-unused-vars
  var subscriptionBuilder = new _components_subscriptionBuilder_svelte__WEBPACK_IMPORTED_MODULE_11__["default"]({
    target: subscriptionBuilderContainer,
    props: {
      debug: subscriptionBuilderContainer.dataset.debug,
      recurring: subscriptionBuilderContainer.dataset.recurring
    }
  });
}

// One cart watcher for the whole site. Rebuy's drawer opens on every page, so quantity
// rules have to be enforced everywhere — not just on the subscription builder. Components
// that care (the builder) listen for 'coava:cart-changed' rather than polling themselves.
function handleCartChange(_x) {
  return _handleCartChange.apply(this, arguments);
} // Backstop: polls only while Smart Cart is on screen.
function _handleCartChange() {
  _handleCartChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(cart) {
    var corrected;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return (0,_components_subscriptionCartGuard__WEBPACK_IMPORTED_MODULE_3__.enforceCartQuantityRules)(cart);
        case 1:
          corrected = _context2.v;
          if (!corrected) {
            _context2.n = 2;
            break;
          }
          _context2.n = 2;
          return (0,_components_rebuyCart__WEBPACK_IMPORTED_MODULE_2__.refreshRebuyCart)(corrected);
        case 2:
          document.dispatchEvent(new CustomEvent('coava:cart-changed', {
            detail: corrected || cart
          }));
        case 3:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return _handleCartChange.apply(this, arguments);
}
(0,_components_rebuyCart__WEBPACK_IMPORTED_MODULE_2__.watchRebuyCart)(handleCartChange);

// Fast path for Rebuy → Smart Cart → Global Settings → Event Callbacks
// (LineItemIncrease / LineItemDecrease / LineItemRemoved), each calling:
//   window.coavaEnforceCartRules && window.coavaEnforceCartRules();
// Catches a change the moment it happens rather than on the next poll. Lives here rather
// than in the builder so it exists on every page, since the drawer opens everywhere.
window.coavaEnforceCartRules = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
  var res, _t, _t2, _t3;
  return _regenerator().w(function (_context) {
    while (1) switch (_context.n) {
      case 0:
        _context.p = 0;
        _context.n = 1;
        return fetch('/cart.js', {
          headers: {
            Accept: 'application/json'
          }
        });
      case 1:
        res = _context.v;
        if (!res.ok) {
          _context.n = 3;
          break;
        }
        _t = handleCartChange;
        _context.n = 2;
        return res.json();
      case 2:
        _t2 = _context.v;
        _context.n = 3;
        return _t(_t2);
      case 3:
        _context.n = 5;
        break;
      case 4:
        _context.p = 4;
        _t3 = _context.v;
        console.warn('[Coava] cart rule check failed:', _t3);
      case 5:
        return _context.a(2);
    }
  }, _callee, null, [[0, 4]]);
}));

// On Load
autosize__WEBPACK_IMPORTED_MODULE_0___default()(document.querySelectorAll('textarea'));

// Pick 3 random items from the grid
var gridItems = document.querySelectorAll('.js-pick .grid-item');
var itemsArray = Array.from(gridItems);
var numToKeep = 3;

// Shuffle array
for (var i = itemsArray.length - 1; i > 0; i--) {
  var j = Math.floor(Math.random() * (i + 1));
  var _ref2 = [itemsArray[j], itemsArray[i]];
  itemsArray[i] = _ref2[0];
  itemsArray[j] = _ref2[1];
}

// Remove all but first numToKeep items
itemsArray.slice(numToKeep).forEach(function (item) {
  return item.remove();
});
document.querySelectorAll('.js-share-popup').forEach(function (button) {
  button.addEventListener('click', function (event) {
    event.preventDefault();
    _components_sharePopup__WEBPACK_IMPORTED_MODULE_9__["default"].open(button.getAttribute('href'));
  });
});
window.setTimeout(function () {
  var _document$querySelect;
  (_document$querySelect = document.querySelector('html.wf-loading')) === null || _document$querySelect === void 0 || _document$querySelect.classList.remove('wf-loading');
}, 3000);
document.querySelectorAll('.js-nav_toggle').forEach(function (toggle) {
  toggle.addEventListener('click', function (event) {
    event.preventDefault();
    document.body.classList.toggle('nav-active');
    toggle.textContent = toggle.textContent === 'Menu' ? 'Close' : 'Menu';
  });
});
document.querySelectorAll('.js-subheader').forEach(function (toggle) {
  var subheaderNavList = toggle.querySelector('.subheader-nav-list');
  var checkOverflow = function checkOverflow() {
    if (subheaderNavList.scrollWidth > subheaderNavList.clientWidth) {
      subheaderNavList.classList.add('is-overflowing');
    } else {
      subheaderNavList.classList.remove('is-overflowing');
    }
  };

  // Check on load
  checkOverflow();

  // Check on resize
  window.addEventListener('resize', checkOverflow);
});
document.querySelectorAll('.js-announcement-toggle').forEach(function (toggle) {
  toggle.addEventListener('click', function (event) {
    event.preventDefault();
    var announcement = document.querySelector('.js-announcement');
    var expandedElement = announcement.querySelector('.announcement-expanded');
    var isExpanded = announcement === null || announcement === void 0 ? void 0 : announcement.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    if (announcement) {
      announcement.setAttribute('id', 'announcement');
      expandedElement === null || expandedElement === void 0 || expandedElement.setAttribute('aria-hidden', isExpanded ? 'false' : 'true');
    }
  });
});
var activateContentToggle = function activateContentToggle(link) {
  var activeClass = 'is-active';
  var parent = link.parentElement;
  var siblings = parent.querySelectorAll('button');
  siblings.forEach(function (sibling) {
    return sibling.classList.remove(activeClass);
  });
  link.classList.add(activeClass);
  siblings.forEach(function (sibling) {
    return sibling.setAttribute('aria-selected', 'false');
  });
  var contentItems = Array.from(parent.parentElement.children).filter(function (el) {
    return !el.matches('.js-content_toggle');
  });
  contentItems.forEach(function (item) {
    return item.classList.remove(activeClass);
  });
  contentItems[Array.from(siblings).indexOf(link)].classList.add(activeClass);

  // Set the aria-selected attribute on the button
  link.setAttribute('aria-selected', 'true');
};
document.querySelectorAll('.js-content_toggle button').forEach(function (link) {
  link.addEventListener('click', function () {
    return activateContentToggle(link);
  });

  // Inactive panels are only visually hidden, so reveal one when keyboard focus lands inside it.
  var panel = document.getElementById(link.getAttribute('aria-controls'));
  panel === null || panel === void 0 || panel.addEventListener('focusin', function () {
    if (!panel.classList.contains('is-active')) activateContentToggle(link);
  });
});
document.querySelectorAll('.js-faq-toggle').forEach(function (button) {
  button.addEventListener('click', function (event) {
    event.preventDefault();
    var isExpanded = button.getAttribute('aria-expanded') === 'true';
    var answerId = button.getAttribute('aria-controls');
    var answerPanel = document.getElementById(answerId);
    if (answerPanel) {
      var _button$closest;
      button.setAttribute('aria-expanded', !isExpanded ? 'true' : 'false');
      answerPanel.setAttribute('aria-hidden', !isExpanded ? 'false' : 'true');
      (_button$closest = button.closest('.faq-question')) === null || _button$closest === void 0 || _button$closest.classList.toggle('is-expanded', !isExpanded);
    }
  });
});
document.querySelectorAll('.image_w_text_card').forEach(function (card) {
  card.classList.remove('is-hidden');
});
document.querySelectorAll('.js-to_top').forEach(function (button) {
  button.addEventListener('click', function (event) {
    event.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    var focusableElements = document.body.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

    // Focus the second focusable element (skip the skip to content link)
    focusableElements[1].focus();
  });
});
document.querySelectorAll('.js-animate_scroll').forEach(function (link) {
  link.addEventListener('click', function (event) {
    event.preventDefault();
    var target = document.querySelector(link.getAttribute('href'));
    var padding = link.dataset.scrollPadding || 0;
    if (target) {
      var top = target.getBoundingClientRect().top + window.pageYOffset - padding;
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });
    }
  });
});
document.querySelectorAll('.js-component_view-toggle').forEach(function (toggle) {
  toggle.addEventListener('click', function (event) {
    var _toggle$closest, _toggle$closest2;
    event.preventDefault();
    document.querySelectorAll('.js-component_view').forEach(function (view) {
      return view.classList.toggle('is-hidden');
    });
    (_toggle$closest = toggle.closest('.js-component_view')) === null || _toggle$closest === void 0 || _toggle$closest.classList.toggle('is-active');
    var id = (_toggle$closest2 = toggle.closest('.component_library-heading')) === null || _toggle$closest2 === void 0 ? void 0 : _toggle$closest2.id;
    setTimeout(function () {
      window.location.hash = id;
    }, 50);
  });
});
document.querySelectorAll('.js-show_all_siblings').forEach(function (button) {
  button.addEventListener('click', function (event) {
    event.preventDefault();
    button.style.display = 'none';
    Array.from(button.parentElement.children).filter(function (sibling) {
      return sibling !== button;
    }).forEach(function (sibling) {
      return sibling.classList.remove('is-hidden');
    });
  });
});

// If the current domain isn't https://coavacoffee.com or shop.coavacoffee.com, make sure folks confirm that they want to leave the site if clicking a link to an external site.
// if (window.location.hostname !== 'coavacoffee.com' && window.location.hostname !== 'shop.coavacoffee.com') {
//   document.querySelectorAll('a').forEach(link => {
//     if (
//       link.href.startsWith('http') &&
//       new URL(link.href).hostname !== window.location.hostname
//     ) {
//       link.addEventListener('click', (event) => {
//         event.preventDefault();
//         const confirm = window.confirm('Are you sure you want to leave the site?');
//         if (confirm) {
//           window.location.href = link.href;
//         }
//       });
//     }
//   });
// }
})();

/******/ })()
;
//# sourceMappingURL=scripts.js.map